import type { SVGProps } from "react";

const SvgEdbSmallLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="34 34 444 444"
    width="1em"
    height="1em"
    {...props}
  >
    <defs>
      <linearGradient
        id="swedbank_ee_svg__b"
        x1="19.425%"
        x2="59.005%"
        y1="86.659%"
        y2="36.097%"
      >
        <stop offset="24.44%" stopColor="#3E0900" />
        <stop offset="25.44%" stopColor="#451000" />
        <stop offset="36.8%" stopColor="#823800" />
        <stop offset="46.91%" stopColor="#B05012" />
        <stop offset="55.41%" stopColor="#D3611C" />
        <stop offset="61.97%" stopColor="#E86B20" />
        <stop offset="65.79%" stopColor="#F37021" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__c"
        x1="77.794%"
        x2="41.273%"
        y1="10.96%"
        y2="73.589%"
      >
        <stop offset="16.92%" stopColor="#FFFDE9" />
        <stop offset="19.16%" stopColor="#FFF1D7" />
        <stop offset="23.48%" stopColor="#FED8B1" />
        <stop offset="29.43%" stopColor="#FAB079" />
        <stop offset="36.72%" stopColor="#F57E32" />
        <stop offset="38.72%" stopColor="#F37021" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__d"
        x1="72.723%"
        x2="37.786%"
        y1="7.689%"
        y2="72.468%"
      >
        <stop offset="15.79%" stopColor="#3E0900" />
        <stop offset="17.02%" stopColor="#451000" />
        <stop offset="30.96%" stopColor="#823800" />
        <stop offset="43.37%" stopColor="#B05012" />
        <stop offset="53.8%" stopColor="#D3611C" />
        <stop offset="61.85%" stopColor="#E86B20" />
        <stop offset="66.54%" stopColor="#F37021" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__e"
        x1="22.276%"
        x2="58.81%"
        y1="88.772%"
        y2="26.226%"
      >
        <stop offset="24.06%" stopColor="#FFFDE9" />
        <stop offset="31.08%" stopColor="#FFE6C7" />
        <stop offset="46.51%" stopColor="#FBB47E" />
        <stop offset="67.67%" stopColor="#F37021" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__f"
        x1="37.587%"
        x2="72.946%"
        y1="103.094%"
        y2="9.766%"
      >
        <stop offset="14.66%" stopColor="#952D09" />
        <stop offset="25.58%" stopColor="#A93B12" />
        <stop offset="48.74%" stopColor="#DD601E" />
        <stop offset="56.77%" stopColor="#F37021" />
        <stop offset="62.25%" stopColor="#F47A20" />
        <stop offset="72.49%" stopColor="#F7921E" />
        <stop offset="82.33%" stopColor="#FCAF17" />
        <stop offset="84.35%" stopColor="#FCB11E" />
        <stop offset="87.17%" stopColor="#FDB632" />
        <stop offset="90.46%" stopColor="#FEBF51" />
        <stop offset="94.12%" stopColor="#FFCB76" />
        <stop offset="98.03%" stopColor="#FFDBA0" />
        <stop offset="100%" stopColor="#FFE4B8" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__g"
        x1="29.186%"
        x2="72.439%"
        y1="125.722%"
        y2="-20.854%"
      >
        <stop offset="12.78%" stopColor="#DB5C1E" />
        <stop offset="28.58%" stopColor="#E86120" />
        <stop offset="42.86%" stopColor="#F26522" />
        <stop offset="100%" stopColor="#F37021" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__h"
        x1="1.183%"
        x2="95.851%"
        y1="93.224%"
        y2="8.161%"
      >
        <stop offset="12.78%" stopColor="#C85C1A" />
        <stop offset="20.26%" stopColor="#D55F1D" />
        <stop offset="34.36%" stopColor="#E86320" />
        <stop offset="42.86%" stopColor="#F26522" />
        <stop offset="100%" stopColor="#F37021" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__i"
        x1="19.462%"
        x2="67.746%"
        y1="93.109%"
        y2="-13.941%"
      >
        <stop offset="12.78%" stopColor="#C6401B" />
        <stop offset="20.26%" stopColor="#D34C1E" />
        <stop offset="34.36%" stopColor="#E75D20" />
        <stop offset="42.86%" stopColor="#F26522" />
        <stop offset="100%" stopColor="#F37021" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__j"
        x1="33.524%"
        x2="67.454%"
        y1="92.24%"
        y2="32%"
      >
        <stop offset="12.03%" stopColor="#C74A1B" />
        <stop offset="19.69%" stopColor="#D4531D" />
        <stop offset="34.15%" stopColor="#E85F20" />
        <stop offset="42.86%" stopColor="#F26522" />
        <stop offset="100%" stopColor="#F58220" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__k"
        x1="37.03%"
        x2="83.083%"
        y1="76.265%"
        y2="5.664%"
      >
        <stop offset="13.16%" stopColor="#C64020" />
        <stop offset="20.54%" stopColor="#D34C21" />
        <stop offset="34.46%" stopColor="#E75D21" />
        <stop offset="42.86%" stopColor="#F26522" />
        <stop offset="99.25%" stopColor="#F37021" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__l"
        x1="33.496%"
        x2="81.381%"
        y1="85.535%"
        y2="15.974%"
      >
        <stop offset="12.78%" stopColor="#C85C1A" />
        <stop offset="20.26%" stopColor="#D55F1D" />
        <stop offset="34.36%" stopColor="#E86320" />
        <stop offset="42.86%" stopColor="#F26522" />
        <stop offset="100%" stopColor="#F58220" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__m"
        x1="5.472%"
        x2="99.365%"
        y1="93.24%"
        y2="13.36%"
      >
        <stop offset="12.41%" stopColor="#C6401B" />
        <stop offset="19.97%" stopColor="#D34C1E" />
        <stop offset="34.25%" stopColor="#E75D20" />
        <stop offset="42.86%" stopColor="#F26522" />
        <stop offset="100%" stopColor="#F37021" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__n"
        x1="35.257%"
        x2="61.903%"
        y1="113.78%"
        y2="-.073%"
      >
        <stop offset="0%" stopColor="#C6401B" />
        <stop offset="2.909%" stopColor="#C8441B" />
        <stop offset="27.84%" stopColor="#D75D1D" />
        <stop offset="42.86%" stopColor="#DC661E" />
        <stop offset="98.87%" stopColor="#F58220" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__o"
        x1="19.163%"
        x2="104.013%"
        y1="99.612%"
        y2="5.552%"
      >
        <stop offset="12.78%" stopColor="#C6401B" />
        <stop offset="20.26%" stopColor="#D34C1E" />
        <stop offset="34.36%" stopColor="#E75D20" />
        <stop offset="42.86%" stopColor="#F26522" />
        <stop offset="99.25%" stopColor="#F58220" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__p"
        x1="37.771%"
        x2="64.602%"
        y1="116.146%"
        y2="-29.466%"
      >
        <stop offset="12.78%" stopColor="#DC661E" />
        <stop offset="28.58%" stopColor="#E86520" />
        <stop offset="42.86%" stopColor="#F26522" />
        <stop offset="100%" stopColor="#F37021" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__q"
        x1="29.259%"
        x2="74.196%"
        y1="121.654%"
        y2="-14.55%"
      >
        <stop offset="13.16%" stopColor="#C85420" />
        <stop offset="20.54%" stopColor="#D45921" />
        <stop offset="34.46%" stopColor="#E86121" />
        <stop offset="42.86%" stopColor="#F26522" />
        <stop offset="100%" stopColor="#F37021" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__r"
        x1="31.929%"
        x2="67.312%"
        y1="89.171%"
        y2="27.888%"
      >
        <stop offset="12.78%" stopColor="#C8541A" />
        <stop offset="20.26%" stopColor="#D4591D" />
        <stop offset="34.36%" stopColor="#E86120" />
        <stop offset="42.86%" stopColor="#F26522" />
        <stop offset="100%" stopColor="#F37021" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__s"
        x1="10.077%"
        x2="112.687%"
        y1="94.735%"
        y2="6.621%"
      >
        <stop offset="0%" stopColor="#C6401B" />
        <stop offset="12.78%" stopColor="#F37021" />
        <stop offset="14.08%" stopColor="#F36D21" />
        <stop offset="19.17%" stopColor="#F26522" />
        <stop offset="100%" stopColor="#F15A22" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__t"
        x1="-25.392%"
        x2="141.248%"
        y1="86.68%"
        y2="14.322%"
      >
        <stop offset="12.78%" stopColor="#C8541A" />
        <stop offset="20.26%" stopColor="#D4591D" />
        <stop offset="34.36%" stopColor="#E86120" />
        <stop offset="42.86%" stopColor="#F26522" />
        <stop offset="100%" stopColor="#F58220" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__u"
        x1="29.345%"
        x2="87.683%"
        y1="74.713%"
        y2="5.139%"
      >
        <stop offset="0%" stopColor="#C6401B" />
        <stop offset="24.85%" stopColor="#D4521D" />
        <stop offset="71.74%" stopColor="#E96D1F" />
        <stop offset="100%" stopColor="#F47920" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__v"
        x1="49.812%"
        x2="62.496%"
        y1="59.774%"
        y2="27.763%"
      >
        <stop offset="12.78%" stopColor="#C8541A" />
        <stop offset="20.26%" stopColor="#D4591D" />
        <stop offset="34.36%" stopColor="#E86120" />
        <stop offset="42.86%" stopColor="#F26522" />
        <stop offset="100%" stopColor="#F37021" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__w"
        x1="13.876%"
        x2="91.989%"
        y1="82.417%"
        y2="6.105%"
      >
        <stop offset="0%" stopColor="#C6401B" />
        <stop offset="10.65%" stopColor="#D34C1E" />
        <stop offset="30.75%" stopColor="#E75D20" />
        <stop offset="42.86%" stopColor="#F26522" />
        <stop offset="99.25%" stopColor="#F58220" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__x"
        x1="28.091%"
        x2="73.024%"
        y1="84.661%"
        y2="13.175%"
      >
        <stop offset="5.263%" stopColor="#3E0900" />
        <stop offset="6.8%" stopColor="#623000" />
        <stop offset="8.885%" stopColor="#88572C" />
        <stop offset="11.02%" stopColor="#AA7D50" />
        <stop offset="13.18%" stopColor="#C8A272" />
        <stop offset="15.35%" stopColor="#E0C18F" />
        <stop offset="17.56%" stopColor="#F1D8A7" />
        <stop offset="19.81%" stopColor="#FBE7B6" />
        <stop offset="22.18%" stopColor="#FFEEBD" />
        <stop offset="25.55%" stopColor="#FFEBB8" />
        <stop offset="29.48%" stopColor="#FFE4AB" />
        <stop offset="33.68%" stopColor="#FFD895" />
        <stop offset="38.07%" stopColor="#FEC77A" />
        <stop offset="42.62%" stopColor="#FBB155" />
        <stop offset="47.23%" stopColor="#F89926" />
        <stop offset="48.12%" stopColor="#F7941D" />
        <stop offset="51.01%" stopColor="#E2821C" />
        <stop offset="57.01%" stopColor="#B35C12" />
        <stop offset="61.28%" stopColor="#904004" />
        <stop offset="61.87%" stopColor="#823800" />
        <stop offset="62.85%" stopColor="#6F2D00" />
        <stop offset="63.98%" stopColor="#5E2300" />
        <stop offset="65.3%" stopColor="#511A00" />
        <stop offset="66.93%" stopColor="#461100" />
        <stop offset="69.21%" stopColor="#400B00" />
        <stop offset="75.56%" stopColor="#3E0900" />
        <stop offset="79.02%" stopColor="#3E0900" />
        <stop offset="100%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__y"
        x1="-12.772%"
        x2="91.225%"
        y1="54.667%"
        y2="45.991%"
      >
        <stop offset="9.551%" stopColor="#FFE4B8" />
        <stop offset="21.53%" stopColor="#FFE4B7" />
        <stop offset="25.84%" stopColor="#FFE0B1" />
        <stop offset="28.92%" stopColor="#FFDBA6" />
        <stop offset="31.41%" stopColor="#FFD397" />
        <stop offset="33.54%" stopColor="#FEC985" />
        <stop offset="35.42%" stopColor="#FCBC6F" />
        <stop offset="37.13%" stopColor="#FBAD53" />
        <stop offset="38.65%" stopColor="#F99D32" />
        <stop offset="39.47%" stopColor="#F7941D" />
        <stop offset="43.71%" stopColor="#CC7418" />
        <stop offset="49%" stopColor="#A0540A" />
        <stop offset="53.93%" stopColor="#803D00" />
        <stop offset="58.34%" stopColor="#692C00" />
        <stop offset="62.06%" stopColor="#5A2100" />
        <stop offset="64.66%" stopColor="#551C00" />
        <stop offset="74.12%" stopColor="#451000" />
        <stop offset="80.83%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__z"
        x1="-22.453%"
        x2="154.951%"
        y1="42.038%"
        y2="60.35%"
      >
        <stop offset="10.9%" stopColor="#3E0900" />
        <stop offset="14.66%" stopColor="#8E3E03" />
        <stop offset="15.14%" stopColor="#954609" />
        <stop offset="17.84%" stopColor="#BE6F29" />
        <stop offset="20.19%" stopColor="#DE9142" />
        <stop offset="22.1%" stopColor="#F1A852" />
        <stop offset="23.31%" stopColor="#FBB35A" />
        <stop offset="38.72%" stopColor="#FFE293" />
        <stop offset="40.66%" stopColor="#FFD680" />
        <stop offset="45.46%" stopColor="#FDBC56" />
        <stop offset="49.73%" stopColor="#FAA936" />
        <stop offset="53.27%" stopColor="#F99E22" />
        <stop offset="55.64%" stopColor="#F89A1C" />
        <stop offset="58.98%" stopColor="#F99C20" />
        <stop offset="62.84%" stopColor="#FAA22D" />
        <stop offset="66.97%" stopColor="#FBAD43" />
        <stop offset="71.28%" stopColor="#FDBC62" />
        <stop offset="75.73%" stopColor="#FFD085" />
        <stop offset="80.24%" stopColor="#FFE8B2" />
        <stop offset="81.2%" stopColor="#FFEEBD" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__B"
        x1=".168%"
        x2="99.958%"
        y1="50.537%"
        y2="50.537%"
      >
        <stop offset="5%" stopColor="#F58220" />
        <stop offset="9.758%" stopColor="#F78F31" />
        <stop offset="20.45%" stopColor="#FAAA5B" />
        <stop offset="31.14%" stopColor="#FDC37C" />
        <stop offset="41.64%" stopColor="#FFD597" />
        <stop offset="51.91%" stopColor="#FFE3AB" />
        <stop offset="61.82%" stopColor="#FFEBB8" />
        <stop offset="71%" stopColor="#FFEEBD" />
        <stop offset="95%" stopColor="#F99D1C" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__C"
        x1="-.381%"
        x2="99.642%"
        y1="50.48%"
        y2="50.48%"
      >
        <stop offset="0%" stopColor="#3E0900" />
        <stop offset=".704%" stopColor="#5A2800" />
        <stop offset="1.772%" stopColor="#7A481C" />
        <stop offset="2.971%" stopColor="#97683C" />
        <stop offset="4.277%" stopColor="#B28759" />
        <stop offset="5.72%" stopColor="#CAA474" />
        <stop offset="7.349%" stopColor="#DDBD8C" />
        <stop offset="9.251%" stopColor="#ECD1A0" />
        <stop offset="11.6%" stopColor="#F6E0AF" />
        <stop offset="14.9%" stopColor="#FEEAB9" />
        <stop offset="24.06%" stopColor="#FFEEBD" />
        <stop offset="26.94%" stopColor="#FFEDBA" />
        <stop offset="29.32%" stopColor="#FFE8B0" />
        <stop offset="31.53%" stopColor="#FFE1A1" />
        <stop offset="33.63%" stopColor="#FFD78C" />
        <stop offset="35.66%" stopColor="#FFCA72" />
        <stop offset="37.63%" stopColor="#FDBB4F" />
        <stop offset="39.52%" stopColor="#FBA922" />
        <stop offset="39.85%" stopColor="#FAA61A" />
        <stop offset="41.49%" stopColor="#FCB645" />
        <stop offset="43.35%" stopColor="#FEC76C" />
        <stop offset="45.26%" stopColor="#FFD588" />
        <stop offset="47.19%" stopColor="#FFE09E" />
        <stop offset="49.16%" stopColor="#FFE8AF" />
        <stop offset="51.19%" stopColor="#FFECB9" />
        <stop offset="53.38%" stopColor="#FFEEBD" />
        <stop offset="55.16%" stopColor="#FFE8B3" />
        <stop offset="58.13%" stopColor="#FFD99B" />
        <stop offset="61.91%" stopColor="#FDC176" />
        <stop offset="65.41%" stopColor="#FAA74F" />
        <stop offset="65.61%" stopColor="#FAA953" />
        <stop offset="67.21%" stopColor="#FCBC6F" />
        <stop offset="69.02%" stopColor="#FECB86" />
        <stop offset="71.07%" stopColor="#FFD899" />
        <stop offset="73.46%" stopColor="#FFE2A9" />
        <stop offset="76.42%" stopColor="#FFE9B4" />
        <stop offset="80.57%" stopColor="#FFEDBB" />
        <stop offset="92.11%" stopColor="#FFEEBD" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__D"
        x1=".876%"
        x2="104.753%"
        y1="13.273%"
        y2="71.077%"
      >
        <stop offset="2.632%" stopColor="#FFF3D1" />
        <stop offset="3.899%" stopColor="#FFF0CB" />
        <stop offset="5.754%" stopColor="#FFE6B8" />
        <stop offset="7.971%" stopColor="#FFD69B" />
        <stop offset="10.47%" stopColor="#FDC176" />
        <stop offset="13.16%" stopColor="#FAA744" />
        <stop offset="15.04%" stopColor="#F7941D" />
        <stop offset="15.86%" stopColor="#F99E31" />
        <stop offset="18.35%" stopColor="#FCBB6B" />
        <stop offset="20.61%" stopColor="#FFD394" />
        <stop offset="22.58%" stopColor="#FFE4B5" />
        <stop offset="24.17%" stopColor="#FFEFCA" />
        <stop offset="25.19%" stopColor="#FFF3D1" />
        <stop offset="28.5%" stopColor="#FFE3AE" />
        <stop offset="38.72%" stopColor="#FCB749" />
        <stop offset="43.23%" stopColor="#FAA61A" />
        <stop offset="45.68%" stopColor="#FCB034" />
        <stop offset="51.3%" stopColor="#FEC568" />
        <stop offset="56.54%" stopColor="#FFD78B" />
        <stop offset="61.24%" stopColor="#FFE3A6" />
        <stop offset="65.24%" stopColor="#FFEBB7" />
        <stop offset="68.05%" stopColor="#FFEEBD" />
        <stop offset="70.02%" stopColor="#FFEBB7" />
        <stop offset="72.67%" stopColor="#FFE2A7" />
        <stop offset="75.7%" stopColor="#FFD38E" />
        <stop offset="79.03%" stopColor="#FDBF6D" />
        <stop offset="82.54%" stopColor="#FAA640" />
        <stop offset="84.96%" stopColor="#F7941D" />
        <stop offset="86.11%" stopColor="#EC8C1C" />
        <stop offset="88.05%" stopColor="#D77C1A" />
        <stop offset="90.55%" stopColor="#B36311" />
        <stop offset="93.52%" stopColor="#854200" />
        <stop offset="96.84%" stopColor="#4A1600" />
        <stop offset="97.37%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__E"
        x1="80.087%"
        x2="22.471%"
        y1="-41.271%"
        y2="108.589%"
      >
        <stop offset="23.31%" stopColor="#3E0900" />
        <stop offset="24.35%" stopColor="#592300" />
        <stop offset="26.15%" stopColor="#7C3F00" />
        <stop offset="28.07%" stopColor="#9B5816" />
        <stop offset="30.07%" stopColor="#B76E24" />
        <stop offset="32.19%" stopColor="#CE812E" />
        <stop offset="34.46%" stopColor="#E09136" />
        <stop offset="36.94%" stopColor="#ED9C3C" />
        <stop offset="39.82%" stopColor="#F6A33F" />
        <stop offset="43.99%" stopColor="#FAA741" />
        <stop offset="100%" stopColor="#FFEEBD" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__F"
        x1="50.576%"
        x2="50.576%"
        y1="99.778%"
        y2=".686%"
      >
        <stop offset="0%" stopColor="#CA6C18" />
        <stop offset=".19%" stopColor="#CB6D19" />
        <stop offset="4.53%" stopColor="#DA8C38" />
        <stop offset="9.04%" stopColor="#E7A857" />
        <stop offset="13.71%" stopColor="#F1C070" />
        <stop offset="18.59%" stopColor="#F9D282" />
        <stop offset="23.83%" stopColor="#FFDD8E" />
        <stop offset="30.08%" stopColor="#FFE293" />
        <stop offset="37.78%" stopColor="#FEC468" />
        <stop offset="45.92%" stopColor="#FAA93E" />
        <stop offset="52.28%" stopColor="#F89925" />
        <stop offset="56.02%" stopColor="#F7941D" />
        <stop offset="59.67%" stopColor="#F79422" />
        <stop offset="64.38%" stopColor="#F79430" />
        <stop offset="64.66%" stopColor="#F79431" />
        <stop offset="66.48%" stopColor="#EA8B2E" />
        <stop offset="69.79%" stopColor="#D07725" />
        <stop offset="74.25%" stopColor="#A45814" />
        <stop offset="79.6%" stopColor="#6E3100" />
        <stop offset="83.46%" stopColor="#3E0900" />
        <stop offset="85.8%" stopColor="#3E0900" />
        <stop offset="100%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__G"
        x1="6.71%"
        x2="93.948%"
        y1="-12.167%"
        y2="109.231%"
      >
        <stop offset="23.31%" stopColor="#FFEEBD" />
        <stop offset="27.44%" stopColor="#FFE7B2" />
        <stop offset="31.54%" stopColor="#FFD290" />
        <stop offset="36.69%" stopColor="#FCBB6F" />
        <stop offset="41.8%" stopColor="#FAAA54" />
        <stop offset="46.78%" stopColor="#F99D40" />
        <stop offset="51.59%" stopColor="#F89635" />
        <stop offset="56.02%" stopColor="#F79431" />
        <stop offset="59.34%" stopColor="#F9A44A" />
        <stop offset="64.58%" stopColor="#FCBA6D" />
        <stop offset="70.03%" stopColor="#FECD88" />
        <stop offset="75.65%" stopColor="#FFDB9E" />
        <stop offset="81.51%" stopColor="#FFE6AF" />
        <stop offset="87.77%" stopColor="#FFECB9" />
        <stop offset="95.11%" stopColor="#FFEEBD" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__H"
        x1="-8.4%"
        x2="104.11%"
        y1="75.558%"
        y2="30.187%"
      >
        <stop offset="10.53%" stopColor="#F7941D" />
        <stop offset="14.82%" stopColor="#F4921D" />
        <stop offset="16.37%" stopColor="#ED8C1D" />
        <stop offset="17.47%" stopColor="#E4841C" />
        <stop offset="18.36%" stopColor="#D67A1A" />
        <stop offset="19.12%" stopColor="#C46C16" />
        <stop offset="19.8%" stopColor="#AD5A10" />
        <stop offset="20.41%" stopColor="#944705" />
        <stop offset="20.97%" stopColor="#793200" />
        <stop offset="21.47%" stopColor="#591900" />
        <stop offset="21.8%" stopColor="#3E0000" />
        <stop offset="26.91%" stopColor="#3E0000" />
        <stop offset="68.8%" stopColor="#3E0000" />
        <stop offset="69.81%" stopColor="#521100" />
        <stop offset="72.27%" stopColor="#772D00" />
        <stop offset="74.87%" stopColor="#964307" />
        <stop offset="77.57%" stopColor="#B25513" />
        <stop offset="80.39%" stopColor="#C96519" />
        <stop offset="83.37%" stopColor="#DB711C" />
        <stop offset="86.59%" stopColor="#E87A1E" />
        <stop offset="90.22%" stopColor="#F17F1F" />
        <stop offset="95.11%" stopColor="#F58220" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__I"
        x1="29.293%"
        x2="79.579%"
        y1="-7.817%"
        y2="101.283%"
      >
        <stop offset="7.895%" stopColor="#CA6C18" />
        <stop offset="9.907%" stopColor="#C06516" />
        <stop offset="13.62%" stopColor="#A5540D" />
        <stop offset="18.61%" stopColor="#7C3900" />
        <stop offset="24.65%" stopColor="#400B00" />
        <stop offset="24.81%" stopColor="#3E0900" />
        <stop offset="45.11%" stopColor="#3E0900" />
        <stop offset="72.93%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__J"
        x1="6.877%"
        x2="107.062%"
        y1="71.838%"
        y2="34.892%"
      >
        <stop offset="9.774%" stopColor="#F7941D" />
        <stop offset="11.71%" stopColor="#E8891C" />
        <stop offset="15.43%" stopColor="#C87217" />
        <stop offset="20.56%" stopColor="#964E05" />
        <stop offset="26.84%" stopColor="#541E00" />
        <stop offset="28.57%" stopColor="#3E0900" />
        <stop offset="63.53%" stopColor="#3E0900" />
        <stop offset="65.88%" stopColor="#511B00" />
        <stop offset="78.36%" stopColor="#A5520D" />
        <stop offset="86.98%" stopColor="#DC741C" />
        <stop offset="90.98%" stopColor="#F58220" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__K"
        x1="-.411%"
        x2="99.696%"
        y1="48.152%"
        y2="48.152%"
      >
        <stop offset="39.47%" stopColor="#F99D1C" />
        <stop offset="44.94%" stopColor="#F0951C" />
        <stop offset="52.94%" stopColor="#DF841B" />
        <stop offset="62.49%" stopColor="#C46917" />
        <stop offset="72.93%" stopColor="#A1490C" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__L"
        x1="3.092%"
        x2="108.375%"
        y1="93.85%"
        y2="10.2%"
      >
        <stop offset="16.17%" stopColor="#FECF8D" />
        <stop offset="20.85%" stopColor="#C69058" />
        <stop offset="25.89%" stopColor="#955D2C" />
        <stop offset="30.53%" stopColor="#723C08" />
        <stop offset="34.61%" stopColor="#572400" />
        <stop offset="37.98%" stopColor="#451200" />
        <stop offset="40.23%" stopColor="#3E0900" />
        <stop offset="67.29%" stopColor="#3E0900" />
        <stop offset="68.84%" stopColor="#4D1800" />
        <stop offset="77.73%" stopColor="#914604" />
        <stop offset="84.96%" stopColor="#C56617" />
        <stop offset="90.18%" stopColor="#E6791E" />
        <stop offset="92.86%" stopColor="#F58220" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__M"
        x1=".249%"
        x2="101.142%"
        y1="51.313%"
        y2="51.313%"
      >
        <stop offset="23.68%" stopColor="#3E0900" />
        <stop offset="26.98%" stopColor="#713300" />
        <stop offset="31.17%" stopColor="#A65A11" />
        <stop offset="34.67%" stopColor="#D0781F" />
        <stop offset="37.28%" stopColor="#EB8B25" />
        <stop offset="38.72%" stopColor="#F79428" />
        <stop offset="52.24%" stopColor="#7B3B00" />
        <stop offset="58.65%" stopColor="#3E0900" />
        <stop offset="77.82%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__N"
        x1="-7.77%"
        x2="76.16%"
        y1="46.043%"
        y2="46.043%"
      >
        <stop offset="22.56%" stopColor="#3E0900" />
        <stop offset="37.3%" stopColor="#AD5F0F" />
        <stop offset="46.24%" stopColor="#F7941D" />
        <stop offset="51.59%" stopColor="#FBAC4A" />
        <stop offset="57.26%" stopColor="#FDC373" />
        <stop offset="62.69%" stopColor="#FFD591" />
        <stop offset="67.76%" stopColor="#FFE3A9" />
        <stop offset="72.32%" stopColor="#FFEBB7" />
        <stop offset="75.94%" stopColor="#FFEEBD" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__O"
        x1="27.237%"
        x2="70.777%"
        y1="123.988%"
        y2="-27%"
      >
        <stop offset="16.54%" stopColor="#3E0900" />
        <stop offset="26.28%" stopColor="#773600" />
        <stop offset="35.5%" stopColor="#A2520C" />
        <stop offset="42.27%" stopColor="#BF6516" />
        <stop offset="45.86%" stopColor="#CA6C18" />
        <stop offset="56.77%" stopColor="#CA6C18" />
        <stop offset="86.77%" stopColor="#5E2500" />
        <stop offset="94.36%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__P"
        x1="-.886%"
        x2="89.353%"
        y1="47.829%"
        y2="47.829%"
      >
        <stop offset="33.83%" stopColor="#F7941D" />
        <stop offset="52.43%" stopColor="#F8991D" />
        <stop offset="77.07%" stopColor="#FAA61A" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__Q"
        x1="-5.167%"
        x2="99.929%"
        y1="77.807%"
        y2="11.54%"
      >
        <stop offset="33.08%" stopColor="#3E0900" />
        <stop offset="35.04%" stopColor="#491400" />
        <stop offset="38.58%" stopColor="#632800" />
        <stop offset="43.28%" stopColor="#884100" />
        <stop offset="48.91%" stopColor="#BE6316" />
        <stop offset="51.88%" stopColor="#DE761C" />
        <stop offset="55.57%" stopColor="#E58E41" />
        <stop offset="61%" stopColor="#EEB175" />
        <stop offset="65.96%" stopColor="#F5CEA1" />
        <stop offset="70.25%" stopColor="#FBE5C5" />
        <stop offset="73.72%" stopColor="#FFF5DE" />
        <stop offset="75.94%" stopColor="#FFFDE9" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__R"
        x1="-13.14%"
        x2="129.138%"
        y1="85.157%"
        y2="14.92%"
      >
        <stop offset="6.391%" stopColor="#F7941D" />
        <stop offset="12.93%" stopColor="#C56F19" />
        <stop offset="21.62%" stopColor="#8B4709" />
        <stop offset="28.85%" stopColor="#652B00" />
        <stop offset="34.26%" stopColor="#491500" />
        <stop offset="37.22%" stopColor="#3E0900" />
        <stop offset="39.84%" stopColor="#501B00" />
        <stop offset="45.21%" stopColor="#783900" />
        <stop offset="52.76%" stopColor="#B66517" />
        <stop offset="59.4%" stopColor="#F7941D" />
        <stop offset="86.09%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__S"
        x1=".391%"
        x2="94.816%"
        y1="99.575%"
        y2="-.963%"
      >
        <stop offset="6.767%" stopColor="#FFEEBD" />
        <stop offset="8.236%" stopColor="#FFECB9" />
        <stop offset="9.758%" stopColor="#FFE5AD" />
        <stop offset="11.31%" stopColor="#FFDA9A" />
        <stop offset="12.87%" stopColor="#FECB81" />
        <stop offset="14.45%" stopColor="#FCB861" />
        <stop offset="16.02%" stopColor="#F9A237" />
        <stop offset="16.92%" stopColor="#F7941D" />
        <stop offset="18.11%" stopColor="#E8891C" />
        <stop offset="20.43%" stopColor="#C67016" />
        <stop offset="23.66%" stopColor="#914A03" />
        <stop offset="27.64%" stopColor="#4A1600" />
        <stop offset="28.2%" stopColor="#3E0900" />
        <stop offset="28.47%" stopColor="#531D00" />
        <stop offset="29.05%" stopColor="#753600" />
        <stop offset="29.68%" stopColor="#914B03" />
        <stop offset="30.37%" stopColor="#AB5D0F" />
        <stop offset="31.12%" stopColor="#C26E15" />
        <stop offset="31.96%" stopColor="#D57B19" />
        <stop offset="32.92%" stopColor="#E3851B" />
        <stop offset="34.09%" stopColor="#ED8D1C" />
        <stop offset="35.67%" stopColor="#F4921D" />
        <stop offset="39.47%" stopColor="#F7941D" />
        <stop offset="40.43%" stopColor="#E8891C" />
        <stop offset="42.29%" stopColor="#C67016" />
        <stop offset="44.87%" stopColor="#914A03" />
        <stop offset="48.05%" stopColor="#4A1600" />
        <stop offset="48.5%" stopColor="#3E0900" />
        <stop offset="48.86%" stopColor="#4E1900" />
        <stop offset="50.04%" stopColor="#753600" />
        <stop offset="51.27%" stopColor="#944D05" />
        <stop offset="52.54%" stopColor="#B16211" />
        <stop offset="53.86%" stopColor="#CA7317" />
        <stop offset="55.25%" stopColor="#DD811A" />
        <stop offset="56.74%" stopColor="#EA8A1C" />
        <stop offset="58.39%" stopColor="#F3911D" />
        <stop offset="60.53%" stopColor="#F7941D" />
        <stop offset="61.92%" stopColor="#E8891C" />
        <stop offset="64.63%" stopColor="#C67016" />
        <stop offset="68.39%" stopColor="#914A03" />
        <stop offset="73.03%" stopColor="#4A1600" />
        <stop offset="73.68%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__T"
        x1="24.936%"
        x2="72.636%"
        y1="108.889%"
        y2="-13.508%"
      >
        <stop offset="0%" stopColor="#F7941D" />
        <stop offset="3.747%" stopColor="#F18F1D" />
        <stop offset="8.139%" stopColor="#E5871C" />
        <stop offset="12.86%" stopColor="#D27919" />
        <stop offset="17.81%" stopColor="#B76612" />
        <stop offset="22.93%" stopColor="#954E05" />
        <stop offset="28.19%" stopColor="#703300" />
        <stop offset="33.46%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__U"
        x1="44.893%"
        x2="44.893%"
        y1="98.882%"
        y2="1.109%"
      >
        <stop offset="0%" stopColor="#F7941D" />
        <stop offset="36.84%" stopColor="#F7941D" />
        <stop offset="39.74%" stopColor="#EE8D1C" />
        <stop offset="44.34%" stopColor="#DB801A" />
        <stop offset="50.05%" stopColor="#BD6A14" />
        <stop offset="56.65%" stopColor="#944D04" />
        <stop offset="63.92%" stopColor="#642A00" />
        <stop offset="68.42%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__V"
        x1="18.683%"
        x2="84.613%"
        y1="95.086%"
        y2="-2.173%"
      >
        <stop offset="12.41%" stopColor="#F58220" />
        <stop offset="14.38%" stopColor="#EF7E1F" />
        <stop offset="16.7%" stopColor="#E3781D" />
        <stop offset="19.2%" stopColor="#D06C1A" />
        <stop offset="21.81%" stopColor="#B65C13" />
        <stop offset="24.52%" stopColor="#954806" />
        <stop offset="27.3%" stopColor="#6F3000" />
        <stop offset="30.08%" stopColor="#3E0900" />
        <stop offset="71.8%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__W"
        x1="18.189%"
        x2="80.497%"
        y1="103.152%"
        y2="-.896%"
      >
        <stop offset="0%" stopColor="#FFEEBD" />
        <stop offset="8.736%" stopColor="#FFEDBA" />
        <stop offset="13.49%" stopColor="#FFEAB3" />
        <stop offset="17.29%" stopColor="#FFE4A7" />
        <stop offset="20.59%" stopColor="#FFDC96" />
        <stop offset="23.52%" stopColor="#FFD281" />
        <stop offset="24.81%" stopColor="#FFCC76" />
        <stop offset="52.26%" stopColor="#7B3400" />
        <stop offset="56.59%" stopColor="#9B5619" />
        <stop offset="61.46%" stopColor="#BC7A37" />
        <stop offset="66.26%" stopColor="#D89B51" />
        <stop offset="70.91%" stopColor="#EBB464" />
        <stop offset="75.34%" stopColor="#F8C471" />
        <stop offset="79.32%" stopColor="#FFCC76" />
        <stop offset="80.64%" stopColor="#FFD589" />
        <stop offset="82.34%" stopColor="#FFDE9B" />
        <stop offset="84.34%" stopColor="#FFE5AA" />
        <stop offset="86.83%" stopColor="#FFEAB5" />
        <stop offset="90.32%" stopColor="#FFEDBB" />
        <stop offset="100%" stopColor="#FFEEBD" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__X"
        x1="5.394%"
        x2="75.569%"
        y1="88.898%"
        y2="1.915%"
      >
        <stop offset="14.29%" stopColor="#F7941D" />
        <stop offset="16.65%" stopColor="#EB8B1C" />
        <stop offset="20.81%" stopColor="#D47A19" />
        <stop offset="26.27%" stopColor="#AC5E0F" />
        <stop offset="32.85%" stopColor="#7A3A00" />
        <stop offset="39.47%" stopColor="#3E0900" />
        <stop offset="42.24%" stopColor="#441000" />
        <stop offset="45.96%" stopColor="#531D00" />
        <stop offset="50.23%" stopColor="#692E00" />
        <stop offset="54.9%" stopColor="#864300" />
        <stop offset="59.9%" stopColor="#AD5E0F" />
        <stop offset="65.09%" stopColor="#DE821B" />
        <stop offset="67.29%" stopColor="#F7941D" />
        <stop offset="70.39%" stopColor="#FBAD4C" />
        <stop offset="73.49%" stopColor="#FDC475" />
        <stop offset="76.47%" stopColor="#FFD692" />
        <stop offset="79.27%" stopColor="#FFE3A9" />
        <stop offset="81.8%" stopColor="#FFEBB7" />
        <stop offset="83.83%" stopColor="#FFEEBD" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__Y"
        x1="49.372%"
        x2="49.372%"
        y1="105.642%"
        y2="3.533%"
      >
        <stop offset="18.8%" stopColor="#F7941D" />
        <stop offset="19.99%" stopColor="#EB8B1C" />
        <stop offset="28.4%" stopColor="#AD5F0F" />
        <stop offset="35.9%" stopColor="#7F3E00" />
        <stop offset="42.22%" stopColor="#5E2600" />
        <stop offset="47.12%" stopColor="#471300" />
        <stop offset="50%" stopColor="#3E0900" />
        <stop offset="52.78%" stopColor="#461300" />
        <stop offset="57.07%" stopColor="#582600" />
        <stop offset="62.35%" stopColor="#754216" />
        <stop offset="68.41%" stopColor="#9B6B40" />
        <stop offset="75.02%" stopColor="#D0AC7B" />
        <stop offset="80.08%" stopColor="#FFEEBD" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__Z"
        x1="-.482%"
        x2="100.899%"
        y1="49.367%"
        y2="49.367%"
      >
        <stop offset="4.887%" stopColor="#DE761C" />
        <stop offset="6.909%" stopColor="#E07C22" />
        <stop offset="18.69%" stopColor="#E99A4D" />
        <stop offset="30.31%" stopColor="#F1B672" />
        <stop offset="41.52%" stopColor="#F7CD8F" />
        <stop offset="52.21%" stopColor="#FCDEA7" />
        <stop offset="62.17%" stopColor="#FFEAB7" />
        <stop offset="70.68%" stopColor="#FFEEBD" />
        <stop offset="95%" stopColor="#F99D1C" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__aa"
        x1="-2.208%"
        x2="99.095%"
        y1="60.292%"
        y2="28.184%"
      >
        <stop offset="9.774%" stopColor="#F7941D" />
        <stop offset="40.98%" stopColor="#CA6C18" />
        <stop offset="84.47%" stopColor="#E9871C" />
        <stop offset="100%" stopColor="#F7941D" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__ab"
        x1="2.821%"
        x2="93.019%"
        y1="101.764%"
        y2="9.821%"
      >
        <stop offset="15.04%" stopColor="#DE761C" />
        <stop offset="29.17%" stopColor="#E99133" />
        <stop offset="44.67%" stopColor="#F3AB4D" />
        <stop offset="57.93%" stopColor="#FABD5E" />
        <stop offset="67.29%" stopColor="#FEC465" />
        <stop offset="74.72%" stopColor="#FEC262" />
        <stop offset="81.26%" stopColor="#FDBB57" />
        <stop offset="87.45%" stopColor="#FBAF45" />
        <stop offset="93.4%" stopColor="#F99F2E" />
        <stop offset="96.99%" stopColor="#F7941D" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__ac"
        x1="-9.11%"
        x2="95.496%"
        y1="26.434%"
        y2="100.518%"
      >
        <stop offset="8.271%" stopColor="#CA6C18" />
        <stop offset="11.29%" stopColor="#E0861A" />
        <stop offset="14.39%" stopColor="#F19C1A" />
        <stop offset="16.54%" stopColor="#FAA61A" />
        <stop offset="50.38%" stopColor="#FFFDE9" />
        <stop offset="52.43%" stopColor="#FFFAE3" />
        <stop offset="54.95%" stopColor="#FFF2D4" />
        <stop offset="57.73%" stopColor="#FFE9BE" />
        <stop offset="60.68%" stopColor="#FFDCA0" />
        <stop offset="63.77%" stopColor="#FECB7C" />
        <stop offset="66.92%" stopColor="#FCB74C" />
        <stop offset="69.55%" stopColor="#FAA61A" />
        <stop offset="78.2%" stopColor="#CA6C18" />
        <stop offset="86.09%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__ad"
        x1="5.884%"
        x2="93.548%"
        y1="79.71%"
        y2="-.06%"
      >
        <stop offset="6.767%" stopColor="#F58220" />
        <stop offset="10.37%" stopColor="#F79337" />
        <stop offset="17.42%" stopColor="#FBB266" />
        <stop offset="24.02%" stopColor="#FECC89" />
        <stop offset="29.98%" stopColor="#FFDEA4" />
        <stop offset="35.08%" stopColor="#FFEAB6" />
        <stop offset="38.72%" stopColor="#FFEEBD" />
        <stop offset="48.89%" stopColor="#F7CE92" />
        <stop offset="65.14%" stopColor="#ECA65D" />
        <stop offset="79.03%" stopColor="#E48B37" />
        <stop offset="89.84%" stopColor="#E07C22" />
        <stop offset="96.24%" stopColor="#DE761C" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__ae"
        x1="-14.888%"
        x2="115.427%"
        y1="22.652%"
        y2="80.207%"
      >
        <stop offset="2.632%" stopColor="#A1490C" />
        <stop offset="3.224%" stopColor="#AC591E" />
        <stop offset="4.31%" stopColor="#BE763C" />
        <stop offset="5.532%" stopColor="#CF925A" />
        <stop offset="6.882%" stopColor="#DEAC74" />
        <stop offset="8.407%" stopColor="#EAC28C" />
        <stop offset="10.19%" stopColor="#F3D4A0" />
        <stop offset="12.39%" stopColor="#FAE2AF" />
        <stop offset="15.48%" stopColor="#FFEBB9" />
        <stop offset="24.06%" stopColor="#FFEEBD" />
        <stop offset="26.32%" stopColor="#FFEDBA" />
        <stop offset="28.19%" stopColor="#FFE8B0" />
        <stop offset="29.93%" stopColor="#FFE1A1" />
        <stop offset="31.58%" stopColor="#FFD78C" />
        <stop offset="33.17%" stopColor="#FFCA72" />
        <stop offset="34.72%" stopColor="#FDBB4F" />
        <stop offset="36.21%" stopColor="#FBA922" />
        <stop offset="36.47%" stopColor="#FAA61A" />
        <stop offset="38.52%" stopColor="#FCB645" />
        <stop offset="40.84%" stopColor="#FEC76C" />
        <stop offset="43.23%" stopColor="#FFD588" />
        <stop offset="45.64%" stopColor="#FFE09E" />
        <stop offset="48.11%" stopColor="#FFE8AF" />
        <stop offset="50.65%" stopColor="#FFECB9" />
        <stop offset="53.38%" stopColor="#FFEEBD" />
        <stop offset="55.72%" stopColor="#FFEAB4" />
        <stop offset="59.64%" stopColor="#FFDF9D" />
        <stop offset="64.66%" stopColor="#FFCE7A" />
        <stop offset="70.51%" stopColor="#FCB645" />
        <stop offset="74.44%" stopColor="#FAA61A" />
        <stop offset="76.17%" stopColor="#FCB647" />
        <stop offset="78.29%" stopColor="#FEC773" />
        <stop offset="80.46%" stopColor="#FFD694" />
        <stop offset="82.67%" stopColor="#FFE3B1" />
        <stop offset="84.9%" stopColor="#FFEDC9" />
        <stop offset="87.19%" stopColor="#FFF5D9" />
        <stop offset="89.55%" stopColor="#FFFBE4" />
        <stop offset="92.11%" stopColor="#FFFDE9" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__af"
        x1="3.181%"
        x2="97.209%"
        y1="78.72%"
        y2="16.42%"
      >
        <stop offset=".752%" stopColor="#F58220" />
        <stop offset="6.712%" stopColor="#F79336" />
        <stop offset="15.17%" stopColor="#FAA856" />
        <stop offset="23.75%" stopColor="#FCB96E" />
        <stop offset="32.37%" stopColor="#FDC57F" />
        <stop offset="41.08%" stopColor="#FECD89" />
        <stop offset="50%" stopColor="#FECF8D" />
        <stop offset="58.54%" stopColor="#FECD8A" />
        <stop offset="65.9%" stopColor="#FDC680" />
        <stop offset="72.81%" stopColor="#FCBB71" />
        <stop offset="79.47%" stopColor="#FAAB5B" />
        <stop offset="85.87%" stopColor="#F8983F" />
        <stop offset="92.11%" stopColor="#F58220" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__ag"
        x1="53.165%"
        x2="53.165%"
        y1="2.395%"
        y2="101.582%"
      >
        <stop offset="21.05%" stopColor="#3E0900" />
        <stop offset="25.1%" stopColor="#743600" />
        <stop offset="29.13%" stopColor="#9F550A" />
        <stop offset="32.8%" stopColor="#C46F16" />
        <stop offset="36.05%" stopColor="#DE821B" />
        <stop offset="38.76%" stopColor="#EF8E1D" />
        <stop offset="40.6%" stopColor="#F7941D" />
        <stop offset="47.16%" stopColor="#FAA63F" />
        <stop offset="58.51%" stopColor="#FDC475" />
        <stop offset="68.17%" stopColor="#FFDB9A" />
        <stop offset="75.67%" stopColor="#FFE9B3" />
        <stop offset="80.08%" stopColor="#FFEEBD" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__ah"
        x1="11.862%"
        x2="89.527%"
        y1="86.219%"
        y2="-14.767%"
      >
        <stop offset="34.59%" stopColor="#F7941D" />
        <stop offset="43.13%" stopColor="#F99E32" />
        <stop offset="61.18%" stopColor="#FBB35B" />
        <stop offset="77.33%" stopColor="#FDC277" />
        <stop offset="90.82%" stopColor="#FECC87" />
        <stop offset="100%" stopColor="#FECF8D" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__ai"
        x1="1.936%"
        x2="99.669%"
        y1="49.902%"
        y2="49.902%"
      >
        <stop offset="8.271%" stopColor="#FFEEBD" />
        <stop offset="14.01%" stopColor="#FFDB9E" />
        <stop offset="24.53%" stopColor="#FCBC70" />
        <stop offset="33.67%" stopColor="#FAA64E" />
        <stop offset="40.96%" stopColor="#F89939" />
        <stop offset="45.49%" stopColor="#F79431" />
        <stop offset="50.09%" stopColor="#F1902F" />
        <stop offset="55.62%" stopColor="#E4872C" />
        <stop offset="61.64%" stopColor="#D17825" />
        <stop offset="68%" stopColor="#B5651B" />
        <stop offset="74.63%" stopColor="#934C0B" />
        <stop offset="81.38%" stopColor="#6C3000" />
        <stop offset="87.59%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__aj"
        x1="-3.59%"
        x2="91.393%"
        y1="24.909%"
        y2="108.734%"
      >
        <stop offset="11.65%" stopColor="#3E0900" />
        <stop offset="19.55%" stopColor="#F7941D" />
        <stop offset="20.02%" stopColor="#F89928" />
        <stop offset="20.9%" stopColor="#FAA747" />
        <stop offset="22.08%" stopColor="#FDBF76" />
        <stop offset="23.5%" stopColor="#FFE1B6" />
        <stop offset="24.44%" stopColor="#FFFDE9" />
        <stop offset="26.92%" stopColor="#FFF3D5" />
        <stop offset="32.02%" stopColor="#FFDFA6" />
        <stop offset="39.23%" stopColor="#FEC161" />
        <stop offset="40.98%" stopColor="#FDBA4D" />
        <stop offset="57.89%" stopColor="#FFF1E2" />
        <stop offset="59.96%" stopColor="#FFEFDE" />
        <stop offset="62.19%" stopColor="#FFE9D2" />
        <stop offset="64.49%" stopColor="#FFE0BF" />
        <stop offset="66.84%" stopColor="#FED3A5" />
        <stop offset="69.23%" stopColor="#FDC385" />
        <stop offset="71.65%" stopColor="#FBB05F" />
        <stop offset="74.05%" stopColor="#F89B2E" />
        <stop offset="74.81%" stopColor="#F7941D" />
        <stop offset="89.47%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__ak"
        x1="100.078%"
        x2="2.857%"
        y1="49.832%"
        y2="49.832%"
      >
        <stop offset="14.66%" stopColor="#F7941D" />
        <stop offset="42.48%" stopColor="#FFEEBD" />
        <stop offset="78.57%" stopColor="#FFFDE9" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__al"
        x1="-.671%"
        x2="100.005%"
        y1="36.27%"
        y2="36.27%"
      >
        <stop offset="11.65%" stopColor="#FAA61A" />
        <stop offset="18.57%" stopColor="#F19E19" />
        <stop offset="29.08%" stopColor="#DF8F18" />
        <stop offset="41.9%" stopColor="#C27714" />
        <stop offset="56.52%" stopColor="#9B5807" />
        <stop offset="72.43%" stopColor="#6E3400" />
        <stop offset="86.09%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__am"
        x1=".386%"
        x2="99.24%"
        y1="49.323%"
        y2="49.323%"
      >
        <stop offset="6.015%" stopColor="#FFFDE9" />
        <stop offset="8.384%" stopColor="#FFF8DD" />
        <stop offset="13.42%" stopColor="#FFF2CB" />
        <stop offset="18.33%" stopColor="#FFEFC0" />
        <stop offset="22.93%" stopColor="#FFEEBD" />
        <stop offset="24.57%" stopColor="#FCE4B0" />
        <stop offset="27.37%" stopColor="#F3CD92" />
        <stop offset="30.98%" stopColor="#E6AC69" />
        <stop offset="35.22%" stopColor="#D48234" />
        <stop offset="37.59%" stopColor="#CA6C18" />
        <stop offset="38.92%" stopColor="#CB6E1B" />
        <stop offset="40.45%" stopColor="#CE7525" />
        <stop offset="42.08%" stopColor="#D38137" />
        <stop offset="43.78%" stopColor="#DB9352" />
        <stop offset="45.54%" stopColor="#E4AC74" />
        <stop offset="47.35%" stopColor="#F0CCA2" />
        <stop offset="49.16%" stopColor="#FFF9E4" />
        <stop offset="49.25%" stopColor="#FFFDE9" />
        <stop offset="50.8%" stopColor="#FFF9E1" />
        <stop offset="53%" stopColor="#FFF1D0" />
        <stop offset="55.59%" stopColor="#FFE5B5" />
        <stop offset="58.49%" stopColor="#FFD591" />
        <stop offset="61.63%" stopColor="#FDC164" />
        <stop offset="64.93%" stopColor="#FBA924" />
        <stop offset="65.41%" stopColor="#FAA61A" />
        <stop offset="65.67%" stopColor="#FBAA25" />
        <stop offset="66.89%" stopColor="#FDBC57" />
        <stop offset="68.17%" stopColor="#FECC7E" />
        <stop offset="69.49%" stopColor="#FFDA9C" />
        <stop offset="70.85%" stopColor="#FFE5B7" />
        <stop offset="72.26%" stopColor="#FFEFCC" />
        <stop offset="73.76%" stopColor="#FFF6DB" />
        <stop offset="75.4%" stopColor="#FFFBE5" />
        <stop offset="77.44%" stopColor="#FFFDE9" />
        <stop offset="78.88%" stopColor="#FFEDCB" />
        <stop offset="82.02%" stopColor="#FECA89" />
        <stop offset="86.59%" stopColor="#F89622" />
        <stop offset="86.84%" stopColor="#F7941D" />
        <stop offset="95.11%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__an"
        x1="-1.503%"
        x2="97.828%"
        y1="100.622%"
        y2="-1.328%"
      >
        <stop offset="11.65%" stopColor="#3E0900" />
        <stop offset="13.19%" stopColor="#461300" />
        <stop offset="23.07%" stopColor="#703500" />
        <stop offset="32.36%" stopColor="#8D4D01" />
        <stop offset="40.79%" stopColor="#A45F0B" />
        <stop offset="48.07%" stopColor="#B26A10" />
        <stop offset="53.38%" stopColor="#B76E11" />
        <stop offset="93.98%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__ao"
        x1="26.121%"
        x2="70.831%"
        y1="-22.508%"
        y2="120.215%"
      >
        <stop offset="11.65%" stopColor="#3E0900" />
        <stop offset="18.12%" stopColor="#824000" />
        <stop offset="28.57%" stopColor="#F79431" />
        <stop offset="30.1%" stopColor="#F9A34E" />
        <stop offset="32.49%" stopColor="#FCBA75" />
        <stop offset="34.98%" stopColor="#FECD95" />
        <stop offset="37.52%" stopColor="#FFDDB2" />
        <stop offset="40.15%" stopColor="#FFEAC9" />
        <stop offset="42.89%" stopColor="#FFF3D9" />
        <stop offset="45.82%" stopColor="#FFFAE4" />
        <stop offset="49.25%" stopColor="#FFFDE9" />
        <stop offset="51.76%" stopColor="#FFF9E2" />
        <stop offset="55.11%" stopColor="#FFF2D2" />
        <stop offset="58.93%" stopColor="#FFE7BA" />
        <stop offset="63.1%" stopColor="#FFD999" />
        <stop offset="67.49%" stopColor="#FEC871" />
        <stop offset="70.68%" stopColor="#FDBA4D" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__ap"
        x1="-15.67%"
        x2="135.271%"
        y1="31.884%"
        y2="72.309%"
      >
        <stop offset="10.53%" stopColor="#3E0900" />
        <stop offset="14.84%" stopColor="#6F3200" />
        <stop offset="20.55%" stopColor="#A55915" />
        <stop offset="25.32%" stopColor="#D07825" />
        <stop offset="28.88%" stopColor="#EA8B2E" />
        <stop offset="30.83%" stopColor="#F79431" />
        <stop offset="33.27%" stopColor="#FAA551" />
        <stop offset="36.69%" stopColor="#FCBB77" />
        <stop offset="40.26%" stopColor="#FECE97" />
        <stop offset="43.93%" stopColor="#FFDEB3" />
        <stop offset="47.73%" stopColor="#FFEAC9" />
        <stop offset="51.73%" stopColor="#FFF3DA" />
        <stop offset="56.05%" stopColor="#FFFAE4" />
        <stop offset="61.28%" stopColor="#FFFDE9" />
        <stop offset="80.08%" stopColor="#FFFDE9" />
        <stop offset="89.1%" stopColor="#F7941D" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__aq"
        x1="-2.444%"
        x2="96.029%"
        y1="49.452%"
        y2="49.452%"
      >
        <stop offset="37.97%" stopColor="#FFFDE9" />
        <stop offset="41.24%" stopColor="#FFF8E1" />
        <stop offset="45.91%" stopColor="#FFEECF" />
        <stop offset="51.42%" stopColor="#FFE0B3" />
        <stop offset="57.56%" stopColor="#FECC8E" />
        <stop offset="64.23%" stopColor="#FBB461" />
        <stop offset="71.25%" stopColor="#F89725" />
        <stop offset="72.18%" stopColor="#F7941D" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__ar"
        x1="39.134%"
        x2="59.276%"
        y1="-8.164%"
        y2="96.575%"
      >
        <stop offset="10.15%" stopColor="#3E0900" />
        <stop offset="32.33%" stopColor="#F7941D" />
        <stop offset="34.28%" stopColor="#FAA440" />
        <stop offset="37.46%" stopColor="#FCBD72" />
        <stop offset="40.54%" stopColor="#FFD399" />
        <stop offset="43.45%" stopColor="#FFE4BA" />
        <stop offset="46.13%" stopColor="#FFF0D2" />
        <stop offset="48.52%" stopColor="#FFF9E2" />
        <stop offset="50.38%" stopColor="#FFFDE9" />
        <stop offset="51.72%" stopColor="#FFF9E1" />
        <stop offset="53.69%" stopColor="#FFF0CF" />
        <stop offset="56.04%" stopColor="#FFE4B3" />
        <stop offset="58.69%" stopColor="#FFD48D" />
        <stop offset="61.55%" stopColor="#FDC05E" />
        <stop offset="62.41%" stopColor="#FDBA4D" />
        <stop offset="80.08%" stopColor="#FFEEBD" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__as"
        x1="-8.912%"
        x2="122.924%"
        y1="36.471%"
        y2="71.274%"
      >
        <stop offset="16.92%" stopColor="#F7941D" />
        <stop offset="27.99%" stopColor="#FCB666" />
        <stop offset="39.57%" stopColor="#FFDAA7" />
        <stop offset="47.82%" stopColor="#FFF1D5" />
        <stop offset="51.88%" stopColor="#FFFDE9" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__at"
        x1="25.236%"
        x2="74.418%"
        y1="81.31%"
        y2="-12.38%"
      >
        <stop offset="0%" stopColor="#3E0900" />
        <stop offset="42.86%" stopColor="#B66113" />
        <stop offset="100%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__au"
        x1="23.013%"
        x2="70.561%"
        y1="-3.93%"
        y2="105.527%"
      >
        <stop offset="6.767%" stopColor="#3E0900" />
        <stop offset="6.85%" stopColor="#400B00" />
        <stop offset="12.26%" stopColor="#9E5409" />
        <stop offset="15.97%" stopColor="#DC801A" />
        <stop offset="17.67%" stopColor="#F7941D" />
        <stop offset="19.01%" stopColor="#FAA440" />
        <stop offset="21.2%" stopColor="#FCBD72" />
        <stop offset="23.31%" stopColor="#FFD399" />
        <stop offset="25.31%" stopColor="#FFE4BA" />
        <stop offset="27.16%" stopColor="#FFF0D2" />
        <stop offset="28.8%" stopColor="#FFF9E2" />
        <stop offset="30.08%" stopColor="#FFFDE9" />
        <stop offset="32.39%" stopColor="#FFF8DF" />
        <stop offset="36.11%" stopColor="#FFEECA" />
        <stop offset="40.78%" stopColor="#FFDFA8" />
        <stop offset="46.22%" stopColor="#FECB7C" />
        <stop offset="52.23%" stopColor="#FCB33F" />
        <stop offset="55.26%" stopColor="#FAA61A" />
        <stop offset="80.83%" stopColor="#FFEEBD" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__av"
        x1="8.024%"
        x2="97.253%"
        y1="-3.907%"
        y2="98.938%"
      >
        <stop offset="4.511%" stopColor="#FFFDE9" />
        <stop offset="8.554%" stopColor="#FFDBA9" />
        <stop offset="13.12%" stopColor="#FCBC70" />
        <stop offset="16.94%" stopColor="#FAA543" />
        <stop offset="19.82%" stopColor="#F89827" />
        <stop offset="21.43%" stopColor="#F7941D" />
        <stop offset="21.75%" stopColor="#F89B2C" />
        <stop offset="22.67%" stopColor="#FBAD54" />
        <stop offset="23.68%" stopColor="#FDBF77" />
        <stop offset="24.77%" stopColor="#FECF93" />
        <stop offset="25.95%" stopColor="#FFDCAC" />
        <stop offset="27.25%" stopColor="#FFE7C1" />
        <stop offset="28.74%" stopColor="#FFF0D2" />
        <stop offset="30.51%" stopColor="#FFF6DE" />
        <stop offset="32.84%" stopColor="#FFFBE6" />
        <stop offset="37.97%" stopColor="#FFFDE9" />
        <stop offset="39.22%" stopColor="#FFF9E2" />
        <stop offset="40.81%" stopColor="#FFF0D3" />
        <stop offset="42.59%" stopColor="#FFE4BB" />
        <stop offset="44.5%" stopColor="#FFD39A" />
        <stop offset="46.51%" stopColor="#FDBE74" />
        <stop offset="48.59%" stopColor="#FAA543" />
        <stop offset="50%" stopColor="#F7941D" />
        <stop offset="50.21%" stopColor="#F89825" />
        <stop offset="51.67%" stopColor="#FBB461" />
        <stop offset="53.06%" stopColor="#FECD8E" />
        <stop offset="54.34%" stopColor="#FFE0B3" />
        <stop offset="55.49%" stopColor="#FFEECF" />
        <stop offset="56.46%" stopColor="#FFF8E1" />
        <stop offset="57.14%" stopColor="#FFFDE9" />
        <stop offset="64.29%" stopColor="#F7941D" />
        <stop offset="66.26%" stopColor="#F99E34" />
        <stop offset="71.22%" stopColor="#FCB96B" />
        <stop offset="75.98%" stopColor="#FED094" />
        <stop offset="80.42%" stopColor="#FFE2B7" />
        <stop offset="84.47%" stopColor="#FFEFD1" />
        <stop offset="88%" stopColor="#FFF8E1" />
        <stop offset="90.6%" stopColor="#FFFDE9" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__aw"
        x1="8.4%"
        x2="90.174%"
        y1="82.676%"
        y2="28.537%"
      >
        <stop offset="12.03%" stopColor="#3E0900" />
        <stop offset="12.6%" stopColor="#410" />
        <stop offset="17.93%" stopColor="#743800" />
        <stop offset="23.25%" stopColor="#995606" />
        <stop offset="28.45%" stopColor="#BA7012" />
        <stop offset="33.51%" stopColor="#D58617" />
        <stop offset="38.37%" stopColor="#E89719" />
        <stop offset="42.96%" stopColor="#F4A11A" />
        <stop offset="46.99%" stopColor="#FAA61A" />
        <stop offset="68.8%" stopColor="#FFEEBD" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__ax"
        x1="-.28%"
        x2="88.937%"
        y1="11.162%"
        y2="99.952%"
      >
        <stop offset="9.023%" stopColor="#3E0900" />
        <stop offset="11.46%" stopColor="#4D1800" />
        <stop offset="16.22%" stopColor="#6E3200" />
        <stop offset="22.85%" stopColor="#A1560A" />
        <stop offset="31.01%" stopColor="#EB8B1C" />
        <stop offset="31.95%" stopColor="#F7941D" />
        <stop offset="40.24%" stopColor="#FBB059" />
        <stop offset="49.71%" stopColor="#FECF92" />
        <stop offset="57.63%" stopColor="#FFE6BF" />
        <stop offset="63.6%" stopColor="#FFF5DC" />
        <stop offset="66.92%" stopColor="#FFFDE9" />
        <stop offset="77.07%" stopColor="#FFFDE9" />
        <stop offset="78.56%" stopColor="#ECDCC3" />
        <stop offset="81.64%" stopColor="#BE9B7A" />
        <stop offset="85.98%" stopColor="#7A4A24" />
        <stop offset="89.47%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__ay"
        x1="48.1%"
        x2="48.1%"
        y1="96.826%"
        y2=".507%"
      >
        <stop offset="6.767%" stopColor="#3E0900" />
        <stop offset="7.184%" stopColor="#430E00" />
        <stop offset="11.99%" stopColor="#6D2F00" />
        <stop offset="17%" stopColor="#8F4403" />
        <stop offset="22.12%" stopColor="#AD5710" />
        <stop offset="27.38%" stopColor="#C66618" />
        <stop offset="32.81%" stopColor="#D9721C" />
        <stop offset="38.5%" stopColor="#E77A1E" />
        <stop offset="44.61%" stopColor="#F07F1F" />
        <stop offset="51.88%" stopColor="#F58220" />
        <stop offset="56.46%" stopColor="#EF7F1F" />
        <stop offset="61.79%" stopColor="#E3781D" />
        <stop offset="67.49%" stopColor="#D16D1A" />
        <stop offset="73.46%" stopColor="#B65D13" />
        <stop offset="79.63%" stopColor="#964906" />
        <stop offset="85.97%" stopColor="#703100" />
        <stop offset="92.35%" stopColor="#3F0B00" />
        <stop offset="92.48%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__az"
        x1="36.824%"
        x2="68.24%"
        y1="138.873%"
        y2="-3.098%"
      >
        <stop offset="7.143%" stopColor="#3E0900" />
        <stop offset="8.678%" stopColor="#632800" />
        <stop offset="10.64%" stopColor="#873F00" />
        <stop offset="12.65%" stopColor="#A7530E" />
        <stop offset="14.69%" stopColor="#C26417" />
        <stop offset="16.75%" stopColor="#D7711B" />
        <stop offset="18.85%" stopColor="#E6791E" />
        <stop offset="21%" stopColor="#F07F1F" />
        <stop offset="23.31%" stopColor="#F58220" />
        <stop offset="23.76%" stopColor="#F78F31" />
        <stop offset="24.57%" stopColor="#F9A451" />
        <stop offset="25.5%" stopColor="#FCB86E" />
        <stop offset="26.51%" stopColor="#FEC985" />
        <stop offset="27.67%" stopColor="#FFD698" />
        <stop offset="29.01%" stopColor="#FFE1A8" />
        <stop offset="30.67%" stopColor="#FFE8B4" />
        <stop offset="33%" stopColor="#FFEDBB" />
        <stop offset="39.47%" stopColor="#FFEEBD" />
        <stop offset="50%" stopColor="#F7941D" />
        <stop offset="63.16%" stopColor="#FFEEBD" />
        <stop offset="72.56%" stopColor="#FFEEBD" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__aA"
        x1="22.09%"
        x2="62.634%"
        y1="7.242%"
        y2="98.828%"
      >
        <stop offset="15.04%" stopColor="#DE761C" />
        <stop offset="33.5%" stopColor="#EE8A29" />
        <stop offset="47.74%" stopColor="#F79431" />
        <stop offset="49.55%" stopColor="#F99E43" />
        <stop offset="55.52%" stopColor="#FCBD7B" />
        <stop offset="60.95%" stopColor="#FFD7A7" />
        <stop offset="65.64%" stopColor="#FFEAC9" />
        <stop offset="69.42%" stopColor="#FFF6DF" />
        <stop offset="71.8%" stopColor="#FFFDE9" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__aB"
        x1="1.849%"
        x2="107.379%"
        y1="16.141%"
        y2="73.876%"
      >
        <stop offset="7.143%" stopColor="#FFFDE9" />
        <stop offset="8.195%" stopColor="#FFF8E1" />
        <stop offset="9.674%" stopColor="#FFF0D0" />
        <stop offset="11.41%" stopColor="#FFE3B5" />
        <stop offset="13.33%" stopColor="#FFD191" />
        <stop offset="15.41%" stopColor="#FDBB65" />
        <stop offset="17.6%" stopColor="#FAA228" />
        <stop offset="18.05%" stopColor="#F99D1C" />
        <stop offset="18.99%" stopColor="#FAA631" />
        <stop offset="21.85%" stopColor="#FDC06C" />
        <stop offset="24.45%" stopColor="#FFD695" />
        <stop offset="26.7%" stopColor="#FFE6B5" />
        <stop offset="28.53%" stopColor="#FFF0CA" />
        <stop offset="29.7%" stopColor="#FFF3D1" />
        <stop offset="32.18%" stopColor="#FFE3AE" />
        <stop offset="39.85%" stopColor="#FCB749" />
        <stop offset="43.23%" stopColor="#FAA61A" />
        <stop offset="43.98%" stopColor="#FBA924" />
        <stop offset="49.04%" stopColor="#FDC164" />
        <stop offset="53.86%" stopColor="#FFD591" />
        <stop offset="58.3%" stopColor="#FFE5B5" />
        <stop offset="62.29%" stopColor="#FFF1D0" />
        <stop offset="65.67%" stopColor="#FFF9E1" />
        <stop offset="68.05%" stopColor="#FFFDE9" />
        <stop offset="70.29%" stopColor="#FFFAE3" />
        <stop offset="72.85%" stopColor="#FFF2D6" />
        <stop offset="75.58%" stopColor="#FFE9C1" />
        <stop offset="78.42%" stopColor="#FFDBA4" />
        <stop offset="81.34%" stopColor="#FECA82" />
        <stop offset="84.34%" stopColor="#FCB558" />
        <stop offset="87.35%" stopColor="#F99F20" />
        <stop offset="87.59%" stopColor="#F99D1C" />
        <stop offset="88.18%" stopColor="#EE941B" />
        <stop offset="89.18%" stopColor="#D78319" />
        <stop offset="90.47%" stopColor="#B46711" />
        <stop offset="92%" stopColor="#854400" />
        <stop offset="93.71%" stopColor="#4A1600" />
        <stop offset="93.98%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__aC"
        x1="18.533%"
        x2="79.383%"
        y1="109.19%"
        y2="-43.99%"
      >
        <stop offset="0%" stopColor="#F7941D" />
        <stop offset="32.33%" stopColor="#F79431" />
        <stop offset="54.14%" stopColor="#F79431" />
        <stop offset="57.04%" stopColor="#EF8E2F" />
        <stop offset="61.31%" stopColor="#DF822A" />
        <stop offset="66.41%" stopColor="#C46F21" />
        <stop offset="72.17%" stopColor="#A05612" />
        <stop offset="78.48%" stopColor="#753700" />
        <stop offset="84.96%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__aD"
        x1="19.906%"
        x2="71.631%"
        y1="106.401%"
        y2="-11.4%"
      >
        <stop offset="27.82%" stopColor="#F7941D" />
        <stop offset="30.56%" stopColor="#F99C2C" />
        <stop offset="35.07%" stopColor="#FAA740" />
        <stop offset="40.41%" stopColor="#FBB050" />
        <stop offset="47.01%" stopColor="#FCB65B" />
        <stop offset="56.26%" stopColor="#FCB961" />
        <stop offset="81.95%" stopColor="#FDBA63" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__aE"
        x1="49.18%"
        x2="49.18%"
        y1="98.847%"
        y2="-.851%"
      >
        <stop offset="15.79%" stopColor="#FFFDE9" />
        <stop offset="18.88%" stopColor="#FFF3D7" />
        <stop offset="24.93%" stopColor="#FFDFB1" />
        <stop offset="33.37%" stopColor="#FDC077" />
        <stop offset="43.77%" stopColor="#F89724" />
        <stop offset="44.74%" stopColor="#F7941D" />
        <stop offset="84.21%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__aG"
        x1="14.262%"
        x2="82.516%"
        y1="-.808%"
        y2="100.424%"
      >
        <stop offset="0%" stopColor="#F7941D" />
        <stop offset=".081%" stopColor="#F89520" />
        <stop offset="1.149%" stopColor="#FAA945" />
        <stop offset="2.298%" stopColor="#FDBB66" />
        <stop offset="3.547%" stopColor="#FECB80" />
        <stop offset="4.909%" stopColor="#FFD895" />
        <stop offset="6.427%" stopColor="#FFE1A6" />
        <stop offset="8.191%" stopColor="#FFE9B3" />
        <stop offset="10.42%" stopColor="#FFEDBA" />
        <stop offset="14.66%" stopColor="#FFEEBD" />
        <stop offset="21.75%" stopColor="#FFECB9" />
        <stop offset="27.55%" stopColor="#FFE7B0" />
        <stop offset="32.88%" stopColor="#FFDEA0" />
        <stop offset="37.94%" stopColor="#FFD18B" />
        <stop offset="42.82%" stopColor="#FDC171" />
        <stop offset="47.54%" stopColor="#FBAE4F" />
        <stop offset="52.07%" stopColor="#F89825" />
        <stop offset="53.01%" stopColor="#F7941D" />
        <stop offset="53.62%" stopColor="#F89621" />
        <stop offset="59.42%" stopColor="#FBAC4B" />
        <stop offset="65.44%" stopColor="#FDC06F" />
        <stop offset="71.61%" stopColor="#FFD189" />
        <stop offset="77.97%" stopColor="#FFDD9F" />
        <stop offset="84.6%" stopColor="#FFE7AF" />
        <stop offset="91.69%" stopColor="#FFECB9" />
        <stop offset="100%" stopColor="#FFEEBD" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__aH"
        x1="-1.394%"
        x2="98.406%"
        y1="48.236%"
        y2="48.236%"
      >
        <stop offset="0%" stopColor="#F7941D" />
        <stop offset="32.33%" stopColor="#F79431" />
        <stop offset="35.43%" stopColor="#F9A147" />
        <stop offset="40.62%" stopColor="#FCB566" />
        <stop offset="46.34%" stopColor="#FEC780" />
        <stop offset="52.61%" stopColor="#FFD595" />
        <stop offset="59.66%" stopColor="#FFE0A6" />
        <stop offset="67.94%" stopColor="#FFE8B3" />
        <stop offset="78.59%" stopColor="#FFEDBA" />
        <stop offset="100%" stopColor="#FFEEBD" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__aI"
        x1="2.95%"
        x2="98.089%"
        y1="100.05%"
        y2="-7.042%"
      >
        <stop offset="9.023%" stopColor="#FFEEBD" />
        <stop offset="12.17%" stopColor="#FFECB9" />
        <stop offset="15.33%" stopColor="#FFE5AD" />
        <stop offset="18.49%" stopColor="#FFDB9B" />
        <stop offset="21.66%" stopColor="#FECC83" />
        <stop offset="24.84%" stopColor="#FCBA64" />
        <stop offset="27.97%" stopColor="#FAA43B" />
        <stop offset="30.08%" stopColor="#F7941D" />
        <stop offset="37.74%" stopColor="#FAA33B" />
        <stop offset="50.94%" stopColor="#FDBD6A" />
        <stop offset="63.35%" stopColor="#FFD28C" />
        <stop offset="74.6%" stopColor="#FFE1A6" />
        <stop offset="84.31%" stopColor="#FFEBB7" />
        <stop offset="91.35%" stopColor="#FFEEBD" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__aJ"
        x1="16.564%"
        x2="70.403%"
        y1="-8.037%"
        y2="121.005%"
      >
        <stop offset="20.3%" stopColor="#FFFDE9" />
        <stop offset="25.15%" stopColor="#FFF2D7" />
        <stop offset="34.74%" stopColor="#FFDEAF" />
        <stop offset="48.16%" stopColor="#FDBE74" />
        <stop offset="64.76%" stopColor="#F8941F" />
        <stop offset="65.04%" stopColor="#F7941D" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__aK"
        x1="10.829%"
        x2="84.383%"
        y1="3.493%"
        y2="89.288%"
      >
        <stop offset="14.66%" stopColor="#F7941D" />
        <stop offset="21.43%" stopColor="#FBB059" />
        <stop offset="28.05%" stopColor="#FECA89" />
        <stop offset="34.11%" stopColor="#FFDEB0" />
        <stop offset="39.47%" stopColor="#FFEECD" />
        <stop offset="43.95%" stopColor="#FFF8E0" />
        <stop offset="46.99%" stopColor="#FFFDE9" />
        <stop offset="50.31%" stopColor="#FFF6DD" />
        <stop offset="56.07%" stopColor="#FFE8C2" />
        <stop offset="63.59%" stopColor="#FFD399" />
        <stop offset="72.56%" stopColor="#FCB665" />
        <stop offset="82.71%" stopColor="#F7941D" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__aL"
        x1="4.244%"
        x2="88.061%"
        y1="74.792%"
        y2="5%"
      >
        <stop offset="16.54%" stopColor="#3E0900" />
        <stop offset="17.69%" stopColor="#4F1D00" />
        <stop offset="20.7%" stopColor="#73401C" />
        <stop offset="24.02%" stopColor="#91613B" />
        <stop offset="27.59%" stopColor="#AD8158" />
        <stop offset="31.48%" stopColor="#C6A073" />
        <stop offset="35.79%" stopColor="#DBBA8B" />
        <stop offset="40.7%" stopColor="#EACFA0" />
        <stop offset="46.57%" stopColor="#F6DFAF" />
        <stop offset="54.36%" stopColor="#FEEAB9" />
        <stop offset="71.8%" stopColor="#FFEEBD" />
        <stop offset="74.76%" stopColor="#FDE8B7" />
        <stop offset="76.85%" stopColor="#F3DCAB" />
        <stop offset="78.66%" stopColor="#E6C997" />
        <stop offset="80.33%" stopColor="#D3AF7E" />
        <stop offset="81.89%" stopColor="#BA9061" />
        <stop offset="83.38%" stopColor="#9C6D41" />
        <stop offset="84.8%" stopColor="#7C4A1E" />
        <stop offset="86.14%" stopColor="#572500" />
        <stop offset="86.84%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__aM"
        x1="3.037%"
        x2="74.78%"
        y1="-2.094%"
        y2="97.047%"
      >
        <stop offset="19.17%" stopColor="#3E0900" />
        <stop offset="22.5%" stopColor="#4D1800" />
        <stop offset="29.05%" stopColor="#703300" />
        <stop offset="38.21%" stopColor="#A4580C" />
        <stop offset="49.53%" stopColor="#F2901D" />
        <stop offset="50%" stopColor="#F7941D" />
        <stop offset="72.18%" stopColor="#FFFDE9" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__aN"
        x1="6.537%"
        x2="65.145%"
        y1="7.775%"
        y2="104.067%"
      >
        <stop offset="4.511%" stopColor="#3E0900" />
        <stop offset="18.95%" stopColor="#400C00" />
        <stop offset="27.64%" stopColor="#481400" />
        <stop offset="34.8%" stopColor="#551D00" />
        <stop offset="41.14%" stopColor="#652900" />
        <stop offset="46.93%" stopColor="#783600" />
        <stop offset="52.33%" stopColor="#904503" />
        <stop offset="57.41%" stopColor="#AD5710" />
        <stop offset="62.13%" stopColor="#D06C1A" />
        <stop offset="66.17%" stopColor="#F58220" />
        <stop offset="66.53%" stopColor="#F68624" />
        <stop offset="69.48%" stopColor="#F9A450" />
        <stop offset="72.38%" stopColor="#FCBE76" />
        <stop offset="75.16%" stopColor="#FFD393" />
        <stop offset="77.81%" stopColor="#FFE2A9" />
        <stop offset="80.27%" stopColor="#FFEBB8" />
        <stop offset="82.33%" stopColor="#FFEEBD" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__aO"
        x1="90.151%"
        x2="-3.281%"
        y1="92.956%"
        y2="17.35%"
      >
        <stop offset="4.511%" stopColor="#F58220" />
        <stop offset="5.28%" stopColor="#F78F31" />
        <stop offset="6.69%" stopColor="#F9A451" />
        <stop offset="8.277%" stopColor="#FCB86E" />
        <stop offset="10.03%" stopColor="#FEC985" />
        <stop offset="12.01%" stopColor="#FFD698" />
        <stop offset="14.32%" stopColor="#FFE1A8" />
        <stop offset="17.18%" stopColor="#FFE8B4" />
        <stop offset="21.19%" stopColor="#FFEDBB" />
        <stop offset="32.33%" stopColor="#FFEEBD" />
        <stop offset="39.54%" stopColor="#FFD495" />
        <stop offset="49.39%" stopColor="#FCB66B" />
        <stop offset="58.73%" stopColor="#F99F49" />
        <stop offset="67.29%" stopColor="#F78F31" />
        <stop offset="74.8%" stopColor="#F68523" />
        <stop offset="80.45%" stopColor="#F58220" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__aP"
        x1="32.012%"
        x2="69.614%"
        y1="-6.998%"
        y2="104.103%"
      >
        <stop offset="9.774%" stopColor="#3E0900" />
        <stop offset="11.62%" stopColor="#5C2800" />
        <stop offset="15.16%" stopColor="#89511B" />
        <stop offset="18.59%" stopColor="#B0783A" />
        <stop offset="21.8%" stopColor="#D19A55" />
        <stop offset="24.75%" stopColor="#E8B568" />
        <stop offset="27.35%" stopColor="#F7C675" />
        <stop offset="29.32%" stopColor="#FFCE7B" />
        <stop offset="46.98%" stopColor="#FCCB78" />
        <stop offset="54.77%" stopColor="#F4C272" />
        <stop offset="60.62%" stopColor="#E9B668" />
        <stop offset="65.5%" stopColor="#D9A55B" />
        <stop offset="69.78%" stopColor="#C59049" />
        <stop offset="73.64%" stopColor="#AD7735" />
        <stop offset="77.18%" stopColor="#915C1E" />
        <stop offset="80.37%" stopColor="#744100" />
        <stop offset="83.08%" stopColor="#552500" />
        <stop offset="97.74%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__aQ"
        x1="50.009%"
        x2="50.009%"
        y1="-1.869%"
        y2="99.518%"
      >
        <stop offset="22.56%" stopColor="#3E0900" />
        <stop offset="23.37%" stopColor="#4C1700" />
        <stop offset="27.76%" stopColor="#864300" />
        <stop offset="31.68%" stopColor="#B46412" />
        <stop offset="35%" stopColor="#D77D1A" />
        <stop offset="37.57%" stopColor="#EC8C1C" />
        <stop offset="39.1%" stopColor="#F7941D" />
        <stop offset="39.76%" stopColor="#F89927" />
        <stop offset="43.95%" stopColor="#FDBC68" />
        <stop offset="47.44%" stopColor="#FFD794" />
        <stop offset="50.06%" stopColor="#FFE8B1" />
        <stop offset="51.5%" stopColor="#FFEEBD" />
        <stop offset="53.71%" stopColor="#FFECB8" />
        <stop offset="56.2%" stopColor="#FFE6AC" />
        <stop offset="58.84%" stopColor="#FFDD98" />
        <stop offset="61.57%" stopColor="#FFD07E" />
        <stop offset="64.38%" stopColor="#FDBF5A" />
        <stop offset="67.21%" stopColor="#FBAC2A" />
        <stop offset="68.05%" stopColor="#FAA61A" />
        <stop offset="78.35%" stopColor="#F7A41A" />
        <stop offset="82.06%" stopColor="#F09E1A" />
        <stop offset="84.71%" stopColor="#E6951B" />
        <stop offset="86.85%" stopColor="#D8891A" />
        <stop offset="88.68%" stopColor="#C67A19" />
        <stop offset="90.3%" stopColor="#AF6714" />
        <stop offset="91.77%" stopColor="#95530D" />
        <stop offset="93.12%" stopColor="#793D00" />
        <stop offset="94.32%" stopColor="#5A2400" />
        <stop offset="95.11%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__aR"
        x1="-3.56%"
        x2="73.4%"
        y1="80.976%"
        y2="11.029%"
      >
        <stop offset="20.68%" stopColor="#3E0900" />
        <stop offset="38.95%" stopColor="#8C4701" />
        <stop offset="57.22%" stopColor="#D77C19" />
        <stop offset="65.41%" stopColor="#F7941D" />
        <stop offset="83.83%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__aS"
        x1=".792%"
        x2="101.8%"
        y1="36.76%"
        y2="36.76%"
      >
        <stop offset="25.94%" stopColor="#FFEEBD" />
        <stop offset="28.1%" stopColor="#FFEAB7" />
        <stop offset="30.86%" stopColor="#FFDFA7" />
        <stop offset="33.93%" stopColor="#FECE8E" />
        <stop offset="37.24%" stopColor="#FBB56F" />
        <stop offset="40.69%" stopColor="#F89746" />
        <stop offset="42.86%" stopColor="#F5822B" />
        <stop offset="44.18%" stopColor="#ED7E29" />
        <stop offset="46%" stopColor="#DF7526" />
        <stop offset="48.12%" stopColor="#C8681F" />
        <stop offset="50.45%" stopColor="#A85413" />
        <stop offset="52.96%" stopColor="#813B00" />
        <stop offset="55.58%" stopColor="#511B00" />
        <stop offset="56.39%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__aT"
        x1="23.873%"
        x2="76.062%"
        y1="94.107%"
        y2="-21.564%"
      >
        <stop offset="19.55%" stopColor="#3E0900" />
        <stop offset="20.98%" stopColor="#4B1600" />
        <stop offset="30.76%" stopColor="#914B03" />
        <stop offset="38.71%" stopColor="#C67016" />
        <stop offset="44.43%" stopColor="#E8891C" />
        <stop offset="47.37%" stopColor="#F7941D" />
        <stop offset="48.55%" stopColor="#E8891C" />
        <stop offset="53.36%" stopColor="#BB6813" />
        <stop offset="58.2%" stopColor="#944D05" />
        <stop offset="62.95%" stopColor="#773800" />
        <stop offset="67.61%" stopColor="#602700" />
        <stop offset="72.14%" stopColor="#4E1900" />
        <stop offset="76.49%" stopColor="#420E00" />
        <stop offset="80.45%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__aV"
        x1=".416%"
        x2="110.583%"
        y1="24.845%"
        y2="64.674%"
      >
        <stop offset="0%" stopColor="#FFEEBD" />
        <stop offset="3.273%" stopColor="#FFECB9" />
        <stop offset="6.772%" stopColor="#FFE7AD" />
        <stop offset="10.38%" stopColor="#FFDE9A" />
        <stop offset="14.06%" stopColor="#FFD281" />
        <stop offset="17.8%" stopColor="#FEC260" />
        <stop offset="21.53%" stopColor="#FBAF33" />
        <stop offset="23.31%" stopColor="#FAA61A" />
        <stop offset="23.67%" stopColor="#FBAF31" />
        <stop offset="24.34%" stopColor="#FDBD55" />
        <stop offset="25.09%" stopColor="#FFCA72" />
        <stop offset="25.92%" stopColor="#FFD589" />
        <stop offset="26.85%" stopColor="#FFDE9B" />
        <stop offset="27.95%" stopColor="#FFE5AA" />
        <stop offset="29.3%" stopColor="#FFEAB5" />
        <stop offset="31.2%" stopColor="#FFEDBB" />
        <stop offset="36.47%" stopColor="#FFEEBD" />
        <stop offset="37.91%" stopColor="#FFEBB7" />
        <stop offset="39.76%" stopColor="#FFE4A9" />
        <stop offset="41.82%" stopColor="#FFD791" />
        <stop offset="44.04%" stopColor="#FEC673" />
        <stop offset="46.37%" stopColor="#FBB049" />
        <stop offset="47.37%" stopColor="#FAA634" />
        <stop offset="48.72%" stopColor="#FBAC41" />
        <stop offset="54.03%" stopColor="#FEC36E" />
        <stop offset="59.06%" stopColor="#FFD68F" />
        <stop offset="63.65%" stopColor="#FFE3A7" />
        <stop offset="67.67%" stopColor="#FFEBB7" />
        <stop offset="70.68%" stopColor="#FFEEBD" />
        <stop offset="70.8%" stopColor="#FFEDBA" />
        <stop offset="73.13%" stopColor="#FFD497" />
        <stop offset="75.5%" stopColor="#FDC07F" />
        <stop offset="77.87%" stopColor="#FBB26E" />
        <stop offset="80.27%" stopColor="#FAAA64" />
        <stop offset="82.71%" stopColor="#FAA860" />
        <stop offset="83.74%" stopColor="#F09F5A" />
        <stop offset="85.39%" stopColor="#DC8E4D" />
        <stop offset="87.46%" stopColor="#BD7438" />
        <stop offset="89.85%" stopColor="#93511C" />
        <stop offset="92.49%" stopColor="#612A00" />
        <stop offset="93.98%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__aW"
        x1="6.635%"
        x2="93.857%"
        y1="-11.33%"
        y2="111.4%"
      >
        <stop offset="23.31%" stopColor="#FFEEBD" />
        <stop offset="27.44%" stopColor="#FFE7B2" />
        <stop offset="31.54%" stopColor="#FFD290" />
        <stop offset="36.69%" stopColor="#FCBB6F" />
        <stop offset="41.8%" stopColor="#FAAA54" />
        <stop offset="46.78%" stopColor="#F99D40" />
        <stop offset="51.59%" stopColor="#F89635" />
        <stop offset="56.02%" stopColor="#F79431" />
        <stop offset="59.34%" stopColor="#F9A44A" />
        <stop offset="64.58%" stopColor="#FCBA6D" />
        <stop offset="70.03%" stopColor="#FECD88" />
        <stop offset="75.65%" stopColor="#FFDB9E" />
        <stop offset="81.51%" stopColor="#FFE6AF" />
        <stop offset="87.77%" stopColor="#FFECB9" />
        <stop offset="95.11%" stopColor="#FFEEBD" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__aX"
        x1="61.456%"
        x2="35.663%"
        y1="2.08%"
        y2="94.12%"
      >
        <stop offset="0%" stopColor="#F7941D" />
        <stop offset="6.974%" stopColor="#FAA742" />
        <stop offset="20.46%" stopColor="#FECD83" />
        <stop offset="30.13%" stopColor="#FFE5AC" />
        <stop offset="34.96%" stopColor="#FFEEBD" />
        <stop offset="54.89%" stopColor="#F7941D" />
        <stop offset="58%" stopColor="#F08F1D" />
        <stop offset="61.92%" stopColor="#E3861B" />
        <stop offset="66.28%" stopColor="#CE7718" />
        <stop offset="70.95%" stopColor="#B16211" />
        <stop offset="75.88%" stopColor="#8D4801" />
        <stop offset="80.95%" stopColor="#642A00" />
        <stop offset="84.59%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__aY"
        x1="15.859%"
        x2="72.625%"
        y1="-7.365%"
        y2="104.618%"
      >
        <stop offset="7.143%" stopColor="#3E0900" />
        <stop offset="12.24%" stopColor="#874400" />
        <stop offset="16.68%" stopColor="#C16D15" />
        <stop offset="19.84%" stopColor="#E6881C" />
        <stop offset="21.43%" stopColor="#F7941D" />
        <stop offset="22.94%" stopColor="#FAA541" />
        <stop offset="24.83%" stopColor="#FCB869" />
        <stop offset="26.87%" stopColor="#FEC988" />
        <stop offset="29.02%" stopColor="#FFD8A4" />
        <stop offset="31.32%" stopColor="#FFE5BC" />
        <stop offset="33.83%" stopColor="#FFEECF" />
        <stop offset="36.65%" stopColor="#FFF5DC" />
        <stop offset="40.03%" stopColor="#FFFBE5" />
        <stop offset="45.49%" stopColor="#FFFDE9" />
        <stop offset="53.67%" stopColor="#FFFBE6" />
        <stop offset="56.62%" stopColor="#FFF6DF" />
        <stop offset="58.72%" stopColor="#FFF0D3" />
        <stop offset="60.42%" stopColor="#FFE7C3" />
        <stop offset="61.88%" stopColor="#FFDCAF" />
        <stop offset="63.17%" stopColor="#FECE97" />
        <stop offset="64.33%" stopColor="#FCBE7C" />
        <stop offset="65.41%" stopColor="#FAAB5D" />
        <stop offset="66.36%" stopColor="#F89839" />
        <stop offset="66.54%" stopColor="#F79431" />
        <stop offset="68.28%" stopColor="#E98A2D" />
        <stop offset="71.56%" stopColor="#CB7423" />
        <stop offset="76.05%" stopColor="#9B5210" />
        <stop offset="81.52%" stopColor="#5E2600" />
        <stop offset="83.83%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__aZ"
        x1="83.23%"
        x2="-2.79%"
        y1="24.653%"
        y2="79.935%"
      >
        <stop offset="0%" stopColor="#F7941D" />
        <stop offset="4.323%" stopColor="#F89621" />
        <stop offset="9.741%" stopColor="#F99D2F" />
        <stop offset="15.75%" stopColor="#FAAA47" />
        <stop offset="22.17%" stopColor="#FDBC68" />
        <stop offset="28.86%" stopColor="#FFD38E" />
        <stop offset="35.34%" stopColor="#FFEEBD" />
        <stop offset="39.01%" stopColor="#FFEBB7" />
        <stop offset="43.57%" stopColor="#FFE2A8" />
        <stop offset="48.6%" stopColor="#FFD391" />
        <stop offset="53.97%" stopColor="#FDBE73" />
        <stop offset="59.56%" stopColor="#FAA44B" />
        <stop offset="62.78%" stopColor="#F79431" />
        <stop offset="65.85%" stopColor="#CA7423" />
        <stop offset="69.92%" stopColor="#98500E" />
        <stop offset="73.63%" stopColor="#743600" />
        <stop offset="76.87%" stopColor="#582100" />
        <stop offset="79.5%" stopColor="#461100" />
        <stop offset="81.2%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__ba"
        x1="-2.88%"
        x2="83.73%"
        y1="76.017%"
        y2="19.475%"
      >
        <stop offset="16.92%" stopColor="#3E0900" />
        <stop offset="18.31%" stopColor="#5D2400" />
        <stop offset="20.52%" stopColor="#833D07" />
        <stop offset="22.78%" stopColor="#A3511D" />
        <stop offset="25.04%" stopColor="#C0632B" />
        <stop offset="27.31%" stopColor="#D67036" />
        <stop offset="29.58%" stopColor="#E67A3D" />
        <stop offset="31.88%" stopColor="#F08042" />
        <stop offset="34.21%" stopColor="#F58344" />
        <stop offset="35.98%" stopColor="#F58235" />
        <stop offset="38.1%" stopColor="#F58228" />
        <stop offset="40.48%" stopColor="#F58221" />
        <stop offset="43.61%" stopColor="#F58220" />
        <stop offset="49.98%" stopColor="#F58223" />
        <stop offset="55.64%" stopColor="#F5822B" />
        <stop offset="59.04%" stopColor="#F07F2A" />
        <stop offset="62.47%" stopColor="#E57927" />
        <stop offset="65.91%" stopColor="#D57023" />
        <stop offset="69.37%" stopColor="#BF621C" />
        <stop offset="72.83%" stopColor="#A25011" />
        <stop offset="76.3%" stopColor="#813B00" />
        <stop offset="79.72%" stopColor="#5A2100" />
        <stop offset="81.58%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__bb"
        x1="20.257%"
        x2="76.084%"
        y1="-2.001%"
        y2="99.853%"
      >
        <stop offset="7.143%" stopColor="#3E0900" />
        <stop offset="7.183%" stopColor="#400B00" />
        <stop offset="8.246%" stopColor="#6C2E00" />
        <stop offset="9.348%" stopColor="#8E4402" />
        <stop offset="10.48%" stopColor="#AC5610" />
        <stop offset="11.63%" stopColor="#C56617" />
        <stop offset="12.82%" stopColor="#D9721C" />
        <stop offset="14.06%" stopColor="#E77A1E" />
        <stop offset="15.38%" stopColor="#F07F1F" />
        <stop offset="16.92%" stopColor="#F58220" />
        <stop offset="23.75%" stopColor="#F8993A" />
        <stop offset="31.53%" stopColor="#FBB056" />
        <stop offset="39.19%" stopColor="#FDC16B" />
        <stop offset="46.57%" stopColor="#FFCB77" />
        <stop offset="53.38%" stopColor="#FFCE7B" />
        <stop offset="56.77%" stopColor="#FECA76" />
        <stop offset="60.72%" stopColor="#FDBF69" />
        <stop offset="64.97%" stopColor="#FBAD53" />
        <stop offset="69.39%" stopColor="#F79535" />
        <stop offset="69.55%" stopColor="#F79434" />
        <stop offset="71.5%" stopColor="#F19032" />
        <stop offset="73.65%" stopColor="#E6872E" />
        <stop offset="75.89%" stopColor="#D47928" />
        <stop offset="78.2%" stopColor="#BB661E" />
        <stop offset="80.56%" stopColor="#9B4F0F" />
        <stop offset="82.93%" stopColor="#783500" />
        <stop offset="83.83%" stopColor="#692A00" />
        <stop offset="84.42%" stopColor="#7E4111" />
        <stop offset="85.26%" stopColor="#996239" />
        <stop offset="86.15%" stopColor="#B3845D" />
        <stop offset="87.1%" stopColor="#CAA480" />
        <stop offset="88.1%" stopColor="#DDC1A1" />
        <stop offset="89.18%" stopColor="#EBD8BD" />
        <stop offset="90.39%" stopColor="#F5EAD3" />
        <stop offset="91.81%" stopColor="#FDF7E2" />
        <stop offset="93.98%" stopColor="#FFFDE9" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__bc"
        x1="-1.06%"
        x2="97.555%"
        y1="46.857%"
        y2="46.857%"
      >
        <stop offset="8.271%" stopColor="#3E0900" />
        <stop offset="9.19%" stopColor="#522100" />
        <stop offset="11.65%" stopColor="#7D4D28" />
        <stop offset="14.14%" stopColor="#A27855" />
        <stop offset="16.6%" stopColor="#C3A181" />
        <stop offset="19.03%" stopColor="#DCC5A9" />
        <stop offset="21.42%" stopColor="#EFE0C8" />
        <stop offset="23.74%" stopColor="#FAF3DE" />
        <stop offset="25.94%" stopColor="#FFFDE9" />
        <stop offset="37.22%" stopColor="#F7941D" />
        <stop offset="38.58%" stopColor="#F89A2A" />
        <stop offset="44.88%" stopColor="#FCB564" />
        <stop offset="50.9%" stopColor="#FECE90" />
        <stop offset="56.46%" stopColor="#FFE1B4" />
        <stop offset="61.47%" stopColor="#FFEFCF" />
        <stop offset="65.75%" stopColor="#FFF8E1" />
        <stop offset="68.8%" stopColor="#FFFDE9" />
        <stop offset="71.05%" stopColor="#F5EAD4" />
        <stop offset="74.84%" stopColor="#DEC7AC" />
        <stop offset="79.7%" stopColor="#B99573" />
        <stop offset="85.45%" stopColor="#895A36" />
        <stop offset="91.89%" stopColor="#4D1C00" />
        <stop offset="93.23%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__bd"
        x1=".572%"
        x2="99.918%"
        y1="45.348%"
        y2="45.348%"
      >
        <stop offset="5.263%" stopColor="#3E0900" />
        <stop offset="9.774%" stopColor="#F79548" />
        <stop offset="9.883%" stopColor="#F8974C" />
        <stop offset="10.78%" stopColor="#FAAD6E" />
        <stop offset="11.77%" stopColor="#FCC28B" />
        <stop offset="12.83%" stopColor="#FED3A6" />
        <stop offset="13.99%" stopColor="#FFE1BD" />
        <stop offset="15.29%" stopColor="#FFEDCF" />
        <stop offset="16.8%" stopColor="#FFF5DD" />
        <stop offset="18.74%" stopColor="#FFFBE6" />
        <stop offset="22.56%" stopColor="#FFFDE9" />
        <stop offset="32.33%" stopColor="#FFFDE9" />
        <stop offset="36.56%" stopColor="#FFECCD" />
        <stop offset="46.01%" stopColor="#FED19B" />
        <stop offset="55.23%" stopColor="#FCBA76" />
        <stop offset="64.01%" stopColor="#FAA958" />
        <stop offset="72.24%" stopColor="#F99D42" />
        <stop offset="79.7%" stopColor="#F89635" />
        <stop offset="85.71%" stopColor="#F79430" />
        <stop offset="86.48%" stopColor="#F08F2E" />
        <stop offset="87.48%" stopColor="#E2852A" />
        <stop offset="88.61%" stopColor="#CC7523" />
        <stop offset="89.83%" stopColor="#AE5F18" />
        <stop offset="91.14%" stopColor="#884404" />
        <stop offset="92.49%" stopColor="#5D2500" />
        <stop offset="93.23%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__be"
        x1="-4.556%"
        x2="100.484%"
        y1="24.457%"
        y2="84.275%"
      >
        <stop offset="13.91%" stopColor="#FFEEBD" />
        <stop offset="16.61%" stopColor="#FFE9B4" />
        <stop offset="21%" stopColor="#FFDC9D" />
        <stop offset="26.56%" stopColor="#FEC87B" />
        <stop offset="32.98%" stopColor="#FBAC4B" />
        <stop offset="38.35%" stopColor="#F7941D" />
        <stop offset="43.61%" stopColor="#F7941D" />
        <stop offset="46.38%" stopColor="#F9A034" />
        <stop offset="51.26%" stopColor="#FCB45A" />
        <stop offset="56.46%" stopColor="#FEC678" />
        <stop offset="61.95%" stopColor="#FFD490" />
        <stop offset="67.82%" stopColor="#FFE0A3" />
        <stop offset="74.26%" stopColor="#FFE8B1" />
        <stop offset="81.71%" stopColor="#FFECBA" />
        <stop offset="92.48%" stopColor="#FFEEBD" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__bf"
        x1="87.819%"
        x2="38.929%"
        y1="97.786%"
        y2="-1.239%"
      >
        <stop offset="2.256%" stopColor="#FFEEBD" />
        <stop offset="10.71%" stopColor="#FFEEBD" />
        <stop offset="10.9%" stopColor="#FFEEBD" />
        <stop offset="21.57%" stopColor="#FFEEBD" />
        <stop offset="21.8%" stopColor="#FFEEBD" />
        <stop offset="27.61%" stopColor="#FFECB9" />
        <stop offset="33.19%" stopColor="#FFE6AE" />
        <stop offset="38.69%" stopColor="#FFDC9C" />
        <stop offset="44.13%" stopColor="#FFCE85" />
        <stop offset="49.53%" stopColor="#FDBC67" />
        <stop offset="54.83%" stopColor="#FAA640" />
        <stop offset="59.02%" stopColor="#F7941D" />
        <stop offset="62.84%" stopColor="#F2901D" />
        <stop offset="66.4%" stopColor="#E8891C" />
        <stop offset="69.86%" stopColor="#D97E1A" />
        <stop offset="73.26%" stopColor="#C36F16" />
        <stop offset="76.61%" stopColor="#A85B0D" />
        <stop offset="79.94%" stopColor="#840" />
        <stop offset="83.17%" stopColor="#642A00" />
        <stop offset="85.71%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__bg"
        x1=".834%"
        x2="100.299%"
        y1="50.193%"
        y2="50.193%"
      >
        <stop offset="0%" stopColor="#F7941D" />
        <stop offset="0%" stopColor="#F8971D" />
        <stop offset="0%" stopColor="#F99B1C" />
        <stop offset="0%" stopColor="#F99D1C" />
        <stop offset="2.426%" stopColor="#F9A124" />
        <stop offset="16.21%" stopColor="#FCB755" />
        <stop offset="29.8%" stopColor="#FECB7B" />
        <stop offset="42.92%" stopColor="#FFDA96" />
        <stop offset="55.43%" stopColor="#FFE5AB" />
        <stop offset="67.1%" stopColor="#FFECB8" />
        <stop offset="77.07%" stopColor="#FFEEBD" />
        <stop offset="80.3%" stopColor="#FCE8B7" />
        <stop offset="83%" stopColor="#F2DAA9" />
        <stop offset="85.51%" stopColor="#E3C593" />
        <stop offset="87.9%" stopColor="#CDA878" />
        <stop offset="90.21%" stopColor="#B28658" />
        <stop offset="92.46%" stopColor="#926236" />
        <stop offset="94.66%" stopColor="#6F3C0E" />
        <stop offset="96.77%" stopColor="#410" />
        <stop offset="96.99%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__bh"
        x1="27.938%"
        x2="72.354%"
        y1="116.65%"
        y2="-10.39%"
      >
        <stop offset=".752%" stopColor="#3E0900" />
        <stop offset="16.54%" stopColor="#551C00" />
        <stop offset="28.57%" stopColor="#F7941D" />
        <stop offset="30.08%" stopColor="#F99F33" />
        <stop offset="33.78%" stopColor="#FCBA65" />
        <stop offset="37.22%" stopColor="#FFD089" />
        <stop offset="40.3%" stopColor="#FFE0A4" />
        <stop offset="42.91%" stopColor="#FFEAB6" />
        <stop offset="44.74%" stopColor="#FFEEBD" />
        <stop offset="58.27%" stopColor="#FFEEBD" />
        <stop offset="63.07%" stopColor="#FFE8B2" />
        <stop offset="71.61%" stopColor="#FFD896" />
        <stop offset="82.9%" stopColor="#FDBF6C" />
        <stop offset="96.38%" stopColor="#F99D2E" />
        <stop offset="100%" stopColor="#F7941D" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__bi"
        x1="27.714%"
        x2="72.541%"
        y1="67.661%"
        y2="33.777%"
      >
        <stop offset="0%" stopColor="#F7941D" />
        <stop offset="37.59%" stopColor="#F79431" />
        <stop offset="39.99%" stopColor="#F99E42" />
        <stop offset="45.27%" stopColor="#FBB363" />
        <stop offset="51.02%" stopColor="#FDC57D" />
        <stop offset="57.26%" stopColor="#FFD493" />
        <stop offset="64.18%" stopColor="#FFDFA5" />
        <stop offset="72.13%" stopColor="#FFE8B2" />
        <stop offset="82.05%" stopColor="#FFEDBA" />
        <stop offset="100%" stopColor="#FFEEBD" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__bj"
        x1="62.67%"
        x2="26.863%"
        y1="27.531%"
        y2="88.543%"
      >
        <stop offset="13.91%" stopColor="#3E0900" />
        <stop offset="15.31%" stopColor="#491500" />
        <stop offset="25.13%" stopColor="#844100" />
        <stop offset="33.9%" stopColor="#B36311" />
        <stop offset="41.29%" stopColor="#D77C19" />
        <stop offset="47.01%" stopColor="#EC8C1C" />
        <stop offset="50.38%" stopColor="#F7941D" />
        <stop offset="52.66%" stopColor="#F99E34" />
        <stop offset="59.49%" stopColor="#FDBD73" />
        <stop offset="65.63%" stopColor="#FFD7A2" />
        <stop offset="70.85%" stopColor="#FFEAC7" />
        <stop offset="74.96%" stopColor="#FFF6DE" />
        <stop offset="77.44%" stopColor="#FFFDE9" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__bk"
        x1="3.902%"
        x2="79.081%"
        y1="79.082%"
        y2="21.4%"
      >
        <stop offset="14.29%" stopColor="#3E0900" />
        <stop offset="20.3%" stopColor="#3E0900" />
        <stop offset="24.33%" stopColor="#713802" />
        <stop offset="28.77%" stopColor="#9D602B" />
        <stop offset="32.85%" stopColor="#C48449" />
        <stop offset="36.44%" stopColor="#E1A060" />
        <stop offset="39.39%" stopColor="#F3B26F" />
        <stop offset="41.35%" stopColor="#FCBB76" />
        <stop offset="63.53%" stopColor="#FCBB76" />
        <stop offset="65.9%" stopColor="#EEAD6B" />
        <stop offset="70.29%" stopColor="#D08F53" />
        <stop offset="76.25%" stopColor="#A1632E" />
        <stop offset="83.45%" stopColor="#673000" />
        <stop offset="87.59%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__bl"
        x1="104.96%"
        x2="-.559%"
        y1="72.122%"
        y2="37.421%"
      >
        <stop offset="13.91%" stopColor="#3E0900" />
        <stop offset="25.56%" stopColor="#F79431" />
        <stop offset="25.95%" stopColor="#F89839" />
        <stop offset="28%" stopColor="#FAAB5D" />
        <stop offset="30.29%" stopColor="#FCBE7C" />
        <stop offset="32.79%" stopColor="#FECE97" />
        <stop offset="35.56%" stopColor="#FFDCAF" />
        <stop offset="38.68%" stopColor="#FFE7C3" />
        <stop offset="42.32%" stopColor="#FFF0D3" />
        <stop offset="46.82%" stopColor="#FFF6DF" />
        <stop offset="53.14%" stopColor="#FFFBE6" />
        <stop offset="70.68%" stopColor="#FFFDE9" />
        <stop offset="71.96%" stopColor="#FFEDCC" />
        <stop offset="74.74%" stopColor="#FECC8D" />
        <stop offset="78.78%" stopColor="#F89A2B" />
        <stop offset="79.32%" stopColor="#F7941D" />
        <stop offset="80.35%" stopColor="#F2901D" />
        <stop offset="81.44%" stopColor="#E7881C" />
        <stop offset="82.56%" stopColor="#D67C19" />
        <stop offset="83.69%" stopColor="#BD6A14" />
        <stop offset="84.85%" stopColor="#9F5409" />
        <stop offset="86.01%" stopColor="#7C3C00" />
        <stop offset="87.16%" stopColor="#521C00" />
        <stop offset="87.59%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__bm"
        x1="77.285%"
        x2="23.632%"
        y1="-35.156%"
        y2="154.701%"
      >
        <stop offset="24.44%" stopColor="#3E0900" />
        <stop offset="38.27%" stopColor="#9A5715" />
        <stop offset="48.66%" stopColor="#DC8D34" />
        <stop offset="53.38%" stopColor="#FAA741" />
        <stop offset="100%" stopColor="#FFEEBD" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__bn"
        x1="94.668%"
        x2="5.532%"
        y1="-12.741%"
        y2="98.194%"
      >
        <stop offset="10.53%" stopColor="#F58220" />
        <stop offset="12.59%" stopColor="#F79338" />
        <stop offset="15.72%" stopColor="#FAAB5C" />
        <stop offset="18.8%" stopColor="#FDBF77" />
        <stop offset="21.77%" stopColor="#FECD8A" />
        <stop offset="24.58%" stopColor="#FFD596" />
        <stop offset="27.07%" stopColor="#FFD89B" />
        <stop offset="29.68%" stopColor="#FFD493" />
        <stop offset="33.84%" stopColor="#FEC980" />
        <stop offset="39.01%" stopColor="#FCB661" />
        <stop offset="44.95%" stopColor="#F99E31" />
        <stop offset="47.37%" stopColor="#F7941D" />
        <stop offset="51.02%" stopColor="#E2841B" />
        <stop offset="58.69%" stopColor="#B26211" />
        <stop offset="69.65%" stopColor="#6B2F00" />
        <stop offset="75.56%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__bo"
        x1="-.66%"
        x2="100.561%"
        y1="52.737%"
        y2="52.737%"
      >
        <stop offset="27.07%" stopColor="#F7941D" />
        <stop offset="34.16%" stopColor="#FAA33A" />
        <stop offset="45.12%" stopColor="#FCB963" />
        <stop offset="56.2%" stopColor="#FECC82" />
        <stop offset="67.25%" stopColor="#FFDB9B" />
        <stop offset="78.25%" stopColor="#FFE5AD" />
        <stop offset="89.18%" stopColor="#FFECB9" />
        <stop offset="100%" stopColor="#FFEEBD" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__bp"
        x1="-14.726%"
        x2="112.344%"
        y1="33.466%"
        y2="70.15%"
      >
        <stop offset="0%" stopColor="#FFCE7B" />
        <stop offset="12.7%" stopColor="#FFCB77" />
        <stop offset="24.43%" stopColor="#FDC36D" />
        <stop offset="35.78%" stopColor="#FCB45B" />
        <stop offset="46.89%" stopColor="#F9A042" />
        <stop offset="57.74%" stopColor="#F68825" />
        <stop offset="60.15%" stopColor="#F58220" />
        <stop offset="64.28%" stopColor="#F89945" />
        <stop offset="73.6%" stopColor="#FED7A9" />
        <stop offset="78.57%" stopColor="#FFFDE9" />
        <stop offset="83.83%" stopColor="#FFFDE9" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__bq"
        x1="13.364%"
        x2="73.573%"
        y1="-13.098%"
        y2="97.845%"
      >
        <stop offset="26.69%" stopColor="#F79431" />
        <stop offset="26.95%" stopColor="#F79431" />
        <stop offset="66.54%" stopColor="#F79431" />
        <stop offset="67.02%" stopColor="#F8993B" />
        <stop offset="69.32%" stopColor="#FBB268" />
        <stop offset="71.67%" stopColor="#FDC88C" />
        <stop offset="74.01%" stopColor="#FFDAAB" />
        <stop offset="76.36%" stopColor="#FFE8C5" />
        <stop offset="78.71%" stopColor="#FFF2D7" />
        <stop offset="81.07%" stopColor="#FFF9E4" />
        <stop offset="83.46%" stopColor="#FFFDE9" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__br"
        x1="-1.403%"
        x2="99.409%"
        y1="48.161%"
        y2="48.161%"
      >
        <stop offset="16.92%" stopColor="#FFEEBD" />
        <stop offset="21.88%" stopColor="#FFDEA3" />
        <stop offset="35.7%" stopColor="#FCB667" />
        <stop offset="45.68%" stopColor="#F99D40" />
        <stop offset="50.75%" stopColor="#F79431" />
        <stop offset="53.88%" stopColor="#F99E45" />
        <stop offset="60.44%" stopColor="#FCBB77" />
        <stop offset="69.81%" stopColor="#FFEAC8" />
        <stop offset="72.93%" stopColor="#FFFDE9" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__bs"
        x1=".982%"
        x2="100.71%"
        y1="-5.309%"
        y2="84.591%"
      >
        <stop offset="13.16%" stopColor="#3E0900" />
        <stop offset="20.3%" stopColor="#FAA866" />
        <stop offset="20.37%" stopColor="#FAAA68" />
        <stop offset="21.1%" stopColor="#FCBF80" />
        <stop offset="21.92%" stopColor="#FED095" />
        <stop offset="22.87%" stopColor="#FFDDA6" />
        <stop offset="24.02%" stopColor="#FFE7B3" />
        <stop offset="25.57%" stopColor="#FFECBA" />
        <stop offset="29.32%" stopColor="#FFEEBD" />
        <stop offset="31.81%" stopColor="#FFEBB6" />
        <stop offset="35.42%" stopColor="#FFE3A5" />
        <stop offset="39.72%" stopColor="#FFD68A" />
        <stop offset="44.53%" stopColor="#FEC465" />
        <stop offset="49.73%" stopColor="#FBAE2F" />
        <stop offset="51.5%" stopColor="#FAA61A" />
        <stop offset="54.39%" stopColor="#FDBA4D" />
        <stop offset="57.85%" stopColor="#FFD07E" />
        <stop offset="60.84%" stopColor="#FFE09F" />
        <stop offset="63.21%" stopColor="#FFEAB4" />
        <stop offset="64.66%" stopColor="#FFEEBD" />
        <stop offset="66.02%" stopColor="#FFEBB7" />
        <stop offset="67.85%" stopColor="#FFE4A8" />
        <stop offset="69.93%" stopColor="#FFD990" />
        <stop offset="72.21%" stopColor="#FEC970" />
        <stop offset="74.62%" stopColor="#FCB541" />
        <stop offset="76.32%" stopColor="#FAA61A" />
        <stop offset="76.94%" stopColor="#FBAA26" />
        <stop offset="79.47%" stopColor="#FDBC52" />
        <stop offset="82.12%" stopColor="#FFCB74" />
        <stop offset="84.85%" stopColor="#FFD78D" />
        <stop offset="87.7%" stopColor="#FFE1A1" />
        <stop offset="90.72%" stopColor="#FFE8B1" />
        <stop offset="94.02%" stopColor="#FFEDBA" />
        <stop offset="98.12%" stopColor="#FFEEBD" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__bt"
        x1="63.149%"
        x2="43.343%"
        y1="103.699%"
        y2="-13.91%"
      >
        <stop offset="69.17%" stopColor="#FFFDE9" />
        <stop offset="73.33%" stopColor="#FDF7E3" />
        <stop offset="75.25%" stopColor="#F5EAD4" />
        <stop offset="76.7%" stopColor="#EAD9C0" />
        <stop offset="77.92%" stopColor="#DAC2A5" />
        <stop offset="78.99%" stopColor="#C6A686" />
        <stop offset="79.96%" stopColor="#AD8562" />
        <stop offset="80.86%" stopColor="#90633F" />
        <stop offset="81.69%" stopColor="#724019" />
        <stop offset="82.45%" stopColor="#4E1C00" />
        <stop offset="82.71%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__bv"
        x1="-10.878%"
        x2="101.342%"
        y1="29.481%"
        y2="88.997%"
      >
        <stop offset="0%" stopColor="#F7941D" />
        <stop offset="37.97%" stopColor="#F79431" />
        <stop offset="42.55%" stopColor="#F9A34E" />
        <stop offset="49.73%" stopColor="#FCBA75" />
        <stop offset="57.19%" stopColor="#FECD95" />
        <stop offset="64.83%" stopColor="#FFDDB2" />
        <stop offset="72.71%" stopColor="#FFEAC9" />
        <stop offset="80.93%" stopColor="#FFF3D9" />
        <stop offset="89.71%" stopColor="#FFFAE4" />
        <stop offset="100%" stopColor="#FFFDE9" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__bw"
        x1=".495%"
        x2="107.5%"
        y1="33.131%"
        y2="92.273%"
      >
        <stop offset="10.9%" stopColor="#3E0900" />
        <stop offset="12.47%" stopColor="#592100" />
        <stop offset="15.46%" stopColor="#803B00" />
        <stop offset="18.5%" stopColor="#A1500C" />
        <stop offset="21.52%" stopColor="#BE6216" />
        <stop offset="24.54%" stopColor="#D56F1B" />
        <stop offset="27.54%" stopColor="#E5791D" />
        <stop offset="30.52%" stopColor="#F07F1F" />
        <stop offset="33.46%" stopColor="#F58220" />
        <stop offset="35.21%" stopColor="#F78E32" />
        <stop offset="40.64%" stopColor="#FBB270" />
        <stop offset="45.51%" stopColor="#FED19F" />
        <stop offset="49.66%" stopColor="#FFE7C5" />
        <stop offset="52.92%" stopColor="#FFF5DE" />
        <stop offset="54.89%" stopColor="#FFFDE9" />
        <stop offset="77.44%" stopColor="#F7941D" />
        <stop offset="79.55%" stopColor="#CE7618" />
        <stop offset="84.31%" stopColor="#733500" />
        <stop offset="86.84%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__bx"
        x1="4.807%"
        x2="95.563%"
        y1="-10.744%"
        y2="109.37%"
      >
        <stop offset="16.17%" stopColor="#F7941D" />
        <stop offset="16.42%" stopColor="#F89622" />
        <stop offset="18.43%" stopColor="#FAA84C" />
        <stop offset="20.61%" stopColor="#FCB970" />
        <stop offset="22.94%" stopColor="#FDC78D" />
        <stop offset="25.43%" stopColor="#FED4A6" />
        <stop offset="28.15%" stopColor="#FFDEBB" />
        <stop offset="31.19%" stopColor="#FFE7CC" />
        <stop offset="34.72%" stopColor="#FFECD8" />
        <stop offset="39.19%" stopColor="#FFF0E0" />
        <stop offset="47.74%" stopColor="#FFF1E2" />
        <stop offset="50.26%" stopColor="#FFE6CD" />
        <stop offset="55.53%" stopColor="#FDCC9A" />
        <stop offset="63.03%" stopColor="#F9A350" />
        <stop offset="65.79%" stopColor="#F79431" />
        <stop offset="66.72%" stopColor="#F89A3D" />
        <stop offset="70.33%" stopColor="#FBB36A" />
        <stop offset="74.03%" stopColor="#FDC88D" />
        <stop offset="77.73%" stopColor="#FFDAAC" />
        <stop offset="81.46%" stopColor="#FFE8C5" />
        <stop offset="85.2%" stopColor="#FFF2D8" />
        <stop offset="88.98%" stopColor="#FFFAE4" />
        <stop offset="92.86%" stopColor="#FFFDE9" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__by"
        x1="1.756%"
        x2="92.193%"
        y1="102.022%"
        y2="1.4%"
      >
        <stop offset="26.32%" stopColor="#FAA61A" />
        <stop offset="31.18%" stopColor="#FEC670" />
        <stop offset="35.56%" stopColor="#FFE2AE" />
        <stop offset="38.67%" stopColor="#FFF4D7" />
        <stop offset="40.23%" stopColor="#FFFDE9" />
        <stop offset="55.07%" stopColor="#FFFDE9" />
        <stop offset="57.52%" stopColor="#FFFDE9" />
        <stop offset="66.82%" stopColor="#FFFBE6" />
        <stop offset="70.17%" stopColor="#FFF7DF" />
        <stop offset="72.56%" stopColor="#FFF1D3" />
        <stop offset="74.49%" stopColor="#FFE9C4" />
        <stop offset="76.15%" stopColor="#FFDEB0" />
        <stop offset="77.61%" stopColor="#FED298" />
        <stop offset="78.94%" stopColor="#FDC37D" />
        <stop offset="80.16%" stopColor="#FBB25E" />
        <stop offset="81.24%" stopColor="#F9A139" />
        <stop offset="81.95%" stopColor="#F7941D" />
        <stop offset="91.39%" stopColor="#743600" />
        <stop offset="95.49%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__bz"
        x1=".747%"
        x2="99.987%"
        y1="50.259%"
        y2="50.259%"
      >
        <stop offset="9.023%" stopColor="#3E0900" />
        <stop offset="10%" stopColor="#5D2500" />
        <stop offset="11.6%" stopColor="#834100" />
        <stop offset="13.22%" stopColor="#A4580C" />
        <stop offset="14.85%" stopColor="#C16D15" />
        <stop offset="16.48%" stopColor="#D87D1A" />
        <stop offset="18.12%" stopColor="#E8891C" />
        <stop offset="19.76%" stopColor="#F2901D" />
        <stop offset="21.43%" stopColor="#F7941D" />
        <stop offset="24.02%" stopColor="#FAAA4D" />
        <stop offset="26.94%" stopColor="#FDC27A" />
        <stop offset="29.81%" stopColor="#FFD69F" />
        <stop offset="32.56%" stopColor="#FFE5BD" />
        <stop offset="35.14%" stopColor="#FFF1D4" />
        <stop offset="37.52%" stopColor="#FFF9E3" />
        <stop offset="39.47%" stopColor="#FFFDE9" />
        <stop offset="68.72%" stopColor="#FFFDE9" />
        <stop offset="73.68%" stopColor="#FFFDE9" />
        <stop offset="78.71%" stopColor="#FFDEA6" />
        <stop offset="88.72%" stopColor="#FAA61A" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__bA"
        x1="38.37%"
        x2="38.37%"
        y1="99.76%"
        y2="-2.585%"
      >
        <stop offset="7.143%" stopColor="#3E0900" />
        <stop offset="36.47%" stopColor="#F79431" />
        <stop offset="37.99%" stopColor="#F89837" />
        <stop offset="50.43%" stopColor="#FCB567" />
        <stop offset="62.06%" stopColor="#FECE8A" />
        <stop offset="72.55%" stopColor="#FFDFA5" />
        <stop offset="81.54%" stopColor="#FFEAB6" />
        <stop offset="87.97%" stopColor="#FFEEBD" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__bB"
        x1="27.967%"
        x2="59.753%"
        y1="-22.761%"
        y2="100.234%"
      >
        <stop offset="48.87%" stopColor="#F7941D" />
        <stop offset="50.12%" stopColor="#F89A2A" />
        <stop offset="55.21%" stopColor="#FBB25D" />
        <stop offset="60.32%" stopColor="#FDC785" />
        <stop offset="65.34%" stopColor="#FFD9A6" />
        <stop offset="70.27%" stopColor="#FFE8C2" />
        <stop offset="75.05%" stopColor="#FFF2D6" />
        <stop offset="79.65%" stopColor="#FFF9E3" />
        <stop offset="83.83%" stopColor="#FFFDE9" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__bC"
        x1="-.478%"
        x2="94.67%"
        y1="13.662%"
        y2="106.288%"
      >
        <stop offset="3.759%" stopColor="#3E0900" />
        <stop offset="4.838%" stopColor="#6B2F00" />
        <stop offset="6.057%" stopColor="#924B03" />
        <stop offset="7.252%" stopColor="#B46412" />
        <stop offset="8.395%" stopColor="#D07818" />
        <stop offset="9.475%" stopColor="#E4861B" />
        <stop offset="10.46%" stopColor="#F18F1D" />
        <stop offset="11.28%" stopColor="#F7941D" />
        <stop offset="13.47%" stopColor="#FAA94B" />
        <stop offset="18.99%" stopColor="#FFE2B8" />
        <stop offset="21.43%" stopColor="#FFFDE9" />
        <stop offset="58.27%" stopColor="#FFFDE9" />
        <stop offset="60.04%" stopColor="#FFF5DC" />
        <stop offset="63.19%" stopColor="#FFE7C0" />
        <stop offset="67.35%" stopColor="#FED094" />
        <stop offset="72.3%" stopColor="#FBB25D" />
        <stop offset="77.07%" stopColor="#F7941D" />
        <stop offset="78.2%" stopColor="#F08F1D" />
        <stop offset="79.64%" stopColor="#E3851B" />
        <stop offset="81.25%" stopColor="#CE7618" />
        <stop offset="82.99%" stopColor="#B06110" />
        <stop offset="84.83%" stopColor="#8B4700" />
        <stop offset="86.72%" stopColor="#622900" />
        <stop offset="87.97%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__bD"
        x1="33.568%"
        x2="57.053%"
        y1="95.472%"
        y2="23.214%"
      >
        <stop offset="9.023%" stopColor="#3E0900" />
        <stop offset="9.212%" stopColor="#400B00" />
        <stop offset="15.84%" stopColor="#773500" />
        <stop offset="22.11%" stopColor="#A1500B" />
        <stop offset="27.86%" stopColor="#C46517" />
        <stop offset="32.98%" stopColor="#DD741C" />
        <stop offset="37.27%" stopColor="#ED7D1F" />
        <stop offset="40.23%" stopColor="#F58220" />
        <stop offset="53.01%" stopColor="#F58220" />
        <stop offset="55.8%" stopColor="#D7701B" />
        <stop offset="61.8%" stopColor="#A04F0B" />
        <stop offset="67.21%" stopColor="#783600" />
        <stop offset="71.85%" stopColor="#5B2200" />
        <stop offset="75.54%" stopColor="#461200" />
        <stop offset="77.82%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__bE"
        x1="87.693%"
        x2="10.289%"
        y1="78.385%"
        y2="25.81%"
      >
        <stop offset="0%" stopColor="#FFEEBD" />
        <stop offset="8.68%" stopColor="#FFEBB7" />
        <stop offset="20.47%" stopColor="#FFE4A7" />
        <stop offset="33.98%" stopColor="#FFD88F" />
        <stop offset="45.49%" stopColor="#FFCC76" />
        <stop offset="48.5%" stopColor="#F79431" />
        <stop offset="49.22%" stopColor="#CF7924" />
        <stop offset="49.97%" stopColor="#AD6317" />
        <stop offset="50.76%" stopColor="#915008" />
        <stop offset="51.6%" stopColor="#7C4100" />
        <stop offset="52.48%" stopColor="#6C3600" />
        <stop offset="53.44%" stopColor="#5F2D00" />
        <stop offset="54.53%" stopColor="#582700" />
        <stop offset="56.02%" stopColor="#552500" />
        <stop offset="57.94%" stopColor="#512100" />
        <stop offset="64.6%" stopColor="#461500" />
        <stop offset="73.97%" stopColor="#400C00" />
        <stop offset="100%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__bF"
        x1="-3.9%"
        x2="95.925%"
        y1="74.564%"
        y2="8.7%"
      >
        <stop offset="6.015%" stopColor="#FFFDE9" />
        <stop offset="9.98%" stopColor="#FFECCA" />
        <stop offset="18.51%" stopColor="#FED095" />
        <stop offset="26.73%" stopColor="#FCBA6D" />
        <stop offset="34.42%" stopColor="#FAA94A" />
        <stop offset="41.46%" stopColor="#F99D31" />
        <stop offset="47.63%" stopColor="#F89622" />
        <stop offset="52.26%" stopColor="#F7941D" />
        <stop offset="71.37%" stopColor="#F5921D" />
        <stop offset="78.25%" stopColor="#EE8D1D" />
        <stop offset="83.16%" stopColor="#E4871C" />
        <stop offset="87.13%" stopColor="#D67E1B" />
        <stop offset="90.53%" stopColor="#C57218" />
        <stop offset="93.54%" stopColor="#AF6313" />
        <stop offset="96.26%" stopColor="#95520A" />
        <stop offset="98.68%" stopColor="#7B3F00" />
        <stop offset="100%" stopColor="#693300" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__bG"
        x1="22.878%"
        x2="80.359%"
        y1="102.968%"
        y2="-10.814%"
      >
        <stop offset="54.89%" stopColor="#551C00" />
        <stop offset="78.41%" stopColor="#461100" />
        <stop offset="97.37%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__bH"
        x1="27.234%"
        x2="73.816%"
        y1="127.231%"
        y2="-15.259%"
      >
        <stop offset="1.504%" stopColor="#CA6C18" />
        <stop offset="20.23%" stopColor="#E3A04F" />
        <stop offset="40.23%" stopColor="#FFE293" />
        <stop offset="44.22%" stopColor="#FFDE8C" />
        <stop offset="50.01%" stopColor="#FFD37B" />
        <stop offset="56.87%" stopColor="#FDC05F" />
        <stop offset="64.52%" stopColor="#FAA734" />
        <stop offset="64.66%" stopColor="#FAA634" />
        <stop offset="67.97%" stopColor="#E9982E" />
        <stop offset="74.55%" stopColor="#C47A20" />
        <stop offset="83.68%" stopColor="#8B4D03" />
        <stop offset="89.1%" stopColor="#693300" />
        <stop offset="89.58%" stopColor="#662F00" />
        <stop offset="91.23%" stopColor="#5D2500" />
        <stop offset="93.55%" stopColor="#582000" />
        <stop offset="100%" stopColor="#571E00" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__bI"
        x1="50.257%"
        x2="50.257%"
        y1="99.786%"
        y2="-.683%"
      >
        <stop offset="0%" stopColor="#CA6C18" />
        <stop offset=".19%" stopColor="#CB6D19" />
        <stop offset="4.53%" stopColor="#DA8C38" />
        <stop offset="9.04%" stopColor="#E7A857" />
        <stop offset="13.71%" stopColor="#F1C070" />
        <stop offset="18.59%" stopColor="#F9D282" />
        <stop offset="23.83%" stopColor="#FFDD8E" />
        <stop offset="30.08%" stopColor="#FFE293" />
        <stop offset="37.78%" stopColor="#FEC468" />
        <stop offset="45.92%" stopColor="#FAA93E" />
        <stop offset="52.28%" stopColor="#F89925" />
        <stop offset="56.02%" stopColor="#F7941D" />
        <stop offset="59.67%" stopColor="#F79422" />
        <stop offset="64.38%" stopColor="#F79430" />
        <stop offset="64.66%" stopColor="#F79431" />
        <stop offset="66.48%" stopColor="#EA8B2E" />
        <stop offset="69.79%" stopColor="#D07725" />
        <stop offset="74.25%" stopColor="#A45814" />
        <stop offset="79.6%" stopColor="#6E3100" />
        <stop offset="83.46%" stopColor="#3E0900" />
        <stop offset="85.8%" stopColor="#3E0900" />
        <stop offset="100%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__bJ"
        x1="-11.005%"
        x2="111.787%"
        y1="45.113%"
        y2="56.49%"
      >
        <stop offset="8.647%" stopColor="#F7941D" />
        <stop offset="14.54%" stopColor="#F7941D" />
        <stop offset="49.62%" stopColor="#F7941D" />
        <stop offset="65.61%" stopColor="#E27C1D" />
        <stop offset="98.4%" stopColor="#B54516" />
        <stop offset="100%" stopColor="#B34215" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__bK"
        x1="32.311%"
        x2="69.385%"
        y1="85.179%"
        y2="15.878%"
      >
        <stop offset="1.128%" stopColor="#FFEEBD" />
        <stop offset="8.788%" stopColor="#FFECB8" />
        <stop offset="17.4%" stopColor="#FFE4AB" />
        <stop offset="26.48%" stopColor="#FFD997" />
        <stop offset="35.87%" stopColor="#FEC97C" />
        <stop offset="45.43%" stopColor="#FCB55A" />
        <stop offset="47.74%" stopColor="#FBAF4F" />
        <stop offset="50.22%" stopColor="#FAA63E" />
        <stop offset="53.6%" stopColor="#F99E2F" />
        <stop offset="57.8%" stopColor="#F89824" />
        <stop offset="63.7%" stopColor="#F8951F" />
        <stop offset="80.08%" stopColor="#F7941D" />
        <stop offset="80.99%" stopColor="#F89824" />
        <stop offset="82.45%" stopColor="#FAA33A" />
        <stop offset="84.3%" stopColor="#FCB65E" />
        <stop offset="86.42%" stopColor="#FFD28B" />
        <stop offset="88.35%" stopColor="#FFEEBD" />
        <stop offset="100%" stopColor="#FFE293" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__bL"
        x1="86.963%"
        x2="-6.986%"
        y1="72.412%"
        y2="22.838%"
      >
        <stop offset="13.16%" stopColor="#FFFDE9" />
        <stop offset="14.76%" stopColor="#FCF1DA" />
        <stop offset="17.53%" stopColor="#F5DCBB" />
        <stop offset="21.13%" stopColor="#EBBE8E" />
        <stop offset="25.42%" stopColor="#DD9859" />
        <stop offset="30.26%" stopColor="#CB6E1A" />
        <stop offset="30.45%" stopColor="#CA6C18" />
        <stop offset="30.64%" stopColor="#CA6C18" />
        <stop offset="37.59%" stopColor="#CA6C18" />
        <stop offset="43.13%" stopColor="#D78943" />
        <stop offset="48.99%" stopColor="#E3A76E" />
        <stop offset="54.76%" stopColor="#EDC294" />
        <stop offset="60.3%" stopColor="#F4D9B5" />
        <stop offset="65.55%" stopColor="#FAEACF" />
        <stop offset="70.39%" stopColor="#FEF7E1" />
        <stop offset="74.44%" stopColor="#FFFDE9" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__bM"
        x1="4.24%"
        x2="109.591%"
        y1="67.673%"
        y2="12.539%"
      >
        <stop offset="28.2%" stopColor="#FFE9AC" />
        <stop offset="36.4%" stopColor="#FFE8AA" />
        <stop offset="40.12%" stopColor="#FFE4A3" />
        <stop offset="42.95%" stopColor="#FFDE97" />
        <stop offset="45.31%" stopColor="#FFD588" />
        <stop offset="47.39%" stopColor="#FECA74" />
        <stop offset="49.27%" stopColor="#FDBB5A" />
        <stop offset="50.96%" stopColor="#FBAB39" />
        <stop offset="52.26%" stopColor="#F99D1C" />
        <stop offset="55.35%" stopColor="#D37F18" />
        <stop offset="60.58%" stopColor="#9D5608" />
        <stop offset="65.34%" stopColor="#773900" />
        <stop offset="69.45%" stopColor="#5A2300" />
        <stop offset="72.74%" stopColor="#461200" />
        <stop offset="74.81%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__bN"
        x1="1.84%"
        x2="70.87%"
        y1="24.32%"
        y2="24.32%"
      >
        <stop offset="4.135%" stopColor="#FFEEBD" />
        <stop offset="9.271%" stopColor="#FFE8B0" />
        <stop offset="18.98%" stopColor="#FFD990" />
        <stop offset="32.22%" stopColor="#FEC15D" />
        <stop offset="45.86%" stopColor="#FAA61A" />
        <stop offset="67.24%" stopColor="#FEC05D" />
        <stop offset="100%" stopColor="#FFEEBD" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__bO"
        x1="-23.162%"
        x2="103.279%"
        y1="72.383%"
        y2="19.553%"
      >
        <stop offset="34.21%" stopColor="#3E0900" />
        <stop offset="35.11%" stopColor="#4F1900" />
        <stop offset="38.83%" stopColor="#874000" />
        <stop offset="42.16%" stopColor="#B45B13" />
        <stop offset="44.98%" stopColor="#D6701B" />
        <stop offset="47.18%" stopColor="#EB7C1E" />
        <stop offset="48.5%" stopColor="#F58220" />
        <stop offset="50.24%" stopColor="#EA7C1E" />
        <stop offset="53.22%" stopColor="#D46F1B" />
        <stop offset="57.09%" stopColor="#B05912" />
        <stop offset="61.7%" stopColor="#813C00" />
        <stop offset="66.88%" stopColor="#441000" />
        <stop offset="67.29%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__bP"
        x1="26.083%"
        x2="73.352%"
        y1="121.857%"
        y2="-15.928%"
      >
        <stop offset="10.53%" stopColor="#3E0900" />
        <stop offset="13.4%" stopColor="#410C00" />
        <stop offset="15.89%" stopColor="#4B1500" />
        <stop offset="18.23%" stopColor="#5A1F00" />
        <stop offset="20.48%" stopColor="#6D2900" />
        <stop offset="22.67%" stopColor="#843500" />
        <stop offset="24.79%" stopColor="#A0410D" />
        <stop offset="25.19%" stopColor="#A74310" />
        <stop offset="25.81%" stopColor="#AF4B14" />
        <stop offset="27.95%" stopColor="#C8641F" />
        <stop offset="30.22%" stopColor="#DB7827" />
        <stop offset="32.63%" stopColor="#E9862E" />
        <stop offset="35.3%" stopColor="#F39032" />
        <stop offset="38.72%" stopColor="#F79433" />
        <stop offset="40.63%" stopColor="#EF8B2F" />
        <stop offset="43.43%" stopColor="#DF7627" />
        <stop offset="46.76%" stopColor="#C6561B" />
        <stop offset="47.74%" stopColor="#BE4C18" />
        <stop offset="48.74%" stopColor="#B14714" />
        <stop offset="51.52%" stopColor="#933B06" />
        <stop offset="54.5%" stopColor="#7B3000" />
        <stop offset="57.65%" stopColor="#672600" />
        <stop offset="61.04%" stopColor="#561C00" />
        <stop offset="64.77%" stopColor="#491300" />
        <stop offset="69.12%" stopColor="#410C00" />
        <stop offset="75.56%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__bQ"
        x1="19.81%"
        x2="71.151%"
        y1="85.34%"
        y2="-4.76%"
      >
        <stop offset="0%" stopColor="#F7941D" />
        <stop offset="5.323%" stopColor="#EF8E1D" />
        <stop offset="13.35%" stopColor="#DE811B" />
        <stop offset="23.08%" stopColor="#C26E15" />
        <stop offset="34.14%" stopColor="#9C5308" />
        <stop offset="46.15%" stopColor="#703300" />
        <stop offset="57.14%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__bR"
        x1="7.004%"
        x2="60.144%"
        y1="94.35%"
        y2="2.31%"
      >
        <stop offset="0%" stopColor="#F7941D" />
        <stop offset="4.634%" stopColor="#F7941D" />
        <stop offset="32.33%" stopColor="#F7941D" />
        <stop offset="34.3%" stopColor="#E5871C" />
        <stop offset="40.56%" stopColor="#B86713" />
        <stop offset="46.86%" stopColor="#934C04" />
        <stop offset="53.07%" stopColor="#763800" />
        <stop offset="59.18%" stopColor="#602700" />
        <stop offset="65.16%" stopColor="#4E1900" />
        <stop offset="70.94%" stopColor="#420E00" />
        <stop offset="76.32%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__bS"
        x1="9.225%"
        x2="97.455%"
        y1="102.874%"
        y2="2.954%"
      >
        <stop offset="62.03%" stopColor="#3E0900" />
        <stop offset="62.96%" stopColor="#561F00" />
        <stop offset="65.3%" stopColor="#844101" />
        <stop offset="67.54%" stopColor="#AA5D11" />
        <stop offset="69.64%" stopColor="#CB7419" />
        <stop offset="71.55%" stopColor="#E2841C" />
        <stop offset="73.21%" stopColor="#F08F1D" />
        <stop offset="74.44%" stopColor="#F7941D" />
        <stop offset="76.27%" stopColor="#F99F32" />
        <stop offset="80.41%" stopColor="#FCB65D" />
        <stop offset="84.56%" stopColor="#FECA7F" />
        <stop offset="88.63%" stopColor="#FFD998" />
        <stop offset="92.61%" stopColor="#FFE5AC" />
        <stop offset="96.45%" stopColor="#FFECB8" />
        <stop offset="100%" stopColor="#FFEEBD" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__bT"
        x1="4.59%"
        x2="99.73%"
        y1="51.105%"
        y2="51.105%"
      >
        <stop offset="0%" stopColor="#FFEEBD" />
        <stop offset="7.16%" stopColor="#FFEDBA" />
        <stop offset="11.47%" stopColor="#FFE8B2" />
        <stop offset="15.02%" stopColor="#FFE1A5" />
        <stop offset="18.16%" stopColor="#FFD693" />
        <stop offset="21.03%" stopColor="#FEC97C" />
        <stop offset="23.71%" stopColor="#FCB861" />
        <stop offset="26.18%" stopColor="#FAA53E" />
        <stop offset="28.2%" stopColor="#F7941D" />
        <stop offset="33.94%" stopColor="#C16D15" />
        <stop offset="39.95%" stopColor="#934C04" />
        <stop offset="45.5%" stopColor="#713300" />
        <stop offset="50.39%" stopColor="#572000" />
        <stop offset="54.44%" stopColor="#451100" />
        <stop offset="57.14%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__bU"
        x1="2.446%"
        x2="102.232%"
        y1="59.08%"
        y2="26.233%"
      >
        <stop offset="10.53%" stopColor="#3E0900" />
        <stop offset="16.95%" stopColor="#541E00" />
        <stop offset="30.63%" stopColor="#854200" />
        <stop offset="50.3%" stopColor="#D57B19" />
        <stop offset="57.52%" stopColor="#F7941D" />
        <stop offset="57.77%" stopColor="#F8951F" />
        <stop offset="63.15%" stopColor="#FBAB49" />
        <stop offset="68.71%" stopColor="#FDBF6D" />
        <stop offset="74.39%" stopColor="#FFD089" />
        <stop offset="80.22%" stopColor="#FFDD9F" />
        <stop offset="86.27%" stopColor="#FFE7AF" />
        <stop offset="92.66%" stopColor="#FFECB9" />
        <stop offset="100%" stopColor="#FFEEBD" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__bV"
        x1="45.021%"
        x2="77.441%"
        y1="98.502%"
        y2="-5.271%"
      >
        <stop offset="31.58%" stopColor="#FFEEBD" />
        <stop offset="41.66%" stopColor="#FFEDBB" />
        <stop offset="45.29%" stopColor="#FFE8B4" />
        <stop offset="47.88%" stopColor="#FFE1A8" />
        <stop offset="49.98%" stopColor="#FFD698" />
        <stop offset="51.77%" stopColor="#FEC985" />
        <stop offset="53.36%" stopColor="#FCB86E" />
        <stop offset="54.79%" stopColor="#F9A451" />
        <stop offset="56.07%" stopColor="#F78F31" />
        <stop offset="56.77%" stopColor="#F58220" />
        <stop offset="58.03%" stopColor="#D9721C" />
        <stop offset="59.95%" stopColor="#B85E15" />
        <stop offset="62.1%" stopColor="#9B4C0A" />
        <stop offset="64.45%" stopColor="#833D00" />
        <stop offset="67.04%" stopColor="#6F3000" />
        <stop offset="69.97%" stopColor="#5E2500" />
        <stop offset="73.39%" stopColor="#511A00" />
        <stop offset="77.62%" stopColor="#461200" />
        <stop offset="83.54%" stopColor="#400B00" />
        <stop offset="100%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__bW"
        x1="24.09%"
        x2="57.45%"
        y1="102.181%"
        y2=".947%"
      >
        <stop offset="12.78%" stopColor="#3E0900" />
        <stop offset="21.81%" stopColor="#632900" />
        <stop offset="35.22%" stopColor="#8E4604" />
        <stop offset="45.13%" stopColor="#AB5910" />
        <stop offset="50.38%" stopColor="#B66113" />
        <stop offset="58.25%" stopColor="#9C5009" />
        <stop offset="75.46%" stopColor="#5F2600" />
        <stop offset="83.08%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__bX"
        x1="4.43%"
        x2="96.63%"
        y1="74.672%"
        y2="47.14%"
      >
        <stop offset="29.7%" stopColor="#FFEEBD" />
        <stop offset="31.26%" stopColor="#FFECB9" />
        <stop offset="32.61%" stopColor="#FFE7AF" />
        <stop offset="33.9%" stopColor="#FFDD9F" />
        <stop offset="35.14%" stopColor="#FFD089" />
        <stop offset="36.34%" stopColor="#FDBF6D" />
        <stop offset="37.53%" stopColor="#FBAB49" />
        <stop offset="38.67%" stopColor="#F8951F" />
        <stop offset="38.72%" stopColor="#F7941D" />
        <stop offset="39.38%" stopColor="#E5871C" />
        <stop offset="41.12%" stopColor="#C26E15" />
        <stop offset="43.05%" stopColor="#A1560B" />
        <stop offset="45.12%" stopColor="#874400" />
        <stop offset="47.38%" stopColor="#723500" />
        <stop offset="49.87%" stopColor="#612800" />
        <stop offset="52.71%" stopColor="#521C00" />
        <stop offset="56.11%" stopColor="#471300" />
        <stop offset="60.62%" stopColor="#400C00" />
        <stop offset="70.68%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__bY"
        x1="15.084%"
        x2="78.699%"
        y1="101.688%"
        y2="-1.971%"
      >
        <stop offset="13.91%" stopColor="#F7941D" />
        <stop offset="25.94%" stopColor="#F7941D" />
        <stop offset="28.25%" stopColor="#C46F16" />
        <stop offset="30.56%" stopColor="#9A5107" />
        <stop offset="32.8%" stopColor="#7B3B00" />
        <stop offset="34.97%" stopColor="#632900" />
        <stop offset="37.03%" stopColor="#4F1A00" />
        <stop offset="38.96%" stopColor="#430F00" />
        <stop offset="40.6%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__bZ"
        x1="24.883%"
        x2="79.474%"
        y1="114.39%"
        y2="-20.381%"
      >
        <stop offset="21.05%" stopColor="#FFEEBD" />
        <stop offset="23.32%" stopColor="#F8E3B2" />
        <stop offset="26.55%" stopColor="#E7CB9A" />
        <stop offset="30.36%" stopColor="#CDA877" />
        <stop offset="34.61%" stopColor="#A87A4D" />
        <stop offset="39.22%" stopColor="#7D4A1F" />
        <stop offset="44.07%" stopColor="#471500" />
        <stop offset="44.74%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__ca"
        x1="6.444%"
        x2="124.981%"
        y1="87.227%"
        y2="30.85%"
      >
        <stop offset="26.69%" stopColor="#FFEEBD" />
        <stop offset="28.84%" stopColor="#FFEAB3" />
        <stop offset="32.53%" stopColor="#FFDE9B" />
        <stop offset="37.31%" stopColor="#FFCC76" />
        <stop offset="42.94%" stopColor="#FCB33C" />
        <stop offset="45.86%" stopColor="#FAA61A" />
        <stop offset="47.49%" stopColor="#F5A21A" />
        <stop offset="48.86%" stopColor="#EC9A19" />
        <stop offset="50.15%" stopColor="#DD8D18" />
        <stop offset="51.37%" stopColor="#C87C15" />
        <stop offset="52.56%" stopColor="#AE670E" />
        <stop offset="53.72%" stopColor="#8F4E02" />
        <stop offset="54.85%" stopColor="#6D3300" />
        <stop offset="55.94%" stopColor="#420E00" />
        <stop offset="56.02%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__cb"
        x1="27.436%"
        x2="81.364%"
        y1="97.277%"
        y2="-3.323%"
      >
        <stop offset="12.03%" stopColor="#3E0000" />
        <stop offset="14.47%" stopColor="#641B00" />
        <stop offset="17.44%" stopColor="#873500" />
        <stop offset="20.49%" stopColor="#A74B0F" />
        <stop offset="23.59%" stopColor="#C25E17" />
        <stop offset="26.73%" stopColor="#D76D1C" />
        <stop offset="29.94%" stopColor="#E6781E" />
        <stop offset="33.25%" stopColor="#F07F1F" />
        <stop offset="36.84%" stopColor="#F58220" />
        <stop offset="59.62%" stopColor="#904503" />
        <stop offset="78.2%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__cc"
        x1="-.013%"
        x2="87.503%"
        y1="77.668%"
        y2="18.911%"
      >
        <stop offset="25.56%" stopColor="#3E0900" />
        <stop offset="27.15%" stopColor="#521B00" />
        <stop offset="31.51%" stopColor="#7B3800" />
        <stop offset="35.92%" stopColor="#9E4E0A" />
        <stop offset="40.28%" stopColor="#BC6015" />
        <stop offset="44.57%" stopColor="#D46F1B" />
        <stop offset="48.79%" stopColor="#E5791D" />
        <stop offset="52.9%" stopColor="#EF7F1F" />
        <stop offset="56.77%" stopColor="#F58220" />
        <stop offset="59.74%" stopColor="#EC7D1E" />
        <stop offset="64.24%" stopColor="#DB731C" />
        <stop offset="69.73%" stopColor="#C06316" />
        <stop offset="75.99%" stopColor="#9A4C08" />
        <stop offset="82.79%" stopColor="#6F2F00" />
        <stop offset="88.72%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__cd"
        x1="-8.25%"
        x2="104.475%"
        y1="68.107%"
        y2="12.329%"
      >
        <stop offset="9.774%" stopColor="#FFFDE9" />
        <stop offset="12.13%" stopColor="#FFF8E1" />
        <stop offset="15.45%" stopColor="#FFEFCF" />
        <stop offset="19.32%" stopColor="#FFE1B4" />
        <stop offset="23.62%" stopColor="#FECE90" />
        <stop offset="28.28%" stopColor="#FCB564" />
        <stop offset="33.16%" stopColor="#F89A2A" />
        <stop offset="34.21%" stopColor="#F7941D" />
        <stop offset="37.32%" stopColor="#EE8E1D" />
        <stop offset="42.03%" stopColor="#DD811B" />
        <stop offset="47.75%" stopColor="#C26E15" />
        <stop offset="54.25%" stopColor="#9C5208" />
        <stop offset="61.33%" stopColor="#703300" />
        <stop offset="67.67%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__ce"
        x1="39.027%"
        x2="64.556%"
        y1="98.45%"
        y2="-8.13%"
      >
        <stop offset="10.53%" stopColor="#FFEEBD" />
        <stop offset="12.08%" stopColor="#FFEBB8" />
        <stop offset="13.97%" stopColor="#FFE3AA" />
        <stop offset="16.03%" stopColor="#FFD793" />
        <stop offset="18.22%" stopColor="#FEC577" />
        <stop offset="20.5%" stopColor="#FBAE4F" />
        <stop offset="22.83%" stopColor="#F8951F" />
        <stop offset="22.93%" stopColor="#F7941D" />
        <stop offset="27.82%" stopColor="#CD7518" />
        <stop offset="38.88%" stopColor="#6F3200" />
        <stop offset="43.99%" stopColor="#3E0900" />
        <stop offset="44.41%" stopColor="#461200" />
        <stop offset="47.98%" stopColor="#7B3B00" />
        <stop offset="51.36%" stopColor="#A4580C" />
        <stop offset="54.48%" stopColor="#C77116" />
        <stop offset="57.26%" stopColor="#E0831B" />
        <stop offset="59.63%" stopColor="#EF8E1D" />
        <stop offset="61.28%" stopColor="#F7941D" />
        <stop offset="62.38%" stopColor="#F18F1D" />
        <stop offset="63.71%" stopColor="#E4861B" />
        <stop offset="65.17%" stopColor="#D07818" />
        <stop offset="66.71%" stopColor="#B46412" />
        <stop offset="68.33%" stopColor="#924B03" />
        <stop offset="69.97%" stopColor="#6B2F00" />
        <stop offset="71.43%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__cf"
        x1="30.215%"
        x2="69.57%"
        y1="114.337%"
        y2="1.443%"
      >
        <stop offset="14.66%" stopColor="#FFEEBD" />
        <stop offset="45.86%" stopColor="#FFEEBD" />
        <stop offset="48.87%" stopColor="#F6DFAE" />
        <stop offset="53.82%" stopColor="#E0C190" />
        <stop offset="60.1%" stopColor="#BC9364" />
        <stop offset="67.46%" stopColor="#8E5D32" />
        <stop offset="75.66%" stopColor="#562400" />
        <stop offset="78.57%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__cg"
        x1="10.72%"
        x2="75.81%"
        y1="94.583%"
        y2=".65%"
      >
        <stop offset="0%" stopColor="#FFEEBD" />
        <stop offset="5.82%" stopColor="#FFEBB7" />
        <stop offset="13.48%" stopColor="#FFE3A8" />
        <stop offset="22.17%" stopColor="#FFD790" />
        <stop offset="31.61%" stopColor="#FEC570" />
        <stop offset="41.55%" stopColor="#FBAF44" />
        <stop offset="49.25%" stopColor="#F99D1C" />
        <stop offset="51.11%" stopColor="#F2981B" />
        <stop offset="53.44%" stopColor="#E58D1A" />
        <stop offset="56.02%" stopColor="#CF7D17" />
        <stop offset="58.79%" stopColor="#B26610" />
        <stop offset="61.7%" stopColor="#8E4B01" />
        <stop offset="64.69%" stopColor="#652C00" />
        <stop offset="66.92%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__ch"
        x1="74.373%"
        x2="7.313%"
        y1="95.569%"
        y2="4.457%"
      >
        <stop offset="6.015%" stopColor="#F7941D" />
        <stop offset="19.83%" stopColor="#F8971D" />
        <stop offset="33.81%" stopColor="#F99F1B" />
        <stop offset="40.98%" stopColor="#FAA61A" />
        <stop offset="45.96%" stopColor="#F99B1C" />
        <stop offset="55.55%" stopColor="#F57F20" />
        <stop offset="60.15%" stopColor="#F37021" />
        <stop offset="63.15%" stopColor="#F47721" />
        <stop offset="68.31%" stopColor="#F68B1F" />
        <stop offset="74.06%" stopColor="#FAA61A" />
        <stop offset="76.2%" stopColor="#F5A21A" />
        <stop offset="77.98%" stopColor="#EC9A19" />
        <stop offset="79.64%" stopColor="#DD8E18" />
        <stop offset="81.22%" stopColor="#C97D15" />
        <stop offset="82.74%" stopColor="#AF670F" />
        <stop offset="84.23%" stopColor="#904F02" />
        <stop offset="85.68%" stopColor="#6E3400" />
        <stop offset="87.07%" stopColor="#441000" />
        <stop offset="87.22%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__ci"
        x1="11.733%"
        x2="95.6%"
        y1="94.61%"
        y2="21.98%"
      >
        <stop offset="14.66%" stopColor="#FAA61A" />
        <stop offset="24.47%" stopColor="#FAA31B" />
        <stop offset="34.04%" stopColor="#F99B1C" />
        <stop offset="43.49%" stopColor="#F78D1E" />
        <stop offset="49.25%" stopColor="#F58220" />
        <stop offset="57.96%" stopColor="#AF5813" />
        <stop offset="66.67%" stopColor="#753400" />
        <stop offset="72.87%" stopColor="#4F1900" />
        <stop offset="75.94%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__cj"
        x1="37.76%"
        x2="37.76%"
        y1="100.311%"
        y2="1.031%"
      >
        <stop offset="23.31%" stopColor="#FFFDE9" />
        <stop offset="25.38%" stopColor="#FFF7DF" />
        <stop offset="28.75%" stopColor="#FFEBC8" />
        <stop offset="33.02%" stopColor="#FFD8A4" />
        <stop offset="38%" stopColor="#FDBF76" />
        <stop offset="43.53%" stopColor="#F9A139" />
        <stop offset="45.86%" stopColor="#F7941D" />
        <stop offset="48.94%" stopColor="#C97317" />
        <stop offset="52.41%" stopColor="#9E5409" />
        <stop offset="55.82%" stopColor="#7E3D00" />
        <stop offset="59.08%" stopColor="#642A00" />
        <stop offset="62.15%" stopColor="#501B00" />
        <stop offset="64.97%" stopColor="#430F00" />
        <stop offset="67.29%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__ck"
        x1="9.943%"
        x2="88.643%"
        y1="58.724%"
        y2="-4.886%"
      >
        <stop offset="0%" stopColor="#FFFDE9" />
        <stop offset="6.262%" stopColor="#FFF9E4" />
        <stop offset="12.35%" stopColor="#FFF2D7" />
        <stop offset="18.37%" stopColor="#FFE7C5" />
        <stop offset="24.35%" stopColor="#FED8AB" />
        <stop offset="30.3%" stopColor="#FDC58C" />
        <stop offset="36.23%" stopColor="#FAAE69" />
        <stop offset="42.03%" stopColor="#F7943D" />
        <stop offset="45.86%" stopColor="#F58220" />
        <stop offset="48.62%" stopColor="#EF7F1F" />
        <stop offset="51.73%" stopColor="#E4781D" />
        <stop offset="55.01%" stopColor="#D26D1A" />
        <stop offset="58.41%" stopColor="#B95E14" />
        <stop offset="61.9%" stopColor="#994B07" />
        <stop offset="65.47%" stopColor="#743300" />
        <stop offset="69.04%" stopColor="#461200" />
        <stop offset="69.55%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__cl"
        x1="2.2%"
        x2="74.79%"
        y1="50.16%"
        y2="8.26%"
      >
        <stop offset="14.66%" stopColor="#FFFDE9" />
        <stop offset="28.18%" stopColor="#FBB360" />
        <stop offset="34.59%" stopColor="#F7941D" />
        <stop offset="42.78%" stopColor="#844100" />
        <stop offset="47.74%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__cm"
        x1="-22.329%"
        x2="141.948%"
        y1="70.273%"
        y2="32.421%"
      >
        <stop offset="14.29%" stopColor="#FFFDE9" />
        <stop offset="15.78%" stopColor="#FAEFD8" />
        <stop offset="18.3%" stopColor="#EFD8B8" />
        <stop offset="21.54%" stopColor="#DEB68A" />
        <stop offset="25.38%" stopColor="#C58B54" />
        <stop offset="29.68%" stopColor="#A75D16" />
        <stop offset="30.45%" stopColor="#A2550B" />
        <stop offset="35.27%" stopColor="#AE5E12" />
        <stop offset="48.41%" stopColor="#CD7520" />
        <stop offset="60.62%" stopColor="#E38529" />
        <stop offset="71.42%" stopColor="#F08F2F" />
        <stop offset="79.7%" stopColor="#F79431" />
        <stop offset="81.44%" stopColor="#E8892D" />
        <stop offset="84.85%" stopColor="#C67122" />
        <stop offset="89.57%" stopColor="#914B0A" />
        <stop offset="95.39%" stopColor="#4B1600" />
        <stop offset="96.24%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__cn"
        x1="18.189%"
        x2="94.347%"
        y1="81.35%"
        y2="32.5%"
      >
        <stop offset="14.66%" stopColor="#FFFDE9" />
        <stop offset="27.14%" stopColor="#FFFBE6" />
        <stop offset="33.26%" stopColor="#FFF6DE" />
        <stop offset="38%" stopColor="#FFF0D1" />
        <stop offset="42.02%" stopColor="#FFE7C0" />
        <stop offset="45.6%" stopColor="#FFDCAA" />
        <stop offset="48.86%" stopColor="#FECE90" />
        <stop offset="51.88%" stopColor="#FDBE74" />
        <stop offset="54.71%" stopColor="#FAAC50" />
        <stop offset="57.28%" stopColor="#F89927" />
        <stop offset="57.89%" stopColor="#F7941D" />
        <stop offset="59.83%" stopColor="#F18F1D" />
        <stop offset="62.1%" stopColor="#E5871C" />
        <stop offset="64.54%" stopColor="#D27919" />
        <stop offset="67.1%" stopColor="#B76612" />
        <stop offset="69.75%" stopColor="#954E05" />
        <stop offset="72.47%" stopColor="#6F3300" />
        <stop offset="75.19%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__co"
        x1="42.748%"
        x2="56.573%"
        y1="6.224%"
        y2="87.106%"
      >
        <stop offset="30.83%" stopColor="#3E0900" />
        <stop offset="40.12%" stopColor="#6B3200" />
        <stop offset="61.33%" stopColor="#D58619" />
        <stop offset="67.67%" stopColor="#FAA61A" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__cp"
        x1="94.536%"
        x2="-11.1%"
        y1="73.473%"
        y2="31.915%"
      >
        <stop offset="16.92%" stopColor="#3E0900" />
        <stop offset="19.21%" stopColor="#410D00" />
        <stop offset="21.06%" stopColor="#4A1600" />
        <stop offset="22.74%" stopColor="#592200" />
        <stop offset="24.34%" stopColor="#6B3000" />
        <stop offset="25.87%" stopColor="#824000" />
        <stop offset="27.35%" stopColor="#9E540D" />
        <stop offset="28.79%" stopColor="#C26E17" />
        <stop offset="30.16%" stopColor="#EB8B1D" />
        <stop offset="30.45%" stopColor="#F7941D" />
        <stop offset="32.44%" stopColor="#FAA440" />
        <stop offset="35.69%" stopColor="#FCBD72" />
        <stop offset="38.83%" stopColor="#FFD399" />
        <stop offset="41.8%" stopColor="#FFE4BA" />
        <stop offset="44.54%" stopColor="#FFF0D2" />
        <stop offset="46.98%" stopColor="#FFF9E2" />
        <stop offset="48.87%" stopColor="#FFFDE9" />
        <stop offset="58.65%" stopColor="#FFFDE9" />
        <stop offset="60.41%" stopColor="#FFF0D0" />
        <stop offset="70.7%" stopColor="#FDBA54" />
        <stop offset="75.19%" stopColor="#FAA61A" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__cq"
        x1="2.152%"
        x2="102.54%"
        y1="51.804%"
        y2="51.804%"
      >
        <stop offset="14.66%" stopColor="#3E0900" />
        <stop offset="35.83%" stopColor="#B65316" />
        <stop offset="45.86%" stopColor="#F37021" />
        <stop offset="100%" stopColor="#FDB913" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__cr"
        x1="1.805%"
        x2="99.085%"
        y1="100.866%"
        y2="15.393%"
      >
        <stop offset="14.29%" stopColor="#3E0900" />
        <stop offset="17.55%" stopColor="#5A2300" />
        <stop offset="25.29%" stopColor="#8E4802" />
        <stop offset="32.27%" stopColor="#B96713" />
        <stop offset="38.24%" stopColor="#D97E1A" />
        <stop offset="42.97%" stopColor="#ED8D1C" />
        <stop offset="45.86%" stopColor="#F7941D" />
        <stop offset="50.77%" stopColor="#F2901D" />
        <stop offset="55.78%" stopColor="#E7881C" />
        <stop offset="60.85%" stopColor="#D77C19" />
        <stop offset="65.95%" stopColor="#BF6C15" />
        <stop offset="71.08%" stopColor="#A1560B" />
        <stop offset="76.24%" stopColor="#7F3E00" />
        <stop offset="81.32%" stopColor="#582100" />
        <stop offset="83.83%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__cs"
        x1="7.636%"
        x2="95.599%"
        y1="101.368%"
        y2="-13.677%"
      >
        <stop offset="5.639%" stopColor="#3E0800" />
        <stop offset="9.744%" stopColor="#76370B" />
        <stop offset="14.28%" stopColor="#A95C1B" />
        <stop offset="18.09%" stopColor="#D2791F" />
        <stop offset="20.96%" stopColor="#EB8B1E" />
        <stop offset="22.56%" stopColor="#F7941D" />
        <stop offset="27.59%" stopColor="#F89B2E" />
        <stop offset="33.98%" stopColor="#F9A13E" />
        <stop offset="40.83%" stopColor="#FAA647" />
        <stop offset="48.87%" stopColor="#FAA74A" />
        <stop offset="83.46%" stopColor="#F79434" />
        <stop offset="84.62%" stopColor="#F19033" />
        <stop offset="85.95%" stopColor="#E5872F" />
        <stop offset="87.37%" stopColor="#D37A29" />
        <stop offset="88.85%" stopColor="#B8671F" />
        <stop offset="90.37%" stopColor="#974F0F" />
        <stop offset="91.93%" stopColor="#723500" />
        <stop offset="93.5%" stopColor="#420E00" />
        <stop offset="93.61%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__ct"
        x1="49.838%"
        x2="49.838%"
        y1="97.068%"
        y2="-3.265%"
      >
        <stop offset="25.94%" stopColor="#FFFDE9" />
        <stop offset="27.77%" stopColor="#FFF8E2" />
        <stop offset="30.11%" stopColor="#FFEED1" />
        <stop offset="32.72%" stopColor="#FFDEB8" />
        <stop offset="35.52%" stopColor="#FDC997" />
        <stop offset="38.48%" stopColor="#FAAE70" />
        <stop offset="41.53%" stopColor="#F79041" />
        <stop offset="42.86%" stopColor="#F5822B" />
        <stop offset="44.18%" stopColor="#ED7E29" />
        <stop offset="46%" stopColor="#DF7526" />
        <stop offset="48.12%" stopColor="#C8681F" />
        <stop offset="50.45%" stopColor="#A85413" />
        <stop offset="52.96%" stopColor="#813B00" />
        <stop offset="55.58%" stopColor="#511B00" />
        <stop offset="56.39%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__cu"
        x1="14.142%"
        x2="95.195%"
        y1="98.266%"
        y2="12.866%"
      >
        <stop offset="23.68%" stopColor="#FFFDE9" />
        <stop offset="26.96%" stopColor="#FFFAE4" />
        <stop offset="30.38%" stopColor="#FFF2D7" />
        <stop offset="33.87%" stopColor="#FFE9C4" />
        <stop offset="37.39%" stopColor="#FFDBA9" />
        <stop offset="40.96%" stopColor="#FECA89" />
        <stop offset="44.56%" stopColor="#FCB564" />
        <stop offset="48.11%" stopColor="#F99E33" />
        <stop offset="49.62%" stopColor="#F7941D" />
        <stop offset="51.72%" stopColor="#EE8E1D" />
        <stop offset="54.9%" stopColor="#DD811B" />
        <stop offset="58.77%" stopColor="#C16D15" />
        <stop offset="63.19%" stopColor="#9B5208" />
        <stop offset="68%" stopColor="#6F3200" />
        <stop offset="72.18%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__cv"
        x1="9.8%"
        x2="37%"
        y1="76.85%"
        y2="2.12%"
      >
        <stop offset="3.759%" stopColor="#F7941D" />
        <stop offset="18.05%" stopColor="#F7941D" />
        <stop offset="23.1%" stopColor="#F2901D" />
        <stop offset="28.17%" stopColor="#E7881C" />
        <stop offset="33.25%" stopColor="#D77D1A" />
        <stop offset="38.35%" stopColor="#C06C15" />
        <stop offset="43.45%" stopColor="#A3570B" />
        <stop offset="48.56%" stopColor="#813F00" />
        <stop offset="53.59%" stopColor="#5A2300" />
        <stop offset="56.39%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__cw"
        x1="19%"
        x2="48.34%"
        y1="95.032%"
        y2="14.422%"
      >
        <stop offset="16.54%" stopColor="#FFFDE9" />
        <stop offset="29.32%" stopColor="#FFFDE9" />
        <stop offset="31.28%" stopColor="#FFF8E1" />
        <stop offset="34.04%" stopColor="#FFEFCF" />
        <stop offset="37.27%" stopColor="#FFE0B4" />
        <stop offset="40.86%" stopColor="#FECD8F" />
        <stop offset="44.76%" stopColor="#FCB563" />
        <stop offset="48.84%" stopColor="#F89928" />
        <stop offset="49.62%" stopColor="#F7941D" />
        <stop offset="87.59%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__cx"
        x1="10.75%"
        x2="75.69%"
        y1="105.357%"
        y2=".929%"
      >
        <stop offset="0%" stopColor="#FFFDE9" />
        <stop offset="28.6%" stopColor="#FFFDE9" />
        <stop offset="33.46%" stopColor="#FFFDE9" />
        <stop offset="36.19%" stopColor="#F6ECD6" />
        <stop offset="40.5%" stopColor="#E2CEB3" />
        <stop offset="45.86%" stopColor="#C3A181" />
        <stop offset="52.05%" stopColor="#976A47" />
        <stop offset="58.85%" stopColor="#653406" />
        <stop offset="63.16%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__cy"
        x1="36.208%"
        x2="61.869%"
        y1="86.36%"
        y2="-5.3%"
      >
        <stop offset="0%" stopColor="#F7941D" />
        <stop offset="15.39%" stopColor="#F7941D" />
        <stop offset="18.05%" stopColor="#F7941D" />
        <stop offset="19.98%" stopColor="#F18F1D" />
        <stop offset="22.25%" stopColor="#E5871C" />
        <stop offset="24.69%" stopColor="#D27919" />
        <stop offset="27.25%" stopColor="#B76612" />
        <stop offset="29.91%" stopColor="#954E05" />
        <stop offset="32.62%" stopColor="#6F3200" />
        <stop offset="35.34%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__cz"
        x1="27.05%"
        x2="37.44%"
        y1="6.82%"
        y2="65.75%"
      >
        <stop offset="46.62%" stopColor="#3E0900" />
        <stop offset="59.76%" stopColor="#7D3D00" />
        <stop offset="71.81%" stopColor="#AE6010" />
        <stop offset="81.87%" stopColor="#D47B19" />
        <stop offset="89.57%" stopColor="#EC8C1C" />
        <stop offset="93.98%" stopColor="#F7941D" />
        <stop offset="100%" stopColor="#F7941D" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__cA"
        x1="1.97%"
        x2="76.43%"
        y1="53.2%"
        y2="10.21%"
      >
        <stop offset="19.55%" stopColor="#FFFDE9" />
        <stop offset="28.7%" stopColor="#FFE2B4" />
        <stop offset="43.23%" stopColor="#FDBA63" />
        <stop offset="45.5%" stopColor="#F3B15D" />
        <stop offset="48.96%" stopColor="#E09F50" />
        <stop offset="53.18%" stopColor="#C3823C" />
        <stop offset="58.01%" stopColor="#9B5E22" />
        <stop offset="63.27%" stopColor="#6E3600" />
        <stop offset="67.67%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__cB"
        x1="12.53%"
        x2="90.365%"
        y1="90.051%"
        y2="2.581%"
      >
        <stop offset="24.06%" stopColor="#FFFDE9" />
        <stop offset="26.37%" stopColor="#FFF7DF" />
        <stop offset="30.1%" stopColor="#FFEBC8" />
        <stop offset="34.77%" stopColor="#FFD9A5" />
        <stop offset="40.21%" stopColor="#FDC179" />
        <stop offset="46.22%" stopColor="#F9A33E" />
        <stop offset="49.25%" stopColor="#F7941D" />
        <stop offset="51.4%" stopColor="#F1901D" />
        <stop offset="53.77%" stopColor="#E6871C" />
        <stop offset="56.25%" stopColor="#D47B19" />
        <stop offset="58.79%" stopColor="#BB6914" />
        <stop offset="61.4%" stopColor="#9B5208" />
        <stop offset="64.05%" stopColor="#773800" />
        <stop offset="66.69%" stopColor="#4B1700" />
        <stop offset="67.29%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__cC"
        x1="-4.4%"
        x2="101.179%"
        y1="63.455%"
        y2="39.764%"
      >
        <stop offset="23.68%" stopColor="#FFFDE9" />
        <stop offset="26.38%" stopColor="#FFF9E3" />
        <stop offset="29.49%" stopColor="#FFF0D4" />
        <stop offset="32.8%" stopColor="#FFE3BE" />
        <stop offset="36.26%" stopColor="#FED2A0" />
        <stop offset="39.82%" stopColor="#FCBB7D" />
        <stop offset="43.48%" stopColor="#F9A153" />
        <stop offset="47.15%" stopColor="#F58422" />
        <stop offset="47.37%" stopColor="#F58220" />
        <stop offset="53.31%" stopColor="#C56617" />
        <stop offset="66.9%" stopColor="#5A2200" />
        <stop offset="69.92%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__cD"
        x1="43.18%"
        x2="29.52%"
        y1="83.94%"
        y2="6.45%"
      >
        <stop offset="14.66%" stopColor="#FFCE7B" />
        <stop offset="18.57%" stopColor="#FEC973" />
        <stop offset="25.03%" stopColor="#FDBA5C" />
        <stop offset="33.2%" stopColor="#FAA235" />
        <stop offset="37.97%" stopColor="#F7941D" />
        <stop offset="40.14%" stopColor="#ED8D1C" />
        <stop offset="43.64%" stopColor="#DA7F1A" />
        <stop offset="48.03%" stopColor="#BB6914" />
        <stop offset="53.13%" stopColor="#914A03" />
        <stop offset="58.77%" stopColor="#5F2600" />
        <stop offset="61.65%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__cE"
        x1="3.675%"
        x2="96.001%"
        y1="107.944%"
        y2="10.269%"
      >
        <stop offset="14.66%" stopColor="#FFFDE9" />
        <stop offset="27.42%" stopColor="#FBB360" />
        <stop offset="33.46%" stopColor="#F7941D" />
        <stop offset="36.59%" stopColor="#DB7F1A" />
        <stop offset="43.47%" stopColor="#995107" />
        <stop offset="52.63%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__cF"
        x1="47.574%"
        x2="22.824%"
        y1="99.987%"
        y2="12.219%"
      >
        <stop offset="14.66%" stopColor="#FFFDE9" />
        <stop offset="27.42%" stopColor="#FBB360" />
        <stop offset="33.46%" stopColor="#F7941D" />
        <stop offset="36.59%" stopColor="#DB7F1A" />
        <stop offset="43.47%" stopColor="#995107" />
        <stop offset="52.63%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__cG"
        x1="13.833%"
        x2="72.283%"
        y1="106.974%"
        y2="-2.968%"
      >
        <stop offset="23.31%" stopColor="#FFFDE9" />
        <stop offset="25.81%" stopColor="#FFF8E1" />
        <stop offset="29.33%" stopColor="#FFEFCF" />
        <stop offset="33.47%" stopColor="#FFE0B4" />
        <stop offset="38.06%" stopColor="#FECD8F" />
        <stop offset="43.05%" stopColor="#FCB563" />
        <stop offset="48.28%" stopColor="#F89928" />
        <stop offset="49.25%" stopColor="#F7941D" />
        <stop offset="57.6%" stopColor="#C26E15" />
        <stop offset="66.46%" stopColor="#934C04" />
        <stop offset="74.62%" stopColor="#713400" />
        <stop offset="81.82%" stopColor="#572000" />
        <stop offset="87.77%" stopColor="#451100" />
        <stop offset="91.73%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__cH"
        x1="61.22%"
        x2="27.47%"
        y1="88.892%"
        y2="11.617%"
      >
        <stop offset="14.66%" stopColor="#FFFDE9" />
        <stop offset="16.63%" stopColor="#FFF4D7" />
        <stop offset="20.55%" stopColor="#FFE2B0" />
        <stop offset="26.04%" stopColor="#FEC875" />
        <stop offset="32.71%" stopColor="#FAA61A" />
        <stop offset="35.22%" stopColor="#DD8D18" />
        <stop offset="40.76%" stopColor="#9A5706" />
        <stop offset="48.12%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__cI"
        x1="34.314%"
        x2="55.794%"
        y1="99.275%"
        y2="-2.225%"
      >
        <stop offset="21.43%" stopColor="#FFEEBD" />
        <stop offset="25.91%" stopColor="#F8E2B1" />
        <stop offset="32.55%" stopColor="#E6C998" />
        <stop offset="40.53%" stopColor="#C9A373" />
        <stop offset="49.57%" stopColor="#A27447" />
        <stop offset="59.37%" stopColor="#754216" />
        <stop offset="69.17%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__cJ"
        x1="-3.605%"
        x2="103.61%"
        y1="72.01%"
        y2="31.26%"
      >
        <stop offset="21.8%" stopColor="#FFFDE9" />
        <stop offset="34.7%" stopColor="#FBB268" />
        <stop offset="40.23%" stopColor="#F79431" />
        <stop offset="42.57%" stopColor="#E5872C" />
        <stop offset="47.37%" stopColor="#BB691E" />
        <stop offset="54.12%" stopColor="#7D3C00" />
        <stop offset="60.15%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__cK"
        x1="28.594%"
        x2="74.867%"
        y1="-7.036%"
        y2="100.66%"
      >
        <stop offset="39.47%" stopColor="#3E0900" />
        <stop offset="44.22%" stopColor="#692E00" />
        <stop offset="49.92%" stopColor="#904A07" />
        <stop offset="55.48%" stopColor="#B36314" />
        <stop offset="60.8%" stopColor="#D0771A" />
        <stop offset="65.8%" stopColor="#E4861C" />
        <stop offset="70.35%" stopColor="#F18F1D" />
        <stop offset="74.06%" stopColor="#F7941D" />
        <stop offset="100%" stopColor="#F7941D" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__cL"
        x1="81.677%"
        x2="22.462%"
        y1="106.324%"
        y2="-1.606%"
      >
        <stop offset="9.023%" stopColor="#FFEEBD" />
        <stop offset="15.41%" stopColor="#FFEEBD" />
        <stop offset="18.49%" stopColor="#F6DFAE" />
        <stop offset="23.6%" stopColor="#DFC08F" />
        <stop offset="30.12%" stopColor="#BB9162" />
        <stop offset="37.8%" stopColor="#8C5A2F" />
        <stop offset="46.36%" stopColor="#532100" />
        <stop offset="48.87%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__cM"
        x1="17.91%"
        x2="51.9%"
        y1="63.25%"
        y2="4.37%"
      >
        <stop offset="17.29%" stopColor="#FFFDE9" />
        <stop offset="19.58%" stopColor="#FFF9E3" />
        <stop offset="22.19%" stopColor="#FFF2D5" />
        <stop offset="24.97%" stopColor="#FFE7C0" />
        <stop offset="27.86%" stopColor="#FFD8A3" />
        <stop offset="30.85%" stopColor="#FDC581" />
        <stop offset="33.9%" stopColor="#FBAE57" />
        <stop offset="36.96%" stopColor="#F89621" />
        <stop offset="37.22%" stopColor="#F7941D" />
        <stop offset="39.11%" stopColor="#E6881C" />
        <stop offset="46.52%" stopColor="#B36311" />
        <stop offset="53.6%" stopColor="#894500" />
        <stop offset="60.16%" stopColor="#6B3000" />
        <stop offset="66.08%" stopColor="#541E00" />
        <stop offset="71.16%" stopColor="#441000" />
        <stop offset="74.81%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__cN"
        x1="5.902%"
        x2="99.848%"
        y1="70.136%"
        y2="15.556%"
      >
        <stop offset="24.06%" stopColor="#F7941D" />
        <stop offset="30.35%" stopColor="#F1901D" />
        <stop offset="37.17%" stopColor="#E6881C" />
        <stop offset="44.24%" stopColor="#D57B19" />
        <stop offset="51.49%" stopColor="#BC6914" />
        <stop offset="58.87%" stopColor="#9D5309" />
        <stop offset="66.36%" stopColor="#793A00" />
        <stop offset="73.81%" stopColor="#4E1900" />
        <stop offset="75.94%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__cO"
        x1="31.272%"
        x2="88.304%"
        y1="110.563%"
        y2="2.169%"
      >
        <stop offset="37.22%" stopColor="#F7941D" />
        <stop offset="41.91%" stopColor="#E1841B" />
        <stop offset="51.85%" stopColor="#AE6010" />
        <stop offset="66.11%" stopColor="#642A00" />
        <stop offset="72.18%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__cP"
        x1="4.291%"
        x2="85.879%"
        y1="92.196%"
        y2="11.739%"
      >
        <stop offset="15.79%" stopColor="#FFEEBD" />
        <stop offset="17.15%" stopColor="#FFECB8" />
        <stop offset="18.62%" stopColor="#FFE5AC" />
        <stop offset="20.14%" stopColor="#FFDA98" />
        <stop offset="21.69%" stopColor="#FECA7F" />
        <stop offset="23.27%" stopColor="#FCB65E" />
        <stop offset="24.84%" stopColor="#F99F32" />
        <stop offset="25.56%" stopColor="#F7941D" />
        <stop offset="27.11%" stopColor="#F08E1D" />
        <stop offset="29.24%" stopColor="#E1841B" />
        <stop offset="31.7%" stopColor="#CA7317" />
        <stop offset="34.41%" stopColor="#A95C0E" />
        <stop offset="37.33%" stopColor="#813F00" />
        <stop offset="40.37%" stopColor="#521C00" />
        <stop offset="41.35%" stopColor="#3E0900" />
        <stop offset="43.05%" stopColor="#3E0900" />
        <stop offset="53.38%" stopColor="#3E0900" />
        <stop offset="65.79%" stopColor="#3E0900" />
        <stop offset="66.7%" stopColor="#4C1700" />
        <stop offset="71.59%" stopColor="#864300" />
        <stop offset="75.95%" stopColor="#B46412" />
        <stop offset="79.64%" stopColor="#D77D1A" />
        <stop offset="82.51%" stopColor="#EC8C1C" />
        <stop offset="84.21%" stopColor="#F7941D" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__cQ"
        x1="20.825%"
        x2="93.675%"
        y1="77.692%"
        y2="21.262%"
      >
        <stop offset="17.29%" stopColor="#3E0900" />
        <stop offset="25.41%" stopColor="#723500" />
        <stop offset="33.82%" stopColor="#9E5409" />
        <stop offset="41.58%" stopColor="#C36E16" />
        <stop offset="48.43%" stopColor="#DE821B" />
        <stop offset="54.1%" stopColor="#EF8E1D" />
        <stop offset="57.89%" stopColor="#F7941D" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__cR"
        x1="15.825%"
        x2="75.835%"
        y1="86.573%"
        y2="-5.091%"
      >
        <stop offset="25.94%" stopColor="#FFEEBD" />
        <stop offset="29.17%" stopColor="#FFEBB7" />
        <stop offset="33.77%" stopColor="#FFE3A6" />
        <stop offset="39.18%" stopColor="#FFD78B" />
        <stop offset="45.22%" stopColor="#FEC568" />
        <stop offset="51.69%" stopColor="#FCB034" />
        <stop offset="54.51%" stopColor="#FAA61A" />
        <stop offset="57.53%" stopColor="#F19F19" />
        <stop offset="61.94%" stopColor="#E19119" />
        <stop offset="67.22%" stopColor="#C67A15" />
        <stop offset="73.15%" stopColor="#A15C0A" />
        <stop offset="79.65%" stopColor="#763A00" />
        <stop offset="86.47%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__cS"
        x1="4.912%"
        x2="102.731%"
        y1="79.304%"
        y2="19.874%"
      >
        <stop offset="2.632%" stopColor="#3E0900" />
        <stop offset="22.11%" stopColor="#AE5F12" />
        <stop offset="34.59%" stopColor="#F7941D" />
        <stop offset="57.14%" stopColor="#F7941D" />
        <stop offset="67.72%" stopColor="#BC6A14" />
        <stop offset="79.14%" stopColor="#874400" />
        <stop offset="88.72%" stopColor="#622900" />
        <stop offset="95.95%" stopColor="#491500" />
        <stop offset="100%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__cT"
        x1="32.181%"
        x2="67.494%"
        y1="77.71%"
        y2="-20.15%"
      >
        <stop offset="6.767%" stopColor="#3E0900" />
        <stop offset="10.61%" stopColor="#662C00" />
        <stop offset="15.68%" stopColor="#8E4902" />
        <stop offset="20.62%" stopColor="#B26211" />
        <stop offset="25.31%" stopColor="#CF7718" />
        <stop offset="29.7%" stopColor="#E4861B" />
        <stop offset="33.67%" stopColor="#F08F1D" />
        <stop offset="36.84%" stopColor="#F7941D" />
        <stop offset="45.49%" stopColor="#F7941D" />
        <stop offset="49.72%" stopColor="#E98A1C" />
        <stop offset="57.7%" stopColor="#CC7517" />
        <stop offset="68.58%" stopColor="#9C5308" />
        <stop offset="81.79%" stopColor="#612800" />
        <stop offset="87.97%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__cU"
        x1="10.21%"
        x2="93.42%"
        y1="94.633%"
        y2="8.779%"
      >
        <stop offset="9.399%" stopColor="#3E0900" />
        <stop offset="27.65%" stopColor="#AE5711" />
        <stop offset="38.35%" stopColor="#F58220" />
        <stop offset="41.24%" stopColor="#F79235" />
        <stop offset="47.28%" stopColor="#FBB165" />
        <stop offset="52.92%" stopColor="#FECB89" />
        <stop offset="58%" stopColor="#FFDEA4" />
        <stop offset="62.34%" stopColor="#FFEAB6" />
        <stop offset="65.41%" stopColor="#FFEEBD" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__cV"
        x1="3.122%"
        x2="88.208%"
        y1="92.825%"
        y2="4.41%"
      >
        <stop offset="19.92%" stopColor="#FFEEBD" />
        <stop offset="23.5%" stopColor="#FFEBB6" />
        <stop offset="28.91%" stopColor="#FFE2A3" />
        <stop offset="35.47%" stopColor="#FFD486" />
        <stop offset="42.87%" stopColor="#FEC15E" />
        <stop offset="45.49%" stopColor="#FDBA4D" />
        <stop offset="48.93%" stopColor="#F1AE47" />
        <stop offset="54.82%" stopColor="#D9973B" />
        <stop offset="62.44%" stopColor="#B47327" />
        <stop offset="71.52%" stopColor="#834809" />
        <stop offset="81.7%" stopColor="#461200" />
        <stop offset="82.71%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__cW"
        x1="2.77%"
        x2="99.98%"
        y1="72.41%"
        y2="16.29%"
      >
        <stop offset="14.66%" stopColor="#FFEEBD" />
        <stop offset="21.3%" stopColor="#FFECBA" />
        <stop offset="26.05%" stopColor="#FFE8B1" />
        <stop offset="30.21%" stopColor="#FFDFA2" />
        <stop offset="34.03%" stopColor="#FFD48F" />
        <stop offset="37.62%" stopColor="#FEC577" />
        <stop offset="41.03%" stopColor="#FBB358" />
        <stop offset="44.25%" stopColor="#F99F32" />
        <stop offset="45.86%" stopColor="#F7941D" />
        <stop offset="68.1%" stopColor="#844100" />
        <stop offset="81.58%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__cX"
        x1="-11.598%"
        x2="65.232%"
        y1="87.808%"
        y2="11.508%"
      >
        <stop offset="28.57%" stopColor="#FFEEBD" />
        <stop offset="30.48%" stopColor="#FFE9B4" />
        <stop offset="33.51%" stopColor="#FFDD9F" />
        <stop offset="37.3%" stopColor="#FECA7E" />
        <stop offset="41.65%" stopColor="#FBAF51" />
        <stop offset="45.86%" stopColor="#F7941D" />
        <stop offset="63.42%" stopColor="#844100" />
        <stop offset="74.06%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__cY"
        x1="9.025%"
        x2="92.181%"
        y1="93.64%"
        y2="16.82%"
      >
        <stop offset="21.05%" stopColor="#FFFDE9" />
        <stop offset="23.38%" stopColor="#FFF8E0" />
        <stop offset="26.83%" stopColor="#FFEDCD" />
        <stop offset="31%" stopColor="#FFDEAF" />
        <stop offset="35.72%" stopColor="#FEC987" />
        <stop offset="40.83%" stopColor="#FBAF57" />
        <stop offset="45.86%" stopColor="#F7941D" />
        <stop offset="73.01%" stopColor="#844100" />
        <stop offset="89.47%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__cZ"
        x1="65.534%"
        x2="30.694%"
        y1="88.557%"
        y2="9.827%"
      >
        <stop offset="16.17%" stopColor="#FFFDE9" />
        <stop offset="18.98%" stopColor="#FFF8E1" />
        <stop offset="23.06%" stopColor="#FFEECE" />
        <stop offset="27.93%" stopColor="#FFDFB1" />
        <stop offset="33.41%" stopColor="#FECB8B" />
        <stop offset="39.38%" stopColor="#FBB15C" />
        <stop offset="45.68%" stopColor="#F8951F" />
        <stop offset="45.86%" stopColor="#F7941D" />
        <stop offset="50.96%" stopColor="#D87D1A" />
        <stop offset="62.31%" stopColor="#8F4902" />
        <stop offset="74.44%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__da"
        x1="-13.842%"
        x2="112.64%"
        y1="79.018%"
        y2="23.196%"
      >
        <stop offset="14.66%" stopColor="#FFEEBD" />
        <stop offset="41.81%" stopColor="#F99F32" />
        <stop offset="45.86%" stopColor="#F7941D" />
        <stop offset="64.12%" stopColor="#844100" />
        <stop offset="75.19%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__db"
        x1="25.209%"
        x2="77.001%"
        y1="108.355%"
        y2="4.01%"
      >
        <stop offset="14.66%" stopColor="#FFEEBD" />
        <stop offset="41.81%" stopColor="#F99F32" />
        <stop offset="45.86%" stopColor="#F7941D" />
        <stop offset="53.77%" stopColor="#CE7618" />
        <stop offset="67.64%" stopColor="#914A03" />
        <stop offset="79.1%" stopColor="#672C00" />
        <stop offset="87.56%" stopColor="#4A1600" />
        <stop offset="92.11%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__dc"
        x1="82.942%"
        x2="10.172%"
        y1="10.5%"
        y2="97.23%"
      >
        <stop offset="22.56%" stopColor="#3E0900" />
        <stop offset="45.51%" stopColor="#B86615" />
        <stop offset="56.39%" stopColor="#F7941D" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__dd"
        x1="-8.5%"
        x2="105.3%"
        y1="63.81%"
        y2="22.39%"
      >
        <stop offset="17.67%" stopColor="#FFFDE9" />
        <stop offset="36.8%" stopColor="#FBB360" />
        <stop offset="45.86%" stopColor="#F7941D" />
        <stop offset="60.14%" stopColor="#844100" />
        <stop offset="68.8%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__de"
        x1="-9.31%"
        x2="85.81%"
        y1="77.992%"
        y2="32.233%"
      >
        <stop offset="28.57%" stopColor="#F7941D" />
        <stop offset="31.99%" stopColor="#ED8C1C" />
        <stop offset="37.66%" stopColor="#D87E1A" />
        <stop offset="44.9%" stopColor="#B76612" />
        <stop offset="53.4%" stopColor="#8A4600" />
        <stop offset="62.88%" stopColor="#531D00" />
        <stop offset="65.79%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__df"
        x1="46.122%"
        x2="46.122%"
        y1="93.017%"
        y2="-4.108%"
      >
        <stop offset="33.46%" stopColor="#FFFDE9" />
        <stop offset="35.55%" stopColor="#FFF9E3" />
        <stop offset="37.92%" stopColor="#FFF2D5" />
        <stop offset="40.42%" stopColor="#FFE7C1" />
        <stop offset="43.02%" stopColor="#FFD8A4" />
        <stop offset="45.7%" stopColor="#FDC682" />
        <stop offset="48.43%" stopColor="#FBAF58" />
        <stop offset="51.17%" stopColor="#F89723" />
        <stop offset="51.5%" stopColor="#F7941D" />
        <stop offset="69.92%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__dg"
        x1="50.334%"
        x2="50.334%"
        y1="96.126%"
        y2=".164%"
      >
        <stop offset="1.88%" stopColor="#FFFDE9" />
        <stop offset="19.17%" stopColor="#FFEEBD" />
        <stop offset="49.92%" stopColor="#F99F32" />
        <stop offset="54.51%" stopColor="#F7941D" />
        <stop offset="61.09%" stopColor="#C16D15" />
        <stop offset="67.85%" stopColor="#924C04" />
        <stop offset="74.09%" stopColor="#703300" />
        <stop offset="79.59%" stopColor="#572000" />
        <stop offset="84.16%" stopColor="#451100" />
        <stop offset="87.22%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__dh"
        x1="41.527%"
        x2="41.527%"
        y1="99.038%"
        y2="-4.644%"
      >
        <stop offset="0%" stopColor="#3E0900" />
        <stop offset="22.96%" stopColor="#B86613" />
        <stop offset="33.83%" stopColor="#F7941D" />
        <stop offset="37.28%" stopColor="#F2901D" />
        <stop offset="40.85%" stopColor="#E7881C" />
        <stop offset="44.47%" stopColor="#D67C19" />
        <stop offset="48.14%" stopColor="#BF6B15" />
        <stop offset="51.84%" stopColor="#A0560A" />
        <stop offset="55.57%" stopColor="#7E3D00" />
        <stop offset="59.26%" stopColor="#551F00" />
        <stop offset="60.9%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__di"
        x1="63.97%"
        x2="-12.93%"
        y1="31.41%"
        y2="59.4%"
      >
        <stop offset="54.89%" stopColor="#3E0900" />
        <stop offset="57.82%" stopColor="#6F3200" />
        <stop offset="61.18%" stopColor="#9B5210" />
        <stop offset="64.27%" stopColor="#C16D20" />
        <stop offset="66.98%" stopColor="#DD812A" />
        <stop offset="69.21%" stopColor="#EE8E2F" />
        <stop offset="70.68%" stopColor="#F79431" />
        <stop offset="76.28%" stopColor="#F9A23B" />
        <stop offset="83.41%" stopColor="#FBAF45" />
        <stop offset="91.04%" stopColor="#FCB74B" />
        <stop offset="100%" stopColor="#FDBA4D" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__dj"
        x1="-27.936%"
        x2="98.254%"
        y1="62.188%"
        y2="31.972%"
      >
        <stop offset="10.9%" stopColor="#FFEEBD" />
        <stop offset="32.33%" stopColor="#F7941D" />
        <stop offset="37.49%" stopColor="#D57B19" />
        <stop offset="45.9%" stopColor="#A65A0D" />
        <stop offset="54.05%" stopColor="#824000" />
        <stop offset="61.74%" stopColor="#672D00" />
        <stop offset="68.85%" stopColor="#521C00" />
        <stop offset="75.18%" stopColor="#430F00" />
        <stop offset="80.08%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__dk"
        x1="52.838%"
        x2="52.838%"
        y1="97.673%"
        y2="4.282%"
      >
        <stop offset="18.8%" stopColor="#FFFDE9" />
        <stop offset="20.87%" stopColor="#FFF9E2" />
        <stop offset="23.5%" stopColor="#FFF0D3" />
        <stop offset="26.44%" stopColor="#FFE4BB" />
        <stop offset="29.61%" stopColor="#FFD39A" />
        <stop offset="32.95%" stopColor="#FDBE74" />
        <stop offset="36.39%" stopColor="#FAA543" />
        <stop offset="38.72%" stopColor="#F7941D" />
        <stop offset="42.24%" stopColor="#D57B19" />
        <stop offset="54.96%" stopColor="#6C3000" />
        <stop offset="60.53%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__dl"
        x1="-14.44%"
        x2="90.87%"
        y1="72.47%"
        y2="34.14%"
      >
        <stop offset="34.96%" stopColor="#FFFDE9" />
        <stop offset="42.36%" stopColor="#FBB360" />
        <stop offset="45.86%" stopColor="#F7941D" />
        <stop offset="61.54%" stopColor="#844100" />
        <stop offset="71.05%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__dm"
        x1="-8.079%"
        x2="99.921%"
        y1="83.74%"
        y2="18.535%"
      >
        <stop offset="22.56%" stopColor="#FFFDE9" />
        <stop offset="24.38%" stopColor="#FFF8E2" />
        <stop offset="26.78%" stopColor="#FFF0D2" />
        <stop offset="29.5%" stopColor="#FFE3B9" />
        <stop offset="32.46%" stopColor="#FED297" />
        <stop offset="35.62%" stopColor="#FCBB6F" />
        <stop offset="38.88%" stopColor="#F9A23B" />
        <stop offset="40.6%" stopColor="#F7941D" />
        <stop offset="69.55%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__dn"
        x1="13.554%"
        x2="76.654%"
        y1="99.367%"
        y2=".997%"
      >
        <stop offset="24.44%" stopColor="#3E0900" />
        <stop offset="25.41%" stopColor="#461200" />
        <stop offset="31.44%" stopColor="#703300" />
        <stop offset="37.74%" stopColor="#914B03" />
        <stop offset="44.21%" stopColor="#AF6010" />
        <stop offset="50.87%" stopColor="#C87217" />
        <stop offset="57.8%" stopColor="#DC801A" />
        <stop offset="65.1%" stopColor="#EA8A1C" />
        <stop offset="73.02%" stopColor="#F3911D" />
        <stop offset="82.71%" stopColor="#F7941D" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__do"
        x1="12.321%"
        x2="58.171%"
        y1="52.58%"
        y2="-2.06%"
      >
        <stop offset="25.56%" stopColor="#FDBA63" />
        <stop offset="53.76%" stopColor="#F79439" />
        <stop offset="56.29%" stopColor="#F08F37" />
        <stop offset="59.58%" stopColor="#E38532" />
        <stop offset="63.3%" stopColor="#CD7629" />
        <stop offset="67.32%" stopColor="#AE601D" />
        <stop offset="71.59%" stopColor="#894507" />
        <stop offset="76%" stopColor="#5E2600" />
        <stop offset="78.57%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__dp"
        x1="-1.846%"
        x2="65.564%"
        y1="67.49%"
        y2="10.92%"
      >
        <stop offset="32.33%" stopColor="#FFEEBD" />
        <stop offset="34.03%" stopColor="#FFEAB5" />
        <stop offset="36.76%" stopColor="#FFE09F" />
        <stop offset="40.2%" stopColor="#FFD07F" />
        <stop offset="44.15%" stopColor="#FDBB50" />
        <stop offset="47.74%" stopColor="#FAA61A" />
        <stop offset="50.16%" stopColor="#DC8D18" />
        <stop offset="56.85%" stopColor="#985505" />
        <stop offset="62.33%" stopColor="#6A3100" />
        <stop offset="66.32%" stopColor="#4B1700" />
        <stop offset="68.42%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__dq"
        x1="110.135%"
        x2="-1.24%"
        y1="24.787%"
        y2="69.326%"
      >
        <stop offset="28.57%" stopColor="#3E0900" />
        <stop offset="35.5%" stopColor="#622900" />
        <stop offset="51.01%" stopColor="#B26211" />
        <stop offset="62.41%" stopColor="#F7941D" />
        <stop offset="68.06%" stopColor="#FBAD52" />
        <stop offset="74.44%" stopColor="#FDC785" />
        <stop offset="80.3%" stopColor="#FFDDAD" />
        <stop offset="85.45%" stopColor="#FFEDCC" />
        <stop offset="89.68%" stopColor="#FFF7E0" />
        <stop offset="92.48%" stopColor="#FFFDE9" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__dr"
        x1="30.311%"
        x2="74.291%"
        y1="84.02%"
        y2="7.84%"
      >
        <stop offset="26.32%" stopColor="#DE7724" />
        <stop offset="30.77%" stopColor="#D57122" />
        <stop offset="38.67%" stopColor="#BD621B" />
        <stop offset="49.1%" stopColor="#974A0B" />
        <stop offset="61.5%" stopColor="#662A00" />
        <stop offset="69.55%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__ds"
        x1="19.732%"
        x2="72.122%"
        y1="90.09%"
        y2="-.64%"
      >
        <stop offset="30.08%" stopColor="#B45314" />
        <stop offset="35.69%" stopColor="#994408" />
        <stop offset="44.49%" stopColor="#753000" />
        <stop offset="52.2%" stopColor="#591F00" />
        <stop offset="58.43%" stopColor="#461100" />
        <stop offset="62.41%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__dt"
        x1="-2.519%"
        x2="89.341%"
        y1="79.523%"
        y2="20.231%"
      >
        <stop offset="49.62%" stopColor="#3E0900" />
        <stop offset="100%" stopColor="#B45314" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__du"
        x1=".102%"
        x2="102.277%"
        y1="48.757%"
        y2="48.757%"
      >
        <stop offset="20.68%" stopColor="#FFFDE9" />
        <stop offset="23.89%" stopColor="#FEF4DC" />
        <stop offset="29.32%" stopColor="#FAE1C0" />
        <stop offset="36.28%" stopColor="#F4C797" />
        <stop offset="44.51%" stopColor="#EBA565" />
        <stop offset="53.72%" stopColor="#E17E28" />
        <stop offset="55.64%" stopColor="#DE761C" />
        <stop offset="86.47%" stopColor="#FFEEBD" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__dv"
        x1="-7.306%"
        x2="100.274%"
        y1="64.47%"
        y2="25.627%"
      >
        <stop offset="1.128%" stopColor="#FFEEBD" />
        <stop offset="6.9%" stopColor="#FFECB9" />
        <stop offset="12.21%" stopColor="#FFE6AF" />
        <stop offset="17.34%" stopColor="#FFDC9D" />
        <stop offset="22.35%" stopColor="#FFCF87" />
        <stop offset="27.29%" stopColor="#FDBD6A" />
        <stop offset="32.1%" stopColor="#FAA945" />
        <stop offset="36.47%" stopColor="#F7941D" />
        <stop offset="39.42%" stopColor="#E4861B" />
        <stop offset="49.04%" stopColor="#B16110" />
        <stop offset="58.25%" stopColor="#884500" />
        <stop offset="66.8%" stopColor="#6B2F00" />
        <stop offset="74.55%" stopColor="#541E00" />
        <stop offset="81.24%" stopColor="#441000" />
        <stop offset="86.09%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__dw"
        x1="34.582%"
        x2="60.834%"
        y1="84.38%"
        y2="-19.43%"
      >
        <stop offset="16.92%" stopColor="#FFEEBD" />
        <stop offset="19.58%" stopColor="#F6DFAE" />
        <stop offset="23.99%" stopColor="#DFC08F" />
        <stop offset="29.61%" stopColor="#BB9263" />
        <stop offset="36.23%" stopColor="#8C5B30" />
        <stop offset="43.6%" stopColor="#532200" />
        <stop offset="45.86%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__dx"
        x1="-16.62%"
        x2="42.73%"
        y1="86.03%"
        y2="15.3%"
      >
        <stop offset="40.6%" stopColor="#FFEEBD" />
        <stop offset="44.01%" stopColor="#F0D7A6" />
        <stop offset="50.66%" stopColor="#CCA676" />
        <stop offset="59.9%" stopColor="#936338" />
        <stop offset="71.27%" stopColor="#4B1900" />
        <stop offset="72.93%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__dy"
        x1="14.983%"
        x2="85.073%"
        y1="104.837%"
        y2="7.249%"
      >
        <stop offset="25.94%" stopColor="#FFEEBD" />
        <stop offset="31.89%" stopColor="#E7CA99" />
        <stop offset="44.64%" stopColor="#AD8053" />
        <stop offset="63.05%" stopColor="#592700" />
        <stop offset="68.05%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__dz"
        x1="29.341%"
        x2="69.402%"
        y1="108.144%"
        y2="-5.756%"
      >
        <stop offset="19.17%" stopColor="#F58220" />
        <stop offset="23.58%" stopColor="#EA7C1E" />
        <stop offset="31.1%" stopColor="#D56F1B" />
        <stop offset="40.8%" stopColor="#B25A12" />
        <stop offset="52.32%" stopColor="#833D00" />
        <stop offset="65.24%" stopColor="#481300" />
        <stop offset="66.92%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__dA"
        x1="-3.676%"
        x2="97.91%"
        y1="50.889%"
        y2="50.889%"
      >
        <stop offset="25.56%" stopColor="#FFEEBD" />
        <stop offset="28.66%" stopColor="#F9E3B2" />
        <stop offset="32.98%" stopColor="#E8CC9B" />
        <stop offset="38.04%" stopColor="#CEA979" />
        <stop offset="43.65%" stopColor="#AA7D50" />
        <stop offset="49.7%" stopColor="#804E23" />
        <stop offset="56.06%" stopColor="#4D1B00" />
        <stop offset="57.52%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__dB"
        x1="6.903%"
        x2="109.605%"
        y1="74.686%"
        y2="29.276%"
      >
        <stop offset="14.29%" stopColor="#FFFDE9" />
        <stop offset="17.38%" stopColor="#FFF9E2" />
        <stop offset="21.71%" stopColor="#FFF1D1" />
        <stop offset="26.76%" stopColor="#FFE5B6" />
        <stop offset="32.37%" stopColor="#FFD693" />
        <stop offset="38.43%" stopColor="#FEC267" />
        <stop offset="44.78%" stopColor="#FBAB2A" />
        <stop offset="46.24%" stopColor="#FAA61A" />
        <stop offset="48.04%" stopColor="#EF9D19" />
        <stop offset="51.01%" stopColor="#DA8B18" />
        <stop offset="54.81%" stopColor="#B86F11" />
        <stop offset="59.27%" stopColor="#8B4A00" />
        <stop offset="64.24%" stopColor="#541F00" />
        <stop offset="65.79%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__dC"
        x1="38.965%"
        x2="60.381%"
        y1="102.539%"
        y2="-1.059%"
      >
        <stop offset="22.93%" stopColor="#FFFDE9" />
        <stop offset="24.61%" stopColor="#FFF9E2" />
        <stop offset="26.95%" stopColor="#FFF1D1" />
        <stop offset="29.68%" stopColor="#FFE5B6" />
        <stop offset="32.72%" stopColor="#FFD693" />
        <stop offset="36%" stopColor="#FEC267" />
        <stop offset="39.43%" stopColor="#FBAB2A" />
        <stop offset="40.23%" stopColor="#FAA61A" />
        <stop offset="45.56%" stopColor="#D38517" />
        <stop offset="57.52%" stopColor="#7D4000" />
        <stop offset="65.79%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__dD"
        x1="-1.213%"
        x2="101.012%"
        y1="48.758%"
        y2="48.758%"
      >
        <stop offset="22.93%" stopColor="#FFFDE9" />
        <stop offset="24.61%" stopColor="#FFF8E1" />
        <stop offset="26.95%" stopColor="#FFEFD0" />
        <stop offset="29.68%" stopColor="#FFE1B4" />
        <stop offset="32.72%" stopColor="#FECE90" />
        <stop offset="36%" stopColor="#FCB665" />
        <stop offset="39.43%" stopColor="#F89A2B" />
        <stop offset="40.23%" stopColor="#F7941D" />
        <stop offset="49.59%" stopColor="#BE6B14" />
        <stop offset="72.56%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__dE"
        x1="33.719%"
        x2="59.579%"
        y1="105.257%"
        y2=".84%"
      >
        <stop offset="7.519%" stopColor="#FFFDE9" />
        <stop offset="27.67%" stopColor="#FBB360" />
        <stop offset="37.22%" stopColor="#F7941D" />
        <stop offset="48.36%" stopColor="#C26D15" />
        <stop offset="62.07%" stopColor="#8A4600" />
        <stop offset="73.52%" stopColor="#642A00" />
        <stop offset="82.1%" stopColor="#491500" />
        <stop offset="86.84%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__dF"
        x1=".479%"
        x2="99.34%"
        y1="44.866%"
        y2="44.866%"
      >
        <stop offset="0%" stopColor="#F58220" />
        <stop offset="49.62%" stopColor="#FAA74A" />
        <stop offset="55.19%" stopColor="#F3A145" />
        <stop offset="62.22%" stopColor="#E59539" />
        <stop offset="70.02%" stopColor="#D08326" />
        <stop offset="77.07%" stopColor="#B76E11" />
        <stop offset="81.48%" stopColor="#BE7013" />
        <stop offset="88.51%" stopColor="#D07419" />
        <stop offset="93.23%" stopColor="#DE761C" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__dG"
        x1="23.785%"
        x2="68.723%"
        y1="108.879%"
        y2="-3.328%"
      >
        <stop offset="43.61%" stopColor="#3E0900" />
        <stop offset="46.92%" stopColor="#4E1800" />
        <stop offset="53.5%" stopColor="#713200" />
        <stop offset="62.63%" stopColor="#A65511" />
        <stop offset="68.05%" stopColor="#CA6C18" />
        <stop offset="90.98%" stopColor="#FFE293" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__dH"
        x1="5.531%"
        x2="90.425%"
        y1="94.288%"
        y2="6.425%"
      >
        <stop offset="0%" stopColor="#C6401B" />
        <stop offset="14.42%" stopColor="#D14F1D" />
        <stop offset="43.81%" stopColor="#E3651F" />
        <stop offset="72.63%" stopColor="#EE7320" />
        <stop offset="100%" stopColor="#F47920" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__dI"
        x1="3.18%"
        x2="27.6%"
        y1="30.94%"
        y2="30.94%"
      >
        <stop offset="29.32%" stopColor="#A53410" />
        <stop offset="29.91%" stopColor="#A63612" />
        <stop offset="40.46%" stopColor="#BC623A" />
        <stop offset="50.99%" stopColor="#CF8963" />
        <stop offset="61.24%" stopColor="#E0AE8B" />
        <stop offset="71.17%" stopColor="#EDCCAF" />
        <stop offset="80.69%" stopColor="#F6E4CB" />
        <stop offset="89.62%" stopColor="#FDF4DF" />
        <stop offset="97.37%" stopColor="#FFFDE9" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__dJ"
        x1="42.03%"
        x2="16.42%"
        y1="45.8%"
        y2="1.44%"
      >
        <stop offset="41.73%" stopColor="#3E0900" />
        <stop offset="68.42%" stopColor="#A93512" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__dK"
        x1="49.603%"
        x2="55.658%"
        y1="49.731%"
        y2="54.347%"
      >
        <stop offset="0%" stopColor="#A53410" />
        <stop offset="37.91%" stopColor="#A63511" />
        <stop offset="55.66%" stopColor="#AC3A13" />
        <stop offset="69.22%" stopColor="#B74316" />
        <stop offset="80.65%" stopColor="#C5501A" />
        <stop offset="90.63%" stopColor="#D8611D" />
        <stop offset="99.64%" stopColor="#F27820" />
        <stop offset="100%" stopColor="#F47920" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__dL"
        x1="22.27%"
        x2="22.27%"
        y1="32.5%"
        y2="5.16%"
      >
        <stop offset="10.15%" stopColor="#3E0900" />
        <stop offset="22.8%" stopColor="#601F00" />
        <stop offset="36.2%" stopColor="#792900" />
        <stop offset="49.87%" stopColor="#8C2F03" />
        <stop offset="63.73%" stopColor="#99320B" />
        <stop offset="77.9%" stopColor="#A2330F" />
        <stop offset="92.86%" stopColor="#A53410" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__dM"
        x1="37.89%"
        x2="35.06%"
        y1="30.73%"
        y2="14.65%"
      >
        <stop offset="29.32%" stopColor="#A53410" />
        <stop offset="29.91%" stopColor="#A63612" />
        <stop offset="40.46%" stopColor="#BC623A" />
        <stop offset="50.99%" stopColor="#CF8963" />
        <stop offset="61.24%" stopColor="#E0AE8B" />
        <stop offset="71.17%" stopColor="#EDCCAF" />
        <stop offset="80.69%" stopColor="#F6E4CB" />
        <stop offset="89.62%" stopColor="#FDF4DF" />
        <stop offset="97.37%" stopColor="#FFFDE9" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__dN"
        x1=".517%"
        x2="99.404%"
        y1="41.67%"
        y2="52.771%"
      >
        <stop offset="0%" stopColor="#C6401B" />
        <stop offset="38.16%" stopColor="#D4521D" />
        <stop offset="100%" stopColor="#F47920" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__dO"
        x1="25.88%"
        x2="40.95%"
        y1="39.15%"
        y2="19.87%"
      >
        <stop offset="6.391%" stopColor="#3E0900" />
        <stop offset="20.13%" stopColor="#793D00" />
        <stop offset="48.12%" stopColor="#FAA61A" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__dP"
        x1=".614%"
        x2="100.419%"
        y1="51.843%"
        y2="51.843%"
      >
        <stop offset="4.511%" stopColor="#DE761C" />
        <stop offset="9.172%" stopColor="#E17C1C" />
        <stop offset="15.56%" stopColor="#EA8B1C" />
        <stop offset="22.56%" stopColor="#FAA61A" />
        <stop offset="46.24%" stopColor="#FFFDE9" />
        <stop offset="59.4%" stopColor="#FFFDE9" />
        <stop offset="62.6%" stopColor="#FFF3D5" />
        <stop offset="69.12%" stopColor="#FFE0A9" />
        <stop offset="78.28%" stopColor="#FEC268" />
        <stop offset="86.84%" stopColor="#FAA61A" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__dQ"
        x1="9.03%"
        x2="84.33%"
        y1="106.036%"
        y2="12.871%"
      >
        <stop offset="24.44%" stopColor="#3E0900" />
        <stop offset="33.25%" stopColor="#692C00" />
        <stop offset="43.69%" stopColor="#904603" />
        <stop offset="53.43%" stopColor="#B15B12" />
        <stop offset="62.17%" stopColor="#CA6A18" />
        <stop offset="69.59%" stopColor="#D9731B" />
        <stop offset="74.81%" stopColor="#DE761C" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__dR"
        x1="24.555%"
        x2="75.764%"
        y1="103.004%"
        y2="5.434%"
      >
        <stop offset="50%" stopColor="#FAA61A" />
        <stop offset="52.97%" stopColor="#ED9B19" />
        <stop offset="58.42%" stopColor="#D18317" />
        <stop offset="65.72%" stopColor="#A55F0B" />
        <stop offset="74.5%" stopColor="#6E3400" />
        <stop offset="80.83%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__dS"
        x1="99.575%"
        x2="10.067%"
        y1="87.9%"
        y2="12.792%"
      >
        <stop offset="25.56%" stopColor="#FAA61A" />
        <stop offset="26.46%" stopColor="#FBAD2E" />
        <stop offset="28.68%" stopColor="#FDBC58" />
        <stop offset="31.14%" stopColor="#FECB7B" />
        <stop offset="33.78%" stopColor="#FFD796" />
        <stop offset="36.65%" stopColor="#FFE2AF" />
        <stop offset="39.85%" stopColor="#FFEBC3" />
        <stop offset="43.49%" stopColor="#FFF2D3" />
        <stop offset="47.86%" stopColor="#FFF7DF" />
        <stop offset="53.69%" stopColor="#FFFCE6" />
        <stop offset="66.92%" stopColor="#FFFDE9" />
        <stop offset="82.71%" stopColor="#FDB913" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__dT"
        x1="85.19%"
        x2="14.39%"
        y1="92.835%"
        y2="20.7%"
      >
        <stop offset="25.56%" stopColor="#FDB913" />
        <stop offset="32.38%" stopColor="#FCB017" />
        <stop offset="45.25%" stopColor="#FAA51A" />
        <stop offset="60.31%" stopColor="#F99F1B" />
        <stop offset="82.71%" stopColor="#F99D1C" />
        <stop offset="95.86%" stopColor="#FFFDE9" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__dU"
        x1="11.333%"
        x2="82.9%"
        y1="-15.06%"
        y2="34.52%"
      >
        <stop offset=".376%" stopColor="#F99D1C" />
        <stop offset="6.721%" stopColor="#F9A01B" />
        <stop offset="27.42%" stopColor="#FAA51A" />
        <stop offset="84.96%" stopColor="#FAA61A" />
        <stop offset="97.37%" stopColor="#FFFDE9" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__dV"
        x1="27.72%"
        x2="58.45%"
        y1="47.96%"
        y2="11.32%"
      >
        <stop offset="8.647%" stopColor="#3E0900" />
        <stop offset="15.4%" stopColor="#743700" />
        <stop offset="23.28%" stopColor="#A85F0D" />
        <stop offset="29.88%" stopColor="#D27F18" />
        <stop offset="34.84%" stopColor="#EC931B" />
        <stop offset="37.59%" stopColor="#F99D1C" />
        <stop offset="64.29%" stopColor="#FAA61A" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__dW"
        x1="78.057%"
        x2="21.8%"
        y1="11.614%"
        y2="88.9%"
      >
        <stop offset="26.32%" stopColor="#FAA61A" />
        <stop offset="26.67%" stopColor="#FAA71C" />
        <stop offset="34.88%" stopColor="#FEC052" />
        <stop offset="41.98%" stopColor="#FFD276" />
        <stop offset="47.63%" stopColor="#FFDE8B" />
        <stop offset="51.13%" stopColor="#FFE293" />
        <stop offset="81.95%" stopColor="#FAA61A" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__dX"
        x1="184.567%"
        x2="-77.833%"
        y1="75.255%"
        y2="27.215%"
      >
        <stop offset="29.32%" stopColor="#F58220" />
        <stop offset="45.03%" stopColor="#F7901E" />
        <stop offset="61.96%" stopColor="#F8991D" />
        <stop offset="76.69%" stopColor="#F99D1C" />
        <stop offset="78.74%" stopColor="#F99F21" />
        <stop offset="81.68%" stopColor="#FAA734" />
        <stop offset="85.15%" stopColor="#FCB451" />
        <stop offset="89.04%" stopColor="#FEC677" />
        <stop offset="93.21%" stopColor="#FFDEA5" />
        <stop offset="97.37%" stopColor="#FFFCDF" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__dY"
        x1="8.715%"
        x2="92.085%"
        y1="48.234%"
        y2="51.787%"
      >
        <stop offset="3.759%" stopColor="#F58220" />
        <stop offset="18.8%" stopColor="#3E0900" />
        <stop offset="28.55%" stopColor="#420D00" />
        <stop offset="37.54%" stopColor="#4C1700" />
        <stop offset="46.24%" stopColor="#5B2400" />
        <stop offset="54.75%" stopColor="#703300" />
        <stop offset="63.13%" stopColor="#840" />
        <stop offset="71.41%" stopColor="#A85B0D" />
        <stop offset="79.45%" stopColor="#CF7718" />
        <stop offset="86.09%" stopColor="#F7941D" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__dZ"
        x1="5.03%"
        x2="37.31%"
        y1="40.01%"
        y2="28.26%"
      >
        <stop offset="33.83%" stopColor="#F7941D" />
        <stop offset="42.6%" stopColor="#FBAE57" />
        <stop offset="51.62%" stopColor="#FEC987" />
        <stop offset="59.94%" stopColor="#FFDEAF" />
        <stop offset="67.28%" stopColor="#FFEDCD" />
        <stop offset="73.36%" stopColor="#FFF8E0" />
        <stop offset="77.44%" stopColor="#FFFDE9" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__ea"
        x1="31.68%"
        x2="19.67%"
        y1="45.59%"
        y2="12.6%"
      >
        <stop offset="33.83%" stopColor="#B34215" />
        <stop offset="42.6%" stopColor="#C76E40" />
        <stop offset="51.62%" stopColor="#DA996F" />
        <stop offset="59.94%" stopColor="#EABF9C" />
        <stop offset="67.28%" stopColor="#F4DDC2" />
        <stop offset="73.36%" stopColor="#FCF2DC" />
        <stop offset="77.44%" stopColor="#FFFDE9" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__eb"
        x1="42.096%"
        x2="52.626%"
        y1="45.625%"
        y2="48.977%"
      >
        <stop offset="0%" stopColor="#A53410" />
        <stop offset="37.91%" stopColor="#A63511" />
        <stop offset="55.66%" stopColor="#AC3A13" />
        <stop offset="69.22%" stopColor="#B74316" />
        <stop offset="80.65%" stopColor="#C5501A" />
        <stop offset="90.63%" stopColor="#D8611D" />
        <stop offset="99.64%" stopColor="#F27820" />
        <stop offset="100%" stopColor="#F47920" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__ec"
        x1="19.944%"
        x2="37.834%"
        y1="9.89%"
        y2="59.03%"
      >
        <stop offset="0%" stopColor="#B34215" />
        <stop offset="15.04%" stopColor="#A53C10" />
        <stop offset="15.33%" stopColor="#A33C0F" />
        <stop offset="18.78%" stopColor="#893301" />
        <stop offset="22.53%" stopColor="#742B00" />
        <stop offset="26.68%" stopColor="#622200" />
        <stop offset="31.32%" stopColor="#531900" />
        <stop offset="36.74%" stopColor="#471200" />
        <stop offset="43.65%" stopColor="#400B00" />
        <stop offset="57.14%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__ed"
        x1="46.011%"
        x2="55.585%"
        y1="49.018%"
        y2="52.011%"
      >
        <stop offset="0%" stopColor="#A53410" />
        <stop offset="37.91%" stopColor="#A63511" />
        <stop offset="55.66%" stopColor="#AC3A13" />
        <stop offset="69.22%" stopColor="#B74316" />
        <stop offset="80.65%" stopColor="#C5501A" />
        <stop offset="90.63%" stopColor="#D8611D" />
        <stop offset="99.64%" stopColor="#F27820" />
        <stop offset="100%" stopColor="#F47920" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__ee"
        x1="-3.95%"
        x2="37.36%"
        y1="27.222%"
        y2="27.222%"
      >
        <stop offset="29.32%" stopColor="#A53410" />
        <stop offset="29.91%" stopColor="#A63612" />
        <stop offset="40.46%" stopColor="#BC623A" />
        <stop offset="50.99%" stopColor="#CF8963" />
        <stop offset="61.24%" stopColor="#E0AE8B" />
        <stop offset="71.17%" stopColor="#EDCCAF" />
        <stop offset="80.69%" stopColor="#F6E4CB" />
        <stop offset="89.62%" stopColor="#FDF4DF" />
        <stop offset="97.37%" stopColor="#FFFDE9" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__ef"
        x1="30.926%"
        x2="69.269%"
        y1="83.653%"
        y2="17.232%"
      >
        <stop offset="0%" stopColor="#C6401B" />
        <stop offset="21.88%" stopColor="#D2501D" />
        <stop offset="71.04%" stopColor="#E96D1F" />
        <stop offset="100%" stopColor="#F47920" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__eg"
        x1="6.684%"
        x2="100.961%"
        y1="75.685%"
        y2="23.384%"
      >
        <stop offset="0%" stopColor="#C6401B" />
        <stop offset="100%" stopColor="#F47920" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__eh"
        x1=".64%"
        x2="30.76%"
        y1="26.84%"
        y2="32.16%"
      >
        <stop offset="12.78%" stopColor="#DE761C" />
        <stop offset="13.97%" stopColor="#E1802A" />
        <stop offset="17.28%" stopColor="#E89952" />
        <stop offset="20.76%" stopColor="#EEB075" />
        <stop offset="24.37%" stopColor="#F3C694" />
        <stop offset="28.13%" stopColor="#F7D7B0" />
        <stop offset="32.09%" stopColor="#FBE6C7" />
        <stop offset="36.34%" stopColor="#FEF1D9" />
        <stop offset="41.09%" stopColor="#FFFAE4" />
        <stop offset="47.37%" stopColor="#FFFDE9" />
        <stop offset="49.39%" stopColor="#FFF6DD" />
        <stop offset="52.9%" stopColor="#FFEAC3" />
        <stop offset="57.47%" stopColor="#FFD69B" />
        <stop offset="62.92%" stopColor="#FDBD67" />
        <stop offset="69.07%" stopColor="#F99D1D" />
        <stop offset="69.17%" stopColor="#F99D1C" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__ei"
        x1="35.52%"
        x2="40.49%"
        y1="40.1%"
        y2="11.91%"
      >
        <stop offset="32.33%" stopColor="#3E0900" />
        <stop offset="32.67%" stopColor="#410C00" />
        <stop offset="40.87%" stopColor="#713600" />
        <stop offset="49.05%" stopColor="#975505" />
        <stop offset="57%" stopColor="#B97012" />
        <stop offset="64.71%" stopColor="#D48617" />
        <stop offset="72.08%" stopColor="#E79619" />
        <stop offset="78.99%" stopColor="#F4A11A" />
        <stop offset="84.96%" stopColor="#FAA61A" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__ej"
        x1="7.606%"
        x2="86.713%"
        y1="100.441%"
        y2=".795%"
      >
        <stop offset="17.67%" stopColor="#3E0900" />
        <stop offset="31.64%" stopColor="#692C00" />
        <stop offset="63.48%" stopColor="#CB6B19" />
        <stop offset="69.17%" stopColor="#DE761C" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__ek"
        x1="35.08%"
        x2="39.71%"
        y1="34.24%"
        y2="7.96%"
      >
        <stop offset="30.08%" stopColor="#3E0900" />
        <stop offset="37.37%" stopColor="#5A2400" />
        <stop offset="53.44%" stopColor="#975505" />
        <stop offset="74.81%" stopColor="#FAA61A" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__el"
        x1="3.267%"
        x2="96.605%"
        y1="87.273%"
        y2="38.264%"
      >
        <stop offset="4.511%" stopColor="#DE761C" />
        <stop offset="9.172%" stopColor="#E17C1C" />
        <stop offset="15.56%" stopColor="#EA8B1C" />
        <stop offset="22.56%" stopColor="#FAA61A" />
        <stop offset="28.16%" stopColor="#FCB649" />
        <stop offset="35.41%" stopColor="#FECA7A" />
        <stop offset="42.49%" stopColor="#FFDB9F" />
        <stop offset="49.22%" stopColor="#FFE9BE" />
        <stop offset="55.52%" stopColor="#FFF2D4" />
        <stop offset="61.22%" stopColor="#FFF9E3" />
        <stop offset="65.79%" stopColor="#FFFDE9" />
        <stop offset="67.74%" stopColor="#FFF7DE" />
        <stop offset="71.06%" stopColor="#FFECC5" />
        <stop offset="75.36%" stopColor="#FFDB9F" />
        <stop offset="80.47%" stopColor="#FEC46D" />
        <stop offset="86.21%" stopColor="#FBA922" />
        <stop offset="86.84%" stopColor="#FAA61A" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__em"
        x1="-10.962%"
        x2="100.3%"
        y1="92.231%"
        y2="11.847%"
      >
        <stop offset="51.13%" stopColor="#DC661E" />
        <stop offset="58.57%" stopColor="#BA5516" />
        <stop offset="71.1%" stopColor="#863B00" />
        <stop offset="81.61%" stopColor="#622500" />
        <stop offset="89.54%" stopColor="#491400" />
        <stop offset="93.98%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__en"
        x1="-7.354%"
        x2="98.657%"
        y1="18.676%"
        y2="97.467%"
      >
        <stop offset="18.42%" stopColor="#DC661E" />
        <stop offset="20.06%" stopColor="#DF7028" />
        <stop offset="26.51%" stopColor="#E8945A" />
        <stop offset="32.67%" stopColor="#F0B685" />
        <stop offset="38.38%" stopColor="#F6D2AC" />
        <stop offset="43.53%" stopColor="#FBE7CB" />
        <stop offset="47.95%" stopColor="#FFF6DF" />
        <stop offset="51.13%" stopColor="#FFFDE9" />
        <stop offset="53.34%" stopColor="#FFF5DF" />
        <stop offset="56.65%" stopColor="#FBE7C8" />
        <stop offset="60.64%" stopColor="#F6D2A7" />
        <stop offset="65.15%" stopColor="#F0B77E" />
        <stop offset="70.05%" stopColor="#E7964E" />
        <stop offset="74.81%" stopColor="#DE761C" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__eo"
        x1="-2.519%"
        x2="106.973%"
        y1="93.894%"
        y2="12.783%"
      >
        <stop offset="0%" stopColor="#C6401B" />
        <stop offset="67.05%" stopColor="#E2641F" />
        <stop offset="100%" stopColor="#F47920" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__ep"
        x1="10.33%"
        x2="46.41%"
        y1="53.91%"
        y2="23.64%"
      >
        <stop offset="30.08%" stopColor="#3E0900" />
        <stop offset="37.55%" stopColor="#763A00" />
        <stop offset="45.82%" stopColor="#AA630D" />
        <stop offset="52.76%" stopColor="#D48517" />
        <stop offset="57.98%" stopColor="#ED9B19" />
        <stop offset="60.9%" stopColor="#FAA61A" />
        <stop offset="62.55%" stopColor="#FBA919" />
        <stop offset="69.35%" stopColor="#FDB515" />
        <stop offset="74.81%" stopColor="#FDB913" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__eq"
        x1="-.162%"
        x2="100.153%"
        y1="24.61%"
        y2="24.61%"
      >
        <stop offset="4.887%" stopColor="#FDB913" />
        <stop offset="8.581%" stopColor="#FEC136" />
        <stop offset="15.68%" stopColor="#FFCF68" />
        <stop offset="22.95%" stopColor="#FFDC8C" />
        <stop offset="30.27%" stopColor="#FFE6A9" />
        <stop offset="37.66%" stopColor="#FFEFC0" />
        <stop offset="45.16%" stopColor="#FFF5D0" />
        <stop offset="52.82%" stopColor="#FFFADB" />
        <stop offset="60.9%" stopColor="#FFFCDF" />
        <stop offset="64.11%" stopColor="#FFF9D8" />
        <stop offset="68.6%" stopColor="#FFF2C8" />
        <stop offset="73.85%" stopColor="#FFE8AE" />
        <stop offset="79.67%" stopColor="#FFDB8C" />
        <stop offset="85.96%" stopColor="#FFCC5E" />
        <stop offset="92.55%" stopColor="#FDB917" />
        <stop offset="92.86%" stopColor="#FDB913" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__er"
        x1="35%"
        x2="11.01%"
        y1="53.34%"
        y2="24.75%"
      >
        <stop offset="12.41%" stopColor="#DC661E" />
        <stop offset="14.9%" stopColor="#DE6B1E" />
        <stop offset="29.82%" stopColor="#E7851C" />
        <stop offset="45.03%" stopColor="#EF9A1A" />
        <stop offset="60.45%" stopColor="#F6AA17" />
        <stop offset="76.22%" stopColor="#FBB514" />
        <stop offset="92.86%" stopColor="#FDB913" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__es"
        x1="-8.264%"
        x2="29.301%"
        y1="49.172%"
        y2="50.125%"
      >
        <stop offset="0%" stopColor="#A53410" />
        <stop offset="14.35%" stopColor="#B74417" />
        <stop offset="37.23%" stopColor="#D05A1C" />
        <stop offset="59.55%" stopColor="#E26A1E" />
        <stop offset="80.84%" stopColor="#EE7420" />
        <stop offset="100%" stopColor="#F47920" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__et"
        x1="-.796%"
        x2="48.854%"
        y1="47.225%"
        y2="48.091%"
      >
        <stop offset="0%" stopColor="#A53410" />
        <stop offset="14.35%" stopColor="#B74417" />
        <stop offset="37.23%" stopColor="#D05A1C" />
        <stop offset="59.55%" stopColor="#E26A1E" />
        <stop offset="80.84%" stopColor="#EE7420" />
        <stop offset="100%" stopColor="#F47920" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__eu"
        x1=".539%"
        x2="100.03%"
        y1="41.05%"
        y2="41.05%"
      >
        <stop offset="0%" stopColor="#A53410" />
        <stop offset="2.561%" stopColor="#B44116" />
        <stop offset="10.2%" stopColor="#E0681E" />
        <stop offset="13.91%" stopColor="#F47920" />
        <stop offset="29.7%" stopColor="#FAA61A" />
        <stop offset="32.21%" stopColor="#FCB33E" />
        <stop offset="35.95%" stopColor="#FEC56B" />
        <stop offset="39.81%" stopColor="#FFD58C" />
        <stop offset="43.73%" stopColor="#FFE2A9" />
        <stop offset="47.73%" stopColor="#FFECC0" />
        <stop offset="51.84%" stopColor="#FFF4D0" />
        <stop offset="56.13%" stopColor="#FFFADB" />
        <stop offset="60.9%" stopColor="#FFFCDF" />
        <stop offset="64.11%" stopColor="#FFF9D8" />
        <stop offset="68.6%" stopColor="#FFF2C8" />
        <stop offset="73.85%" stopColor="#FFE8AE" />
        <stop offset="79.67%" stopColor="#FFDB8C" />
        <stop offset="85.96%" stopColor="#FFCC5E" />
        <stop offset="92.55%" stopColor="#FDB917" />
        <stop offset="92.86%" stopColor="#FDB913" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__ev"
        x1="49.38%"
        x2="26.28%"
        y1="50.02%"
        y2="22.49%"
      >
        <stop offset="33.83%" stopColor="#DC661E" />
        <stop offset="35.66%" stopColor="#DE6B1E" />
        <stop offset="46.61%" stopColor="#E7851C" />
        <stop offset="57.77%" stopColor="#EF9A1A" />
        <stop offset="69.08%" stopColor="#F6AA17" />
        <stop offset="80.65%" stopColor="#FBB514" />
        <stop offset="92.86%" stopColor="#FDB913" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__ew"
        x1="-1.081%"
        x2="47.799%"
        y1="51.192%"
        y2="52.432%"
      >
        <stop offset="0%" stopColor="#A53410" />
        <stop offset="14.35%" stopColor="#B74417" />
        <stop offset="37.23%" stopColor="#D05A1C" />
        <stop offset="59.55%" stopColor="#E26A1E" />
        <stop offset="80.84%" stopColor="#EE7420" />
        <stop offset="100%" stopColor="#F47920" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__ex"
        x1="2.052%"
        x2="51.812%"
        y1="53.084%"
        y2="54.01%"
      >
        <stop offset="0%" stopColor="#A53410" />
        <stop offset="14.35%" stopColor="#B74417" />
        <stop offset="37.23%" stopColor="#D05A1C" />
        <stop offset="59.55%" stopColor="#E26A1E" />
        <stop offset="80.84%" stopColor="#EE7420" />
        <stop offset="100%" stopColor="#F47920" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__ey"
        x1="-.013%"
        x2="99.049%"
        y1="35.03%"
        y2="35.03%"
      >
        <stop offset="0%" stopColor="#A53410" />
        <stop offset="2.561%" stopColor="#B44116" />
        <stop offset="10.2%" stopColor="#E0681E" />
        <stop offset="13.91%" stopColor="#F47920" />
        <stop offset="29.7%" stopColor="#FAA61A" />
        <stop offset="32.21%" stopColor="#FCB33E" />
        <stop offset="35.95%" stopColor="#FEC56B" />
        <stop offset="39.81%" stopColor="#FFD58C" />
        <stop offset="43.73%" stopColor="#FFE2A9" />
        <stop offset="47.73%" stopColor="#FFECC0" />
        <stop offset="51.84%" stopColor="#FFF4D0" />
        <stop offset="56.13%" stopColor="#FFFADB" />
        <stop offset="60.9%" stopColor="#FFFCDF" />
        <stop offset="64.11%" stopColor="#FFF9D8" />
        <stop offset="68.6%" stopColor="#FFF2C8" />
        <stop offset="73.85%" stopColor="#FFE8AE" />
        <stop offset="79.67%" stopColor="#FFDB8C" />
        <stop offset="85.96%" stopColor="#FFCC5E" />
        <stop offset="92.55%" stopColor="#FDB917" />
        <stop offset="92.86%" stopColor="#FDB913" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__ez"
        x1="26.97%"
        x2="12.13%"
        y1="36.67%"
        y2="18.99%"
      >
        <stop offset="12.41%" stopColor="#DC661E" />
        <stop offset="14.9%" stopColor="#DE6B1E" />
        <stop offset="29.82%" stopColor="#E7851C" />
        <stop offset="45.03%" stopColor="#EF9A1A" />
        <stop offset="60.45%" stopColor="#F6AA17" />
        <stop offset="76.22%" stopColor="#FBB514" />
        <stop offset="92.86%" stopColor="#FDB913" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__eA"
        x1="-1.515%"
        x2="49.635%"
        y1="47.361%"
        y2="48.551%"
      >
        <stop offset="0%" stopColor="#A53410" />
        <stop offset="14.35%" stopColor="#B74417" />
        <stop offset="37.23%" stopColor="#D05A1C" />
        <stop offset="59.55%" stopColor="#E26A1E" />
        <stop offset="80.84%" stopColor="#EE7420" />
        <stop offset="100%" stopColor="#F47920" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__eB"
        x1="29.378%"
        x2="92.731%"
        y1="83.156%"
        y2="13.476%"
      >
        <stop offset="23.6%" stopColor="#C6401B" />
        <stop offset="34.62%" stopColor="#D14F1D" />
        <stop offset="57.07%" stopColor="#E3651F" />
        <stop offset="79.09%" stopColor="#EE7320" />
        <stop offset="100%" stopColor="#F47920" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__eC"
        x1="31.68%"
        x2="39.67%"
        y1="48.34%"
        y2="23.73%"
      >
        <stop offset="54.51%" stopColor="#3E0900" />
        <stop offset="66.85%" stopColor="#7A3400" />
        <stop offset="79.29%" stopColor="#AD4F12" />
        <stop offset="88.29%" stopColor="#CF601B" />
        <stop offset="92.86%" stopColor="#DC661E" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__eD"
        x1="16.222%"
        x2="86.044%"
        y1="114.031%"
        y2="-1.185%"
      >
        <stop offset="13.53%" stopColor="#DC661E" />
        <stop offset="15.21%" stopColor="#E16B1E" />
        <stop offset="21.02%" stopColor="#EB771F" />
        <stop offset="29.19%" stopColor="#F27F1F" />
        <stop offset="51.88%" stopColor="#F58220" />
        <stop offset="68.58%" stopColor="#F6871F" />
        <stop offset="91.92%" stopColor="#F7931E" />
        <stop offset="92.86%" stopColor="#F7941D" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__eE"
        x1="2.37%"
        x2="69.92%"
        y1="28%"
        y2="39.91%"
      >
        <stop offset="79.32%" stopColor="#F7941D" />
        <stop offset="84.09%" stopColor="#FCBB6B" />
        <stop offset="88.31%" stopColor="#FFDCA6" />
        <stop offset="91.33%" stopColor="#FFF1CE" />
        <stop offset="92.86%" stopColor="#FFFCDF" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__eF"
        x1="31.33%"
        x2="-2.74%"
        y1="36.67%"
        y2="24.27%"
      >
        <stop offset="13.53%" stopColor="#F58220" />
        <stop offset="20.76%" stopColor="#F79641" />
        <stop offset="30.53%" stopColor="#FAAF6B" />
        <stop offset="40.54%" stopColor="#FDC68D" />
        <stop offset="50.64%" stopColor="#FFD9AC" />
        <stop offset="60.83%" stopColor="#FFE7C5" />
        <stop offset="71.16%" stopColor="#FFF2D8" />
        <stop offset="81.72%" stopColor="#FFF9E4" />
        <stop offset="92.86%" stopColor="#FFFDE9" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__eG"
        x1="22.22%"
        x2="28.33%"
        y1="27.73%"
        y2="10.94%"
      >
        <stop offset="25.94%" stopColor="#3E0900" />
        <stop offset="35.76%" stopColor="#692C00" />
        <stop offset="58.1%" stopColor="#CA6919" />
        <stop offset="66.54%" stopColor="#F58220" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__eH"
        x1="-.482%"
        x2="100.671%"
        y1="49.706%"
        y2="49.706%"
      >
        <stop offset="8.271%" stopColor="#DC661E" />
        <stop offset="11.17%" stopColor="#DF6C1E" />
        <stop offset="15.8%" stopColor="#E77F1D" />
        <stop offset="21.54%" stopColor="#F69E1B" />
        <stop offset="22.56%" stopColor="#FAA61A" />
        <stop offset="23%" stopColor="#FBAB2A" />
        <stop offset="24.51%" stopColor="#FDBD5A" />
        <stop offset="26.1%" stopColor="#FFCD80" />
        <stop offset="27.75%" stopColor="#FFDB9E" />
        <stop offset="29.45%" stopColor="#FFE6B8" />
        <stop offset="31.24%" stopColor="#FFEFCC" />
        <stop offset="33.14%" stopColor="#FFF6DB" />
        <stop offset="35.25%" stopColor="#FFFBE5" />
        <stop offset="37.97%" stopColor="#FFFDE9" />
        <stop offset="52.26%" stopColor="#FFFDE9" />
        <stop offset="56.29%" stopColor="#FFF0D4" />
        <stop offset="64.51%" stopColor="#FED4A5" />
        <stop offset="76.05%" stopColor="#FAAA62" />
        <stop offset="86.84%" stopColor="#F58220" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__eI"
        x1="-3.239%"
        x2="95.673%"
        y1="32.132%"
        y2="71.037%"
      >
        <stop offset="0%" stopColor="#F58220" />
        <stop offset="12.29%" stopColor="#F5831F" />
        <stop offset="17.66%" stopColor="#F6891F" />
        <stop offset="21.69%" stopColor="#F7911E" />
        <stop offset="25.05%" stopColor="#F99E1C" />
        <stop offset="27.95%" stopColor="#FBAE17" />
        <stop offset="29.32%" stopColor="#FDB913" />
        <stop offset="48.5%" stopColor="#FFFDE9" />
        <stop offset="67.29%" stopColor="#FFE5C2" />
        <stop offset="87.22%" stopColor="#F58220" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__eJ"
        x1="55.435%"
        x2="45.372%"
        y1="99.547%"
        y2="-.532%"
      >
        <stop offset="0%" stopColor="#C6401B" />
        <stop offset="19.23%" stopColor="#D7561E" />
        <stop offset="43.35%" stopColor="#E5691F" />
        <stop offset="69.28%" stopColor="#EF7420" />
        <stop offset="100%" stopColor="#F47920" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__eK"
        x1="17.045%"
        x2="78.818%"
        y1="98.445%"
        y2="5.1%"
      >
        <stop offset="43.99%" stopColor="#3E0900" />
        <stop offset="52.75%" stopColor="#682900" />
        <stop offset="68.25%" stopColor="#A44A0E" />
        <stop offset="79.23%" stopColor="#CD5E1B" />
        <stop offset="84.59%" stopColor="#DC661E" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__eL"
        x1="47.664%"
        x2="47.664%"
        y1=".298%"
        y2="98.332%"
      >
        <stop offset="46.99%" stopColor="#F58220" />
        <stop offset="51.88%" stopColor="#EF7F1F" />
        <stop offset="57.55%" stopColor="#E3781D" />
        <stop offset="63.62%" stopColor="#D16D1A" />
        <stop offset="69.97%" stopColor="#B75D13" />
        <stop offset="76.53%" stopColor="#964906" />
        <stop offset="83.27%" stopColor="#713100" />
        <stop offset="90.04%" stopColor="#400B00" />
        <stop offset="90.23%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__eM"
        x1="78.011%"
        x2="15.421%"
        y1="3.989%"
        y2="93.19%"
      >
        <stop offset="15.79%" stopColor="#3E0900" />
        <stop offset="19.57%" stopColor="#652900" />
        <stop offset="23.75%" stopColor="#843E00" />
        <stop offset="28.28%" stopColor="#A04F0B" />
        <stop offset="33.09%" stopColor="#BA5F14" />
        <stop offset="38.26%" stopColor="#CE6B1A" />
        <stop offset="43.95%" stopColor="#DE751D" />
        <stop offset="50.42%" stopColor="#EA7B1E" />
        <stop offset="58.32%" stopColor="#F1801F" />
        <stop offset="71.8%" stopColor="#F58220" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__eN"
        x1="81.163%"
        x2="25.883%"
        y1="1.217%"
        y2="104.13%"
      >
        <stop offset="39.1%" stopColor="#3E0900" />
        <stop offset="39.57%" stopColor="#430F00" />
        <stop offset="46.75%" stopColor="#813C00" />
        <stop offset="53.14%" stopColor="#B05911" />
        <stop offset="58.5%" stopColor="#D46F1B" />
        <stop offset="62.64%" stopColor="#EA7C1E" />
        <stop offset="65.04%" stopColor="#F58220" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__eO"
        x1="49.49%"
        x2="49.49%"
        y1="99.181%"
        y2="-3.073%"
      >
        <stop offset="13.91%" stopColor="#C6401B" />
        <stop offset="35.4%" stopColor="#D4521D" />
        <stop offset="75.69%" stopColor="#E96E1F" />
        <stop offset="100%" stopColor="#F47920" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__eP"
        x1="65.98%"
        x2="-2.99%"
        y1="86.016%"
        y2="8.174%"
      >
        <stop offset="7.895%" stopColor="#3E0900" />
        <stop offset="25.35%" stopColor="#843D00" />
        <stop offset="54.14%" stopColor="#F58220" />
        <stop offset="86.47%" stopColor="#F7941D" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__eQ"
        x1="18.6%"
        x2="28.32%"
        y1="45.38%"
        y2="51.45%"
      >
        <stop offset="10.15%" stopColor="#3E0900" />
        <stop offset="15.06%" stopColor="#441000" />
        <stop offset="22.02%" stopColor="#551E00" />
        <stop offset="30.2%" stopColor="#6D3000" />
        <stop offset="39.31%" stopColor="#8C4701" />
        <stop offset="49.2%" stopColor="#B66512" />
        <stop offset="59.58%" stopColor="#EB8B1C" />
        <stop offset="61.28%" stopColor="#F7941D" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__eR"
        x1="18.59%"
        x2="48.86%"
        y1="39.38%"
        y2="52.23%"
      >
        <stop offset="38.35%" stopColor="#F7941D" />
        <stop offset="48.31%" stopColor="#F99E1C" />
        <stop offset="69.42%" stopColor="#FCB116" />
        <stop offset="81.95%" stopColor="#FDB913" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__eS"
        x1="2.99%"
        x2="100.5%"
        y1="48.418%"
        y2="48.418%"
      >
        <stop offset="9.774%" stopColor="#FDB913" />
        <stop offset="17.7%" stopColor="#FBAC18" />
        <stop offset="35.71%" stopColor="#F7941D" />
        <stop offset="59.88%" stopColor="#F8941F" />
        <stop offset="68.58%" stopColor="#F89724" />
        <stop offset="74.78%" stopColor="#F99C2F" />
        <stop offset="79.8%" stopColor="#FAA33E" />
        <stop offset="84.09%" stopColor="#FBAC52" />
        <stop offset="87.83%" stopColor="#FCB86A" />
        <stop offset="90.23%" stopColor="#FDC27B" />
        <stop offset="98.87%" stopColor="#FFFDE9" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__eT"
        x1="-1.54%"
        x2="27.75%"
        y1="33.39%"
        y2="33.39%"
      >
        <stop offset="17.29%" stopColor="#FFFDE9" />
        <stop offset="46.11%" stopColor="#FEC988" />
        <stop offset="71.61%" stopColor="#F9A23C" />
        <stop offset="83.08%" stopColor="#F7941D" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__eU"
        x1="30.6%"
        x2="30.6%"
        y1="30.35%"
        y2="2.03%"
      >
        <stop offset="48.5%" stopColor="#3E0900" />
        <stop offset="63.64%" stopColor="#924B03" />
        <stop offset="77.05%" stopColor="#D87E1A" />
        <stop offset="83.08%" stopColor="#F7941D" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__eV"
        x1="48.492%"
        x2="48.492%"
        y1="102.881%"
        y2=".047%"
      >
        <stop offset="7.519%" stopColor="#3E0900" />
        <stop offset="14.76%" stopColor="#602400" />
        <stop offset="26.61%" stopColor="#8B3D01" />
        <stop offset="36.74%" stopColor="#AC4E11" />
        <stop offset="44.6%" stopColor="#C15918" />
        <stop offset="49.25%" stopColor="#C85C1A" />
        <stop offset="74.81%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__eW"
        x1="14.72%"
        x2="67.88%"
        y1="103.95%"
        y2="5.857%"
      >
        <stop offset="20.68%" stopColor="#3E0900" />
        <stop offset="25.1%" stopColor="#5D2500" />
        <stop offset="33.13%" stopColor="#840" />
        <stop offset="40.9%" stopColor="#AE5F0F" />
        <stop offset="48.2%" stopColor="#CC7518" />
        <stop offset="54.93%" stopColor="#E3851B" />
        <stop offset="60.87%" stopColor="#F08F1D" />
        <stop offset="65.41%" stopColor="#F7941D" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__eX"
        x1="21.579%"
        x2="85.716%"
        y1="5.996%"
        y2="138.478%"
      >
        <stop offset="26.4%" stopColor="#F7941D" />
        <stop offset="48.19%" stopColor="#FFDDAC" />
        <stop offset="56.39%" stopColor="#FFFDE9" />
        <stop offset="59.67%" stopColor="#FFF6DE" />
        <stop offset="65.15%" stopColor="#FFEAC6" />
        <stop offset="72.15%" stopColor="#FFD6A0" />
        <stop offset="80.39%" stopColor="#FCBC71" />
        <stop offset="89.59%" stopColor="#F99C30" />
        <stop offset="92.11%" stopColor="#F7941D" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__eY"
        x1="49.401%"
        x2="49.399%"
        y1="98.88%"
        y2="-.929%"
      >
        <stop offset="7.519%" stopColor="#C6401B" />
        <stop offset="10.32%" stopColor="#C8431C" />
        <stop offset="45.1%" stopColor="#DE601F" />
        <stop offset="76.1%" stopColor="#ED7220" />
        <stop offset="100%" stopColor="#F47920" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__eZ"
        x1="1.654%"
        x2="99.166%"
        y1="52.583%"
        y2="52.583%"
      >
        <stop offset="8.271%" stopColor="#DC661E" />
        <stop offset="11.17%" stopColor="#DF6C1E" />
        <stop offset="15.8%" stopColor="#E77F1D" />
        <stop offset="21.54%" stopColor="#F69E1B" />
        <stop offset="22.56%" stopColor="#FAA61A" />
        <stop offset="46.24%" stopColor="#FFFDE9" />
        <stop offset="59.4%" stopColor="#FFFDE9" />
        <stop offset="62.6%" stopColor="#FFF0D4" />
        <stop offset="69.12%" stopColor="#FED4A5" />
        <stop offset="78.28%" stopColor="#FAAA62" />
        <stop offset="86.84%" stopColor="#F58220" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__fa"
        x1="42.293%"
        x2="53.653%"
        y1="95.382%"
        y2="-5.708%"
      >
        <stop offset="19.55%" stopColor="#3E0900" />
        <stop offset="19.65%" stopColor="#3F0A00" />
        <stop offset="30.08%" stopColor="#783300" />
        <stop offset="39.45%" stopColor="#A2490D" />
        <stop offset="47.43%" stopColor="#C25918" />
        <stop offset="53.71%" stopColor="#D5621C" />
        <stop offset="57.52%" stopColor="#DC661E" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__fb"
        x1="-7.36%"
        x2="51.31%"
        y1="14.723%"
        y2="86.042%"
      >
        <stop offset="47.74%" stopColor="#F58220" />
        <stop offset="51.86%" stopColor="#EF7E1F" />
        <stop offset="56.69%" stopColor="#E3781D" />
        <stop offset="61.9%" stopColor="#D06C1A" />
        <stop offset="67.36%" stopColor="#B65C13" />
        <stop offset="73.02%" stopColor="#954805" />
        <stop offset="78.81%" stopColor="#6F3000" />
        <stop offset="84.59%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__fc"
        x1="1.837%"
        x2="97.621%"
        y1="10.58%"
        y2="76.82%"
      >
        <stop offset="25.56%" stopColor="#FAA61A" />
        <stop offset="27.14%" stopColor="#FBAF34" />
        <stop offset="31.11%" stopColor="#FEC56E" />
        <stop offset="34.92%" stopColor="#FFD797" />
        <stop offset="38.47%" stopColor="#FFE6B9" />
        <stop offset="41.71%" stopColor="#FFF1D2" />
        <stop offset="44.53%" stopColor="#FFF9E2" />
        <stop offset="46.62%" stopColor="#FFFDE9" />
        <stop offset="48.97%" stopColor="#FFF9E1" />
        <stop offset="52.38%" stopColor="#FFF0CF" />
        <stop offset="56.44%" stopColor="#FFE4B3" />
        <stop offset="61%" stopColor="#FFD38E" />
        <stop offset="65.98%" stopColor="#FDBF5F" />
        <stop offset="71.23%" stopColor="#FAA71C" />
        <stop offset="71.43%" stopColor="#FAA61A" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__fd"
        x1="45.165%"
        x2="62.4%"
        y1="100.95%"
        y2="-.845%"
      >
        <stop offset="19.55%" stopColor="#3E0900" />
        <stop offset="19.96%" stopColor="#430F00" />
        <stop offset="25.7%" stopColor="#793900" />
        <stop offset="31.15%" stopColor="#A3570B" />
        <stop offset="36.15%" stopColor="#C67016" />
        <stop offset="40.62%" stopColor="#DF831B" />
        <stop offset="44.38%" stopColor="#EF8E1D" />
        <stop offset="46.99%" stopColor="#F7941D" />
        <stop offset="95.86%" stopColor="#F7941D" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__fe"
        x1="29.261%"
        x2="77.522%"
        y1="-5.028%"
        y2="109.311%"
      >
        <stop offset="6.391%" stopColor="#3E0900" />
        <stop offset="8.15%" stopColor="#623001" />
        <stop offset="10.57%" stopColor="#885935" />
        <stop offset="13.04%" stopColor="#AA825F" />
        <stop offset="15.54%" stopColor="#C8A989" />
        <stop offset="18.06%" stopColor="#DFC9AE" />
        <stop offset="20.61%" stopColor="#F0E2CB" />
        <stop offset="23.21%" stopColor="#FBF4DF" />
        <stop offset="25.94%" stopColor="#FFFDE9" />
        <stop offset="31.54%" stopColor="#FFEECB" />
        <stop offset="43.83%" stopColor="#FFD087" />
        <stop offset="60.9%" stopColor="#FAA61A" />
        <stop offset="74.66%" stopColor="#FAA31B" />
        <stop offset="88.96%" stopColor="#F89A1C" />
        <stop offset="95.86%" stopColor="#F7941D" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__ff"
        x1="2.361%"
        x2="92.361%"
        y1="-8.17%"
        y2="67.16%"
      >
        <stop offset="25.56%" stopColor="#FAA61A" />
        <stop offset="27.14%" stopColor="#FBAF34" />
        <stop offset="31.11%" stopColor="#FEC56E" />
        <stop offset="34.92%" stopColor="#FFD797" />
        <stop offset="38.47%" stopColor="#FFE6B9" />
        <stop offset="41.71%" stopColor="#FFF1D2" />
        <stop offset="44.53%" stopColor="#FFF9E2" />
        <stop offset="46.62%" stopColor="#FFFDE9" />
        <stop offset="49.72%" stopColor="#FFFAE4" />
        <stop offset="52.99%" stopColor="#FFF4D8" />
        <stop offset="56.33%" stopColor="#FFECC5" />
        <stop offset="59.73%" stopColor="#FFE0AB" />
        <stop offset="63.17%" stopColor="#FFD28B" />
        <stop offset="66.64%" stopColor="#FDC165" />
        <stop offset="70.07%" stopColor="#FBAE32" />
        <stop offset="71.43%" stopColor="#FAA61A" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__fg"
        x1="30.74%"
        x2="58.2%"
        y1="92.87%"
        y2="-9.6%"
      >
        <stop offset="28.2%" stopColor="#FAA61A" />
        <stop offset="56.02%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__fh"
        x1="30.05%"
        x2="46.63%"
        y1="99.61%"
        y2="5.57%"
      >
        <stop offset="29.7%" stopColor="#FAA61A" />
        <stop offset="33.32%" stopColor="#EF9D19" />
        <stop offset="39.32%" stopColor="#DA8B18" />
        <stop offset="46.95%" stopColor="#B86F11" />
        <stop offset="55.91%" stopColor="#8B4B00" />
        <stop offset="65.88%" stopColor="#552000" />
        <stop offset="69.17%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__fi"
        x1="32.762%"
        x2="59.139%"
        y1="105%"
        y2="-2.96%"
      >
        <stop offset="16.92%" stopColor="#3E0900" />
        <stop offset="25.95%" stopColor="#6A3000" />
        <stop offset="36.61%" stopColor="#915003" />
        <stop offset="47.05%" stopColor="#B56C10" />
        <stop offset="57.02%" stopColor="#D18417" />
        <stop offset="66.4%" stopColor="#E69519" />
        <stop offset="74.96%" stopColor="#F3A01A" />
        <stop offset="81.95%" stopColor="#FAA61A" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__fj"
        x1="8.977%"
        x2="71.597%"
        y1="101.45%"
        y2="11.05%"
      >
        <stop offset="7.895%" stopColor="#FAA61A" />
        <stop offset="12.4%" stopColor="#FAA21B" />
        <stop offset="28.25%" stopColor="#F8971D" />
        <stop offset="41.35%" stopColor="#F7941D" />
        <stop offset="45.89%" stopColor="#E1841B" />
        <stop offset="55.51%" stopColor="#AE6010" />
        <stop offset="69.31%" stopColor="#642A00" />
        <stop offset="75.19%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__fk"
        x1="6.16%"
        x2="37.84%"
        y1="25.71%"
        y2="28.48%"
      >
        <stop offset="25.94%" stopColor="#3E0900" />
        <stop offset="41.57%" stopColor="#692600" />
        <stop offset="66.54%" stopColor="#A93E12" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__fl"
        x1="3.28%"
        x2="29.87%"
        y1="43.734%"
        y2="48.424%"
      >
        <stop offset="14.29%" stopColor="#A53410" />
        <stop offset="21.92%" stopColor="#9E330D" />
        <stop offset="34.37%" stopColor="#8C2F03" />
        <stop offset="50.09%" stopColor="#712600" />
        <stop offset="68.3%" stopColor="#451000" />
        <stop offset="70.68%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__fm"
        x1="-.88%"
        x2="61.43%"
        y1="27.95%"
        y2="27.95%"
      >
        <stop offset="35.34%" stopColor="#3E0900" />
        <stop offset="40.06%" stopColor="#521800" />
        <stop offset="49.87%" stopColor="#7D2A00" />
        <stop offset="58.65%" stopColor="#A53410" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__fn"
        x1="-2.14%"
        x2="94.4%"
        y1="48.92%"
        y2="31.9%"
      >
        <stop offset="33.08%" stopColor="#3E0900" />
        <stop offset="36.48%" stopColor="#3E0600" />
        <stop offset="41.2%" stopColor="#3E0000" />
        <stop offset="43.99%" stopColor="#3E0000" />
        <stop offset="69.55%" stopColor="#A53410" />
        <stop offset="74.24%" stopColor="#AF3D14" />
        <stop offset="82.95%" stopColor="#CB551B" />
        <stop offset="92.86%" stopColor="#F47920" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__fo"
        x1="98.836%"
        x2="15.836%"
        y1="1.54%"
        y2="54.26%"
      >
        <stop offset="0%" stopColor="#3E0900" />
        <stop offset="19.59%" stopColor="#3E0700" />
        <stop offset="38.52%" stopColor="#3E0100" />
        <stop offset="57.12%" stopColor="#3E0000" />
        <stop offset="59.77%" stopColor="#3E0000" />
        <stop offset="62.92%" stopColor="#6E2100" />
        <stop offset="66.11%" stopColor="#933A06" />
        <stop offset="69.26%" stopColor="#B45014" />
        <stop offset="72.28%" stopColor="#CF611B" />
        <stop offset="75.16%" stopColor="#E26E1E" />
        <stop offset="77.82%" stopColor="#EE7520" />
        <stop offset="80.08%" stopColor="#F47920" />
        <stop offset="83.52%" stopColor="#EB721F" />
        <stop offset="88.82%" stopColor="#D9621D" />
        <stop offset="95.26%" stopColor="#BD4918" />
        <stop offset="100%" stopColor="#A53410" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__fp"
        x1="-13.78%"
        x2="83.78%"
        y1="45.45%"
        y2="28.25%"
      >
        <stop offset="33.08%" stopColor="#3E0900" />
        <stop offset="37.07%" stopColor="#3E0600" />
        <stop offset="42.6%" stopColor="#3E0000" />
        <stop offset="45.86%" stopColor="#3E0000" />
        <stop offset="47.54%" stopColor="#4D0300" />
        <stop offset="54.05%" stopColor="#7D2200" />
        <stop offset="58.81%" stopColor="#992F0B" />
        <stop offset="61.28%" stopColor="#A53410" />
        <stop offset="75.33%" stopColor="#CC561B" />
        <stop offset="86.66%" stopColor="#E76E1F" />
        <stop offset="92.86%" stopColor="#F47920" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__fq"
        x1="92.6%"
        x2="23.045%"
        y1="-9.27%"
        y2="54.93%"
      >
        <stop offset="0%" stopColor="#3E0900" />
        <stop offset="19.59%" stopColor="#3E0700" />
        <stop offset="38.52%" stopColor="#3E0100" />
        <stop offset="57.12%" stopColor="#3E0000" />
        <stop offset="59.77%" stopColor="#3E0000" />
        <stop offset="62.92%" stopColor="#6E2100" />
        <stop offset="66.11%" stopColor="#933A06" />
        <stop offset="69.26%" stopColor="#B45014" />
        <stop offset="72.28%" stopColor="#CF611B" />
        <stop offset="75.16%" stopColor="#E26E1E" />
        <stop offset="77.82%" stopColor="#EE7520" />
        <stop offset="80.08%" stopColor="#F47920" />
        <stop offset="83.52%" stopColor="#EB721F" />
        <stop offset="88.82%" stopColor="#D9621D" />
        <stop offset="95.26%" stopColor="#BD4918" />
        <stop offset="100%" stopColor="#A53410" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__fr"
        x1="-3.68%"
        x2="87.71%"
        y1="55.54%"
        y2="22.28%"
      >
        <stop offset="33.08%" stopColor="#3E0900" />
        <stop offset="40.24%" stopColor="#3E0600" />
        <stop offset="50.16%" stopColor="#3E0000" />
        <stop offset="56.02%" stopColor="#3E0000" />
        <stop offset="59.96%" stopColor="#661500" />
        <stop offset="64.3%" stopColor="#872701" />
        <stop offset="67.64%" stopColor="#9C300D" />
        <stop offset="69.55%" stopColor="#A53410" />
        <stop offset="69.97%" stopColor="#A73611" />
        <stop offset="75.5%" stopColor="#C14D19" />
        <stop offset="81.2%" stopColor="#D65F1D" />
        <stop offset="87.07%" stopColor="#E56D1F" />
        <stop offset="93.19%" stopColor="#EF7520" />
        <stop offset="100%" stopColor="#F47920" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__fs"
        x1="62.39%"
        x2="34.9%"
        y1="85.577%"
        y2="6.646%"
      >
        <stop offset="39.47%" stopColor="#3E0900" />
        <stop offset="41.21%" stopColor="#4F1800" />
        <stop offset="46.96%" stopColor="#793300" />
        <stop offset="52.74%" stopColor="#9C460A" />
        <stop offset="58.44%" stopColor="#BA5516" />
        <stop offset="64.04%" stopColor="#D2611C" />
        <stop offset="69.51%" stopColor="#E3681F" />
        <stop offset="74.8%" stopColor="#ED6D20" />
        <stop offset="79.7%" stopColor="#F37021" />
        <stop offset="81.55%" stopColor="#EB6C20" />
        <stop offset="84.15%" stopColor="#DD661E" />
        <stop offset="87.19%" stopColor="#C65B19" />
        <stop offset="90.56%" stopColor="#A54B0E" />
        <stop offset="94.2%" stopColor="#7D3600" />
        <stop offset="98.02%" stopColor="#4C1600" />
        <stop offset="98.87%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__ft"
        x1="36.294%"
        x2="46.564%"
        y1="105.236%"
        y2="-1.418%"
      >
        <stop offset="28.95%" stopColor="#FAA61A" />
        <stop offset="41.72%" stopColor="#FAA41A" />
        <stop offset="46.85%" stopColor="#F99F1B" />
        <stop offset="50.6%" stopColor="#F8971D" />
        <stop offset="53.67%" stopColor="#F68B1F" />
        <stop offset="55.26%" stopColor="#F58220" />
        <stop offset="57.47%" stopColor="#E3781D" />
        <stop offset="61.95%" stopColor="#BC6015" />
        <stop offset="68.22%" stopColor="#813B00" />
        <stop offset="74.44%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__fu"
        x1="24.344%"
        x2="40.694%"
        y1="95.58%"
        y2="2.85%"
      >
        <stop offset="25.56%" stopColor="#FAA61A" />
        <stop offset="32.88%" stopColor="#F9A11B" />
        <stop offset="43.27%" stopColor="#F7941D" />
        <stop offset="53.76%" stopColor="#F58220" />
        <stop offset="56.85%" stopColor="#E97B1E" />
        <stop offset="62.37%" stopColor="#D16D1A" />
        <stop offset="69.68%" stopColor="#A9550F" />
        <stop offset="78.39%" stopColor="#763500" />
        <stop offset="86.47%" stopColor="#3E0900" />
      </linearGradient>
      <linearGradient
        id="swedbank_ee_svg__fv"
        x1="-6.77%"
        x2="90.475%"
        y1="33.09%"
        y2="33.09%"
      >
        <stop offset="28.57%" stopColor="#FFFDE9" />
        <stop offset="34.52%" stopColor="#FFEED0" />
        <stop offset="46.98%" stopColor="#FECE9A" />
        <stop offset="64.77%" stopColor="#F89D4D" />
        <stop offset="74.81%" stopColor="#F58220" />
      </linearGradient>
      <radialGradient
        id="swedbank_ee_svg__a"
        cx="69.163%"
        cy="12.403%"
        r="107.781%"
        fx="69.163%"
        fy="12.403%"
      >
        <stop offset="0%" stopColor="#FDB933" />
        <stop offset="6.529%" stopColor="#FDB731" />
        <stop offset="10.32%" stopColor="#FCB228" />
        <stop offset="13.4%" stopColor="#FBAA1A" />
        <stop offset="13.53%" stopColor="#FBAA19" />
        <stop offset="63.53%" stopColor="#F15A22" />
        <stop offset="68.2%" stopColor="#E75721" />
        <stop offset="86.15%" stopColor="#D04E1D" />
        <stop offset="96.24%" stopColor="#C74A1B" />
      </radialGradient>
      <radialGradient
        id="swedbank_ee_svg__A"
        cx="69.956%"
        cy="12.914%"
        r="110.897%"
        fx="69.956%"
        fy="12.914%"
        gradientTransform="matrix(.91667 0 0 1 .058 0)"
      >
        <stop offset="9.551%" stopColor="#FBAA19" />
        <stop offset="23.43%" stopColor="#FAA51A" />
        <stop offset="42.49%" stopColor="#F8981D" />
        <stop offset="64.56%" stopColor="#F5841F" />
        <stop offset="88.72%" stopColor="#F26622" />
        <stop offset="96.24%" stopColor="#F15A22" />
      </radialGradient>
      <radialGradient
        id="swedbank_ee_svg__aF"
        cx="49.602%"
        cy="50.317%"
        r="51.393%"
        fx="49.602%"
        fy="50.317%"
        gradientTransform="matrix(.92308 0 0 1 .038 0)"
      >
        <stop offset="32.33%" stopColor="#FDB913" />
        <stop offset="33.21%" stopColor="#FDBA1A" />
        <stop offset="41.56%" stopColor="#FFC74E" />
        <stop offset="50.23%" stopColor="#FFD373" />
        <stop offset="59.11%" stopColor="#FFDC8D" />
        <stop offset="68.28%" stopColor="#FFE4A2" />
        <stop offset="77.83%" stopColor="#FFEAB1" />
        <stop offset="88.03%" stopColor="#FFEDBA" />
        <stop offset="100%" stopColor="#FFEEBD" />
      </radialGradient>
      <radialGradient
        id="swedbank_ee_svg__aU"
        cx="50.652%"
        cy="50.52%"
        r="70.488%"
        fx="50.652%"
        fy="50.52%"
        gradientTransform="matrix(1 0 0 .57143 0 .217)"
      >
        <stop offset="0%" stopColor="#F7941D" />
        <stop offset="20.2%" stopColor="#F79423" />
        <stop offset="45.86%" stopColor="#F79431" />
        <stop offset="49.47%" stopColor="#F99D3F" />
        <stop offset="61.71%" stopColor="#FCB96C" />
        <stop offset="73.28%" stopColor="#FFD08D" />
        <stop offset="83.86%" stopColor="#FFE0A6" />
        <stop offset="93.1%" stopColor="#FFEAB7" />
        <stop offset="100%" stopColor="#FFEEBD" />
      </radialGradient>
      <radialGradient
        id="swedbank_ee_svg__bu"
        cx="49.244%"
        cy="50.191%"
        r="50.171%"
        fx="49.244%"
        fy="50.191%"
        gradientTransform="matrix(.94118 0 0 1 .029 0)"
      >
        <stop offset="0%" stopColor="#F7941D" />
        <stop offset="40.6%" stopColor="#F58220" />
        <stop offset="41.2%" stopColor="#F68523" />
        <stop offset="47.51%" stopColor="#F99E4E" />
        <stop offset="54.09%" stopColor="#FBB675" />
        <stop offset="60.82%" stopColor="#FDCB95" />
        <stop offset="67.72%" stopColor="#FFDCB1" />
        <stop offset="74.87%" stopColor="#FFE9C8" />
        <stop offset="82.36%" stopColor="#FFF3D9" />
        <stop offset="90.4%" stopColor="#FFFAE4" />
        <stop offset="100%" stopColor="#FFFDE9" />
      </radialGradient>
    </defs>
    <g fill="none" fillRule="evenodd" transform="translate(66 66)">
      <circle cx={190} cy={190} r={190} fill="url(#swedbank_ee_svg__a)" />
      <path
        fill="url(#swedbank_ee_svg__b)"
        fillRule="nonzero"
        d="M63.6 57.159c.415 1.248-3.736 4.16-5.397 5.824C44.088 76.71 32.88 96.26 24.161 114.98 13.782 137.027 6.31 163.65 7.14 194.433c1.66 62.813 31.551 106.908 65.178 135.61 35.288 29.951 88.011 50.75 151.114 39.103 55.214-10.4 94.653-42.014 119.977-80.7.415 0 1.66.415 1.66.831-11.208 20.8-29.475 38.687-48.987 52.83-19.927 13.727-43.59 24.959-72.235 30.367-65.178 12.063-119.147-10.816-153.605-39.519-17.851-14.975-33.627-33.694-44.836-55.741-11.624-22.047-21.172-49.502-21.172-81.533 0-62.813 22.833-107.74 59.366-138.522"
      />
      <path
        fill="url(#swedbank_ee_svg__c)"
        fillRule="nonzero"
        d="M338.492 299.554c-.831-1.247 2.078-5.82 3.325-7.482 11.223-15.797 19.12-36.998 24.524-57.367 6.234-23.695 9.144-51.132 2.909-81.062-12.47-61.524-46.968-98.522-87.701-122.217-39.902-23.28-95.599-34.919-155.867-12.055-52.787 19.953-86.039 57.782-104.327 100.6-.416 0 0-.416 0-.832 7.481-23.28 20.782-43.233 37.823-60.277C76.22 41.82 97.833 26.853 124.85 16.461c61.932-23.28 119.29-9.977 158.361 12.055 20.367 11.64 39.071 27.436 54.034 47.39 15.38 19.954 29.511 44.896 34.915 76.49 10.806 61.108-3.326 110.576-33.668 147.158"
      />
      <path
        fill="url(#swedbank_ee_svg__d)"
        fillRule="nonzero"
        d="M311.606 316.49c-.416-1.245 3.327-3.734 4.99-5.394 13.31-12.864 24.123-31.951 32.856-49.794 9.982-21.163 17.052-46.89 16.22-76.352-1.664-60.168-27.865-100.833-62.384-129.88-34.103-28.631-84.841-48.964-145.146-37.345-53.234 9.959-91.496 40.25-115.617 77.18-.416 0 0-.414 0-.83 10.813-20.747 27.033-36.93 46.164-50.208 19.13-13.279 42.005-24.068 69.453-29.047 62.8-11.619 114.37 10.374 147.642 37.76 17.051 14.109 32.44 32.367 43.252 53.53 11.23 21.162 20.379 47.304 20.379 78.01-1.248 59.754-23.29 102.909-57.809 132.37"
      />
      <path
        fill="url(#swedbank_ee_svg__e)"
        fillRule="nonzero"
        d="M47.828 83.621c.83.831-2.49 4.57-3.736 6.647-10.791 15.37-19.093 35.31-24.488 54.834-6.226 23.678-7.056 48.603-2.076 78.097 12.037 58.989 44.827 94.714 84.257 117.562 38.186 22.432 91.729 33.232 149.422 11.631 50.637-19.109 82.597-55.665 100.03-96.375.414 0 0 .415 0 .83-7.057 22.433-19.924 41.542-36.111 58.158-16.187 16.201-36.94 30.74-63.09 40.71-59.353 22.017-114.14 9.555-151.496-11.631-19.508-10.8-37.355-26.171-51.882-45.28s-28.224-43.203-33.62-73.528c-10.376-59.819 3.736-106.345 32.79-141.655"
      />
      <path
        fill="url(#swedbank_ee_svg__f)"
        d="M69.065 129.797c-.83 1.248-3.32 3.328-2.49 5.825 1.66 1.664 2.49 2.912 2.075 6.657 0 2.496 1.66 3.328 2.075 4.16s2.905 2.913 2.905 2.913l-6.64-.832s-1.66.832-2.49 3.328c-.416 2.496-1.246 7.073-.83 8.321.414 1.249 0 2.913 4.98 3.329 2.075.416 5.395 2.08 5.395 2.08s2.906 1.248.83 3.745l-1.66 1.248-1.66 1.664-1.245-.416v-.832l-2.905-2.912c-.83-.417-4.98 0-4.98 0s-4.151.416-4.981 1.248-.83 2.08-.83 2.08l-.415 5.825h-.83s-2.49-1.664-3.32-3.745c-.831-1.664-1.246-1.664-2.076-2.08s-2.075-.832-2.905.416c-1.246.832-4.566 3.745-5.396 5.825 0 0 .415.832 0 2.08s-2.905 3.745-2.905 4.577 0 2.08 1.245 2.496 4.565 1.665 4.565 1.665 1.245 2.08 0 2.08h-4.98s-3.32-.416-3.32 2.912v3.329s0 .832-2.076 2.08c-1.245.832-2.49 2.913-2.905 3.745 0 .832.415 1.664 1.245 2.912.415.832 1.245 2.497.83 3.329s-2.49 3.328-2.49 3.328-.415 2.08 0 2.913c.83.832 3.32 2.08 4.565 2.496 1.245 0 4.15.416 4.98 0 1.246-.416 1.661-1.248 2.906-2.08 0-.832 2.49-.832 3.32 0 .83.416 3.32 1.664 4.981 2.08 1.66 0 2.075-.416 3.735-1.248 1.66-1.248 3.736-2.913 4.981-3.745s3.735-2.08 4.566-1.248c1.245.416 1.66 1.248 2.075 2.08 0 .833-.415 2.08-.415 3.329 0 1.248 0 3.744.83 5.825.415.832 1.245.416 2.075.832 1.66-.416 2.075 0 2.905 0s2.49 2.496 3.32 3.328c.83.416 2.49.416 3.321.833.83 0 7.056.416 7.886 0 .83 0 2.49-.833 2.49-.833s1.66-1.248 2.49-2.08c1.246-.416 2.906.832 3.736 1.664.415.832 1.245.832 2.075 1.665.83.832 1.66 1.664 2.905 2.08s2.906 0 2.906 0 2.075-.832 2.905-1.248c1.245-.416 2.49 0 3.735-.416.83 0 3.736.832 4.566.832 1.245.416 2.49.832 4.15.832.83 0 1.245 0 2.49-.416s2.076-1.664 2.49-2.497c.416-.832.416-.832.83-2.08.416-1.664 2.076-2.08 2.076-2.08 1.66 0 4.566 0 7.056.416 3.735.416 14.942 0 18.262-7.073 2.075-2.913-.83-6.241-.83-6.241s-1.245-1.664-1.66-2.497c1.245 0 2.075 0 3.735-.416s3.32-1.664 5.396-1.248c.83 0 1.245 2.08 1.66 4.16 0 2.081-.83 22.468-4.566 30.373-3.32 4.577-4.98 5.825-4.98 5.825s-9.961 4.161-13.282 6.241c-3.32 1.665-8.3 3.329-8.716 7.49 1.246 1.664 6.641-.417 14.527-.417 8.3 0 17.017 0 17.847.832 0 .417-.415 2.913-1.66 4.993-.83 2.08-.83 3.745-.83 4.577s1.245 3.328 3.735 2.08c8.716-4.16 17.432-7.905 29.053-7.489 13.282.416 17.847 4.577 25.318 7.905 4.565 2.497 4.15-3.744 3.735-4.576 0-.833-1.245-4.577-3.735-8.322 2.905.832 11.206.832 19.092.416 7.886.833 12.866.416 13.696-.416 0-.416-.415-5.408-11.62-9.57-8.717-2.912-10.792-4.576-10.792-4.576s-4.15-1.248-6.64-9.985c-1.246-4.16-2.491-11.234-2.906-20.387.415-2.497.83-6.241 1.245-6.241.415-.416 2.905-2.08 4.566-1.249 1.245.833 2.075 1.665 4.15 5.825 2.075 4.577 3.32 9.57 8.716 10.818 4.98 1.248 9.13-1.248 13.696-1.248 5.811 0 4.981 3.744 8.716 4.577 3.32.832 5.396-1.249 6.641-1.665s4.15-.832 6.226 1.665c2.075 2.08 4.98 2.496 8.716.416 1.66-1.249 4.98-4.993 6.225-5.825s4.566-2.913 9.546 2.912c2.49 2.913 3.736 2.497 6.226 2.497s10.376-2.08 12.451-2.08c1.66 0 6.641-1.249 4.566-4.577-.83-2.497 2.905-2.497 4.565 0 .83 1.248 2.076.832 3.736.832 4.565-.416 5.395-.416 5.395-.416 1.66-.416 4.566-1.249 4.98-2.08 1.661-3.33 3.736-3.33 3.736-3.33l2.49-.415s4.566 0 4.981-2.08-.83-5.826-1.245-7.074-.415-2.08-2.075-3.744c-1.245-1.665-4.98-2.913-6.641-7.073-2.075-1.665-6.226-2.497-6.226-2.497s-1.66 0-2.075.416c-.83.416-.83 1.665-2.075 2.497s-4.15 1.248-4.98 0-.83-1.248-1.246-2.08c-.83-.833-1.245-2.08-2.075-2.08-4.15-.833-4.565-.417-4.565-.417s4.98-1.248 6.225-1.248c1.66 0 4.98-1.664 6.226-2.08s1.66-.833 2.905-1.665c.83-.416 6.226-2.08 4.98-9.985-1.244-8.738-7.055-7.905-11.206-12.066-.83-2.912-.415-3.745-.415-4.577 0-1.664-.415-1.664-.83-2.912-.83-.832-.415-1.664-3.735 0-2.075 2.08-7.47 2.912-5.81-.416l3.32-4.16s.415-1.249-2.076-4.578a101 101 0 0 0-7.885-4.992s-1.66-.832 2.49-3.329c2.49-2.496 3.735-10.401 0-13.73-5.81-3.328-9.961-4.993-9.961-4.993s-4.98-2.08-8.301-4.992c-2.075-2.08-2.49-2.08-3.735-2.913-1.246-.832-3.32-1.664-5.811-.416-1.66 1.248-4.98 0-4.98 0l1.244-4.577s2.906-4.992-.83-6.657c-3.32-.416-4.98-.832-4.98-.832s-4.15-.416-3.736-3.328c0-2.913-6.225-9.57-6.64-10.818-.415-2.08-1.245-6.24-2.906-7.905-.83-.832-1.66-2.08-1.66-3.329 0-.832-.83-9.569-7.47-12.481-2.906-1.665-7.471-5.825-9.132-3.745 0 0-2.49 5.825-7.055 4.993-.83 0-8.716-2.08-8.716-2.08s-6.64-6.658-7.056-7.49c0-.832-2.905-6.657-5.396-7.905-2.905-2.08-7.055 1.664-11.206-.416-1.245.416-4.98.832-4.98.832s-1.66-.416-2.49 1.664-1.246 4.161-3.32 3.745c-2.076.416-4.566-1.664-4.566-1.664s-2.49-.832-7.056 1.664c-.415 1.248-3.736 0-3.736 0s-6.225.416-11.206 3.329c-1.66.416-8.716.416-8.716.416s-2.49 1.664-3.735 3.328l-1.66.416s-6.226.416-9.131 8.737h-5.81s-4.566.417-4.566 4.577c0 1.664-1.66 4.16-2.906 4.993-1.245.832-3.735 2.912-3.735 2.912s-1.66 2.08.83 6.241c.83 2.913 2.075 3.745 2.075 5.41 0 1.247-.415.831 0 5.824 0 0-1.66 4.16-4.98.832-1.245-2.496-1.66-4.993-7.886-2.496-2.905 1.248-3.736 3.328-3.736 3.328s-3.735 2.913-6.225 3.329c-1.66 1.664-3.32 2.912-3.736 5.825 0 2.912 2.076 9.153 2.076 9.153s-5.396-4.16-4.566-8.321c-1.245-2.08-2.905-1.665-4.15-.416-1.246.416-5.811 1.664-5.811 1.664s-1.66.416-2.905 1.664c-1.245.832-2.49 2.08-3.32 2.08-1.246 0-2.906.417-3.736.833s-1.245.416-2.075 2.08-.83 4.993-.83 4.993v5.409l-2.906.416c0-.833-2.075 0-3.32 1.248"
      />
      <path
        fill="url(#swedbank_ee_svg__g)"
        d="m118.199 134.843-4.94-.414s-2.47.414-3.293.828c-.823.415-2.058 1.243-2.882 2.071-.411.829-1.234 1.243-2.058 2.071s-1.235.829-2.058 1.243-2.058.414-2.881.828c-.412 0-.412.829-5.763 0 0 0-2.882.414-3.705.829-.823 0-3.293 2.07-3.705 2.485-.411.828-2.47 2.485-2.47 3.313s-.823 2.486-.823 2.486l.412 1.656 1.646 1.243 2.059-2.071s1.234-2.9 2.058-3.728 2.881-1.242 2.881-1.242h5.763c.823 0 2.882.414 3.705.414s2.47-.829 2.47-.829l3.293-2.899 1.646-2.07h1.647c.823 0 2.881-.415 3.705-.415.823 0 2.47-.414 2.47-.414l3.293-.829s-.824-2.485-1.647-2.485c0-.414-.823-2.07-.823-2.07"
      />
      <path
        fill="url(#swedbank_ee_svg__h)"
        d="M83.737 166.184s.824 3.263.412 4.078c0 .816-.824 3.263-.824 3.263l-1.235 2.855s-1.648.816-2.06 1.632c-.411.816-1.647 1.631-1.647 1.631s-.824.816-1.235 1.632c-.412.815-1.236.815-.824 2.039.412.816 0 1.631.824 2.447.411.816 2.059 2.447 2.059 2.447s2.059.816 1.647-.815v-4.079l1.647-2.04c.824-2.039 1.236-1.63 2.06-2.446.823-1.224 1.647-.816 2.059-2.855l1.235-2.856s-.824-1.631-.824-2.447c0-.815.412-1.223.412-2.039-.412-.816-3.706-2.447-3.706-2.447"
      />
      <path
        fill="url(#swedbank_ee_svg__i)"
        d="m54.96 197.554-2.895.866s-2.894-.433-3.308.433 1.24 2.598 1.24 2.598l.414 1.732.827 1.3 1.654.865 2.48-.866 2.481-2.165s1.24-.866 1.654-1.732.827-2.165.827-2.165v-2.598h-2.067z"
      />
      <path
        fill="url(#swedbank_ee_svg__j)"
        d="m72.985 197.727-2.066 1.694.826 2.117s.413 1.27.827 1.27c.413 0 2.065.423 2.065.423s1.24 0 1.652.424c0 .846.413.846.826 1.693 0 .847-.413 2.964-.413 2.964v2.117l.826 2.117 3.305.423h2.891l2.892.847h1.24l-1.653-3.387-2.065-.847-1.653-.423s-.826 0-1.239-1.27c-.413-.847-.826-2.54-.826-2.54l-1.652-2.541-2.066-2.54s0-1.694-.826-2.118-1.652-1.27-1.652-1.27z"
      />
      <path
        fill="url(#swedbank_ee_svg__k)"
        d="m88.436 193.705-1.65 1.216s-2.472 0-2.06 1.216 2.885 3.648 2.885 3.648c1.237.811.825.811 1.649 1.622.412.81 2.473 3.243 3.297 2.837s1.237.406 1.65-.405v-4.864c0-.811-.413-.811-.825-1.622l-.825-1.621-1.236-1.622h-2.885z"
      />
      <path
        fill="url(#swedbank_ee_svg__l)"
        d="M95.102 175.71s-2.036.41-2.443 1.23c-.407.819-1.628 2.048-1.628 3.277s1.628 2.869 1.628 2.869 0 1.229.814 2.048c.815.82 1.629.82 2.443 1.23s.407 1.229 1.628 1.229c1.222 0 2.036.82 2.036.82s1.628-1.23 2.036-1.64c0-.82 0-2.868-.408-3.687-.407-.82-.814-2.459-.814-2.459s-1.628-1.229-1.628-2.049-1.629-2.868-1.629-2.868z"
      />
      <path
        fill="url(#swedbank_ee_svg__m)"
        d="m107.263 192.646-.43 2.964s-.432 1.694-.432 2.54-.862 2.964-.43 3.811c.43.847 1.723 1.27 2.585 1.27s2.155-1.27 2.155-1.27v-2.54c0-.847.431-5.081.431-5.081l-1.293-1.27z"
      />
      <path
        fill="url(#swedbank_ee_svg__n)"
        d="m107.223 209.582-4.72.847-3.004.423s0 1.694.858 2.117.858 1.27 2.145 1.694c1.288.423 2.575.423 3.863.847.858 0 2.145 0 3.003.423.859 0 1.717-.423 2.575-.423s2.146-.847 2.575-1.27c.858-.424.858-1.694.858-1.694l-2.146-1.27-2.574-1.27c-.43.423-3.433-.424-3.433-.424"
      />
      <path
        fill="url(#swedbank_ee_svg__o)"
        d="M125.829 200.056v4.234c0 .846 0 .846-.397 1.693 0 .847 0 1.27-.794 1.694s-.794 2.117-.794 2.117c1.19.423 2.779.423 3.572.847.794 0 2.382 0 2.382-.847s.397-2.117.397-2.117 0-1.694-.397-2.54c0-.847-1.19-.847-.397-1.27.397-.848-.397-3.388-.397-3.388z"
      />
      <path
        fill="url(#swedbank_ee_svg__p)"
        d="m160.891 183.356-1.676-2.902-5.865-2.488-3.352-.829s-2.514-.829-2.933 0c-.42.83-1.257 1.659-1.257 2.488s-.838 1.658-.838 1.658.419.83-.838 1.244h-6.704s-.838.829-1.676 1.243-.838.415-1.676.415c-.419 0-5.447-2.073-7.96-2.487-3.772-.415-5.447 1.243-5.447 1.243s13.407 5.804 14.664 6.219c1.257.414 3.352.414 4.19 0 .838-.415 1.676-.415 2.933-1.658l2.933-2.902c1.257-.83 1.257-.83 3.352-1.659 1.676-.414 1.676-.829 3.352-.829h2.933c.838.415 1.256.83 2.513 1.244s3.352 0 3.352 0"
      />
      <path
        fill="url(#swedbank_ee_svg__q)"
        d="M125.615 157.716c-.82 0-4.514.832-4.514.832s.41.831 0 2.079c-.41 1.247 0 1.247-.41 2.079-.822.832-.822 1.247-1.643 1.247h-5.335l-3.284.416-2.462 1.664s0 2.079.82 2.495c.821 0 1.642.831 2.874.831 1.23 0 3.283-.831 4.104-.416.82 0 2.463-.415 3.283-.831.821-.416 1.642-.416 2.873-.832.821-.416 2.463-.416 3.284-1.247.82-.416 2.463-2.495 2.463-2.495s.41-.832.41-2.08c0-.831-.41-2.495-.41-2.495s-.821-1.247-2.053-1.247"
      />
      <path
        fill="url(#swedbank_ee_svg__r)"
        d="m94.891 154.54-1.743 1.744s.435 1.743 1.743 2.18c.872.435.872 2.178 1.743 2.614s1.308.872 2.18.872c.871 0 1.307-.872 1.307-.872l.436-2.18-1.307-1.743-1.744-.871z"
      />
      <path
        fill="url(#swedbank_ee_svg__s)"
        d="M176.643 234.133s0 2.526-.85 3.369c-.424.842-1.273 2.948-1.273 2.948l-.85 1.684c-.425.843-1.699 1.685-.85 2.527.425.843.425.843 1.275.843s1.274.42 2.123-.843c.85-.842.85-2.105 1.275-2.948.424-.842.85-2.105.85-2.948 0-.842.849-1.684.424-2.948 0-.842-.85-2.948-.85-2.948z"
      />
      <path
        fill="url(#swedbank_ee_svg__t)"
        d="M188.684 216.602c-.772 1.259-.772 2.518-.772 3.357 0 1.258.386 2.937 0 4.195 0 1.259-.387 2.937-.387 4.615s-.386 3.776 0 4.616c0 1.258 0 1.678.387 2.937.386 1.258.772 2.517 1.158 3.356.386.84 3.09 3.776 3.09 3.776h1.545s-1.545-2.937-1.931-3.776c-.387-.84 0-2.937-.387-4.615v-8.811c0-1.259-.386-2.937 0-4.196 0-.839.387-2.097.387-3.356-.387-2.937-2.318-3.357-3.09-2.098"
      />
      <path
        fill="url(#swedbank_ee_svg__u)"
        d="M205.389 202.302c-.841 0-5.469.822-5.469.822l-7.152-.822s-2.103 0-3.365-.411c-.841-.411-2.524-.411-3.786-.411h-2.524c-.842 0-4.207-.823-4.207 0 0 .822 1.683 2.055 2.945 2.878 1.262.41 2.103.822 3.365 1.233.841 0 2.103 1.233 2.945 1.644.841.412 1.262 0 2.103.823.842.41 1.262.41 2.524.41h2.945c1.262 0 1.683-.41 2.524.412.842.822.842 1.233 1.262 2.056.421.822.421 2.055.421 3.7 0 1.644.42 3.7.42 5.344s-.42 3.7 0 4.523c0 .822.842 7.4.842 7.4s.42 1.233.42 2.878c0 1.233 2.104 4.522 2.525 5.344l2.103 4.112s2.104 1.233 2.524 2.055c.421 2.056 2.945 1.234 2.945 1.234l-.42-3.7s-1.263-1.645-2.104-2.878c-.42-1.234-1.683-4.112-1.683-4.934 0-1.233-1.682-5.345-1.682-6.578-.421-2.056-1.262-3.289-1.262-4.933 0-1.234 0-3.7-.421-4.934v-5.344c0-1.645-.42-2.878 0-4.523l1.262-3.7c.42-1.233.841-.822.841-2.056.421-.41 0-1.644-.841-1.644"
      />
      <path
        fill="url(#swedbank_ee_svg__v)"
        d="M153.627 152.423c-.83 0-3.32 2.117-3.32 2.117l4.15 1.694 2.076 1.27s1.66 1.27 2.075 2.117 1.246.847 2.49 1.694c.831.847 10.378 5.927 10.378 5.927l-7.056-8.891s-3.736-3.387-4.566-3.81-3.736-2.118-3.736-2.118z"
      />
      <path
        fill="url(#swedbank_ee_svg__w)"
        d="M168.413 163.373c.85.411 5.955 3.701 7.23 2.879 1.276-.412 1.702-.412 2.552-1.234.426-.823.851-.823 1.702-2.056.425-.823.85-.412.85-1.234s.426-1.645-.425-2.468c-.85-.822-1.701-2.878-1.701-2.878s1.276-.411 1.7-1.234c.426-.822.426.411.426-1.234s.426-1.645.426-2.878-.426-1.645-.851-2.468c-.85-.822-1.701-.822-1.701-.822l-5.104-2.88s5.104-.41 5.529-1.233c.425-.822 1.701-1.645 2.127-2.467s.85-1.234 1.275-2.057c.426-.822 1.702-2.056 2.127-1.233.425.822.85 2.878.85 4.523s-.425 2.057.426 3.702c.425 1.233.425 1.233 1.276 2.878.425 1.234 1.276 1.645 2.126 2.88.85 1.233 1.276 2.055 1.276 3.289s-2.126 1.234-2.552 2.467c-.425 1.234-1.276 2.057-1.7 3.29-.426 1.234-.851 3.29-.851 4.113 0 .822-.426 2.467-.851 3.701 0 .823-.85 3.29-.85 3.29l-.426 3.701-2.552-1.233c-.85-.412-2.126-1.234-2.977-2.057-.85-.822-5.954-3.29-5.954-3.29s-4.253-6.168-3.403-5.757"
      />
      <path
        fill="#FCAF17"
        d="M206.814 52.4s-3.664-.834-3.664-.417c0 .418-1.629.418-1.629.418s-.407.835-.407 1.252.814 2.506.814 2.506l1.629 2.087 2.035 1.253s1.629.835 2.443.835c.407 0 2.036-.417 2.036-.417l1.221-1.67.407-2.088-.407-1.67-2.036-1.253zM207.369 75.538l-2.598-.385-1.732.385-.866 1.155v1.54l.866.77c.433 0 2.165.384 2.165.384l3.031-.385h2.598l.866-.77-.433-1.54-1.732-.384zM223.087 85.738l-3.842.416-1.707.832s-.854 1.663-.427 2.079 0 1.663.854 2.08c.427.415 1.707.83 1.707.83s1.28.832 1.707 1.664c.427.416.427 1.663.854 2.08.427.415.427.83.854 1.247.853.416 1.707.416 1.707.416s1.28-.416 1.707-.416c.427-.416.854-1.248 1.28-1.664s.854-2.079.854-2.079 0-1.663-.427-2.079c0-.416-.853-2.495-.853-2.495l-1.708-1.663-1.28-.832zM197.964 64.89l-2.525 1.657-2.525-.414-2.525-2.485-2.525-.829-2.525.829-3.367 2.9-2.104-1.243-1.263-1.243v-2.071l-.42-1.657h-3.367l-3.788 2.071-.842 1.657s0 2.071.421 2.485 1.263.829 1.263 1.243 0 1.657-.421 1.657c-.421.414-.842.414-1.684.828-.42.414-1.262 1.657-1.683 1.657-.42 0-.842 1.656-.842 2.07 0 .415.421 1.657.842 2.072.42.414 1.263 2.485 1.683 2.485s.421.828.842.828c.421-.414 1.263-.414 1.684-.828 0-.414.841-2.071 1.262-2.485.42-.415 1.263-1.243 1.683-1.657s2.526-.414 2.526-.414h2.525c.42 0 1.262-.415 1.683-.415.42 0 1.683-.828 1.683-.828l.842-2.07 1.263-.83 1.683.83 2.104 1.656 2.525.414 4.63-1.242 4.208-1.243.842-1.657.42-2.07-.42-2.072-1.263-.828z"
      />
      <path
        fill="#FCAF17"
        d="m226.61 88.197-2.835-2.459h-3.24s-2.835.41-3.24 1.64c-.405.819-.405 2.048 0 2.868.81.82 1.62 1.639 2.43 2.049l2.025 2.048c.405.41.81 2.05 1.62 2.46.81.409 1.215.819 2.025.409s1.215-.41 1.62-.82.81-1.639 1.215-2.049c0-.41.405-1.639.405-2.458-.81-.82-2.025-3.688-2.025-3.688M243.156 91.232c-1.597 0-5.59-.804-5.989.803-.4 1.607 1.198 3.616 1.198 3.616s2.396 1.205 2.795 1.607c0 .402 1.198 2.812 1.597 3.214.4.402.799 2.009 1.597 2.812.799.804.4.804 1.597 1.206.8.402 1.598.402 1.997 0 .4 0 .799-.804.799-1.607 0-.402-1.198-2.01-1.598-2.813-.399-.803-.399-2.008 0-2.41 0-.804.4-1.607.4-2.41s-.4-2.01-.799-2.813c-.4.402-3.594-1.205-3.594-1.205"
      />
      <path
        fill="url(#swedbank_ee_svg__x)"
        d="M143.142 202.38s0 .422 0 0c-.406 2.11-.813 5.487 3.251 10.13.813 1.265 6.096 5.908 6.908 1.687 0-.844.407-1.688 0-2.954-2.438-3.798-2.844-4.22-2.844-5.486s-3.658-4.643-3.658-4.643z"
      />
      <path
        fill="url(#swedbank_ee_svg__y)"
        d="M173.141 241.403c-.832 1.706-1.665 2.133-1.665 3.84s4.578 2.133 6.243-.427c.416-.427-.416-1.28-1.665-.427-6.659 1.28 3.746-4.693 0-11.52-1.664 1.28-1.664 5.974-2.913 8.534"
      />
      <path
        fill="#FFEFCF"
        d="M202.046 58.748c1.243 2.08 9.532 4.159 9.532 1.248 0-1.664-2.487 0-4.145-.832-3.315-.832-4.144-4.16-5.802-6.24-.828 2.496-.414 4.576.415 5.824m-33.569 70.291c.415.416 6.217 1.664 5.802-.832-.414-2.08-2.072.416-3.315 0-4.144-1.247-2.901-9.15-6.216-9.982 0 3.744.828 9.15 3.73 10.814m55.948 1.248c2.9 2.08 4.558-1.248 4.558-1.664-.414-2.08-2.9 1.248-3.73 0-1.243-1.663 2.487-11.23-.828-8.318-1.658 1.248-1.244 9.15 0 9.982m-27.767 4.575c.83 2.912-.829 8.319 2.072 10.398.415.416 4.56 2.08 4.145-1.247-.415-1.248-1.658.831-2.487.416-2.9-1.248-.829-7.487-1.658-10.399-.828-2.911-7.045-5.823-5.387-9.566-5.802 1.248 2.486 8.319 3.315 10.398m-62.992-2.495c-.83-1.248 1.243-2.496-1.244-2.496-.414 1.248-.828 2.496-.414 3.743.829 3.744 12.847 6.655 16.991 5.823-4.558-3.743-12.847-2.495-15.333-7.07m126.4 12.477c-.415-1.663 4.558-8.318.828-7.07-1.243.416-3.315 7.07-1.658 9.15.415.832 4.145 2.912 5.388-.832-2.072-.416-3.73 1.248-4.559-1.248M119.99 183.942c-.415 1.663 8.703 4.159 9.531 4.99 1.658.832 2.487 2.08 3.73 2.496 2.072.832 7.46.416 7.874 0-.414.832-1.657-2.911-.828-2.495-4.145.831-7.46-.416-8.703-2.08-.83-.832-4.973-3.327-9.532-3.327 0 .831-1.658-.832-2.072.416m-40.614 27.867c-2.072-4.576 1.658-6.24-2.072-9.15-1.658-1.249-2.487.415-4.144-1.249 0 0-.415-3.327-1.244-2.911-3.73 2.08 4.145 5.407 4.974 6.655 1.243 2.08 0 4.99.828 7.07 1.244 3.328 7.874 3.744 10.775 2.496-2.9-2.08-7.874 0-9.117-2.911m34.812 4.159c-5.802.832-12.847.416-14.505-3.744h-.829c-.829 5.408 13.262 7.903 15.334 3.744"
      />
      <path
        fill="url(#swedbank_ee_svg__z)"
        d="M188.021 214.875c-4.372 5.44-4.372 30.548 5.684 28.456-8.307-5.859-5.684-16.32-5.684-21.342.874-3.767 1.749-5.44 0-7.114"
      />
      <path
        fill="url(#swedbank_ee_svg__A)"
        d="m299.138 140.446-1.666-3.677v-2.451l.833-2.452-1.666-2.451-6.247-6.537-5.414-2.45-7.496-.818-3.332.409v2.042l4.998 1.634 5.83.818 3.332 2.042 1.666 6.128 1.666 6.537 2.498 2.86 2.916.817h1.665l.833-1.634z"
      />
      <path
        fill="#FCAF17"
        d="m235.626 67.52-4.61 3.752-2.513 1.668-2.514-1.251-3.771-3.336h-3.77l-2.515 2.502.42 4.17 2.094 1.25 3.771.418 4.609 1.668 3.77-.417 2.515-2.92 4.609-.416 2.932 1.668.838 3.336-.838 3.336 2.514 2.501 4.61-1.667 2.513 2.084 1.257 6.255 1.676 2.085 2.514-1.25.419-5.005-1.676-4.586-2.933-3.753-2.933-2.502-3.352-5.421-2.933-3.753-4.19-1.25z"
      />
      <path
        fill="url(#swedbank_ee_svg__B)"
        stroke="#FFF"
        strokeWidth={0.118}
        d="M237.894 61.205c0 .416 1.678 0 1.259.831-1.679 2.494-5.455 1.247-8.392.416s-5.874 1.247-9.23-3.741c-3.357-4.573-5.455-8.314-7.553-10.808-2.098-2.91-3.776-2.494-5.454-1.663 1.258-1.662 1.258-2.494.839-2.494 2.517-1.663 7.552 2.91 9.65 7.898.84 1.663 5.035 6.651 6.713 7.482 2.098.416 3.357.832 5.035.832 2.518 0 4.616 2.91 7.133 1.247Z"
      />
      <path
        fill="url(#swedbank_ee_svg__C)"
        stroke="#FFF"
        strokeWidth={0.118}
        d="M246.905 61.07c3.33 2.072 8.326 4.143 9.158 6.628.833 2.07 0 3.313.833 7.041.832 2.485 2.081 3.314 2.498 6.627.416 1.243 0 2.9.416 3.728.833 2.9 4.163 4.97 5.828 10.355.416 1.656-.416 2.07.833 4.142.832 1.656 6.244 4.142 11.656 4.142 0 0 1.665-2.071 1.25-3.728-2.499-2.071-5.83-1.243-7.91-2.485-2.082-1.243-.833-3.728-1.666-6.627-.832-2.486-3.33-3.314-5.412-7.042-.832-2.07-1.249-4.142-2.081-5.798-1.25-2.486-2.082-4.142-2.498-6.628 0-.828 0-3.313-.416-4.556-.417-1.242-2.498-3.313-4.58-4.97-4.163-2.9-9.575-5.385-12.905-5.799-1.249.414 0 1.657-.416 2.485.832 0 2.498.829 5.412 2.486Z"
      />
      <path
        fill="url(#swedbank_ee_svg__D)"
        stroke="#FFF"
        strokeWidth={0.118}
        d="M278.402 111.74h-1.651c-.826.41-1.239-.409-2.065 1.23-1.238.408-1.238 0-1.238.818-1.652 2.456 2.89 2.456 4.541 2.047 1.652-.41 4.129-2.457 5.78-2.047 2.89.41 4.542 4.504 10.322 7.37 4.954 2.866 9.908 2.866 12.798 5.322 1.239.819 4.129 6.141 3.303 8.189.826-.82 1.239.818 1.239.818.825-1.637 1.651-6.96-.826-10.645s-8.257-4.094-13.624-6.55c-4.542-2.457-7.845-8.598-12.386-8.189-1.652 0-2.89 1.228-6.193 1.638Z"
      />
      <path
        fill="url(#swedbank_ee_svg__E)"
        stroke="#FFFCD5"
        strokeWidth={0.118}
        d="M158.774 183.665c-2.458.423-7.785-3.811-12.702 0"
      />
      <path
        fill="url(#swedbank_ee_svg__F)"
        stroke="#FFFDE9"
        strokeWidth={0.118}
        d="M213.816 206.701c0 10.303 3.367 25.964 6.313 33.382 2.946 6.594 10.521 7.418 17.255 10.303 5.05 2.06 6.733 4.534 11.363 5.77-.421-4.121-5.05-5.77-8.838-7.83s-8.838-2.885-12.626-5.77c-6.733-4.534-8.417-19.782-9.258-29.673 0-1.236 0-9.479 5.47-7.006-.42-7.83-5.47-8.243-7.154-7.83-.841 2.472-1.683 7.418-2.525 8.654Z"
      />
      <path
        fill="url(#swedbank_ee_svg__G)"
        stroke="#FFFDE9"
        strokeWidth={0.118}
        d="M145.014 154.952c1.655 3.705 5.792 2.881 8.688 4.116 2.482 1.235 3.723 4.117 6.205 5.763 1.655.824 3.723.824 5.792 1.647 1.24.823 2.896 2.47 4.55 3.705 3.724 2.881 6.206 5.763 11.584 6.586.827-.412-.828-.823-1.241-1.647 0-.411-.828-1.235-.828-1.235-3.723-3.704-8.687-6.586-10.342-7.82-1.241-.824-2.896-1.647-4.137-2.47-7.033-2.47-7.447-5.352-14.893-8.645-1.655 0-2.896 0-4.55-.412-.414 0-.414.412-.828.412Z"
      />
      <path
        fill="url(#swedbank_ee_svg__H)"
        fillRule="nonzero"
        d="M189.894 49.793c0 .82 0 1.231-.423 2.052 4.234.41 4.657-5.336 8.468-5.746 0-.821-.847-1.232-1.27-1.642-4.658.82-4.658 6.567-6.775 5.336"
      />
      <path
        fill="url(#swedbank_ee_svg__I)"
        fillRule="nonzero"
        d="M211.955 58.924c-.402.823-.803 2.469-1.606 2.469-.402 0 0-2.058-.402-2.058l.803-.822c2.008-4.115-3.212-4.526-7.227-4.938h-.803c-.401 0-.803 0-.803.412-.401 0-.803.411-.803.411 0-2.88 2.41-2.469 3.614-2.469 3.212-.411 7.628 1.235 8.03 3.703 0 .823 0 2.058-.803 3.292"
      />
      <path
        fill="url(#swedbank_ee_svg__J)"
        fillRule="nonzero"
        d="M154.013 55.042c0 .407.824 1.221.412 1.628-.824.814-1.647 3.257-2.883 3.664-.412 0-.824-1.221-1.236-1.628 1.236-.407 1.648-2.036 3.707-3.664"
      />
      <path
        fill="url(#swedbank_ee_svg__K)"
        fillRule="nonzero"
        d="M236.69 62.054c1.702-2.068 1.702-2.896 3.405-4.964.852-.827 2.13-1.241 2.98-.827 1.278.413 1.704 2.068 1.278 2.895-1.277-.413-2.129-.827-2.555 0-2.129 2.069-2.554 5.792-6.812 5.378 0-.827 1.703-2.068 1.703-2.482"
      />
      <path
        fill="#3E0900"
        fillRule="nonzero"
        d="M178.373 65.717c-.415-.425-.415-1.275-1.245-.85-.415-.425 0-.85 0-1.275 1.66-6.374-5.809.425-6.639-.85-.83-1.7 5.81-5.1 7.469-2.55 1.245 1.7-.415 5.525 2.49 5.95 2.074.425 4.148-4.25 7.053-3.825 2.075.425 4.15 3.4 5.809 3.825 3.32.425 7.053-5.1 8.713-.425.415 1.275 0 5.95-1.66 5.1-1.244-.85 2.075-4.25-.415-5.525-1.66-.85-4.149 2.975-7.053 2.55s-4.15-3.825-5.809-4.25c-2.075-.425-4.564 5.1-6.639 5.1-.415-.425-.83-1.7-2.074-2.975"
      />
      <path
        fill="url(#swedbank_ee_svg__L)"
        fillRule="nonzero"
        d="M140.78 67.567c.882 0 .882-.823.882-1.235.882-2.058 1.764-4.116 3.97-4.94 0 .412.44 1.236.44 1.236-.882.411-2.205 3.704-2.646 5.351 0 .412-.44.823-1.323.823-1.323-.411-1.323-.411-1.323-1.235"
      />
      <path
        fill="url(#swedbank_ee_svg__M)"
        fillRule="nonzero"
        d="M255.456 92.49c1.261-5.776-.42-10.314-3.364-12.79-.84-.825-2.943-1.238-4.204-2.475-2.523-3.301-3.364-10.315-10.512-9.49-3.363.413-6.306 5.776-9.25 5.776s-3.363-4.126-6.306-4.95c-1.262-.413-1.682 0-2.523.412-.42 0-1.262.412-1.262 1.238-.42 0-1.681-1.238-2.102-1.238.42-.825 1.682-1.65 2.523-1.65 2.102-.826 2.943-.413 4.204 0 2.103.825 3.364 4.125 5.046 4.125 2.523 0 6.307-5.363 10.09-5.776 3.785-.412 7.149 2.063 8.83 4.126 1.262 2.063 1.262 4.126 2.523 5.776 2.523 3.3 8.83 5.776 7.989 14.853 0 .825 0 2.888-1.682 3.713 0 .413.42-1.237 0-1.65 0 .413 0 0 0 0"
      />
      <path
        fill="#3E0900"
        fillRule="nonzero"
        d="M131.105 68.802c4.334 6.31-4.335 7.573-5.123 12.62-.394 3.787 3.152 6.732 2.758 12.621 0 2.524-.788 7.573-2.364 7.573-.788 0-.788-1.262-1.576-2.525 1.97-1.262 1.576-5.89.788-9.255s-3.153-5.89-2.759-8.413c.395-3.366 4.73-4.207 5.911-7.152 1.182-1.683.394-3.365 2.365-5.469M154.789 76.212c-.792 0-1.188 0-1.188-.84 0-1.26.792-4.622-.395-5.042-.396-.42-2.77.84-2.77 2.52-.397 0-1.188.42-1.188 0 .396-.84.396-1.26.396-1.68.791-1.68 2.77-2.94 4.353-2.1 1.979 1.26 1.979 5.041.792 7.142"
      />
      <path
        fill="url(#swedbank_ee_svg__N)"
        fillRule="nonzero"
        d="M185.448 71.083c-.423-.445-.846.444-.846.444-.424 1.333-1.27 2.666-2.117 3.555-.424.444-.424-1.333-.424-1.333.847-.445.847-.889.847-1.333 0-1.333.423-3.111 2.54-3.555-.423-.445 0 1.777 0 2.222"
      />
      <path
        fill="url(#swedbank_ee_svg__O)"
        fillRule="nonzero"
        d="M137.759 77.83c1.617-.871 9.298-.871 11.723-4.794.405.436.809.436.809.436.404 3.051-7.277 5.23-9.702 5.23-.809 0-2.022.436-2.426 1.744-.404 0-1.213-.436-1.617-.872 0-.436.404-1.743 1.213-1.743"
      />
      <path
        fill="url(#swedbank_ee_svg__P)"
        fillRule="nonzero"
        d="M171.818 78.266c.384-.871.768-1.307 1.152-1.743.384-.872.768-1.743 1.153-2.18l.384-.435c.384-.436 1.152-.872 1.92-.872.769 0 0 1.744 0 1.744-.384 0-.768.871-1.152 1.307-.384.872-.768 1.308-1.152 1.744-.385.435-1.153 2.615-2.305 2.615-.768 0 0-1.744 0-2.18"
      />
      <path
        fill="url(#swedbank_ee_svg__Q)"
        fillRule="nonzero"
        d="M230.854 76.847c1.127-.424 1.127-.847 1.127-.847 0-.423 0-.847.376-1.27.375-.424.751-1.694 1.878-1.694.375 0 .751 2.117.751 2.54-1.502 0-1.502 1.694-1.878 1.694 0 .424-.376 1.694-1.502 2.117-.376-.423-1.127-1.693-.752-2.54"
      />
      <path
        fill="#3E0900"
        fillRule="nonzero"
        d="M204.072 75.818c-.422 0-1.69-.397-1.69 0-.423 0-1.268-.397-1.268-.397.423-.793 1.69-1.19 2.536-1.19 3.803-.793 9.718 1.984 7.606 5.156-1.69 0-.423-.793-.846-1.586-2.112-1.983-4.225-1.586-6.338-1.983M156.723 84.916c-.844-.864 6.747-5.187 8.012-2.593 1.265 2.16-.843 5.187-2.108 4.322-1.687-.864 2.108-3.026 0-4.322-.844 0-3.796 4.322-5.904 2.593"
      />
      <path
        fill="url(#swedbank_ee_svg__R)"
        fillRule="nonzero"
        d="M144.644 95.07c.37 1.264.74 2.949-.369 3.37 0-.421-1.108-1.264-1.478-1.685 1.108 0 .37-.842.37-1.263-1.109-2.107-2.956-4.213-2.217-6.74 0-.421 2.217-.421 2.217-1.264.369-1.263-1.109-2.527-1.109-4.633v-1.264c1.847-.842 3.325 4.634 2.217 7.161 0 .421-1.847.421-1.847.843-.37 1.684 1.477 3.79 2.216 5.475"
      />
      <path
        fill="#3E0900"
        fillRule="nonzero"
        d="M229.694 90.63c0 1.59-.43 2.781-1.722 3.576-.43-.397.43-1.192.43-2.384 0-2.782-2.151-6.358-4.734-6.756-1.29 0-5.164 1.987-5.594.795-.43-1.59 5.164-2.782 7.316-1.987 1.291.795 3.873 3.974 4.304 6.756M184.438 91.03c-1.746-1.281.873-1.281 0-2.563-1.746-2.99-7.419.855-8.728-.854 2.619-4.272 15.274-.427 8.728 3.418M216.24 115.376c-2.091-.423-.836-4.657-.836-7.621-.419-2.54-2.51-8.891-4.6-9.738-.42-.424-1.674.847-2.51.847-2.091-.424-6.274-6.775-9.62-7.198-1.672 0-2.927 1.693-3.764.847s2.092-2.54 3.764-2.54c1.673 0 3.765 1.693 5.856 2.963 1.254.847 3.345 3.387 4.6 3.81.837.424 2.091-.423 2.51 0 4.182 2.118 6.691 12.28 4.6 18.63M237.103 91.413c2.04-2.548 7.346-1.274 8.979.424 2.04 2.123.816 5.096 1.224 8.493.408 2.123 2.45 3.821.817 5.52-.817-1.699-2.45-2.973-2.857-5.096-.408-2.972 1.224-4.67 0-6.794-1.225-2.547-5.714-1.273-8.163-2.547M180.682 93.31c-.847 2.443-.423 7.329-2.117 9.364-1.693-2.035 0-6.107.424-9.364 0-.814 0-1.22.423-1.22zq0-.61 0 0M160.718 107.967c-1.643-.43-.822-1.722-.822-2.583-.821-3.013-3.286-5.595-.821-7.747 4.518-3.444-4.518-2.152-4.518-3.013-.41-2.583 6.982-1.722 7.393 2.152 0 1.722-1.643 1.722-2.054 3.443-.821 2.583 2.875 3.443.822 7.748M105.843 101.616c.425.405 2.124-.406 2.124 1.215-6.372 6.484-1.7 12.562-2.974 13.372-2.973 1.62-5.097-5.673-4.247-9.32.85-2.431 3.398-4.457 5.097-5.267M140.16 109.67c-.42-.392-.84-.392-1.26-.783v-.782c0-1.566-1.26-2.74-3.781-2.74-3.782 0-5.042 6.261-8.824 6.653-2.52 0-3.361-2.74-7.563-1.566-1.26.392-2.52 2.348-4.201 1.566-1.26-1.174 3.36-3.913 6.302-3.913 2.941-.392 4.622 1.565 7.143 1.565 3.361-.392 3.781-6.652 8.823-5.87 1.681 0 5.462 1.957 3.362 5.87M230.513 106.95c0-.404-.41-.404-.82-.808l2.458-1.21c2.048-.404 4.096 0 4.505 2.017.41.807-.41 2.017-.41 2.824.41 1.21 4.096 5.246 0 4.439 2.458-1.614-1.638-1.614-2.047-3.632-.41-1.21 1.229-2.824.819-3.63-.41-.808-2.457.403-4.505 0M263.045 112.2c-.795-1.57 1.989-1.963.796-3.927s-3.977.786-5.568-.392c3.58-5.891 11.533 2.749 4.772 4.32"
      />
      <path
        fill="#3E0900"
        fillRule="nonzero"
        d="M135.064 111.105c-.847 1.281-.847 3.417-2.117 4.271-.423 0 0-.427-.423-.427-.424 0-1.27 0-1.27-.427.846-.854 1.693-1.708 1.693-2.563.423-.854.423-1.708.847-1.708.847-.427 1.27 0 1.27.854M155.475 119.61c-1.707-2.755-4.693-6.69-8.96-7.084-.853 0-1.706 1.18-2.56 0 3.84-3.935 12.8 1.18 11.52 7.084M78.54 115.386c1.27-.43 0 13.75-1.27 13.75-.423 0-1.27-1.718-2.117-1.718 1.694-.86-1.27-10.743 3.387-12.032M225.097 117.819c.418-.407 1.254-.815 1.672-1.222s.835-.407 1.671-1.221c.836 0 1.254.407 1.254.814s-.836.814-1.254 1.629c-.418.407-.836.814-1.671 1.221-.418.407-1.254.814-1.672 1.629-.836 0-2.09 0-1.671-.408 0-1.22 1.253-2.442 1.671-2.442M165.125 116.95c.873 0 1.746-.805 3.055-.403 2.182.403 10.91 7.25 6.11 10.472-1.31-.805 0-2.013-.436-3.222-.873-3.222-6.547-4.43-8.729-6.847M250.653 127.201c-1.27.439-1.694.877-2.54.877-.424 0 0-1.315 0-1.754 0-2.63 1.27-4.823 0-6.138-.848-.877-1.271 1.754-2.542 0 1.694-3.946 5.082 0 4.659 3.946 0 .438-.424.877 0 .877.423 0 .847 0 1.27-.439 5.506-1.753 20.329-5.26 18.211 2.193-1.694.438-.424-1.316-.847-1.754-1.27-1.315-5.506-1.315-7.623-.877-3.388 0-7.623 1.754-10.588 3.07M231.81 118.72c2.257-.848.376 1.695-.753 3.391-.752 2.543 0 6.358-1.881 5.934-1.505-.423.376-8.477 2.634-9.325M273.092 119.436c6.153-1.676 13.536-1.257 18.869 3.77.82.838 1.64 2.514 3.281 4.19 1.23 1.257 2.872 2.514 2.872 3.352.41 1.675-1.231 2.932-.82 4.189 0 2.933 3.69 5.446 1.64 7.96-.41-1.257-3.692-6.284-3.692-7.541s1.641-2.514 1.23-4.19c0-1.256-2.05-1.675-2.87-2.932-2.872-2.933-5.333-7.541-10.665-8.38-3.282 0-6.974 1.677-9.845-.418M114.74 121.727c.424 0 1.271.412 1.695.824-2.117.823-2.964 2.47-5.928 3.295-2.54.412-4.657-.412-6.774-.412 1.27-2.471 3.81-.824 5.927-1.236 1.694-.412 3.387-2.471 5.08-2.471M203.87 142.897c-2.05-2.455 4.92-9.003 5.74-11.867.41-.41.82-3.274 0-3.274-1.23-.819-5.33 4.501-6.15 4.501-4.51 0-6.56-9.412-7.79-9.821-.82.41-1.23.41-1.23 1.228-1.64-1.637-.41-4.093 2.46-2.456 2.46 1.228 2.87 8.185 6.15 8.594 1.64 0 7.79-8.184 8.61-1.228.41 4.092-2.46 6.139-4.1 9.412-1.23 1.637-2.05 4.092-3.69 4.91M93.97 131.253c-2.156-1.592-3.45-6.37-6.9-6.769-.862-.398-3.449 1.195-3.449-.398 0-.796 2.156-1.593 4.312-1.195 3.019 0 7.331 5.177 6.037 8.362M237.103 129.725c0-.424.882-1.27 1.323-1.694 1.764-1.694 3.97-2.964 3.97-1.27-2.206.423-2.206 4.234-5.293 2.964M132.312 129.017c6.334-5.627 17.736 1.607 16.891 9.646-3.378-3.617-4.645-10.048-10.557-10.45-2.111.402-5.49 2.813-6.334.804M69.155 129.136c1.204.83 1.204 2.489 2.006 5.392.401 1.659 1.605 2.488 2.006 3.732 0 .83-.401 2.074-.401 2.903.401 1.659 5.616 7.88 2.407 9.124-1.605.414-6.018-5.806-6.018-6.636-.401-1.244.401-3.317 0-4.147-.401-1.659-2.006-2.488-2.407-4.147-.401-3.318 1.204-4.147 2.407-6.22M284.735 140.744c0 1.606-.435 2.409-.871 3.211-.872-.802-.872-2.007-1.308-3.612-.436-2.409-.872-5.219-2.18-6.825l-3.05-2.81c1.743-2.007 5.23 2.409 6.102 4.015s1.307 4.014 1.307 6.021M173.022 144.363c-5.08-3.783 3.809-2.101 5.925-5.464 1.27-1.681 2.963-8.827 6.772-5.885 2.117 1.682.424 7.146 1.27 10.929 1.27 4.203 5.926 5.884 4.233 10.508-.424.84-2.117 2.522-2.54 3.783-1.27 2.522-2.963 7.986-3.386 13.03-.423 3.783-1.693 7.566-3.81 4.203v-.84c.847-6.305 1.27-13.45 4.657-18.915.846-1.261 2.116-.84 2.539-2.522.423-3.363-4.233-5.464-4.656-9.247-.423-1.261.847-5.885-.423-7.566-1.27-1.26-2.54 4.624-5.08 6.725-2.115.84-3.385.84-5.501 1.261M122.38 138.824c-1.663.805-.832-1.208-.832-1.208-1.246-2.014-7.478-2.819-10.802-2.014-3.324 1.208-4.57 5.638-9.971 6.443-2.077.403-3.74-.402-6.232 0-4.155.403-6.232 3.625-8.725 4.027-.83-2.818 4.986-5.235 9.556-5.637 1.662 0 3.324.402 4.985 0 4.986-.806 6.648-5.235 9.14-6.04 5.817-2.417 15.373-.403 12.88 4.429M264.96 146.072c-3.073-2.088 3.072-5.428 2.194-8.351-.878-2.506-3.511-.418-5.706-.836.44-3.34 5.267-2.923 6.584-.835 2.633 3.759-1.756 7.934-3.072 10.022M310.643 134.429c.404 0 1.21 1.318 1.613 1.757-2.016 4.394-6.048 3.955-4.435 5.712-1.21.44-2.42 1.319-4.033.88 1.21-4.395 7.662-4.834 6.855-8.349"
      />
      <path
        fill="url(#swedbank_ee_svg__S)"
        fillRule="nonzero"
        d="M198.246 178.886c-.41-.826-.41-2.477 0-3.302 0 .412.41.412.41 0 1.232-2.477 3.694-3.715 5.335-5.78.41-.825.41-2.063.82-2.476.822-.825 2.053-.825 2.463-1.65 1.231-2.065 0-4.954.82-6.192.411-.413 1.232 0 2.052-.826.821-.413 2.873-2.064 3.693-3.302 2.052-2.477 5.335-9.494 4.104-10.732-.41-.826-5.745 2.476-6.566 0-.41-1.239 7.387-4.54 9.028-3.715.82.413.82 2.476.82 4.128-.41 4.127-3.692 11.144-6.565 13.621-.41.413-2.462 1.238-2.872 1.651-1.231 1.238-.41 4.128-1.231 5.779-.41 1.238-2.052 1.238-2.462 2.476-.41.413-.41 1.239-.821 2.064-1.641 2.477-5.334 5.366-6.976 7.43-.41.413-.41.826-1.23.826z"
      />
      <path
        fill="#3E0900"
        fillRule="nonzero"
        d="M106.908 144.524c1.694-1.664 2.117-3.328 3.81-3.744.847 2.496-2.54 5.409-3.81 3.744M237.103 145.788c1.659-6.353 11.613-4.765 7.465 2.779-.414.397-2.073 2.779-2.073 2.779-3.318.397 1.659-5.558 1.659-6.75-.83-3.97-4.562 1.192-7.05 1.192M293.203 149.332c4.288-4.192 8.147 4.192 7.29 8.384-2.573-.42-1.287-6.707-4.288-7.965-1.287-.838-2.144.839-3.002-.42M90.657 147.13c1.694 1.891-2.117 4.915-2.117 5.293-2.117-1.134 1.27-3.78 2.117-5.292M71.677 176.769c.418-2.085-.418-4.17.836-6.255.836-1.25 3.345-.417 2.927-2.919-.418-3.336-10.872-2.919-11.708-6.255-.836-2.501.836-11.675 2.509-12.092 0 0 1.673 1.668 2.09 2.919.419 2.085-2.09 4.587-.836 7.505 1.673 2.502 15.472 1.668 12.545 8.34-.419 1.668-3.346 2.502-4.182 3.753-1.672 1.668-1.672 4.17-4.181 5.004M318.564 150.306c.448 2.647-2.688 2.647-3.584 5.293-.448 0-1.344-.378-1.344-.756-1.792-1.512 4.48-3.024 4.928-4.537"
      />
      <path
        fill="url(#swedbank_ee_svg__T)"
        fillRule="nonzero"
        d="M209.324 152.266s2.021-.42 2.425-1.678c0-.838 2.426.42 2.022.839-.809 3.354-8.895 4.612-8.895 6.289-.404-.839-1.212-1.258-1.617-1.677-.404-1.258 3.639-2.516 6.065-3.773"
      />
      <path
        fill="url(#swedbank_ee_svg__U)"
        fillRule="nonzero"
        d="M178.584 155.118c-.403.385-.806.77-.403 1.54-.806 0-2.821-.386-2.418-1.155 0-.385.403-1.155 1.21-1.925 0 0 .805-.385.805-1.155.806 0 2.822 0 3.225.385-.806 1.155-1.21 1.54-2.419 2.31"
      />
      <path
        fill="#3E0900"
        fillRule="nonzero"
        d="M250.864 157.397c2.545-1.942 17.82-8.155 12.728.776 0 0-1.697 2.718-2.121 2.718-.425 0-1.273-1.553-1.273-.776 0-.777 1.697-2.33 2.546-3.495 2.121-3.883-10.183 2.718-11.88.777M93.562 154.894c3.728-1.568 9.114 2.352 7.871 6.272 0 .392-.414.784-.414.784-1.243 0-1.243-.392-1.243-1.176v-1.96c-1.243-2.352-4.143-2.744-6.628-3.92zM273.253 158.198c1.231-1.688 4.925-2.532 6.156-2.532 1.641 0 3.693-.422 4.104.844.82 1.688-1.642 5.909-2.873 7.175s-1.231-.844 0-2.954c.41-.422 2.052-2.533 1.642-2.955-.821-1.266-3.694-.422-4.925 0 0 0-1.231.422-2.052 1.689h-1.231c-.821-.845-1.231-.845-.821-1.267M122.539 156.829c4.679-.874 7.23 1.746 7.656 4.366 0 1.31-.85 3.057-1.701 3.93q-.639 0-1.276-1.31c.85-1.31.85-1.746 1.276-2.183 0 0-1.276-3.057-2.553-3.493 0 0-6.38 1.31-5.104-.874.426-.436.851-.436 1.702-.436M304.833 161.218c-.834-.831-2.085 1.663-2.502 1.248-2.084-1.248 1.251-3.742 3.336-2.08.834.416.417 2.495.834 4.158 2.085 3.742 12.092 6.237 9.59 15.384 0 .416-1.25 2.494-1.667 2.079-2.085-.416.417-2.91 0-5.405 0-1.663-1.251-2.91-2.085-4.158-2.502-4.99-7.923-3.742-7.506-11.226M198.529 167.242c-.786 0-1.963 0-1.57-1.645.784-1.644 3.925-3.7 4.71-4.523 1.178-.411 2.356 0 2.356 0 1.57 2.056-4.318 6.168-5.496 6.168M108.822 166.184c0-.385-.428-.77-.855-.77.427-3.08 8.985-1.54 11.125-2.694 0 0 .427-.77.855-.77s2.14 0 1.712 1.54c-.428 1.924-4.707 1.154-8.13 1.54-2.14 0-3.85.384-4.707 1.154M80.881 188.412c-6.7-6.736 11.725-12.63 4.606-22.313 0 0-3.35-.421-1.675-1.684 4.188-2.105 5.444 5.894 5.025 9.262-.837 4.631-8.375 7.578-7.956 14.735M57.418 169.404c4.234-.878-1.27 11.414-1.27 9.219 0-3.073-.424-6.146 1.27-9.219M320.944 173.537c-.41 0-.82-.823-1.231-.411-.822-4.937 9.443 2.468 6.98 5.76-.822-1.234-4.106-6.172-5.749-5.349"
      />
      <path
        fill="url(#swedbank_ee_svg__V)"
        fillRule="nonzero"
        d="M225.46 182.07c.785 0 .392-.421.392-.843 0-2.95 1.178-7.166 3.14-7.587 3.533-.422.786 2.107 0 4.215-.785 2.53 0 6.323-1.57 6.323-.392 0-1.57-1.264-1.962-2.107"
      />
      <path
        fill="#3E0900"
        fillRule="nonzero"
        d="M97.043 177.213c-.415-.427-.83-.427-.83-.427-.83.427-1.244.427-1.659.427 0 0-.414 0-.414.427-.83 0-1.244-.854-.83-1.28.83-.854 2.903-1.708 4.562-1.708.415 0 4.977 4.696 5.806 8.965.415 4.27-1.659 5.124-2.488 4.697 0-.427.83-2.989.415-3.843-.83-2.988-4.147-6.404-4.562-7.258M47.42 173.593c0 1.667-3.367 2.917-3.367 7.084-.42 2.5-2.525 3.75-2.525 4.583.42 1.667 7.155 1.667 7.576 2.5 1.684 2.084 0 5-4.209 3.334l-.42-.834c-2.105-1.666-5.472-.833-6.314-3.333-.421-2.083 1.683-3.333 2.525-5.417 2.105-2.917 1.263-4.583 6.735-7.917M335.331 179.055c.847-.431 1.27 0 1.27.861-1.693 7.754-18.205 8.615-18.205 10.338-1.694.43-3.811 2.154-5.081.861 1.27-5.168 6.35-5.168 13.549-7.322 2.963-.43 8.044-2.585 8.467-4.738M277.326 182.808c6.475-3.257 13.76 4.885 13.76 10.177 0 2.036-2.428 5.7-2.023 2.85 0-.814.81 0 .404-2.85-.809-4.885-4.451-9.77-9.713-9.77-1.214 0-1.619.407-2.428-.407"
      />
      <path
        fill="url(#swedbank_ee_svg__W)"
        fillRule="nonzero"
        d="M139.88 187.11c1.208 0 2.82-4.272 6.445-5.049 0 .777.806 1.165.806 1.942-4.029 2.33-4.432 5.826-6.446 5.438-.806-.388-1.208-1.554-.806-2.33"
      />
      <path
        fill="#3E0900"
        fillRule="nonzero"
        d="M244.847 196.88c-1.677-.41-.838-2.056-.838-3.29-1.258-3.7-3.773-6.578-7.964-5.344 2.934-5.756 12.156 2.467 8.802 8.634M298.496 187.975c3.772-2.42 9.22 2.823 8.381 5.647-.419.807-.838 1.614-1.676.807-1.257-.403.42-.807.42-.807-.42-2.824-2.934-4.84-7.125-5.647M264.4 188.477c1.226 0 2.452-.404 2.86.809 1.635 2.425-.817 6.468-2.45 5.255-.818-.808 2.45-3.638.816-4.447-.817-.404-6.536 4.852-7.353 2.83 0-1.617 4.902-4.447 6.128-4.447M93.944 204.29c-1.208-.823-.402-2.88-.805-4.936-.403-2.468-1.209-4.524-4.028-4.935-2.014 0-2.014 3.29-4.431 1.234 4.43-7.815 14.098 1.233 9.264 8.637M107.611 192.196c7.104-4.09 4.341 13.907 2.368 10.635-.79-1.227 1.579-6.545 0-8.999-.395 0-4.736 0-2.368-1.636"
      />
      <path
        fill="#3E0900"
        fillRule="nonzero"
        d="M36.69 192.646c.83.823 2.903 5.347 1.244 6.992-1.244 1.234-4.148-.411-4.563 2.468-.415 2.467 2.904 4.112 2.49 7.403-.416 2.056-5.808 3.701-.83 4.935 2.488.411 4.562.411 5.807-.411 1.66-1.234 0-2.88 2.489-3.702 4.148-.822 3.733 2.88 6.637 2.88 1.244 0 4.563-2.057 7.052-3.291 2.074-1.234 4.563-3.29 6.222-3.702 3.733-.41 8.711 2.057 9.126 4.113s-3.319 5.758-2.074 7.403c.415.412 3.733.412 3.318.412 1.245.41 2.49 3.701 3.734 4.112.83.412 2.903-.822 4.148-.822s2.489 1.234 3.318.822c1.245 0 3.319-1.645 4.563-2.467.83-.412 1.66-2.057 2.49-2.468 4.977-1.234 7.051 5.758 10.784 6.17 3.319.41 5.393-2.469 9.956-2.057 3.319.411 6.637 2.467 8.296.822.83-.822 0-5.758.415-6.58 2.904-4.113 11.2.411 17.422-.823 2.904-.411 6.638-1.645 9.126-1.234 1.66.412 2.075 2.057 4.563 1.646-3.733 5.757-11.614 7.814-20.326 7.403-2.903 0-4.563-1.234-5.807 0-2.489 2.056-1.244 3.701-4.563 6.169s-7.881-1.234-12.444-.823c-3.734.411-5.393 2.057-9.126 1.234-2.49-.823-4.563-4.524-6.637-4.935-1.66 0-2.49 1.645-4.149 2.056-2.903 1.234-9.54 1.234-13.274 0-1.244-.411-2.074-2.879-4.148-3.701-.83-.412-2.489.822-3.733.41-1.66-.822-2.074-3.7-2.074-5.757 0-1.645.83-3.29.415-4.524-1.66-3.29-5.393 0-6.638.411-2.074 1.234-4.148 3.702-5.807 4.113-3.733.823-7.467-2.056-9.126-2.056-1.244 0-2.489 2.467-4.563 2.879-4.978.822-10.785-2.057-10.785-4.936 0-1.645 2.904-2.879 3.318-4.524 0-1.645-1.659-3.29-1.659-5.347 0-2.467 3.319-3.29 4.563-5.757.415-1.646-.83-2.88.83-4.936"
      />
      <path
        fill="#3E0900"
        fillRule="nonzero"
        d="M59.397 200.41c1.713-1.678.428-3.357 0-3.777-.856-.42-10.706 4.617-10.706 1.26 0-1.68 10.706-3.778 11.991-2.939 2.141 1.26 2.998 8.395-1.285 5.457M160.107 195.92c3.358-.834 6.716 3.753 7.135 9.173 0 2.92-.84 5.838-1.259 9.174-.84 5.837-1.26 11.675-2.938 17.512-.84 2.919-2.938 10.424-5.877 11.675-1.259-.417-1.679-1.25-2.938-1.668 1.26-1.668 2.519-3.336 2.938-4.17 2.1-5.837 2.939-14.593 3.358-21.682 0-2.084.84-9.173-.84-10.007-2.518-1.668-5.456 1.668-8.814 1.668-1.26-2.085-6.716-3.336-7.975-3.753 0-4.586 7.136-3.752 11.333-4.586 2.519-.417 4.198-2.919 5.877-3.336M72.545 196.313c6.279-2.903 9.208 7.88 10.883 10.784.837 1.244 5.44 2.073 6.278 3.318.837 1.659-.419 6.22-2.093 3.732-1.674-.83 1.674-1.244 0-2.488-.837-.83-4.604-.83-5.86-2.489-1.674-2.073-1.674-4.977-2.93-7.05-.837-1.245-3.348-4.148-5.022-4.148-.837.415-2.093.83-1.674 1.244-1.256-.414-2.093-1.659.418-2.903M319.666 221.674c-1.66 2.866-5.81 2.456-9.129 2.866-3.32.409-7.883 2.456-11.203 1.228-3.734-.82-4.979-5.731-8.713-6.14-7.47-1.228-7.47 9.414-17.013 7.777-2.49-.41-4.149-3.275-6.638-3.684-2.905-.41-4.98 2.456-7.054 2.456-3.735 0-4.98-4.093-7.469-4.503-6.639-1.637-12.863 3.275-19.087.41-4.15-2.047-5.394-7.778-7.469-12.69-.414-1.228-1.66-2.456-2.904-3.274h-2.49c-2.074-1.638 0-6.55-4.564-6.55 1.245-6.549 4.564-2.865 8.299-1.228 2.904 1.228 4.979 1.228 5.809 2.456 4.564 4.503 2.904 11.87 7.883 14.327 5.81 2.865 13.693-4.503 19.087 0 1.245.819 1.245 3.684 3.32 4.093 2.904.41 4.149-4.502 6.639-4.502 4.564 0 5.394 10.642 12.447 5.73 1.245-.818 1.66-3.274 4.15-4.502 2.904-2.047 7.469-2.456 10.788-.82 2.075.82 5.394 6.14 8.299 6.55 4.979.41 10.373-2.046 17.012 0M131.017 210.64l-1.264-1.282c.421-.428.421-2.139.421-3.422-.42-2.566-.842-3.849-.42-5.132-.844-1.283-3.793 1.71-3.793-.855 0-2.139 6.32-2.994 6.32-.428-.843 4.277 1.264 8.126-1.264 11.12M211.934 248.747c-1.254-.829-3.762-7.871-5.016-12.013-2.508-7.042-4.18-15.741-2.926-26.511.418-1.657 2.09-4.557 1.672-5.8-.418-.828-2.926-.828-4.18-.828-5.016.414-10.45-.829-14.63-1.657-3.343-.829-5.433.828-5.851-1.243 3.762-3.314 8.36-.828 14.211-.414 3.344.414 12.122-.829 13.794 1.243 1.672 2.07-.836 6.627-1.254 8.699-.836 4.142-.418 9.113 0 12.84-.418 9.528 7.524 24.855 4.18 25.684M316.072 207.414c-.423-.45-.847-.45-1.27-.9.847-.9-2.117-4.05-5.082-3.6-2.54 0-4.658 4.05-7.623 4.5-3.387.45-5.928-2.25-8.893-1.8-.847 0-2.54.45-2.54 1.8-.424 0-.848-.45-1.695-.9.847-5.85 8.047-.9 12.705-1.35 2.964-.45 5.082-4.05 9.317-4.05 2.964 0 6.775 2.7 5.081 6.3"
      />
      <path
        fill="#3E0900"
        fillRule="nonzero"
        d="M265.186 206.383c-.405 0-1.215 0-1.62-.434 1.62-2.605 4.455-1.302 7.29-2.17 3.646-1.303 9.316-3.04 10.531.433 1.215 4.342-4.455 13.46-2.43 5.21.405-.868 1.215-3.039.81-4.341-.405-.869-3.645-1.303-4.05-1.303-3.24 0-6.886 3.474-10.531 2.605M249.77 203.231c1.718 0 3.006 0 3.865.84 1.718 2.519-2.577 7.556-3.006 4.618 0-.84 2.147-2.939 1.718-3.359-1.718-3.358-7.301 3.359-7.73.84-.86-1.68 3.865-2.939 5.153-2.939"
      />
      <path
        fill="#3E0800"
        fillRule="nonzero"
        d="M333.543 211.7c-.412 0-.824 0-1.236-.829.412-.414 0-3.726 0-4.14-.823-.414-3.707 1.242-5.354.828-.412 0-1.236-.414-.824-.828 2.883-2.898 11.12-1.242 7.414 4.968"
      />
      <path
        fill="#3E0900"
        fillRule="nonzero"
        d="M113.074 214.406c3.283-1.568-4.515-4.314-9.03-3.921-.82 0-4.924 0-4.924.784-.82 0-.82-.392-.41-1.569 0-.392 4.104-1.176 5.745-1.176 3.694 0 11.081 1.96 11.902 3.137.41 1.569-.821 4.314-3.283 2.745M314.4 216.045c.836-.832 2.09-.416 3.761-.832 1.672-.415 2.508-2.494 5.016-1.247 1.253.832 1.671 3.326 2.507 3.741 1.254.416 9.195-.83 10.866-1.662 1.254-.832 2.09-3.326 3.344-4.157 1.672-.832 4.18.415 5.851 0 1.672-.416 2.925-1.247 4.597-1.247.418 4.572-5.85 3.325-9.194 4.572-1.672.832-1.254 2.079-3.344 3.742-1.254.83-10.03 2.91-12.538 2.078-1.254-.416-2.09-2.494-3.761-2.91-.836 0-.836.832-1.672.832-1.254 0-5.85-2.079-5.433-2.91M194.763 240.51c0 .842-.445 1.683-.445 2.944-.89-.42-1.334-1.261-1.779-2.102-3.114-5.887-1.334-17.24-1.334-24.81-.445-.84-1.78-.42-2.225 1.262 0-.84-.444.42-.89 0-.889-1.261-.889-1.261-.444-2.523.89-1.261 2.224-2.102 4.448-.84 2.224 1.681.445 12.193.89 18.08.445 3.785.89 4.626 1.78 7.99M179.19 233.363c-1.35-.42-1.8 2.523-1.35 2.523-.9-.42-2.698-5.887 2.249-5.046 4.047 1.682.9 10.512-.9 12.614-.45 0-1.349-.42-1.799-.42.9-.841 3.598-7.569 1.8-9.671M145.469 254.477c1.666 0 22.08-2.12 20.83 2.967-.416 2.12-2.915 2.967-3.332 6.358v2.543c.833.848 5.833-3.39 7.083-3.815 14.165-6.358 31.663-5.934 45.412 2.968 1.666 1.271 7.915 3.814 5 6.358-1.667 1.271-11.666-4.663-13.333-5.51-14.165-4.663-27.914-2.968-39.996 2.966-2.5 1.272-7.082 4.663-7.916-.847-.416-2.967 2.5-8.902 2.083-9.326-1.25-.423-4.582-.423-6.666-.423-3.333 0-11.248 0-16.248.423-4.166 0-8.332.848-9.166-.847-.416-.424.834-2.544 1.25-2.967.833-.424 5.833-.424 7.083-.848zM249.805 258.329c-2.48 1.257-7.852.838-12.397.838-8.265-.42-16.943 1.258-20.662-1.257-6.612-3.773 6.198-3.773 9.091-3.773 7.438-.42 19.422.42 23.968 4.192M167.75 163.22c-1.25-.806-5.002-4.029-5.002-4.029-1.667-1.209-.833-.806-2.917-2.417-3.334-2.82-7.502-3.224-10.003-1.21-1.667 0-2.917-.402-4.167-.402-2.084-2.418 1.25-1.612 4.584-2.82 1.667-.806 2.084-2.015 3.334-2.015 5.001-.403 8.752 5.238 12.92 7.655 1.667 1.209 6.252 6.044 9.17 4.432 1.666-.805 3.333-1.611 4.167-.805.417.805-.417 2.014-1.667 2.82s-2.5 1.209-3.334 1.612c-2.501.805-5.835-2.015-7.086-2.82"
      />
      <path
        fill="url(#swedbank_ee_svg__X)"
        fillRule="nonzero"
        d="M236.484 173.436c0-.405-.405-.81-.405-1.215-.404-2.027 2.831-5.674 4.045-4.863.404.405 1.213 1.62 1.213 2.026-.404-.405-.809 0-.809.81-.809 1.621-2.426 3.242-2.022 4.458-1.618 0-1.618-1.216-2.022-1.216"
      />
      <path
        fill="#3E0900"
        fillRule="nonzero"
        d="M216.254 182.435c-1.24.83-1.24 2.076-3.72 1.66-2.481-.414 1.24-2.49 2.48-3.735 1.654-1.66 3.308-4.567 5.788-6.227.827-.415 2.894-1.245 2.894-1.245.413-.416-.413-2.076-.413-2.491.413-.83 2.894-1.66 3.307-2.076 1.24-1.245 2.48-3.736 3.307-4.15 3.308-2.076 8.682-2.492 11.99-2.076 3.72.415 5.374 3.32 7.441 4.15.827.416 3.308 0 4.135.83 1.653 2.077-.414 7.473-4.135 5.813 0-.83.414-1.66.827-2.076.414-.83-.827-1.245-1.653-1.66-2.481-.83-3.721-3.321-5.375-4.152-3.72-1.245-9.095-.415-11.576 1.66-1.24.831-1.654 2.907-2.894 4.152-.827.83-2.894.83-3.72 2.076-.414.83-.414 2.075-.828 2.905-1.653 2.906-4.547 2.491-7.855 6.642M164.721 184.652c-2.475-.415-3.713-1.658-5.776-2.487-2.888-3.316-12.378-5.803-13.203-5.803-6.19-4.56 5.364-2.487 9.49-.83 3.3 1.659 6.601 4.975 7.839 5.804 2.063 1.243 4.538 1.243 4.126 4.145-.825 2.072-1.238-.415-2.476-.83M130.863 183.768c-2.856-1.2-4.488-2.802-8.16-2.002-.408 0-.816.4-1.224.4-5.712-1.6 3.264-4.803 5.712-3.602 2.448.4 2.856 3.603 5.304 3.202 2.04 0 2.856-2.802 4.488-3.202 1.224-.4 2.448.8 3.672.8 2.04 0 2.856-2.401 3.672-1.2 1.632 1.6 0 3.202-1.224 4.003-2.04.8-3.264-.4-5.304-.4s-2.04 3.602-6.936 2.001"
      />
      <path
        fill="url(#swedbank_ee_svg__Y)"
        fillRule="nonzero"
        d="M170.365 68.185s1.21 1.323-.404 1.323c-1.21.44-3.229 1.764-3.632 2.646-.807.882 2.018.882 2.018.882s0-.44 1.21-.882c2.422-.882 3.633-2.646 4.036-4.41z"
      />
      <path
        fill="url(#swedbank_ee_svg__Z)"
        d="M234.612 61.431c1.246.416 1.66.416 2.491-.832-.415 1.663-.415 2.91-1.66 2.91-2.076 0-2.907-1.247-4.983-1.662-4.151-.416-5.812.415-7.888-2.91-3.736-4.158-6.227-8.731-7.473-10.81-.83-1.247-1.245-1.663-2.076-2.079-.415-.416-.83-.416-1.245-.416s-.83 0-2.076.416c-.415-.416.415-1.663 0-2.079 1.246-2.494 7.058 3.742 8.719 7.9.83 1.663 4.982 7.067 6.642 7.483 2.076.832 2.906.832 4.982.416 1.66.416 2.906 1.247 4.567 1.663"
      />
      <path
        fill="url(#swedbank_ee_svg__aa)"
        d="M177.827 53.944c1.638.402 2.456-2.408 4.912-2.81 3.275-.802 4.912 2.007 6.55 1.205 0-.803.41-1.606 0-2.007-.819-.401-2.047-1.605-3.684-2.408-4.503-1.204-6.959 1.605-7.778 3.21 0 .402.41 2.007 0 2.81"
      />
      <path
        fill="url(#swedbank_ee_svg__ab)"
        d="M174.431 52.774c3.24 0 2.835 1.134 4.455.378 0-.378-1.215-1.89-1.215-2.269-1.62-1.134-6.075-1.134-7.694-1.134-2.025 0-5.265 2.269-6.885 3.78-.405.379.81 1.135.405 1.513 2.835-1.512 5.265-3.403 10.934-2.268"
      />
      <path
        fill="url(#swedbank_ee_svg__ac)"
        d="M201.996 58.72c1.266 2.07 9.703 4.14 9.703 1.242 0-1.655-2.531 0-4.219-.827-3.375-.828-4.218-4.14-5.906-6.21-.844 2.484-.422 4.554.422 5.796"
      />
      <path
        fill="url(#swedbank_ee_svg__ad)"
        d="M164.279 53.983c-1.694 1.27-7.198-1.27-9.739 1.694l.847 1.27c2.117-1.27 5.928 1.27 9.738-1.27-.423 0-.846-1.27-.846-1.694"
      />
      <path
        fill="url(#swedbank_ee_svg__ae)"
        d="M250.651 62.673c1.66 1.233 3.735 2.054 4.565 3.698 1.245 2.054.415 3.286.83 6.162s1.245 3.697 2.49 6.984c.415 1.232.415 3.697.83 4.93.83 2.875 3.734 4.93 4.98 8.626 1.244 2.055.414 4.109.83 5.341 0 1.643 9.959 5.751 11.619 3.697 0 0 .83-1.232.415-2.875-.83-2.465-5.395-1.233-7.47-2.465-2.075-1.643-.415-3.698-1.66-6.573-.83-2.465-3.735-3.698-5.395-7.395-.83-2.054-1.66-4.519-2.49-6.162-1.66-3.287-1.66-3.697-2.074-5.751 0-.822 0-3.287-.415-4.52-1.245-2.875-11.62-9.037-16.185-10.27-.414 0 0 2.054 0 2.465 3.735 1.233 6.64 2.876 9.13 4.108"
      />
      <path
        fill="url(#swedbank_ee_svg__af)"
        d="M144.038 60.758c-.407.423.815 1.27.815 1.27.407-.847 5.29-.847 6.512-2.117 0 0-.814-1.27-1.221-1.694-.814.424-4.884 1.27-6.106 2.54"
      />
      <path
        fill="url(#swedbank_ee_svg__ag)"
        d="M172.535 68.263c-.373-1.77-1.866-.442-2.24-2.212 0-.442.747-2.654.374-3.097-1.12-1.327-1.866.443-1.866 0-2.239 3.982 3.732 9.733 3.732 5.31"
      />
      <path
        fill="url(#swedbank_ee_svg__ah)"
        d="M132.882 71.978c.407-1.834 4.071-3.21 6.92-3.21.815 0 1.63 0 2.036-.458-.407-.458-.814-.458-1.22-.916-.408-.459-.815-.459-1.222-.459-2.85-.917-7.735.917-8.143 1.834.815 1.375 1.222 1.833 1.629 3.209"
      />
      <path
        fill="url(#swedbank_ee_svg__ai)"
        d="M187.602 72.86c2.995.782 15.405-1.175 13.266-3.133-1.284-1.174-10.27 2.35-12.41 1.566-.856-.391-3.852-6.655-4.28-1.566v.392c2.996.391 1.284 1.957 3.424 2.74"
      />
      <path
        fill="url(#swedbank_ee_svg__aj)"
        d="M215.013 74.055c.41 4.736 3.278 3.444 7.784 4.305 2.049.43 8.194 3.875 9.014.861 0-.86-.82-1.291-1.23-1.291-1.229.43-2.048.43-2.048.43-1.639-.43-2.868-1.722-4.507-2.153-1.638-.43-3.687.43-4.916 0-3.278-1.722 0-5.166-1.639-6.888-2.458-2.153-2.868 3.013-2.458 4.736"
      />
      <path
        fill="url(#swedbank_ee_svg__ak)"
        d="M170.503 78.535c-1.616-.84-2.02-7.983-3.635-6.302-3.231 2.94 6.058 12.605 5.654 5.882-.808-.84-.808.84-2.02.42"
      />
      <path
        fill="url(#swedbank_ee_svg__al)"
        d="M180.48 76c.88 0 2.2-1.27 2.64-1.694v-.846l-.44-.424c-1.32.424-2.64.424-3.08.424-.881 0-3.081-.424-3.962 0-3.08 1.693 1.76 2.54 4.841 2.54"
      />
      <path
        fill="url(#swedbank_ee_svg__am)"
        d="M254.576 92.98c-2.931.827-1.675-9.931-6.282-10.759-.838 0-5.864 2.483-7.12.414-1.257-2.482 2.094-3.724 2.094-4.965 0-2.897-5.026-4.552-5.864-4.552-4.607-.413-5.025.828-4.188 1.655 1.675 2.07 7.539-1.655 7.539 3.724 0 1.656-3.35 5.793.838 7.448 1.675.414 5.026-1.655 6.7-.827 2.095.827 1.257 8.275 4.19 9.93.837.414 5.444.414 2.931-1.655-.419-.413-.419-.413-.838-.413"
      />
      <path
        fill="url(#swedbank_ee_svg__an)"
        d="M144.617 82.563c-.86-.824 1.29-1.235 2.15-1.235 4.3-1.235 9.89-5.352 9.89-5.763-.43-.412-1.29-.412-1.29-.412 0 .412-4.73 3.293-6.88 4.528-1.29.412-2.58.412-3.87.823-.43 0-1.72.412-1.72 2.059z"
      />
      <path
        fill="url(#swedbank_ee_svg__ao)"
        d="M207.134 79.469c-1.59 0-3.578.407-4.771 0-.398-.408-.398-.815-.398-1.222V76.62s-.795-.407-1.193-.407c-2.385 4.478 1.59 5.292 5.965 5.292 1.192 0 2.385 0 2.783-.407.398-2.443-1.193-2.036-2.386-1.628"
      />
      <path
        fill="url(#swedbank_ee_svg__ap)"
        d="M141.065 97.516c-1.652-1.277-4.955-11.493-4.955-13.195 0-2.129 2.89-5.108 1.238-5.96-1.238-.425-2.89 3.406-2.89 5.534-.413 3.405 3.716 14.047 5.368 14.898 1.239.852 2.89.852 4.13.426-.414-2.98-1.652-.851-2.891-1.703"
      />
      <path
        fill="url(#swedbank_ee_svg__aq)"
        d="M157.403 84.758c-3.848 3.561 8.552 8.458 6.414 2.225-2.993 4.007-5.558-3.116-6.414-2.225"
      />
      <path
        fill="url(#swedbank_ee_svg__ar)"
        d="M222.106 92.001c-1.737-1.99-3.473-1.592-4.341-2.786-.434-.796 0-.796 0-1.194.434-.398.434-.398.868-.398 0 0 0-.398-.434-.398-1.737-1.592-3.04 1.592-1.737 3.98.434.398 2.605 1.592 3.907 2.786 1.737 1.99 1.303 3.185 2.605 3.98 1.737 1.195 5.644 0 4.342-2.387-3.908 1.194-3.04-1.194-5.21-3.583"
      />
      <path
        fill="url(#swedbank_ee_svg__as)"
        d="M177.33 102.392c-6.103-.854.435-14.092-1.308-14.519s-3.487 6.833-3.487 9.822c0 2.562.436 4.27 2.615 5.551.436.427 3.923 1.281 4.794-1.28 0-.428-.871-.855-1.307-1.709-.436 2.562-1.308 2.135-1.308 2.135"
      />
      <path
        fill="url(#swedbank_ee_svg__at)"
        d="M182.35 89.972c-.77.424-1.155.424-1.54.847s-1.924.847-1.924 1.694c.77.423.77.846 1.54.846 0 0 0-.423.384-.846.385-.424 1.155-.847 1.54-1.27l.77-.847s0-.424-.77-.424"
      />
      <path
        fill="url(#swedbank_ee_svg__au)"
        d="M247.517 105.192c-.82 0-1.229 0-2.048-.43-1.64-1.287-2.05-5.149-4.098-7.724-.82-.858-2.868-1.716-3.278-2.574-.41-.43 0-1.288 0-2.146 0-.43.41-.43.82-.43l-1.64-.857c-.409 0-.819.429-.819.429s-.41.429-.41 1.716c0 3.004 2.869 3.862 4.098 5.579 1.639 2.575 2.868 8.153 6.146 8.153.82 0 1.23-.429 2.459-.858 0-.43-.82-.858-1.23-.858"
      />
      <path
        fill="url(#swedbank_ee_svg__av)"
        d="M194.02 95.828c.833 1.265 5.001.843 7.502 2.529 1.668 1.264 2.501 3.793 3.335 4.636 1.25 1.264 3.751.843 4.585 2.107.833.843 0 2.529.833 3.793.417.843 1.668 1.686 2.084 2.529.834 2.107.417 3.793 1.668 4.636.833.421 2.5.842 2.917-.843.417-.843-2.084-1.265-.833-.843-2.501-1.265-.834-2.529-1.668-4.636-.416-1.264-2.084-1.686-2.5-2.95 0-.843.416-2.529 0-2.95-.834-1.686-3.335-.843-5.002-2.108-.834-.421-.834-2.107-1.667-2.95-3.335-4.214-9.17-3.793-9.587-5.057-.417-.843 1.667-1.686 0-1.264-2.5-1.686-2.084 2.95-1.667 3.371"
      />
      <path
        fill="url(#swedbank_ee_svg__aw)"
        d="M113.295 97.219c0 .815 0 2.037.832 2.037l.832-.815c.831 0 2.495-.407 3.327 0s1.247 3.666 2.495 4.073c2.911.408 4.99 0 6.238-.814-.415-.815-1.247-.815-2.079-2.037-.416 0-2.08 0-2.495-.407-2.496-2.444-1.664-4.888-5.823-3.666-.416 0-3.743.814-3.327 1.629"
      />
      <path
        fill="url(#swedbank_ee_svg__ax)"
        d="M151.662 96.294c-1.226 3.697 1.634 10.27 3.268 11.092.817.41 2.043.821 2.86.41.409 0 1.634-.821 2.043-1.643 0-.41-.817-.821-1.226-.821 0 .41-.408.821-.817.821-.817 0-1.226 0-2.043-.41-1.634-1.233-2.45-4.52-2.45-6.984 0-.41.408-1.643.408-2.465s.408-1.643 1.225-1.643c0-.822-.408-2.054-1.225-1.232-1.226.821-1.635 2.054-2.043 2.875"
      />
      <path
        fill="url(#swedbank_ee_svg__ay)"
        d="M232.446 106.712c-.424 0-1.27-.862-1.694-.862-.847.43-.423 1.725-.423 2.587 0 1.294 0 2.587-.424 3.45 0 .862-.423 1.725-.423 2.587 0 .432-.424 1.294-.424 1.294l-.423.863c.423.43 1.27.43 1.27.862.424-.431.424-.862.847-2.156s.423-3.019.847-4.744v-2.587c.423-.863 0-1.294.847-1.294"
      />
      <path
        fill="url(#swedbank_ee_svg__az)"
        d="M94.049 109.23c-.42 0-2.517 0-4.195.42-1.678.421-2.936 2.105-4.614 2.526-1.258.42-2.936.842-3.775 1.262-1.678.842-2.936 1.263-4.195 2.947h.84c2.096.842.419-.421 2.096-.842 1.259-.42 4.195-.842 5.873-1.684 2.517-1.262 5.034-2.946 5.034-2.946h5.453c2.097.42 1.677 8.418 7.97 7.576 1.258-1.262-2.517-3.788-2.937-5.05-1.678-3.789-.839-5.472-3.775-5.472-2.097.841-2.936.841-3.775 1.262"
      />
      <path
        fill="url(#swedbank_ee_svg__aA)"
        d="M258.585 115.569c-2.065-1.746 1.652-5.675 1.24-6.985-1.24-3.056-5.37 6.112-2.892 8.294 2.065 1.747 7.021-.436 6.608-3.928-1.652-.437-3.717 3.928-4.956 2.619"
      />
      <path
        fill="url(#swedbank_ee_svg__aB)"
        d="M279.586 111.11c-.836 0-1.254-.413-1.671-.826-.836.413-2.09.827-3.343 2.48-1.253.412-2.089 0-2.507.826-.417 3.305 3.343 2.065 5.85 1.652.417 0 4.178-2.479 5.849-2.479 2.924.413 5.013 4.545 10.445 7.437 5.014 2.892 10.027 2.892 12.952 5.371 2.089 1.653 4.178 6.198 2.924 9.503.418-.413 1.672.413 1.672.413.835-1.239.835-8.263-1.672-11.155-2.506-3.719-8.356-4.132-13.787-7.024-4.596-2.479-7.938-8.676-12.952-8.263.418.413-2.089 2.066-3.76 2.066"
      />
      <path
        fill="#FFFDE9"
        d="M143.064 114.342c.403.88 4.437 5.715 6.454 6.154 1.21.44 4.438 0 4.841-.88 1.21-2.197-4.034-.878-4.034-.878-2.42-.88-5.244-6.594-6.05-7.473-.404-.44-.808.44-.808.44-.403 0-.806 2.198-.403 2.637"
      />
      <path
        fill="#FFEEBD"
        d="M113.26 114.675c.422 2.797.846 3.197 1.693 5.194.423.8.846.8 1.27.8 2.117-1.2 0-4.396-.847-6.793 0-.799-.423-1.198 0-1.598-1.694-.4-2.117.8-2.117 2.397"
      />
      <path
        fill="url(#swedbank_ee_svg__aC)"
        d="M122.997 116.646c2.117-.847 4.234-.847 7.621-.847 2.117 0 2.964-.423 3.811-1.27 0 0-.423 0-.423-.423-.424 0-.847-.847-1.27-.847-.847.847-2.964.423-4.235.423-2.117.424-4.657.424-6.774 1.27.423-.423.847 1.27 1.27 1.694"
      />
      <path
        fill="url(#swedbank_ee_svg__aD)"
        d="M235.78 114.603c-1.588.87-3.572 3.045-3.97 3.915.794 2.61 1.191 0 4.764-2.175.397-.435.794-.87 1.588-1.305-.794-.87-1.588-.87-2.382-.435"
      />
      <path
        fill="#FFEEBD"
        d="M167.786 128.446c.414.422 6.2 1.686 5.786-.842-.413-2.107-2.066.421-3.306 0-4.133-1.264-2.893-9.268-6.2-10.111 0 3.792.827 9.268 3.72 10.953"
      />
      <path
        fill="url(#swedbank_ee_svg__aE)"
        d="M224.366 130.549c2.717 2.16 4.27-1.296 4.27-1.728-.389-2.16-2.717 1.296-3.493 0-1.165-1.729 2.328-11.667-.777-8.642-1.552 1.296-1.164 9.506 0 10.37"
      />
      <path
        fill="#B45314"
        d="M242.59 125.961c1.27 0 5.928-7.84 2.54-6.098-1.27.87-3.387 4.791-2.54 6.098"
      />
      <path
        fill="url(#swedbank_ee_svg__aF)"
        d="M273.515 122.21c1.694 3.801 10.585 1.69 13.126 4.646 2.117 2.534 1.693 4.645 2.54 7.601.847 3.378 2.54 7.601 4.234 8.868.423.422 3.387 1.689 5.08 1.689.848 0 1.694 0 2.118-1.69q0-.632-1.27-1.266c0 1.267-1.27.845-1.694.422-.847-.422-2.117-.422-2.117-.844-4.657-2.956-2.964-13.09-7.621-17.314-2.964-2.533-8.892-.844-12.702-2.956-.847-.422-.423-2.111-2.117-1.689 0 1.267 0 1.69.423 2.534"
      />
      <path
        fill="url(#swedbank_ee_svg__aG)"
        d="M195.908 134.044c.832 2.856-.831 8.16 2.079 10.2.415.409 4.572 2.04 4.157-1.223-.416-1.224-1.663.816-2.495.408-2.91-1.224-.831-7.345-1.662-10.2-.832-2.857-7.067-5.713-5.404-9.385-5.82 1.224 2.494 8.16 3.325 10.2"
      />
      <path
        fill="url(#swedbank_ee_svg__aH)"
        d="M121.795 125.06c-4.097-.79-8.194 1.58-10.243 3.16-.41 0-.41.395-.41.395 0 .395 0 1.58.41 1.58 1.229-.395 2.458-1.975 4.097-2.37 3.688-1.58 6.966 0 8.195-.79-.41-.79-1.23-1.976-2.049-1.976"
      />
      <path
        fill="url(#swedbank_ee_svg__aI)"
        d="M268.036 125.961h-2.877c-2.465.442-4.931 1.326-6.575 1.768-2.876 1.326-4.931 4.42-6.575 4.42-1.644.443-6.575-1.767-7.397-.441-.822 1.768 3.698 2.21 4.52 2.652 4.52.442 4.52-1.326 6.987-3.094 2.876-1.768 6.164-2.653 9.451-3.095 1.644-.442 2.055-.884 3.288-1.326-.411-.442 0-.884-.822-.884"
      />
      <path
        fill="url(#swedbank_ee_svg__aJ)"
        d="M84.142 124.903c-2.516 4.468 4.613 8.936 10.064 6.905-2.935-2.844-9.225-.813-8.806-6.5-.42.407-1.258-.405-1.258-.405"
      />
      <path
        fill="url(#swedbank_ee_svg__aK)"
        d="M112.01 128.493c-3.878 1.677-5.17 3.353-6.893 2.515-1.292-.42-.43-2.515-.862-3.773 0-1.257-.43-1.676-1.723-.838-1.723 1.258-.861 6.287 1.293 6.707 2.584.838 5.6-.42 6.892-2.096.43-.42.861-.42 1.292-.838 0-.42.43-1.677 0-1.677"
      />
      <path
        fill="url(#swedbank_ee_svg__aL)"
        d="M70.037 131.253c-.411-2.544 2.882-3.816 6.175-3.392-1.235-3.393-6.586-1.696-7.41.848 0 .424.824 2.12 1.235 2.544"
      />
      <path
        fill="#FFFDE9"
        d="M133.059 131.585c-.818-1.224 1.226-2.449-1.227-2.449-.41 1.225-.818 2.45-.41 3.673.819 3.673 12.678 6.53 16.767 5.714-4.498-3.673-12.677-2.449-15.13-6.938"
      />
      <path
        fill="url(#swedbank_ee_svg__aM)"
        d="M237.439 133.19c-.448 1.216-.448 2.838 0 4.054.895 1.622 5.373 2.432 4.925-.81-1.343-.811-1.343.81-2.686.81-.448-.81 0-2.432 0-3.648 0-1.622-.448-2.027.895-3.649-.448-.405-.895-.81-1.79-.81-1.792.405-1.344 2.837-1.344 4.053"
      />
      <path
        fill="url(#swedbank_ee_svg__aN)"
        d="M277.257 142.992c2.14-2.133 3.424-6.399 2.14-9.811 0-.427 0-1.28 1.284 0 0-.427-2.14-2.986-2.568-2.986-.856.427-.856 1.706-.856 2.56 0 2.559 1.284 6.398-.428 8.53-.856 1.28-2.14.854-2.568 2.133-.856 3.413 3.424 2.56 7.276 2.56.856 0 1.712 0 2.14-.427-.428-1.28-.856-1.28-2.14-1.28a5.96 5.96 0 0 0-3.852 0h-.856c-.428-.853 0-.853.428-1.28"
      />
      <path
        fill="url(#swedbank_ee_svg__aO)"
        d="M259.802 144.796c-.438-1.656 4.822-8.28.877-7.037-1.315.414-3.507 7.037-1.753 9.107.438.828 4.383 2.898 5.698-.828-2.192-.414-3.945 1.242-4.822-1.242"
      />
      <path
        fill="url(#swedbank_ee_svg__aP)"
        d="M313.866 152.423c1.637 0 3.683-2.03 3.683-2.843-.41-4.468-11.866-8.123-9.82-9.748-1.637-.406-3.273.406-3.683.812-2.455 5.28 13.503 7.718 9.82 11.78"
      />
      <path
        fill="url(#swedbank_ee_svg__aQ)"
        d="M172.015 142.897c0 .396-.427.791-.427.791-.856 4.749 3.42 3.562 5.986 5.54.427.792.855 3.166.855 3.561 0 0 .427.396.855.396.427.396 1.71.396 2.565 0 .428-1.187.428-4.748-2.138-6.727-1.71-1.187-3.42 0-4.703-1.978h-.427c-1.71 0-2.138-1.187-2.566-1.583"
      />
      <path
        fill="url(#swedbank_ee_svg__aR)"
        d="M212.546 150.868c-.423-.389 1.27 1.555 1.27 1.555 2.117-2.722 1.27-7.777-2.117-7.388.847 1.556.847 4.666.847 5.833"
      />
      <path
        fill="url(#swedbank_ee_svg__aS)"
        d="M101.412 146.284c-1.691 0-4.228-.847-5.919-.847-.845 0-5.919.847-5.496 2.117s3.805-.423 5.919 0c2.96.424 10.57 1.27 10.992-2.54-1.268 0-3.382 1.27-5.496 1.27"
      />
      <path
        fill="#FFFDE9"
        d="M236.147 150.374c-.398-1.577 1.59-3.154 1.192-3.942-1.192-1.97-3.577 4.73-1.59 6.307 1.193.788 5.962 1.576 5.565-1.183-2.783.394-4.77.788-5.167-1.182"
      />
      <path
        fill="url(#swedbank_ee_svg__aT)"
        d="M68.472 153.482c.407-3.402 8.13-.378 7.724-4.537-.406-.378-3.658-.378-4.471-.756 0 2.647-4.879-.756-6.098 2.269 1.22 0 2.439 3.024 2.845 3.024"
      />
      <path
        fill="url(#swedbank_ee_svg__aU)"
        d="M86.797 151.606c-3.146 1.186-1.967-3.557-1.573-5.534-6.293 1.582.393 11.463 1.573 5.534"
      />
      <path
        fill="#FFEEBD"
        d="M290.42 153.591c-.435.38-1.305-.38-1.74 0-3.915 2.658 8.264 7.214 10.874 4.177-1.305-1.898-11.31-.38-9.134-4.177"
      />
      <path
        fill="url(#swedbank_ee_svg__aV)"
        d="M324.215 161.936c-.421-1.257.422-3.77 0-5.863-2.108-5.864-4.637 0-7.589.418-2.951.42-1.686-.418-3.794 1.257-1.687 1.256-4.638 2.513-.844 3.769 3.795.838 6.325-4.607 9.276-3.77 2.108.838 1.265 7.54 3.795 9.633 1.265 1.257 4.216 1.257 5.902 2.513 2.952 2.094 4.217 7.538 3.795 9.632.422 0 1.265 0 1.686.42 1.687-13.821-10.54-12.984-12.227-18.01"
      />
      <path
        fill="url(#swedbank_ee_svg__aW)"
        d="M145.014 154.952c.842 4.116 6.312 2.881 9.258 4.528 2.525 1.235 3.787 4.116 6.312 5.351 1.683.824 3.787.824 5.892 1.647 1.262.823 2.945 2.47 4.629 3.705 3.787 2.881 6.312 5.763 11.782 6.586.842-.412-.841-.823-1.262-1.647v-1.235c-3.367-3.293-7.996-4.94-11.362-7.82-1.263-.824-2.525-2.059-4.208-2.47-6.733-1.236-7.996-7.822-15.15-8.645-1.683 0-2.945 0-4.629-.412-.42.412-.841.412-1.262.412"
      />
      <path
        fill="url(#swedbank_ee_svg__aX)"
        d="M176.803 159.604c.387.851-.386 1.702-.773 2.553.387.426 3.092.426 3.478.851 1.546-3.404-1.545-6.382-1.159-6.807-.773-.426-1.932-.851-2.319-.426-.772 1.277 0 2.979.773 3.83"
      />
      <path
        fill="url(#swedbank_ee_svg__aY)"
        d="M99.157 161.007c-.404.402-2.017.402-3.227-.402-1.613-1.206-1.613-3.215-2.42-4.421-.403-.402 0-.402.403-.402-2.016-.804-2.016 1.206-1.613 2.814.403 2.411 4.437 6.029 8.067 3.617.806-1.206-1.21-.804-1.21-1.206"
      />
      <path
        fill="url(#swedbank_ee_svg__aZ)"
        d="M202.173 161.192c.846.8 2.117 2.398 2.54 1.599.847-1.199.847-4.395.423-5.194 0-1.199-2.117-1.998-1.693-1.998-1.27 1.998 0 3.196-1.27 5.593"
      />
      <path
        fill="#FFFDE9"
        d="M253.462 159.842c-1.183-.44-1.577-3.08-2.366-1.76-1.182 2.64 2.366 4.401 5.52 4.841 3.155.44 4.732-.88 3.155-2.64-1.971 1.76-5.126.88-6.309-.44"
      />
      <path
        fill="url(#swedbank_ee_svg__ba)"
        d="M119.61 162.343c2.117.414 1.27 2.072 1.694 1.658.846-2.073.423-4.975 2.117-4.975-.847 0-1.27-1.658-1.694-1.244-1.27 1.659-2.117 3.317-2.117 4.56"
      />
      <path
        fill="url(#swedbank_ee_svg__bb)"
        d="M298.687 168.942c.83 3.309 8.72 4.55 10.382 8.686.83 2.482-1.246 3.723-.83 6.205.83 3.31 5.813 0 4.983-2.068-1.661-.414-1.661 1.654-2.907 1.24v-.827c4.568-9.927-15.366-10.34-9.137-19.028-1.246-.827-3.322 2.069-2.491 5.792"
      />
      <path
        fill="#3E0900"
        d="M266.962 169.332c.868 2.15 6.51.86 4.34-1.721-.868.43-2.604.86-2.604.43 0-2.581 5.643-7.314 6.51-9.465-1.735 0-1.735 0-2.17-.86-2.604 2.581-7.379 8.604-6.076 11.616"
      />
      <path
        fill="url(#swedbank_ee_svg__bc)"
        d="M274.106 164.117c-1.242.807-1.657 2.823-4.141 3.226-.414.403-1.657 1.21-.828 1.613.414.403 1.242.403 1.656.403 3.313 0 3.313-2.42 4.555-3.226 2.899-2.419 4.97-1.21 6.212-3.225-.414-1.21-.828-1.613-.414-2.017-.414.404-1.243 1.613-2.07 2.017-2.071.403-3.728.403-4.97 1.21"
      />
      <path
        fill="url(#swedbank_ee_svg__bd)"
        d="M110.495 168.97c-.822-.408-.822-2.042-1.232-2.042-.411-.818-.822-1.226-.822-.41-.822 1.636-.41 2.862 0 3.27 1.643 2.86 14.379 2.452 20.13-4.086 1.644-1.226-.821-.41-.821-1.635-2.465 2.86-13.557 6.13-17.255 4.904"
      />
      <path
        fill="url(#swedbank_ee_svg__be)"
        d="M250.4 172.645h-3.44c-2.58-1.243-1.29-8.695-7.74-5.797 3.44 2.898 2.58 10.765 13.76 6.625-1.72 0-1.72-.414-2.58-.828"
      />
      <path
        fill="url(#swedbank_ee_svg__bf)"
        d="M198.312 174.727v-1.663c0-1.663.424-4.574.424-5.822-1.27.416-2.117 0-2.964 0 0 4.159-2.964 9.565 1.27 11.228.423 0 .847.416 1.27.416 1.27-.416 0-3.327 0-4.159"
      />
      <path
        fill="url(#swedbank_ee_svg__bg)"
        d="M71.663 172.487c0-.428-1.681-3.425-3.362-4.281-3.781-.857-7.563-2.141-10.084 1.284 5.042-.428 5.462-.428 8.824 1.713 2.52 1.712 2.52 4.71 4.622 5.566.42-1.713.42-3.425 0-4.282"
      />
      <path
        fill="url(#swedbank_ee_svg__bh)"
        d="M235.118 171.582c-1.587-.423-6.748.424-7.541 2.54 0 0 1.19.424 2.381 1.27 1.191-1.27 3.97-.846 7.145-.846-1.19-1.27-1.985-2.117-1.985-2.964"
      />
      <path
        fill="url(#swedbank_ee_svg__bi)"
        d="M52.396 176.062c2.165 2.205 2.165 4.85 4.763 3.528 0 0-1.3-2.205-1.732-2.646-1.3-2.645-3.897-4.41-4.764-4.41-.433 0-2.598 0-3.03.883.865 0 3.03-.441 4.763 2.645"
      />
      <path
        fill="url(#swedbank_ee_svg__bj)"
        d="M326.294 178.68c-1.171-.439-3.123.878-3.904 0-.781-2.195-.781-4.39-.781-4.39.39-.438-.39-1.755-1.171-1.755-2.734 6.145 2.342 10.535 6.637 7.462-.39-.439-.78-.878-.78-1.317"
      />
      <path
        fill="url(#swedbank_ee_svg__bk)"
        d="M144.444 173.593c-.773.436-1.547.872-.773 2.615.387 1.308-.387 1.744-.774 2.18.774.871 1.16 2.615 1.547 2.615.387-.436.774-.872 1.548-2.615.387-.872-.387-1.308.774-2.18 1.547.436-2.322-.871-2.322-2.615"
      />
      <path
        fill="url(#swedbank_ee_svg__bl)"
        d="M91.03 182.98c0 3.837 4.393 5.97 6.39 6.396.798 0 3.993.853 5.191-2.559.4 0-1.198 0-1.997.427 0 .426-.399.426-.399.426-3.594-.426-9.184-3.411-6.39-10.66 0-.426-.398-.426-.398-1.28-1.198-.426-2.396 5.97-2.396 7.25"
      />
      <path
        fill="url(#swedbank_ee_svg__bm)"
        d="M159.557 183.26c-3.371 0-9.27-2.961-13.485.424.422.423 1.686.846 2.107 1.27 2.95-.847 4.636 0 5.057 0 3.793 0 12.22 3.384 14.749 2.115.421-.423.421-.846 0-.846-.422-.423-1.686-.423-2.107-1.27-2.107 0-6.321-3.385-6.321-1.692.421 0 .843.423 0 0"
      />
      <path
        fill="url(#swedbank_ee_svg__bn)"
        d="M211.7 183.966c.835 4.19 4.595 1.524 8.356 1.143 2.507-.38 5.85-.38 7.52-1.143-1.253 0-1.67-1.143-2.506-1.905-2.925 0-4.596.381-6.686.762-.835 0-2.507 1.143-2.089.762-.418 0-2.089 1.143-2.507 1.143-1.253 0-1.671-.38-2.089-.762"
      />
      <path
        fill="url(#swedbank_ee_svg__bo)"
        d="M119.785 181.475c-1.68 3.876 9.245 5.6 10.506 6.03 1.68.861 2.1 1.723 2.941 2.154 2.521.43 6.303 1.722 9.665 0-2.101.43-2.521-1.723-1.68-2.154-4.203.861-6.724 1.723-9.666-1.723-.42-.43-5.042-3.446-9.665-3.446-1.26-.43-1.68-2.153-2.1-.861"
      />
      <path
        fill="url(#swedbank_ee_svg__bp)"
        d="M287.198 195.841c-2.033-1.23-1.22-4.103-3.659-7.386-.813-1.232-2.439-1.232-2.845-2.052-1.626-1.231-1.626-2.873-3.252-3.283-.813 4.514 2.845 4.103 4.878 7.386s1.626 6.566 4.065 7.387c.407 0 3.252.41 2.44-1.231 0-1.641-.814 0-1.627-.82"
      />
      <path
        fill="url(#swedbank_ee_svg__bq)"
        d="M302.911 195.74c.875.407 3.5-.814 3.936-1.221.438-.408-.437-.815-1.312-.815-.437 0-.874.407-1.312.407-2.624 1.222-2.624-4.885-5.685-5.699-.437 2.85 2.624 6.92 4.373 7.328"
      />
      <path
        fill="url(#swedbank_ee_svg__br)"
        d="M240.55 196.696c2.942.789 3.362-1.184 2.522-1.578-.42 0-1.682 0-1.682.394-.84-.789-5.885-4.733-5.885-5.522 0-.394.42-1.183.42-1.578-5.885.395 2.943 7.89 4.624 8.284"
      />
      <path
        fill="url(#swedbank_ee_svg__bs)"
        d="M340.779 196.6c-.83-1.214-.83-2.024-1.66-2.428-.83-.405-5.807-2.429-7.881-2.024-1.66.405-1.66 2.428-3.733 2.833-4.978 1.214-3.734-2.023-6.223-3.642-.83-.405-1.244-.81-2.903-.81-2.49.405-1.66 1.214-4.978.81-.83 2.428 4.563 1.619 5.807 2.428 1.245.81.415 2.428 2.49 3.642 4.977 2.834 6.221-2.023 9.54-2.428 1.66-.405 5.392.81 6.637 1.214 1.244.81 1.66 2.024 2.904 3.238s2.903 1.619 4.148 2.428l1.659 1.62c.83 1.213.83.809 1.66.404-1.245-3.642-4.979-4.857-7.467-7.285"
      />
      <path
        fill="#FFFDE9"
        d="M258.406 197.863c1.248 3.07 10.402-.877 7.906-2.631-1.665-.877-4.161 2.631-5.825 2.193-.417-.439-.417-2.193-.417-3.51-2.496-1.315-1.664 3.948-1.664 3.948"
      />
      <path
        fill="url(#swedbank_ee_svg__bt)"
        d="M91.93 204.923c.406 0 .406 0 .812.425h.406c-.406-.85-1.218-1.7-2.03-1.7-1.218-.85-3.248-1.7-5.277-4.675-.406-.425-.812-1.275.406-2.55-.406-.425-1.624-.85-2.436-.425-1.218 2.975 3.653 7.65 8.119 8.925"
      />
      <path
        fill="url(#swedbank_ee_svg__bu)"
        d="M78.733 211.224c-2.073-4.694 1.659-6.401-2.073-9.389-1.658-1.28-2.073 0-4.146-1.706-.415-.427-.83-2.56-1.658-2.134-3.732 2.134 4.146 5.12 5.39 6.4 1.244 2.135 0 5.122.829 7.255 1.244 3.414 7.878 3.841 10.78 2.56-2.902-2.133-7.878 0-9.122-2.986"
      />
      <path
        fill="url(#swedbank_ee_svg__bv)"
        d="M54.66 205.054c.86 0 0-.395 0-1.977-4.734 2.372-4.304-4.348-6.455-5.138-2.152 3.557 2.151 8.696 6.454 7.115"
      />
      <path
        fill="url(#swedbank_ee_svg__bw)"
        d="M125.515 208.281c-.78-1.211 1.17-1.615 1.17-3.23 0 0 .39-1.21 0-2.017-.39-1.211-.39-1.615 0-2.422-.78-.404-.78-.808-.78-1.615-1.56 1.615-1.17 4.844-1.56 6.055-.78 1.614-1.56 1.21-1.56 2.825.78 3.23 5.46 3.23 7.41 2.019l-.78-.808c-1.17-.403-3.51.404-3.9-.807"
      />
      <path
        fill="url(#swedbank_ee_svg__bx)"
        d="M262.985 207.77c.83 2.217 5.802 0 9.118 1.774 2.486.886 1.657 2.66 3.73 3.103-1.244 0 2.9.443 2.486-.443.414-1.774-1.243-.887-2.072-.887-.415 0-.829-2.66-2.487-3.103-2.9-1.774-7.874 0-9.117-1.33-.414-.444.829-.444-1.658-1.33-.828-.887-.414 1.33 0 2.216"
      />
      <path
        fill="url(#swedbank_ee_svg__by)"
        d="M314.231 206.407c-.397.395-4.371 2.37-5.563 3.952-6.358 6.718 7.153-2.767 6.755-3.162s-.795-.79-1.192-.79"
      />
      <path
        fill="url(#swedbank_ee_svg__bz)"
        d="M293.803 209.797c5.093.848 13.58 8.052 15.278.848-7.64 3.814-11.883-4.662-18.673-2.12-.424 0 .849-2.118 0-2.118h-1.273c-.849 4.661 1.697 2.966 4.668 3.39"
      />
      <path
        fill="url(#swedbank_ee_svg__bA)"
        d="M347.822 210.852c.423 0 1.27.847 1.693.847.847-2.117-1.27-7.621-2.117-8.468-.423.424-1.27.424-1.27.424s2.54 5.927 1.694 7.197"
      />
      <path
        fill="#FFFDE9"
        d="M249.721 209.416c-1.674 1.17-6.696.39-5.44-1.95-6.697 1.56 6.696 7.412 5.44 1.95"
      />
      <path
        fill="url(#swedbank_ee_svg__bB)"
        d="M327.52 212.615c1.18.396 5.512 0 5.906-1.585-.394-.396-.394-.396-.787-.396-.788 0-2.757 1.189-3.938.792-1.181-.396-1.575-3.565-1.181-3.565-.394 0-.788 0-1.182-.396-.394 1.189-.787 3.961 1.182 5.15"
      />
      <path
        fill="url(#swedbank_ee_svg__bC)"
        d="M116.263 215.023c.845-.398-1.688.398-2.11-.398-5.064 1.593-13.083.796-14.772-3.586-.422 0-.422-.398-.844-.398-1.266 5.179 10.13 8.764 17.726 4.382"
      />
      <path
        fill="url(#swedbank_ee_svg__bD)"
        d="M319.144 219.187c-3.16-.885-3.95-3.981-4.74-3.097-.395 2.655 3.16 4.867 1.975 5.31 1.185.442 3.16.442 4.345.884-.395 0-.395-2.212-1.58-3.097"
      />
      <path
        fill="url(#swedbank_ee_svg__bE)"
        d="M312.516 153.482s-3.714 4.657-1.857 7.621c.743.423.743.423 1.114.847l2.6-4.658s-1.114 0-.371-2.117c.371-.423-1.486-1.693-1.486-1.693"
      />
      <path
        fill="url(#swedbank_ee_svg__bF)"
        d="M58.35 200.056a49 49 0 0 1-3.97 3.402c-.397.756-.397 1.134-.397 1.134l.397.756s.794 0 5.954-4.158"
      />
      <path
        fill="url(#swedbank_ee_svg__bG)"
        d="M157.65 234.986h4.3s-1.29 8.317-10.75 11.644l-3.01-2.911s5.59-1.664 7.31-4.575c1.72-1.247 2.15-4.158 2.15-4.158"
      />
      <path
        fill="url(#swedbank_ee_svg__bH)"
        d="M150.34 247.454c2.05-.844 6.966-3.799 7.376-5.487-.82-.422-2.459-.844-3.278-1.688-2.458 1.688-7.375 3.799-9.834 5.065s-10.653 4.643-12.292 9.708c2.458.422 4.507-2.11 18.029-7.598"
      />
      <path
        fill="url(#swedbank_ee_svg__bI)"
        d="M213.845 206.727c-.416 9.977 3.743 26.189 7.071 33.671 2.912 6.651 9.982 7.483 16.638 10.392 4.575 1.663 8.318 6.236 13.31 7.483-1.248-4.988-5.408-7.067-10.815-8.73-3.743-1.247-9.15-3.325-12.894-5.82-6.655-4.572-7.487-20.368-7.903-29.93 0-1.246-.416-9.56 4.991-6.65-.415-7.898-5.823-9.561-7.486-9.146-1.664 2.495-2.496 7.899-2.912 8.73"
      />
      <path
        fill="url(#swedbank_ee_svg__bJ)"
        d="M220.112 268.858c2.82-.423 0-11.432-5.237-12.702 0 2.117 4.834 11.008 5.237 12.702"
      />
      <path
        fill="url(#swedbank_ee_svg__bK)"
        d="M180.027 204.668c4.167 3.742 8.752 4.574 12.085 4.99 2.5.416 4.585 0 5.418.831 1.667 1.664 1.25 14.97 1.667 19.545.417 4.158 1.667 5.822 2.5 8.732 1.667 5.406 3.751 9.565 10.002 9.98-.833-2.495-3.334-2.91-4.584-4.158-2.084-2.91-3.334-6.653-4.584-11.227-1.667-4.575-1.25-13.723-1.667-19.129-.417-2.08 0-4.158-.834-5.406-1.666-2.495-4.584-.832-8.334-1.663-3.334-.832-6.251-2.911-10.002-4.99-.833.831-2.084 2.079-1.667 2.495"
      />
      <path
        fill="url(#swedbank_ee_svg__bL)"
        d="M277.209 98.44s3.984.403 3.187 4.839c-1.195 4.032-2.39 6.048-1.992 6.855-.399.806-3.985 1.613-3.985 5.242-5.18-1.613 6.774-11.694 2.391-12.5-.797-.404.399-4.436.399-4.436"
      />
      <path
        fill="url(#swedbank_ee_svg__bM)"
        fillRule="nonzero"
        d="M181.194 203.2c-.38.43-1.138 2.148-1.138 2.148s-3.792-3.436 2.275-5.154c1.517-.86.38 2.577.38 2.577h-1.517c0-.43-.38 0 0 .43"
      />
      <path
        fill="url(#swedbank_ee_svg__bN)"
        d="M191.071 207.465s1.694.424 2.54 0v2.117s-2.116 0-2.963-.423c-.424 0 .423-1.694.423-1.694"
      />
      <path
        fill="url(#swedbank_ee_svg__bO)"
        d="M128.922 214.188s-3.818-.837-5.94 0c-2.545.838-2.12 2.931-2.12 2.931s.424 3.768.424 4.187 0 1.256-2.546 1.675c-.424 1.256 0 6.699 0 6.699s2.97.418 5.515-3.35c.849-1.256 1.273-5.443 5.94-3.768-.424-2.093-1.273-8.374-1.273-8.374"
      />
      <path
        fill="url(#swedbank_ee_svg__bP)"
        d="M43.729 189.55s1.272.878 1.272 1.757c-1.272 1.317-5.513-1.318-8.482 1.756-.848.879-.424 2.197-.424 2.636s2.544-.44 2.544-.44-.424-1.317 1.273-1.317c2.968 0 5.937.44 9.33-3.075.848-.878.848-3.513-1.696-3.513-1.697 1.317-3.817 2.196-3.817 2.196"
      />
      <path
        fill="url(#swedbank_ee_svg__bQ)"
        d="M59.944 198.997s0 1.27-1.671 2.54c-.418.424 1.671 1.27 1.671 1.27s2.507-1.693 2.507-3.81z"
      />
      <path
        fill="url(#swedbank_ee_svg__bR)"
        d="M49.797 196.88s-2.54.424-2.117 3.81c.423.848 1.694 0 1.694 0s-.847-1.693 1.693-1.693c-.847-.847-1.27-2.117-1.27-2.117"
      />
      <path
        fill="url(#swedbank_ee_svg__bS)"
        d="M45.092 176.769s2.964-4.153 5.08-3.323c.424 0 .847.416.847.831.424.415.847-.83.847-.83s-2.117-2.908-7.197 1.66c-1.27.831-1.27 1.247-1.27 1.247z"
      />
      <path
        fill="url(#swedbank_ee_svg__bT)"
        d="M56.524 174.652s.423 4.435-1.27 2.42c-.424-.404-1.27-1.614-1.27-1.614s.423 2.016 0 2.823c.423.403 2.54 1.613 3.386-1.21.847-1.613.847-2.42.847-2.42z"
      />
      <path
        fill="url(#swedbank_ee_svg__bU)"
        d="M58.595 173.593s.416-3.81 3.743-3.387c2.91 0 3.327 0 4.158.847.416-.847 1.248-2.964 1.248-2.964s-1.664-.847-5.406-.847-3.327.424-4.574 1.27c-.832.847-1.248 1.694-1.664 2.964.832 1.27 2.495 2.117 2.495 2.117"
      />
      <path
        fill="url(#swedbank_ee_svg__bV)"
        d="M101.125 113.031s1.247 2.908 0 2.077c-.832.83-3.743.415-3.743.415s1.663 3.739 5.406 2.908c1.248-.415 3.327-.415.832-6.23-.832 0-2.495.83-2.495.83"
      />
      <path
        fill="url(#swedbank_ee_svg__bW)"
        d="m205.56 204.29 2.964.396s0 1.19-.424 1.983c-.423 1.586-1.27 2.379-1.27 4.758 0 .793-2.54-.397-2.54-.397s0-2.379 1.27-4.361c.423-1.19 0-2.38 0-2.38"
      />
      <path
        fill="url(#swedbank_ee_svg__bX)"
        d="M209.794 244.757s1.27 2.605-.424 1.302c-.423.434-.846 2.171-.846 2.171s1.27.434 2.117.434c.846 0 1.693.869 1.27-3.039-.424-1.303-.424-2.171-.424-2.171z"
      />
      <path
        fill="url(#swedbank_ee_svg__bY)"
        d="M218.663 254.475s-4.508.436-3.689 3.05c.82 2.18 1.64 3.923 1.64 3.923l2.869-1.307s-2.05-2.18 1.23-.872h3.688l-.82-5.23z"
      />
      <path
        fill="#FFEEBD"
        d="M241.125 168.936s-.423-.423-.846 0v-1.27l.846-.424.424.424z"
      />
      <path
        fill="url(#swedbank_ee_svg__bZ)"
        d="M251.865 170.792s-.887 1.264-1.33 1.686-1.774.421-1.774.421v1.685s-.443.422 3.547-.842c1.774-.422 2.66-2.528 2.66-2.95.888-.842-3.103 0-3.103 0"
      />
      <path
        fill="#3E0900"
        d="M213.994 142.255s-2.997 1.667-2.14 2.917c.427 1.25 2.14.834 2.14.834s-.856-.417 1.713-.834c.428 0 1.285-.416 1.285-.416l-.857-2.918zM198.946 165.125s-2.066 1.27-2.066 2.964c.413.424 2.479 1.27 2.479 1.27s0-.846 1.239-1.693c.826-.847.413-1.27.413-1.27z"
      />
      <path
        fill="url(#swedbank_ee_svg__ca)"
        d="M177.827 176.335s1.985 1.308 3.176 1.308c1.19.436 1.984.436 2.778-3.924.397-3.052.397-4.36.397-4.36s-2.778.872-3.175.872 0 4.36-1.985 2.616c-.397 0-1.19 3.488-1.19 3.488"
      />
      <path
        fill="url(#swedbank_ee_svg__cb)"
        d="M187.883 152.83s.378 1.222-1.134 2.036c-.756.407-1.134 1.629-1.512 1.629 0 .407 2.646 1.22 2.646 1.22s.756-1.22 1.134-2.035c.378-.407 1.512-1.628 1.512-3.257-.756.408-2.646.408-2.646.408"
      />
      <path
        fill="url(#swedbank_ee_svg__cc)"
        d="M179.973 136.546s-1.253 2.34-1.253 2.73c-.418.39-.836 1.17-2.507 1.56-.417 0-.417.39-.417.39-.418.39.835 1.56.835 1.56l.835 1.17s1.254 0 2.507-1.95c.835-1.17 2.088-3.12 2.088-3.12z"
      />
      <path
        fill="#3E0900"
        d="M303.01 159.833s-2.118.847-3.388 3.81c-.423.847 1.27 0 1.27 0h.424s.847-1.693 2.117-2.54z"
      />
      <path
        fill="url(#swedbank_ee_svg__cd)"
        d="M314.285 178.886s-.441 1.512-1.764 2.646l-.882.756s-.441.756-.441 1.134.44.756.44.756 3.53-1.512 4.852-4.536c-.44-.378-2.205-.756-2.205-.756"
      />
      <path
        fill="url(#swedbank_ee_svg__ce)"
        d="M293.278 148.19s-1.294.423-1.725 1.27c-.431.846-.431 1.27-.863 2.117-.43.846-1.725 1.27-2.587 2.54 0 .423-.432.847 0 1.694l.862.846 1.294-1.27s-.431-1.27.431-1.693c1.726-.424 1.726-1.27 2.157-2.54.431-.848-.863-1.271 1.294-1.694.431-.424-.431-1.27-.431-1.27z"
      />
      <path
        fill="url(#swedbank_ee_svg__cf)"
        fillRule="nonzero"
        d="M298.045 155.3s.909 2.276 0 1.896c-.908-.38-2.27-.38-2.27-.38l-.455 1.898s2.725.38 4.542-.76c1.363-1.137.454-3.414.454-3.414z"
      />
      <path
        fill="url(#swedbank_ee_svg__cg)"
        d="M190.53 244.071c.423.442 1.27.442 2.54.442 2.54 0 .423-5.293.423-5.293l-2.117.441c0 .441.423.882.423 1.764.424.882-.846.441-.846.441z"
      />
      <path
        fill="url(#swedbank_ee_svg__ch)"
        d="M107.967 192.646s-.847.838-.847 1.257-.424.837-.424.837v1.675c0 .419-.846.838-.846 2.094 0 .837 0 4.188 1.693 6.281 3.81 1.675 4.234-.837 4.658-2.093 0-.838-1.694-.42-1.694-.42s-.423 1.676-2.117 0c-.847-1.674-.847-2.512-.847-3.768 0-.419.424-.838.424-1.256v-2.094c-.424-.419.423-.838.846-.838.424 0 .424-.837.424-.837z"
      />
      <path
        fill="url(#swedbank_ee_svg__ci)"
        d="M110.084 200.056s0 2.117-.847 2.117-1.27-.424-1.27-.424l-2.117.847s.423 1.694 2.54 1.694 2.964-.424 3.81-3.81c-1.27 0-2.116-.424-2.116-.424"
      />
      <path
        fill="url(#swedbank_ee_svg__cj)"
        d="M71.554 196.88s-1.693.824-1.693 2.883c0 0 0 .412.423 1.236.424.412 2.117-.412 2.117-.412s-.423-1.647.847-2.06c.847-.823 0-.823 0-.823z"
      />
      <path
        fill="url(#swedbank_ee_svg__ck)"
        d="M83.621 213.37s2.646 0 3.402-.424 1.135 0 1.135 0l.756.847s0 2.117-4.537 1.693c-.756-.423-.756-2.117-.756-2.117"
      />
      <path
        fill="url(#swedbank_ee_svg__cl)"
        d="M92.195 203.02s.847.423 1.27-.847c.847 0 1.694.423 1.694.423s-.424 3.387-2.54 2.117c-.847-.423-.424-1.694-.424-1.694"
      />
      <path
        fill="url(#swedbank_ee_svg__cm)"
        d="M83.381 166.184s.427 1.25-.427 3.333c-.427 2.083-.427 3.333-2.136 6.25-.427 1.25-1.28 2.5-4.27 4.583-1.709 1.25-1.282 2.084-1.282 2.5 0 .417-.854 3.75 2.136 6.25 1.281.834 3.416 0 3.416 0l-1.28-1.666s-1.282.416-2.136-.417c-.855-.417-.855-2.917-.855-3.333s0-1.667.428-2.084c.854-.416 5.125-2.916 6.406-6.25 1.281-3.75 1.708-6.25.854-7.916-.427-.833-.854-1.25-.854-1.25"
      />
      <path
        fill="url(#swedbank_ee_svg__cn)"
        d="M80.403 187.777s.381.847-1.143.847-1.905 0-3.048-1.27c.38-.424 1.143-1.27 1.143-1.27s2.286 1.27 1.524-.847c.762 0 1.524 1.27 1.524 1.27z"
      />
      <path
        fill="#3E0900"
        d="M93.783 154.54s-1.694 0-1.694 2.117l.424-.423s.423-.423.846-.423c.424 0 .847 0 .847.423.847.423.424-.423.424-.423z"
      />
      <path
        fill="url(#swedbank_ee_svg__co)"
        d="M87.632 142.897s-3.802 3.487-4.647 5.666c-.422.872-.422 1.743-.422 1.743l2.112-.435s0-2.616 3.802-4.795c3.802-2.18-.845-2.18-.845-2.18"
      />
      <path
        fill="url(#swedbank_ee_svg__cp)"
        d="M87.855 152.222s-1.134 3.27-3.402 2.043c-1.89-1.634-1.89-4.494-1.89-4.494s2.268-.817 1.89-.409c-.378.409 0 6.538 2.646 1.635.756.408.756 1.225.756 1.225"
      />
      <path
        fill="url(#swedbank_ee_svg__cq)"
        d="M88.914 149.108s1.277-2.796 4.257-3.595c2.555-.799 2.98-.4 3.832-.4s0 1.998 0 1.998-2.554 0-4.257.4c-1.704.399-2.555 1.997-2.98 2.795.425-.798-.852-1.198-.852-1.198"
      />
      <path
        fill="url(#swedbank_ee_svg__cr)"
        d="M109.237 142.897s-1.694 2.013-3.387 2.416c-.847.403-2.964 1.208-4.234 1.208v1.611s4.657.806 8.468-3.624c0-1.208-.847-1.611-.847-1.611"
      />
      <path
        fill="url(#swedbank_ee_svg__cs)"
        d="M115.506 139.944s-1.705.446-2.984.446c-.852 0-1.705-.446-3.41 1.783-.426.891.853 1.782.853 1.782s1.278-2.228 2.557-1.782c1.279 0 3.837 0 6.82-1.783 0 0 3.837-1.337 3.41-2.228-.426-.892-.852-.446-.852-.446s0 .891-2.558.891c-1.705.446-3.836 1.337-3.836 1.337"
      />
      <path
        fill="url(#swedbank_ee_svg__ct)"
        d="M133.835 128.078s-2.964.838-2.54 3.77c0 1.257 0 1.676.847 2.514.846.419 1.693-1.257 1.693-1.257s-.847-.838-.423-2.095c.423-.419 1.27-1.256 1.693-1.256.847-.838-1.27-1.676-1.27-1.676"
      />
      <path
        fill="url(#swedbank_ee_svg__cu)"
        d="M146.058 135.522s.812 2.54-1.218 1.694c-.812-.424-2.436-.847-3.248-.847s-.812 2.117-.812 2.117 2.842.847 4.872.847 2.842.423 2.436-2.117c0-2.117-2.03-1.694-2.03-1.694"
      />
      <path
        fill="url(#swedbank_ee_svg__cv)"
        d="M327.71 206.407s-1.693.423-1.693 1.693v1.27l1.27-.423s0-.847.423-.847c.847 0 0-1.693 0-1.693"
      />
      <path
        fill="url(#swedbank_ee_svg__cw)"
        d="M331.31 211.24s.846 0 .846-.847v-1.694c.423-.423 1.694 0 1.694.423 0 .424-.424 1.27-.424 1.27s-.423 1.27-1.27 1.694c-.423.847-.847-.847-.847-.847"
      />
      <path
        fill="#3E0900"
        d="m290.028 207.842.423.846.847-.423s-.423 0 0-.423c-.423-.847-1.27 0-1.27 0"
      />
      <path
        fill="url(#swedbank_ee_svg__cx)"
        d="M279.02 209.204s-.424 1.572-1.27 1.965c-.424 0-.424 1.573-.424 1.573s2.117.393 3.387-2.752c1.27-2.752-1.694-.786-1.694-.786"
      />
      <path
        fill="url(#swedbank_ee_svg__cy)"
        d="M266.171 204.29s-3.257 0-3.664 2.54c.407.847.407.423.407.423h1.629s0-.846 1.628-.423c.814 0 1.628-.423 1.628-.423z"
      />
      <path
        fill="url(#swedbank_ee_svg__cz)"
        d="M300.613 187.354s-2.117 0-2.117 1.27c0 .847 0 .847.423 1.27.424.424 1.694-.423 1.694-.423s-1.27-1.27-.424-1.27c.847.423.424-.847.424-.847"
      />
      <path
        fill="url(#swedbank_ee_svg__cA)"
        d="M305.905 192.646s0 .424-.423.424c-.424 0-1.27.423-1.27.423h-.424s0 1.694.424 1.694c0 0 2.54-.424 2.963-2.117z"
      />
      <path
        fill="url(#swedbank_ee_svg__cB)"
        d="M324.944 177.045s.395.847-.395.847c-.79.424-1.976.424-1.976.424l-.79 1.27.79.423h.79s1.186.423 2.767-.423c.79-.424 1.185-.847.79-2.117s-1.976-.424-1.976-.424"
      />
      <path
        fill="url(#swedbank_ee_svg__cC)"
        d="M289.574 192.646v1.54c-.378.385-1.134.385-1.512.77-.378 0-.756 0-1.134-.385s-1.134 1.54-1.134 1.54.756.77 2.268.77 1.512-.77 2.268-1.925l.756-2.31z"
      />
      <path
        fill="url(#swedbank_ee_svg__cD)"
        d="M279.549 184.602s-1.27-1.27.423-1.27c.847 0 .424-1.27.424-1.27s-1.694 0-2.54.423c-.848.423-.424 2.117-.424 2.117s0 .846.423 1.27c0 .423 1.694-1.27 1.694-1.27"
      />
      <path
        fill="url(#swedbank_ee_svg__cE)"
        d="M267.872 191.588s-.894 1.984-2.682 3.175c-.895.397-2.683 1.588-2.683 1.588v1.588s2.236-.397 3.13-1.191c1.341-.794 3.13-2.779 3.13-3.573.447-.793-.895-1.587-.895-1.587"
      />
      <path
        fill="url(#swedbank_ee_svg__cF)"
        d="M261.848 192.514s-1.27.794-1.693 1.19v2.382l-1.694.794s-.423-1.19 0-2.778c0-1.191 1.694-2.779 2.54-3.573z"
      />
      <path
        fill="url(#swedbank_ee_svg__cG)"
        d="M247.688 210.147v1.533s1.764.383 4.41-2.299c.883-.766.883-1.15.883-1.15s-1.765-.766-2.206-.766c-.44.383-.882 1.916-2.205 2.3-.44.382-.882.382-.882.382"
      />
      <path
        fill="url(#swedbank_ee_svg__cH)"
        d="M245.36 204.29s-2.118 1.323-2.964 3.97c0 .44.423.881.846 1.322l1.27-1.323s-.846-1.323 1.694-2.205c.424 0-.847-1.764-.847-1.764"
      />
      <path
        fill="url(#swedbank_ee_svg__cI)"
        d="M237.08 186.295s-1.27.441-2.964 3.529c-.424.882 0 1.764 0 1.764l1.27-.882s0-.441.423-1.764c0-.442.847-.883 1.27-1.324.847 0 0-1.323 0-1.323"
      />
      <path
        fill="url(#swedbank_ee_svg__cJ)"
        d="M243.544 194.128s0 1.27-.81 1.27c-.811 0-.811.424-1.217.424-.405 0 0 1.693 0 1.693s2.027.424 3.243-1.27c.811-1.27.811-2.54.811-2.54z"
      />
      <path
        fill="#3E0900"
        d="M174.864 144.379s-.847 0-.424.423h-.847v-.423l.424-.424h.423zM147.978 176.557l-.847.424v.423h.847c.847.423.847 0 .847 0l-.424-1.27-1.27-.424z"
      />
      <path
        fill="url(#swedbank_ee_svg__cK)"
        d="m124.903 183.71-1.54 2.585-1.155-.43-.77-.432s-1.54-.43-2.31-1.293c-.769-.862-.769-1.724 0-3.017 1.156-.43 1.156.431 1.156.431s1.924.431 1.54.862c-.386 0-.77.431.384.431.385 0 1.155.431 1.54.431z"
      />
      <path
        fill="url(#swedbank_ee_svg__cL)"
        d="M150.306 152.423s-2.035.872-3.664.872c-1.628.436-2.035 1.744-1.221 3.051 0 0 .814 1.743 3.257 2.18 2.036.435 2.443.435 4.885 1.307 1.222-.436 1.629-2.18 2.036-2.615-1.629-1.308-2.85-1.744-2.85-1.744s-2.035-1.307 1.221-1.743v-.872z"
      />
      <path
        fill="#3E0900"
        d="M154.329 153.905c-2.117 0-2.117.847-2.117.847s-.847 0-.847-.847 2.54-2.54 2.54-2.54z"
      />
      <path
        fill="#FFFDE9"
        d="m107.967 202.173-2.117.846s.423 1.27 1.27 1.694c.423-.423 1.27-2.54.847-2.54"
      />
      <path
        fill="#3E0900"
        d="M95.171 176.98c-.846 0-1.27.847-1.27.847h-1.27s-.847.424-.423-.423l1.693-1.694zM100.557 188.389c0-.424.424-.424 0-.847 0-.423.424 0 .424 0v.423z"
      />
      <path
        fill="url(#swedbank_ee_svg__cM)"
        d="M85.315 123.844s-1.27 0-1.694 2.117c1.27.423 1.694 0 1.694 0s0-.423 1.27-.847c0 .424-1.27-1.27-1.27-1.27"
      />
      <path
        fill="url(#swedbank_ee_svg__cN)"
        d="M92.496 130.23s1.262 1.693-.42 1.27c-.842-.424-1.262-.424-1.262-.424l-.842 2.117s4.628.847 4.207-1.27c0-2.117-1.683-1.693-1.683-1.693"
      />
      <path
        fill="url(#swedbank_ee_svg__cO)"
        d="M105.736 123.87s-1.831-.403-3.205 2.009c-.458.402-.458 1.205-.915 2.01 0 .803 2.289-1.207 2.289-1.207s-.458-1.205 2.747-.803c.915-.402-.916-2.01-.916-2.01"
      />
      <path
        fill="url(#swedbank_ee_svg__cP)"
        d="M122.797 115.376s-.398 0 0 0c-.797.416-3.187.416-3.187 2.495 0 2.495 5.976 4.99 3.187 7.07h-1.195c0 .415.398 2.078.398 2.078h1.992c.797 0 3.187-2.079 1.195-4.99-1.992-2.495-3.983-4.574-1.593-5.405z"
      />
      <path
        fill="url(#swedbank_ee_svg__cQ)"
        d="M130.195 71s.882-2.442 3.97-3.256l1.322 2.442c-.44.408-1.764.815-1.764 2.036 0 .407 0 .814-.44.814l-.442-.407z"
      />
      <path
        fill="url(#swedbank_ee_svg__cR)"
        d="M126.39 98.44s-.451 1.155-1.803 1.155-1.801-.385-1.801-.385l1.351 3.464s.901 0 2.252-.385c1.352-.385 2.253-.77 2.703-2.31.45-1.154-2.703-1.539-2.703-1.539"
      />
      <path
        fill="url(#swedbank_ee_svg__cS)"
        fillRule="nonzero"
        d="M112.392 96.323c-2.756 1.657-2.362 2.9-3.936 4.142-1.181.828-2.755 1.243-3.543 2.071-.393.414-1.18.828-1.18.828l1.574 2.486s.394-.829 1.18-1.243c1.181-.828 2.756-1.243 3.15-1.657 1.967-1.657 2.755-3.728 3.542-4.142.393-.414-.787-2.485-.787-2.485"
      />
      <path
        fill="url(#swedbank_ee_svg__cT)"
        d="M138.134 107.967s-.794.846-1.985.423c-1.19-.423-2.779 1.694-2.779 1.694l1.588.846s1.588-.846 3.176-.423c1.19 0 1.587-2.117 1.587-2.117z"
      />
      <path
        fill="url(#swedbank_ee_svg__cU)"
        d="M114.766 119.72s.847 1.833-1.27 2.291c-.847.458.847 1.833.847 1.833l1.694-.916c.846-.459 1.693-1.833 1.27-3.666s-2.54.458-2.54.458"
      />
      <path
        fill="url(#swedbank_ee_svg__cV)"
        d="M115.485 115.793s-.418-2.196 1.255-3.514c2.091-1.317-.837-2.195-.837-2.195s-3.346 3.074-2.51 6.148 2.092-.44 2.092-.44"
      />
      <path d="M173.593 124.903s0 1.693-.423 2.116-1.694.847-1.694.847" />
      <path
        fill="url(#swedbank_ee_svg__cW)"
        d="M172.958 125.961s0 1.27-.847 1.694c-.423 0-1.27.423-1.27.423l-.423 1.694s2.117 0 2.54-.847c.847-1.27.847-1.27.847-1.694 1.27-1.27-.847-1.27-.847-1.27"
      />
      <path
        fill="url(#swedbank_ee_svg__cX)"
        d="M166.36 116.435s-1.271 0-1.694.44c-.424.442-.847.442-.424 1.324 0 .882.424 3.528.424 3.528l2.117-.441c0-.441-.424-.882-.424-1.323-.423-.441.424-1.323.847-.882z"
      />
      <path
        fill="url(#swedbank_ee_svg__cY)"
        d="m148.983 119.187-.794 1.693s.794.847 2.779.424c1.985 0 3.572 0 3.572-2.117l-1.587-1.694s.794 1.27-.397 1.694c-.794 0-1.985.423-1.985.423h-1.19z"
      />
      <path
        fill="url(#swedbank_ee_svg__cZ)"
        d="M145.626 111.142s-1.694.435-2.54 1.74c-.424.871 0 2.177 0 2.612l.846.87c.423.436 2.117-1.305 2.117-1.305l-.847-1.306c0-.435 0-.87.847-.87.847-.87-.423-1.74-.423-1.74"
      />
      <path
        fill="url(#swedbank_ee_svg__da)"
        d="M207.353 133.37s-1.978 2.911-2.77 3.743c-.395.832-1.582 2.495-1.978 3.327s-.79 2.079-2.373 2.91c0 0-.396 1.664 0 1.664 1.186 0 2.373-.832 4.352-3.743.79-.831 1.187-2.495 1.582-2.91 0-.416.791-2.08 1.978-3.327 1.187-1.248-.79-1.664-.79-1.664"
      />
      <path
        fill="url(#swedbank_ee_svg__db)"
        d="M193.553 120.669s-.818.45-.409 1.35c0 .9-.818 1.35-1.636 1.799-.818.9-1.227.9-.818 2.7.409 1.35 1.636-.45 1.636-.45v-1.35c.409-.45 1.227-.9 1.227-1.35.41-.45 0-.9.818-1.35 1.227 0-.818-1.35-.818-1.35"
      />
      <path
        fill="#3E0900"
        d="M195.798 122.574s-.423-.847-.847-.424c-.423 0 0-.423 0-.423h.424s.423 0 .423.423zM160.233 105.214l-.847.424s0 .847-.423.847c-.424.423 0 .423 0 .423h1.27l.423-1.27-.423-.847z"
      />
      <path
        fill="url(#swedbank_ee_svg__dc)"
        d="M176.613 85.738s-1.694.424-2.964 3.387c-.423 1.27 1.694.424 1.694.424s0-2.117 2.117-2.117z"
      />
      <path
        fill="url(#swedbank_ee_svg__dd)"
        d="m176.134 101.616-.424 1.27s1.694.423 2.964 0c1.27-.847 1.27-2.964 1.27-2.964l-1.693-.423s0 2.117-.847 2.117c-.423.423-1.27 0-1.27 0"
      />
      <path
        fill="url(#swedbank_ee_svg__de)"
        d="M163.538 83.621s-.424 1.323-.847 1.323c0 0-.424 2.205-1.27 2.205-.847.442-.424 1.765-.424 1.765s1.27 0 1.694-.882c.423-1.324.423-1.324 1.693-2.647z"
      />
      <path
        fill="url(#swedbank_ee_svg__df)"
        d="M157.492 82.563s-.846.882-1.693 2.205 1.27 3.087 1.27 3.087l1.694-1.323s-.424-.441-.424-.882c-.423-.441-.423-.441-.423-.882s.847-.441 1.27-.882z"
      />
      <path
        fill="url(#swedbank_ee_svg__dg)"
        d="M168.286 70.92s-1.595 1.246-1.993 2.493c-.4 1.247.398 3.325.797 3.74s1.994-.415 1.994-.415l-.798-2.078s-.398-1.247 1.197-1.663c.797-.415 1.993-1.247 1.993-1.247z"
      />
      <path
        fill="url(#swedbank_ee_svg__dh)"
        d="M174.44 59.276s-1.27.405-2.54 1.216-2.54 2.432-2.54 2.838c0 .405 2.54 0 2.54 0s0-1.217 1.693-1.622c1.27-.405 1.694-.81 2.117-.81-.423-.406-1.27-1.622-1.27-1.622"
      />
      <path
        fill="#3E0900"
        d="M177.192 63.51s0 .423-.423.847c0 0 0 .423.423.423.424 0 .847.423.847.423v-1.27zM200.105 68.122s-.424 2.117-1.694 2.117.424 1.693.424 1.693 1.693-.847 2.54-2.964-1.27-.846-1.27-.846"
      />
      <path
        fill="url(#swedbank_ee_svg__di)"
        d="M209.37 77.588s.847 1.27 0 1.27h-.846c0 .423.423 2.117.423 2.117s2.117 0 2.54-2.117c0-2.54-2.117-1.27-2.117-1.27"
      />
      <path
        fill="url(#swedbank_ee_svg__dj)"
        d="m228.612 93.01.423-.418s0 1.253-.847 2.924c-.423.418-.423.836-1.27 2.089-.847.417-1.27.835-1.27.835-.424 0 0-2.088 0-2.088s.847 0 1.27-.418q1.27-1.88 1.27-3.76c-.423-.417.424.836.424.836"
      />
      <path
        fill="#3E0900"
        d="M220.223 84.68s-2.22.423-3.107 2.117c-.444.423.444.423.444.423l1.775.423s1.332-1.27 2.22-1.27c2.219-.847-1.332-1.693-1.332-1.693"
      />
      <path
        fill="url(#swedbank_ee_svg__dk)"
        d="M195.857 89.972s-2.408 1.155-3.21 2.694v1.54l1.604-1.155s.402-.77 2.007-1.54c1.605-.769-.401-1.539-.401-1.539"
      />
      <path
        fill="url(#swedbank_ee_svg__dl)"
        d="M214.24 113.047s0 1.27.846 1.27c0 0 .847 0 .847-.846v-1.27c.424 0 1.694.846 1.694.846s0 3.388-2.117 3.388c-1.27 0-1.694-.424-1.694-.424z"
      />
      <path
        fill="url(#swedbank_ee_svg__dm)"
        d="M226.574 127.961s2.089-.874 2.089-2.185 2.09-.873 2.09-.437c0 1.311-1.254 3.933-4.18 4.807-2.506.437 0-2.185 0-2.185"
      />
      <path
        fill="url(#swedbank_ee_svg__dn)"
        d="M232.3 117.493s-.408.88-1.222 1.32c-.814.439-1.629 1.758-2.443 4.836 0 .44 1.629 0 1.629 0s0-.88.814-1.76c.407-.879 1.221-1.758 1.628-2.198.407 0 .814-.879 1.222-.879 0-.44-1.629-1.319-1.629-1.319"
      />
      <path
        fill="url(#swedbank_ee_svg__do)"
        d="M237.825 113.26s0 .422-.424.422c-.423.424-.847.424-1.27.424s.847 1.27.847 1.27.847-.423 1.27-.847c.423 0 .847-.847.847-1.27z"
      />
      <path
        fill="url(#swedbank_ee_svg__dp)"
        d="M248.088 103.733h-.423s.423.846-.424.846h-.423c-.424.424 0 1.694 0 1.694s3.387 0 2.54-2.54z"
      />
      <path
        fill="#3E0900"
        d="M239.855 89.972s-3.387.424-3.81 1.27c0 .424.423 0 .423 0h1.27l.847-.423z"
      />
      <path
        fill="url(#swedbank_ee_svg__dq)"
        d="M263.468 111.142s-1.954 2.577-2.736 3.435c-.39.43-1.563 1.289-1.954 1.718-.391 0-.782.43-1.173 0 0 0-.39 1.288-.39 2.147 1.172.43 3.517-.43 4.299-2.147 1.172-2.147 1.563-2.576 2.735-3.865 1.173-.859-.781-1.288-.781-1.288"
      />
      <path
        fill="url(#swedbank_ee_svg__dr)"
        d="M259.841 106.908s-1.27.847-2.54 2.54c-.424.847.847 0 .847 0l.846.424s.847-1.27 1.27-1.27c1.27 0-.423-1.694-.423-1.694"
      />
      <path
        fill="url(#swedbank_ee_svg__ds)"
        d="M247.956 117.493s-1.27 0-3.387 2.54c-.424.847 1.693 1.27 1.693 1.27s.424-1.27 1.27-2.116c.847-.424.424-1.694.424-1.694"
      />
      <path
        fill="url(#swedbank_ee_svg__dt)"
        fillRule="nonzero"
        d="M243.095 122.786c0 .407-.846 2.442-2.117 3.256-1.27.815-.423 2.036-.423 2.036s1.27-.814 1.694-1.221c1.27-.815 1.27-1.222 2.117-2.036z"
      />
      <path
        fill="url(#swedbank_ee_svg__du)"
        fillRule="nonzero"
        d="M246.588 131.253c-1.293 0-2.156 0-3.88 1.728-2.156 2.158-1.294 2.59-3.018 3.454-.431.432-.862 0-.862-.432s-1.725 1.295-1.725 1.295.862 1.727 3.018 1.296c1.725-.432 1.725-2.16 3.018-3.455s1.725-1.727 3.88-1.295c1.725 0-.43-2.59-.43-2.59"
      />
      <path
        fill="url(#swedbank_ee_svg__dv)"
        d="M267.988 123.878s1.27.42.846 1.26c0 .84-2.54.84-2.963.84s0 2.1 0 2.1 3.81-.42 3.81-2.52-.423-1.68-.423-1.68z"
      />
      <path
        fill="#3E0900"
        d="m268.223 123.844-.424.423s.847.424 1.27.847c0 .424.847.847.847.847v-1.694c-.846-.423-1.693-.423-1.693-.423"
      />
      <path
        fill="url(#swedbank_ee_svg__dw)"
        d="M279.443 118.552h-4.853c-2.206.423-1.324 2.54-1.324 2.54 0 .423 2.206 0 2.206 0s-.441-.423 0-.847c0 0 .441-.423.883-.423h1.764z"
      />
      <path
        fill="url(#swedbank_ee_svg__dx)"
        d="M299.554 141.627c.424 3.387-2.117 3.387-2.117 2.964v-2.117c1.694 0 .424-1.27.424-1.694z"
      />
      <path
        fill="url(#swedbank_ee_svg__dy)"
        d="M283.395 141.116s.423 2.552-1.27 2.127c-1.27-.426 0 1.701 0 1.701s2.963.851 2.963-3.403c0-3.829-1.693-.425-1.693-.425"
      />
      <path
        fill="url(#swedbank_ee_svg__dz)"
        d="M264.918 134.429s-1.719 0-3.438 2.224c-.43.444-1.289 1.334-2.149 4.002.43.445 2.58-.444 2.58-.444s.859-3.114 3.007-3.558c1.72-.445 0-2.224 0-2.224"
      />
      <path
        fill="url(#swedbank_ee_svg__dA)"
        d="M265.682 144.477s-1.952 5.474-6.247 3.128c-.39-.782.39-.782 1.172-1.564 1.952.39 2.733-.782 3.123-1.564.39-1.173 1.952 0 1.952 0"
      />
      <path
        fill="url(#swedbank_ee_svg__dB)"
        d="M261.066 157.81s-1.68 2.552-3.781 2.977h-.84c-.84.426.42 2.127.42 2.127s2.94.85 4.621-2.552c2.52-3.402-.42-2.552-.42-2.552"
      />
      <path
        fill="url(#swedbank_ee_svg__dC)"
        d="M255.683 155.599s-4.381 1.345-4.82 3.14c0 1.793.877 2.242 1.753 3.139.876.448 1.752-1.346 1.752-1.346s-3.066-1.794.877-2.69c1.752-.45.438-2.243.438-2.243"
      />
      <path
        fill="url(#swedbank_ee_svg__dD)"
        d="M244.29 146.072s-1.623 2.73-1.623 3.12-.81 1.95-2.433 2.34c-1.622 0-.811 1.95-.811 1.95s1.216 0 2.028-.39c1.216-.78 1.622-1.56 2.838-3.12 1.217-1.56 1.217-2.34 1.217-2.73.405-.78-1.217-1.17-1.217-1.17"
      />
      <path
        fill="url(#swedbank_ee_svg__dE)"
        d="M238.613 142.897c-.806.402-2.82 3.214-3.224 4.419-.403 1.205-.403 2.41-.403 2.812s1.612 0 1.612 0-.403-.804.403-2.009 1.21-2.41 3.224-4.017c.403 0-1.612-1.205-1.612-1.205"
      />
      <path
        fill="url(#swedbank_ee_svg__dF)"
        fillRule="nonzero"
        d="M210.22 43.398c-2.53 0-2.53 2.512-6.323 1.675-5.057-1.675-7.586-.837-8.008-.419-.421 0 1.265 1.675 1.265 1.675s2.529-.419 7.165 1.256c4.636.419 6.322-2.093 6.322-2.093z"
      />
      <path
        fill="url(#swedbank_ee_svg__dG)"
        d="m139.637 247.688 3.26 2.81-4.89 2.41c-5.298 2.408-2.038 2.007-2.038 2.007s-2.445 4.416-4.483 4.416-2.852-.803-2.037-3.212 8.558-7.226 8.558-7.226z"
      />
      <g fillRule="nonzero">
        <path
          fill="#3E0900"
          d="M92.437 307.856c-.408.408-1.225.817-2.041 0l-3.267-2.858c-.408-.408-.816-1.225 0-2.041l16.331-19.19c.409-.408 1.225-.816 2.042 0l3.266 2.859c.408.408.817 1.224 0 2.04z"
        />
        <path
          fill="url(#swedbank_ee_svg__dH)"
          d="M6.699 23.196c-.409.408-.817.408-.817 0l-2.041-2.041c-.408-.408-.408-.817 0-.817l14.698-16.74c.408-.407.816-.407.816 0l2.042 2.042c.408.409.408.817 0 .817z"
          transform="translate(85.738 282.618)"
        />
        <path
          fill="url(#swedbank_ee_svg__dI)"
          d="M18.539 3.599h-.408l-.409-2.041c.409-.409.817-.409.817-.409z"
          transform="translate(85.738 282.618)"
        />
        <path
          fill="url(#swedbank_ee_svg__dJ)"
          d="M3.433 20.338s-.409.409.408 1.225l-2.042 1.225-.816-.817c0-.408 0-1.224.408-1.224 0-.409 2.042-.409 2.042-.409"
          transform="translate(85.738 282.618)"
        />
        <path
          fill="url(#swedbank_ee_svg__dK)"
          d="M3.433 20.338 18.13 3.598l-.409-2.04-16.33 18.78s-.817.409-.817 1.225c.408 0 2.45-.816 2.858-1.225"
          transform="translate(85.738 282.618)"
        />
        <path
          fill="url(#swedbank_ee_svg__dL)"
          d="M21.397 6.457V5.64l2.041-.408c0 .408 0 .817-.408.817z"
          transform="translate(85.738 282.618)"
        />
        <path
          fill="url(#swedbank_ee_svg__dM)"
          d="m20.58 5.232.408.408 2.042-.408v-.817z"
          transform="translate(85.738 282.618)"
        />
        <path
          fill="#FFFCDF"
          d="m106.318 287.85-2.041-1.633h-.408l.408-2.041c.408 0 .408 0 .817.408l3.266 2.858.408.408z"
        />
      </g>
      <g fillRule="nonzero">
        <path
          fill="#3E0900"
          d="M89.266 279.562c0 .82.824 1.23 1.235 1.23h4.117c.823 0 1.235-.82 1.235-1.23 0 0-.412-13.125-11.526-13.946 0 0-6.998-.41-8.233 5.743-.412 3.281.412 5.332.412 5.332s.823 2.871 2.058 4.922c.823 1.64 1.235 2.871 1.235 2.871s.411 2.461-2.058 1.64c-2.47-.82-4.117-4.921-4.117-8.613 0-.82-.823-1.23-1.235-1.23h-4.528c-.823 0-1.235.82-1.235 1.23 0 0 .412 12.305 10.291 15.176 7.41 1.641 9.88-5.332 9.88-5.332s1.646-2.871-.824-7.793c-2.058-4.512-2.47-4.922-2.47-4.922s-.823-2.05 0-2.461c.824-.41 1.235-.41 2.47.41 2.059 1.23 3.705 4.512 3.293 6.973"
        />
        <path
          fill="url(#swedbank_ee_svg__dN)"
          d="M3.47 14.938v-.41c0-.41.411-.82.411-.82h1.647c.411 0 .823.41.823.41v.82c.823 7.793 5.763 8.614 5.763 8.614s1.646.41 3.293-.82c2.058-2.052.412-4.513.412-4.923s-2.059-4.512-2.059-4.512-.823-1.64-1.234-4.511c0-3.282 2.881-4.922 2.881-4.922s1.647-1.231 5.351-.41c6.175 1.23 7.821 9.433 7.821 9.433v.41c0 .41-.411.82-.411.82H26.52c-.411 0-.823-.41-.823-.41v-.41s-.823-5.332-4.528-6.562c-2.47-.82-3.705.41-3.705.41s-1.235.82-.823 2.871c0 2.05 1.235 3.692 1.235 3.692s2.058 3.28 2.47 4.922c.411 1.64.823 4.101-1.235 6.562-2.058 2.051-4.528 1.64-4.528 1.64s-3.705.411-7.41-4.511-3.704-7.383-3.704-7.383"
          transform="translate(65.627 264.624)"
        />
        <path
          fill="url(#swedbank_ee_svg__dO)"
          d="M28.58 12.887c0 .41 0 .82-.412.82l2.47 1.641s.411-.41.411-.82z"
          transform="translate(65.627 264.624)"
        />
        <path
          fill="url(#swedbank_ee_svg__dP)"
          d="M16.642 2.633c.823-.41 2.47-.41 4.116 0 6.175 1.23 7.821 9.434 7.821 9.434v.41l2.059 2.05v-.41S30.226.993 19.112.173c0 0-1.647 0-3.293.41z"
          transform="translate(65.627 264.624)"
        />
        <path
          fill="#DE761C"
          d="m79.799 268.898 1.235-1.23s.411-.411.823-.411l-.823-2.05c-1.235.41-2.47.82-3.293 1.64z"
        />
        <path
          fill="url(#swedbank_ee_svg__dQ)"
          d="M10.879 5.504c0 .41-.412 1.23-.412 1.23v1.641h2.059v-1.64c.411-.82.411-1.23.411-1.23.412-.411.412-.821.823-1.231l-1.646-1.641c-.412.41-.823 1.23-1.235 2.05.412 0 .412.411 0 .821"
          transform="translate(65.627 264.624)"
        />
        <path
          fill="url(#swedbank_ee_svg__dR)"
          d="M11.702 22.731c2.058.82 3.293 0 3.705-.82.412-.41.823-.82.823-1.23 0 0 0-.41-.823-1.231-.412-.41-1.235 0-1.235 0 0 .82-.412 1.23-2.058.82z"
          transform="translate(65.627 264.624)"
        />
        <path
          fill="url(#swedbank_ee_svg__dS)"
          d="M12.526 20.68c-1.235-.41-2.059-1.23-2.882-2.87l-2.058.82c1.235 2.87 3.293 3.691 4.116 4.101z"
          transform="translate(65.627 264.624)"
        />
        <path
          fill="url(#swedbank_ee_svg__dT)"
          d="M9.644 17.81c-.823-1.641-1.646-3.692-1.646-5.743v-.41l-2.059 1.23v1.23c0 2.052.824 3.282 1.235 4.513z"
          transform="translate(65.627 264.624)"
        />
        <path
          fill="#FFFDE9"
          d="M74.036 276.69c0-.41-.412-.82-.823-.82l-1.235 2.051s.411 0 .411.41z"
        />
        <path
          fill="url(#swedbank_ee_svg__dU)"
          d="M7.174 11.247H2.235l1.646 2.05H5.94z"
          transform="translate(65.627 264.624)"
        />
        <path
          fill="url(#swedbank_ee_svg__dV)"
          d="M3.47 11.247H2.235c-.412 0-.412.41-.824.82l2.059 1.64c0-.41.411-.41 1.234-.41z"
          transform="translate(65.627 264.624)"
        />
        <path
          fill="#DC601E"
          d="M85.973 287.355c.824.41.412 1.64.412 1.64.412-.82.823-1.23.823-1.23s.412-.82.412-2.46l-2.058-.41c0 1.23 0 2.05-.824 3.28 0-.41.824-1.23 1.235-.82"
        />
        <path
          fill="url(#swedbank_ee_svg__dW)"
          d="M21.993 20.27q0-1.845-1.235-4.922c-2.058-4.512-2.47-4.922-2.47-4.922s-.411-.41-.411-1.23l-1.647-.41v.82c0 2.05 1.235 3.691 1.235 3.691s2.058 3.282 2.47 4.922c0 .41.412 1.23.412 2.051z"
          transform="translate(65.627 264.624)"
        />
        <path
          fill="#D85E1D"
          d="M83.504 273.82c0-.41 0-.82.411-1.23 0 0-.411.41-1.235 0-.411-.411 0-1.642 0-1.642-.411.41-.823.82-.823 2.051z"
        />
      </g>
      <g fillRule="nonzero">
        <path
          fill="#3E0900"
          d="M123.908 329.84c.825.41 1.65 0 1.65-.413l12.385-22.228c.413-.823 0-1.647-.413-1.647l-4.128-2.058c-.825-.411-1.651 0-1.651.412l-5.367 9.468v.823c0 .823-.825.823-.825.823s-.413 0-.826-.412c-.413-.411 0-1.234 0-1.234s-2.064-13.996-2.064-15.231-1.238-1.647-1.238-1.647l-3.303-2.058c-.825-.411-1.651 0-1.651.412l-12.385 22.228c-.412.824 0 1.647.413 1.647l3.716 2.058c.825.412 1.65 0 1.65-.412l5.78-10.29s0-.824.413-1.235.413-.412.826-.412.413.823.413 1.235l2.476 15.642s0 1.235 1.239 2.058c-.413.824 2.89 2.47 2.89 2.47"
        />
        <path
          fill="url(#swedbank_ee_svg__dX)"
          d="M21.826 20.347c-.413 0-.825-1.235-.825-1.235s-2.065-13.996-2.065-15.23c0-.412 0-.824-.412-1.236l-1.652 1.235c0 .412.413.412.413.823l2.89 19.347s0 1.235.826 1.235z"
          transform="translate(103.733 294.262)"
        />
        <path
          fill="url(#swedbank_ee_svg__dY)"
          d="M21 25.698c.413 0 .826-.412 1.239-1.647l1.238-2.47 5.367-9.879-.826-2.058-5.366 9.468s-.413 1.235-.826 1.235z"
          transform="translate(103.733 294.262)"
        />
        <path
          fill="url(#swedbank_ee_svg__dZ)"
          d="M29.257 8.82c-.413 0-.826.412-1.239.824l.826 2.058c0-.411.413-.411.826-.411z"
          transform="translate(103.733 294.262)"
        />
        <path
          fill="#FFFCDF"
          d="M137.943 305.964c0-.412-.413-.412-.413-.412l-4.128-2.058h-.413l.413 2.47 2.477 1.235z"
        />
        <path
          fill="url(#swedbank_ee_svg__ea)"
          d="M32.147 12.526c.412 0 .412.411.412.823v.411l2.064-.411v-.412q.62-.617 0-1.235z"
          transform="translate(103.733 294.262)"
        />
        <path
          fill="url(#swedbank_ee_svg__eb)"
          d="m32.147 13.76-10.32 18.936s0 .411-.414.411l-.412.412v2.47c.412 0 .412-.412.825-.412L33.798 13.76z"
          transform="translate(103.733 294.262)"
        />
        <path
          fill="#A53410"
          d="M116.89 305.964s-.413 0-.826 1.235l-.826 1.235-5.779 10.29-.413.412.826 1.647 5.78-10.29s.412-1.236.825-1.647z"
        />
        <path
          fill="url(#swedbank_ee_svg__ec)"
          d="m2.837 23.64-.413-.412s-.413 0-.413-.823l-1.651.411s-.413.412 0 1.235c0 .412.413.412.826.824z"
          transform="translate(103.733 294.262)"
        />
        <path
          fill="url(#swedbank_ee_svg__ed)"
          d="M2.011 22.816s0-.411 0 0L13.157 3.058 12.744 1 .773 22.816l-.413.824z"
          transform="translate(103.733 294.262)"
        />
        <path
          fill="url(#swedbank_ee_svg__ee)"
          d="M14.396.588c-.413-.412-1.239 0-1.652.412l.413 2.058c0-.412.413-.412.826 0z"
          transform="translate(103.733 294.262)"
        />
        <path
          fill="url(#swedbank_ee_svg__ef)"
          d="m22.652 22.816 5.78-11.114c0-.411.412-.411.825-.411l2.477 1.235c.413 0 .413.411.413.823L21.413 33.107c0 .412-.412.412-.825.412l-2.064-1.235c-.413-.412-.413-.823-.413-1.235l-2.89-18.523c-.825-2.059-2.064-.412-2.064-.412L6.14 24.463c0 .412-.413.412-.825.412l-2.89-1.647c-.413 0-.413-.412-.413-.823L12.744 2.646c0-.411.413-.411.826-.411l2.89 1.646c.412.412.412.412.412.823l2.89 19.347s0 .824.413.824q.62.617 1.238 0c.413 0 1.239-2.059 1.239-2.059"
          transform="translate(103.733 294.262)"
        />
        <path
          fill="#FFFCDF"
          d="M122.256 297.32c-.413-.412-.825-.412-.825-.412l-3.303-2.058-.413 2.058 2.89 1.647.413.411z"
        />
      </g>
      <g fillRule="nonzero">
        <path
          fill="#3E0900"
          d="M157.94 331.23c-1.64.82-4.1 1.23-5.742.82-4.101-.82-6.152-4.922-5.332-9.024s4.922-6.562 9.024-5.332c1.64.41 3.281 1.641 4.102 2.871l.41.82c.41.411 1.23.821 2.05.411l4.102-2.871c.41-.41.82-1.23.41-2.051l-.41-.41c-2.05-2.871-4.922-5.332-9.023-6.153-7.794-2.05-15.997 2.871-18.048 10.665s2.871 15.996 11.075 17.637c3.691.82 7.793 0 10.664-1.64 0 0 .41-.411.82-.411.82-.41.82-1.23.41-2.05l-2.46-3.692c-.82 0-1.641 0-2.051.41"
        />
        <path
          fill="url(#swedbank_ee_svg__eg)"
          d="M20.508 27.071c.41 0 .41-.41.41-.82l-.82-1.23c-.41-.411-.41-.411-.82-.411-2.051.82-4.102.82-6.153.41-4.922-1.23-8.203-6.562-6.972-11.484 1.23-5.333 6.562-8.204 11.484-6.973 2.051.41 4.102 1.64 5.332 3.691v.41c0 .41.82.41.82 0l1.231-.82c.41-.41.41-.82.41-.82 0-.41-.41-.82-.41-.82-2.46-2.462-4.512-3.692-7.793-4.512-6.563-1.231-12.715 2.46-14.356 9.844-1.23 6.152 2.461 12.715 9.024 14.355 2.871.41 5.742.41 8.613-.82-.41 0 0 0 0 0"
          transform="translate(138.663 309.08)"
        />
        <path
          fill="url(#swedbank_ee_svg__eh)"
          d="M20.098 25.02c-.41-.41-.41-.41-.82-.41l.41-2.461c.41 0 .82 0 1.23.41z"
          transform="translate(138.663 309.08)"
        />
        <path
          fill="#F99D1C"
          d="m159.581 335.331-.82-1.23.82-2.461s.41 0 .41.41l2.462 3.692v.41z"
        />
        <path
          fill="url(#swedbank_ee_svg__ei)"
          d="M20.508 26.66s.41-.41 0-.82l2.872.41c0 .41 0 .821-.41 1.231z"
          transform="translate(138.663 309.08)"
        />
        <path
          fill="url(#swedbank_ee_svg__ej)"
          d="M6.563 6.563c-1.23 1.23-2.051 2.46-2.871 4.101l-.82 2.461c0 .41 0 .82-.411 1.23H0c0-.41 0-1.23.41-1.64l.82-2.46q1.23-3.077 3.692-4.923z"
          transform="translate(138.663 309.08)"
        />
        <path
          fill="url(#swedbank_ee_svg__ek)"
          d="M27.891 8.614c0 .41 0 .82-.41 1.23l-2.46-.82v-.82z"
          transform="translate(138.663 309.08)"
        />
        <path
          fill="url(#swedbank_ee_svg__el)"
          d="M25.02 8.614c0-.41-.41-.82-.41-.82-2.461-2.462-4.512-3.692-7.793-4.513-4.102-.82-7.793.41-10.664 2.872L4.512 4.512C8.203 1.23 13.125 0 18.047 1.23c3.692.82 6.973 3.28 9.024 6.152l.41.41s0 .41.41.41z"
          transform="translate(138.663 309.08)"
        />
        <path
          fill="url(#swedbank_ee_svg__em)"
          d="M5.332 17.227v-3.691c0-.41.82-2.872 2.871-4.922 0 0 .41-.41 1.23 0s1.231 1.23 1.231 1.23c-2.05 1.64-2.46 3.692-2.87 4.102q-.616 1.23 0 2.46z"
          transform="translate(138.663 309.08)"
        />
        <path
          fill="url(#swedbank_ee_svg__en)"
          d="M17.227 25.02c-1.64.41-2.871.41-4.512 0-3.691-.82-6.562-4.101-6.973-8.203l2.051-.41c.41 2.87 2.461 5.742 5.332 6.562q1.845.615 3.692 0z"
          transform="translate(138.663 309.08)"
        />
        <path
          fill="#DE761C"
          d="M155.89 334.101c.82 0 1.23-.41 2.05-.41l.411-2.461h-.41c-.41.41-1.23.82-2.051.82z"
        />
      </g>
      <g fillRule="nonzero">
        <path
          fill="#3E0900"
          d="m181.109 336.284 13.064.41c.817 0 1.225.82 1.225 1.23v4.102c0 .82-.816 1.231-1.225 1.231l-19.189-.41c-.816 0-1.224-.82-1.224-1.23l.816-25.431c0-.82.817-1.23 1.225-1.23l18.372.41c.817 0 1.225.82 1.225 1.23v4.102c0 .82-.816 1.23-1.225 1.23l-12.248-.41v3.692l11.024.41c.816 0 1.224.82 1.224 1.23v4.102c0 .82-.816 1.23-1.224 1.23l-11.024-.41z"
        />
        <path
          fill="url(#swedbank_ee_svg__eo)"
          d="M6.29 23.962c-.408 0-.816-.41-.816-.82v-6.563c0-.41.408-.82.816-.82l11.024.41c.408 0 .817-.41.817-.82v-1.231c0-.41-.409-.82-.817-.82l-11.024-.41c-.408 0-.816-.411-.816-.821V5.504c0-.41.408-.82.816-.82l13.065.41c.409 0 .817-.41.817-.82v-1.23c0-.411-.408-.821-.817-.821l-16.739-.41c-.408 0-.817.41-.817.82l-.816 22.56c0 .41.408.82.816.82l16.74.41c.408 0 .816-.41.816-.82v-1.231c0-.41-.408-.82-.816-.82z"
          transform="translate(173.593 314.373)"
        />
        <path
          fill="url(#swedbank_ee_svg__ep)"
          d="M2.616 3.043c-.408 0-.408.41-.408.41L.575 2.223v-.41q0-1.23 1.224-1.23z"
          transform="translate(173.593 314.373)"
        />
        <path
          fill="url(#swedbank_ee_svg__eq)"
          d="m19.764 3.453-16.74-.41h-.408L1.799.993h.409l18.372.41h.408z"
          transform="translate(173.593 314.373)"
        />
        <path
          fill="url(#swedbank_ee_svg__er)"
          d="M20.172 3.864c0-.41 0-.41-.408-.82L20.988.991c.409.41.817.82.817 1.23z"
          transform="translate(173.593 314.373)"
        />
        <path
          fill="url(#swedbank_ee_svg__es)"
          d="M21.805 2.633v4.512L20.58 5.094v-1.23z"
          transform="translate(173.593 314.373)"
        />
        <path
          fill="url(#swedbank_ee_svg__et)"
          d="M5.882 13.297V6.735l2.042 1.23v3.692z"
          transform="translate(173.593 314.373)"
        />
        <path
          fill="url(#swedbank_ee_svg__eu)"
          d="m17.314 13.708-11.024-.41s-.408 0-.408-.41l2.042-2.052 11.023.41h.408z"
          transform="translate(173.593 314.373)"
        />
        <path
          fill="url(#swedbank_ee_svg__ev)"
          d="M19.355 11.657c.409.41.817.82.817 1.23l-2.041 1.23c0-.41-.409-.41-.817-.41z"
          transform="translate(173.593 314.373)"
        />
        <path
          fill="url(#swedbank_ee_svg__ew)"
          d="M20.172 12.887V17.4l-2.041-1.64v-2.051z"
          transform="translate(173.593 314.373)"
        />
        <path
          fill="url(#swedbank_ee_svg__ex)"
          d="M5.474 23.141V16.99l2.041 1.23v3.692z"
          transform="translate(173.593 314.373)"
        />
        <path
          fill="url(#swedbank_ee_svg__ey)"
          d="M19.764 24.782s-.409 0-.409-.41l-13.065-.41c-.408 0-.816-.41-.816-.82l2.041-1.231 13.065.41c.408 0 .408 0 .817.41z"
          transform="translate(173.593 314.373)"
        />
        <path
          fill="url(#swedbank_ee_svg__ez)"
          d="M19.764 25.192v-.41l1.633-2.05c.408 0 .408.41.408.82z"
          transform="translate(173.593 314.373)"
        />
        <path
          fill="url(#swedbank_ee_svg__eA)"
          d="M21.805 23.552v4.921l-2.041-1.64v-1.64z"
          transform="translate(173.593 314.373)"
        />
      </g>
      <g fillRule="nonzero">
        <path
          fill="#3E0900"
          d="M223.978 319.745v-.82c0-.82-.847 0-.847 0l-1.694 1.23c-2.117 1.23-2.54-.41-2.54-.41l-1.694-2.871c-.423-.82 0-1.64.424-1.64l5.927-3.692s.424-.41 1.694-.82l2.117-.41c.847-.41 1.693 0 1.693.82l7.198 24.61c.424.82 0 1.64-.847 1.64l-4.657.41c-.847.41-1.694-.41-1.694-.82l-5.08-16.817z"
        />
        <path
          fill="url(#swedbank_ee_svg__eB)"
          d="m9.315 8.614 5.08 17.227c0 .41.424.41.847.41l2.117-.82c.424 0 .424-.41.424-.821L11.432 2.871c0-.41-.424-.41-.847-.41l-1.694.41c-.846.41-5.504 3.282-5.504 3.282-.423 0-.423.41-.423.82l.847 1.23s.423.82 1.27 0c1.27-.82 2.117-1.23 2.117-1.23s1.693-.41 2.117 1.64"
          transform="translate(215.933 309.08)"
        />
        <path
          fill="url(#swedbank_ee_svg__eC)"
          d="M3.387 6.563v.41l-2.964-.41c0-.41 0-.82.424-1.23z"
          transform="translate(215.933 309.08)"
        />
        <path
          fill="url(#swedbank_ee_svg__eD)"
          d="M8.891 3.281c-1.27.41-5.08 3.282-5.08 3.282l-2.54-.82.423-.41L7.62 1.64s.424 0 .847-.41z"
          transform="translate(215.933 309.08)"
        />
        <path
          fill="url(#swedbank_ee_svg__eE)"
          d="m11.008 2.871-1.693.41H8.89l-.846-2.05c.423 0 .423-.41.846-.41l2.117-.41z"
          transform="translate(215.933 309.08)"
        />
        <path
          fill="url(#swedbank_ee_svg__eF)"
          d="M11.855 3.281c0-.41-.423-.41-.847-.41l.424-2.46c.423 0 1.27 0 1.27.41z"
          transform="translate(215.933 309.08)"
        />
        <path
          fill="#F58220"
          d="M234.14 334.511q0-.615 0 0l-6.352-22.149 1.27-2.05s0 .41.424.41l7.198 24.61z"
        />
        <path
          fill="url(#swedbank_ee_svg__eG)"
          d="M20.323 25.84v.82l-2.117-1.23v-.41z"
          transform="translate(215.933 309.08)"
        />
      </g>
      <g fillRule="nonzero">
        <path
          fill="#3E0900"
          d="M304.701 268.898c7.383 6.152 7.793 13.125 3.692 18.867-4.512 5.332-12.305 6.973-19.688.82-6.973-5.742-6.973-13.945-2.871-18.867 3.28-4.922 11.484-6.973 18.867-.82m-13.945 4.922c-1.641 2.05-.82 5.332 2.87 8.203 3.692 2.871 7.384 3.281 9.435 1.23 1.64-2.05.41-5.332-2.872-8.203-4.101-3.281-7.383-3.281-9.433-1.23"
        />
        <path
          fill="#FFE5A1"
          d="M305.111 283.253c0 .41-.41.82-.82 1.231-.41.41-.82.82-1.64 1.23l-1.231-1.64c.41-.41.82-.41.82-.82l.41-.41z"
        />
        <path
          fill="url(#swedbank_ee_svg__eH)"
          d="M26.833 12.067c-.82-2.051-2.461-4.512-4.922-6.153-6.153-4.922-13.125-3.691-16.407.41-.82.82-1.23 2.051-1.64 3.282L2.633 7.145l1.23-2.461C7.556.172 15.759-1.88 23.142 4.274c2.461 2.05 4.102 3.691 4.922 5.742z"
          transform="translate(281.56 264.624)"
        />
        <path
          fill="url(#swedbank_ee_svg__eI)"
          d="m23.141 17.81-.82-.821c0 .82-.41 1.23-.82 2.05-1.641 2.052-5.743 1.641-9.434-1.23-1.23-1.23-2.051-2.05-2.871-3.281l-.41 1.23-1.231-.82c.82 1.64 1.64 2.871 3.281 4.102 4.922 4.101 9.844 3.691 12.305.82.82-.82 1.23-2.05 1.23-3.281z"
          transform="translate(281.56 264.624)"
        />
        <path
          fill="url(#swedbank_ee_svg__eJ)"
          d="M21.91 5.914c6.153 4.922 6.974 11.485 3.282 15.997-3.691 4.512-10.664 5.332-16.817 0-5.742-4.512-6.152-11.895-2.87-15.586 3.28-4.102 10.253-5.743 16.406-.41M7.966 7.965c-2.05 2.461-1.64 7.793 2.871 11.075 4.922 4.101 9.844 3.691 12.305.82s1.641-7.383-3.281-11.485c-4.922-3.691-9.844-2.87-11.895-.41"
          transform="translate(281.56 264.624)"
        />
        <path
          fill="url(#swedbank_ee_svg__eK)"
          d="m5.504 6.325-2.05-1.231c-.821 1.23-1.641 2.871-2.051 4.512 0 .82-.41 1.64-.41 2.46 0 0 .41 1.231 1.23 1.231s.82-.41 1.23-1.23c0-1.23 0-2.461.41-3.281.41 0 .82-1.231 1.641-2.461"
          transform="translate(281.56 264.624)"
        />
        <path
          fill="url(#swedbank_ee_svg__eL)"
          d="M26.833 7.555c1.64 2.461 2.871 4.922 2.871 7.383 0 .41.41 3.281-1.64 6.563-.821 1.23-1.231-1.23-1.641-.82 1.64-2.872 1.23-4.923 1.23-4.923 0-1.23-.41-3.691-2.46-6.152 0-.41 2.05-.82 1.64-2.051"
          transform="translate(281.56 264.624)"
        />
        <path
          fill="url(#swedbank_ee_svg__eM)"
          d="M9.196 14.528c-.41-.41-2.051-2.871 0-5.332 0-.41-2.051-.41-2.051-.41-1.23 2.05-.41 4.101-.41 4.101 0 1.23.82 2.051 1.23 3.282 0 0 .82.82 1.23.41.821-.41.41-1.641 0-2.051"
          transform="translate(281.56 264.624)"
        />
        <path
          fill="url(#swedbank_ee_svg__eN)"
          d="M18.22 19.86c4.101 0 4.101-3.691 3.69-4.922 0 0 0-1.23.821-1.23.82-.41 1.23 1.23 1.23 1.23.41 1.23 0 4.512-2.46 6.153-.82.41-2.051 1.23-3.282 1.23z"
          transform="translate(281.56 264.624)"
        />
      </g>
      <g fillRule="nonzero">
        <path
          fill="#3E0900"
          d="m273.739 305.317-1.647 6.998c0 .823-.411 1.647.412 2.47l2.058 2.47c.412.411 1.235.823 2.058.411l14.82-11.525c.41-.412.822-1.235.41-2.059l-2.469-3.293c-.412-.411-1.235-.823-2.058-.411l-6.175 4.94c-1.235.823-.823 0-.823 0s1.235-3.294 2.058-9.057-3.705-8.233-3.705-8.233-5.35-3.704-11.114.824c-5.763 4.528-5.351 9.467-4.94 11.114 0 1.647 1.647 1.235 1.647 1.235h3.293s2.058 0 1.647-1.647c-.412-2.058 1.235-4.94 3.293-5.351 2.47 0 3.293 1.647 3.293 3.705-.823 1.646-2.058 7.41-2.058 7.41"
        />
        <path
          fill="url(#swedbank_ee_svg__eO)"
          d="M19.523 11.702c0 .412-2.47 9.88-2.47 11.114-.411.824 0 1.235.824 1.235.411 0 .823-.411.823-.411l7.821-6.175c.412-.411.823 0 .823 0l.824 1.235c.411.412 0 .823 0 .823l-12.761 9.88c-.412.411-.823 0-.823 0l-1.235-1.647c-.412-.412 0-.823 0-1.235l2.47-10.29s1.235-4.117.823-4.94c0-1.647-1.235-4.528-4.528-4.94s-4.94 2.058-5.351 3.293c-.412 1.235-.412 2.882-.412 2.882s0 .823-.823.823H3.47s-.824 0-.412-.823c0-.824 0-3.705 3.705-6.587 3.704-3.293 6.997-2.47 8.644-1.646 0-.823 4.94 2.058 4.116 7.41"
          transform="translate(260.39 285.794)"
        />
        <path
          fill="url(#swedbank_ee_svg__eP)"
          d="M20.347 13.76c0-.823.411-2.058.411-3.293V7.586l-1.646.412c.411 1.234.823 2.47.411 3.704 0 .412-.411 1.647-.823 3.293 0 0 0 .412.823.412.824-.412.824-1.647.824-1.647"
          transform="translate(260.39 285.794)"
        />
        <path
          fill="url(#swedbank_ee_svg__eQ)"
          d="M19.112 19.935c-.412 0 0-.412 0-.412l-2.058 2.882v.823z"
          transform="translate(260.39 285.794)"
        />
        <path
          fill="url(#swedbank_ee_svg__eR)"
          d="m19.523 19.935-2.47 3.705c0 .411.412.411.824.411.411 0 .823-.411.823-.411z"
          transform="translate(260.39 285.794)"
        />
        <path
          fill="url(#swedbank_ee_svg__eS)"
          d="M26.521 14.584s-.411 0-.411.411l-6.175 4.94h-.412l-1.235 3.705 7.822-6.175h.411z"
          transform="translate(260.39 285.794)"
        />
        <path
          fill="url(#swedbank_ee_svg__eT)"
          d="M27.756 14.995c-.412-.411-.823-.411-1.235-.411v2.47c.412 0 .412 0 .823.411z"
          transform="translate(260.39 285.794)"
        />
        <path
          fill="#F7941D"
          d="M291.028 304.494s0-.412-.412-.412l-2.47-3.293-.412-.411-.411 2.47.823 1.234v.412z"
        />
        <path
          fill="url(#swedbank_ee_svg__eU)"
          d="M30.638 19.935q.616-.617 0-1.235h-2.47v.412z"
          transform="translate(260.39 285.794)"
        />
        <path
          fill="url(#swedbank_ee_svg__eV)"
          d="M16.23 9.232c.412.412.412 1.235.412 1.647 0 1.235-.823 4.94-.823 4.94l-2.47 10.29v.824H11.29v-.823l1.646-6.998s1.235-5.352 1.235-7.41c0 0 0 .412.412.824 0 .411 0 .823.411.823.412.411 1.647-2.058 1.235-4.117"
          transform="translate(260.39 285.794)"
        />
        <path
          fill="#3E0900"
          d="M268.387 296.261c-.411-.823-1.234-.823-1.234-.823-.412 1.646-.412 3.293-.412 3.705l1.235 1.235v-1.235c0-1.235 0-2.059.411-2.882"
        />
        <path
          fill="url(#swedbank_ee_svg__eW)"
          d="M3.058 5.528C1.823 7.174 1 9.232 1 10.468c0 0 0 1.234.411.823.412.823 1.235 0 1.235 0 0-.824 0-2.47 1.647-4.528z"
          transform="translate(260.39 285.794)"
        />
        <path
          fill="url(#swedbank_ee_svg__eX)"
          d="M20.758 7.586c-.823-3.705-3.704-5.351-3.704-5.351s-5.352-3.705-11.115.823c-1.235.823-2.058 2.058-2.881 2.881l1.235 1.647c.411-.823 1.235-1.235 2.058-2.058 3.705-3.293 6.998-2.47 8.644-1.647 0 0 2.47 1.647 3.705 4.117z"
          transform="translate(260.39 285.794)"
        />
      </g>
      <g fillRule="nonzero">
        <path
          fill="#3E0900"
          d="M257.135 311.845c2.461 0 4.922 1.235 6.153 3.704 2.46 4.528 0 10.291-5.333 13.173-5.332 2.881-11.894 2.058-14.355-2.882-1.23-2.47-.82-4.94.41-7.41-2.051-.41-4.102-1.646-4.922-3.704-2.461-4.116 0-9.88 4.922-12.349 4.922-2.47 10.664-1.647 13.125 2.881.82 2.47.82 4.528 0 6.587m-10.254-2.882c-1.23.823-2.05 2.47-1.23 3.293.82 1.235 2.46 1.647 3.69.824 1.231-.824 2.052-2.47 1.231-3.294-.82-1.234-2.46-1.646-3.691-.823m5.332 9.88c-2.05.823-2.871 2.88-2.05 4.116.82 1.235 2.46 1.235 4.511.411 1.64-.823 2.871-2.881 2.05-4.116-.82-1.235-2.87-1.646-4.51-.412"
        />
        <path
          fill="url(#swedbank_ee_svg__eY)"
          d="M17.571 13.29c2.871 0 5.742.823 6.973 3.293 1.64 3.293-.82 7.41-4.922 9.88s-9.024 2.058-10.664-1.236c-1.231-2.058-.82-4.94.82-7.409.41-.823-.41-.823-.41-.823-2.461 0-4.512-1.235-5.332-2.882-1.641-2.881.41-7.41 4.101-9.467 4.102-2.059 8.614-1.235 10.254 1.646.82 2.058.82 4.117-.82 6.175-.41 0-.82.411 0 .823M8.958 6.292c-2.461 1.235-3.282 4.117-2.461 6.175 1.23 2.058 4.101 2.881 6.562 1.646s3.282-4.116 2.461-6.174C14.29 5.88 11.42 5.057 8.958 6.292m5.332 9.88c-2.871 1.646-4.102 4.527-2.871 6.997 1.23 2.058 4.511 2.882 7.383 1.235 2.87-1.646 4.101-4.528 2.87-6.998s-4.511-2.881-7.382-1.235"
          transform="translate(237.103 300.613)"
        />
        <path
          fill="url(#swedbank_ee_svg__eZ)"
          d="M20.442 6.704c0-.412-.41-1.235-.82-1.647C17.16.941 11.419-.294 6.497 2.176c-1.231.411-2.051 1.235-2.872 2.058l1.641 1.647c.82-.824 1.64-1.235 2.461-1.647 4.102-2.058 8.614-1.235 10.254 1.647.41.411.41 1.234.41 1.646z"
          transform="translate(237.103 300.613)"
        />
        <path
          fill="url(#swedbank_ee_svg__fa)"
          d="M5.266 4.646c-.82-.412-1.23 0-1.23 0Q2.19 6.499 1.575 8.35s-.41.824-.41 1.647c.82 0 1.64.412 2.05.412 0-.412 0-.412.41-.824 0-.411.41-.823.41-.823.41-.823.82-1.647 1.641-2.058 0-.412.41-1.647-.41-2.058"
          transform="translate(237.103 300.613)"
        />
        <path
          fill="url(#swedbank_ee_svg__fb)"
          d="M19.622 5.057c.82 1.647.82 3.293.82 4.528l-.82.824c-.82.823-1.64.411-1.64.411.82-1.646.82-3.293 0-4.528v-.411s.82 1.234 1.64.823c.41 0 0-1.647 0-1.647"
          transform="translate(237.103 300.613)"
        />
        <path
          fill="#A1490C"
          d="M252.623 311.845c-.41 1.235-1.23 2.47-2.46 2.881-2.462 1.235-5.333.412-6.563-1.646-.41-.824-.41-1.647-.41-2.059 0 0 0 1.235.82 1.235s1.23-1.235 1.23-1.235c0 .412 0 .824.41 1.235.82 1.235 2.461 1.647 3.692.824.82-.412 1.23-.824 1.64-1.647 0 0-.41 1.235.41 1.647.821.411 1.231-1.235 1.231-1.235"
        />
        <path
          fill="url(#swedbank_ee_svg__fc)"
          d="M14.29 13.29c-.41.412-.82.823-1.23.823-2.462 1.235-5.333.412-6.563-1.646v-.412s.82.823 1.23.412c.82-.412.41-1.235.41-1.235.82 1.235 2.461 1.646 3.692.823.41-.412.82-.412 1.23-.823 0 0-.82 1.235 0 1.646.82 1.235 1.23.412 1.23.412"
          transform="translate(237.103 300.613)"
        />
        <path
          fill="url(#swedbank_ee_svg__fd)"
          d="m26.595 16.171-1.641.824c.41 1.235.41 2.881-.41 4.116 0 .412-.41 1.235-1.64 2.47 0 0 .41.412 1.23.412.41 0 .82.411.82.411.82-1.235 1.23-2.058 1.64-2.881 0 0 1.231-2.47 0-5.352"
          transform="translate(237.103 300.613)"
        />
        <path
          fill="url(#swedbank_ee_svg__fe)"
          d="M26.595 16.171c0-.411-.41-.823-.41-1.234-1.231-2.47-3.692-3.705-6.153-3.705l-2.871 1.235s-.41.823.41.823c2.871 0 5.742.823 6.973 3.293 0 .412.41.412.41.823 0 0 .41 1.235 1.23.824 0-.412.82-.412.41-2.059"
          transform="translate(237.103 300.613)"
        />
        <path
          fill="url(#swedbank_ee_svg__ff)"
          d="m19.622 21.523.82.411v1.235c-.41.412-1.23.824-1.64 1.235-2.872 1.647-6.153.823-7.383-1.235 0-.411-.41-.411-.41-.823l.82-.823 1.23.411v.412c.82 1.235 2.461 1.235 4.512.412.41-.412.82-.412 1.23-.824z"
          transform="translate(237.103 300.613)"
        />
        <path
          fill="url(#swedbank_ee_svg__fg)"
          d="M20.032 23.17c.82-.824 1.64-2.059 1.64-3.294 0 0 0-.823-1.23-.823-.82 0-1.23 1.646-1.23 1.646 0 .412-.41.824-.82 1.235 0-.411 1.23-.411 1.64 1.235"
          transform="translate(237.103 300.613)"
        />
        <path
          fill="url(#swedbank_ee_svg__fh)"
          d="M12.649 21.523v-1.235s.41-.823.82-1.235c0 0-1.64-.823-2.05-.823-.41.411-.41.823-.41.823-.41.823-.41 2.058-.41 2.881 0 0 .82.412 1.23 0 .41.412.82 0 .82-.411"
          transform="translate(237.103 300.613)"
        />
      </g>
      <path
        fill="url(#swedbank_ee_svg__fi)"
        fillRule="nonzero"
        d="M86.154 283.677s.44 1.693-.44 3.81c-.44.424-1.32 2.117-3.08 2.964-.44.424 1.32 1.694 1.32 1.694s2.2-1.27 3.96-3.81c.44-.848 1.32-2.541.88-4.658z"
      />
      <path
        fill="url(#swedbank_ee_svg__fj)"
        fillRule="nonzero"
        d="M83.396 270.975c-.424 0-2.54 1.323-1.694 5.292l2.117-.44s-1.27-2.206.424-3.088c.423 0-.847-1.764-.847-1.764"
      />
      <path
        fill="url(#swedbank_ee_svg__fk)"
        fillRule="nonzero"
        d="M125.114 328.134s-.423.423-.847 0c-.423 0-.423 2.54-.423 2.54s.423.423.847 0h.423c.424-.423 0-2.54 0-2.54"
      />
      <path
        fill="url(#swedbank_ee_svg__fl)"
        fillRule="nonzero"
        d="M118.128 306.093s-.423-.423-1.27 0c0 .847-.423 3.388-.423 3.388s.423-.424.846 0z"
      />
      <path
        fill="url(#swedbank_ee_svg__fm)"
        fillRule="nonzero"
        d="m110.507 319.877-.847-1.27s-.423.424-.847 0c-.423 0-.846 2.117-.846 2.117s.846.424 1.27.424c.423 0 .847-.424 1.27-.847z"
      />
      <path
        fill="url(#swedbank_ee_svg__fn)"
        fillRule="nonzero"
        d="M191.588 320.513v2.117h2.54s1.27.423 1.694-.847c-.424-.424-1.694-2.117-1.694-2.117s0 .847-.847.847z"
      />
      <path
        fill="url(#swedbank_ee_svg__fo)"
        fillRule="nonzero"
        d="M183.12 319.666h-3.464s-.77 0-.77 1.27c.385 0 1.924 1.27 1.924 1.27h2.31z"
      />
      <path
        fill="url(#swedbank_ee_svg__fp)"
        fillRule="nonzero"
        d="M190.53 330.674h1.27s.423 0 .846-.423c.424.423 2.117 1.693 2.117 1.693s0 1.27-1.27 1.27h-2.54z"
      />
      <path
        fill="url(#swedbank_ee_svg__fq)"
        fillRule="nonzero"
        d="M183.12 331.31h-3.464s-.77 0-.77 1.27c.385.423 1.924.846 1.924.846h2.31z"
      />
      <path
        fill="url(#swedbank_ee_svg__fr)"
        fillRule="nonzero"
        d="M191.588 342.318h1.27s.423 0 .847-.424c.423.424 2.117 1.694 2.117 1.694s-.424.847-1.694.847h-2.54z"
      />
      <path
        fill="url(#swedbank_ee_svg__fs)"
        fillRule="nonzero"
        d="m243.666 319.421 2.964-.814-.424.407c-.423.407-1.27 2.036-1.27 4.479-.847 0-2.54.407-2.54.407s0-2.443 1.27-4.479c.423-.814 0 0 0 0"
      />
      <path
        fill="url(#swedbank_ee_svg__ft)"
        fillRule="nonzero"
        d="M250.84 310.14s0 .77-.847 1.924c-.423 0 0 2.31 0 2.31s2.54-.77 3.387-3.08c.424-.77.424-1.155.424-1.155z"
      />
      <path
        fill="url(#swedbank_ee_svg__fu)"
        fillRule="nonzero"
        d="M242.584 310.14s-.424.846 0 1.693c0 .423.423 1.693.847 2.117.423.423 1.27-1.27 1.27-1.27s-.847-.847 0-2.54z"
      />
      <path
        fill="url(#swedbank_ee_svg__fv)"
        fillRule="nonzero"
        d="m297.854 284.735-.417 2.117s2.503.847 5.006.424c.834-.424-.417-2.117-.417-2.117s-.834.423-2.086 0c-1.251 0-2.086-.424-2.086-.424"
      />
    </g>
  </svg>
);
export default SvgEdbSmallLogo;
